(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './korge-root-klogger.js', './kotlin-kotlin-stdlib-js-ir.js', './korge-root-korim.js', './korge-root-klock.js', './korge-root-korinject.js', './korge-root-korgw.js', './korge-root-korma.js', './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js', './korge-root-kmem.js', './korge-root-korio.js', './korge-root-korau.js', './korge-root-kds.js', './korge-root-krypto.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./korge-root-klogger.js'), require('./kotlin-kotlin-stdlib-js-ir.js'), require('./korge-root-korim.js'), require('./korge-root-klock.js'), require('./korge-root-korinject.js'), require('./korge-root-korgw.js'), require('./korge-root-korma.js'), require('./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'), require('./korge-root-kmem.js'), require('./korge-root-korio.js'), require('./korge-root-korau.js'), require('./korge-root-kds.js'), require('./korge-root-krypto.js'));
  else {
    if (typeof this['korge-root-klogger'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-klogger' was not found. Please, check whether 'korge-root-klogger' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korim'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korim' was not found. Please, check whether 'korge-root-korim' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-klock'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-klock' was not found. Please, check whether 'korge-root-klock' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korinject'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korinject' was not found. Please, check whether 'korge-root-korinject' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korgw'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korgw' was not found. Please, check whether 'korge-root-korgw' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korma'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korma' was not found. Please, check whether 'korge-root-korma' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' was not found. Please, check whether 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-kmem'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-kmem' was not found. Please, check whether 'korge-root-kmem' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korio'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korio' was not found. Please, check whether 'korge-root-korio' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korau'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korau' was not found. Please, check whether 'korge-root-korau' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-kds'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-kds' was not found. Please, check whether 'korge-root-kds' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-krypto'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-krypto' was not found. Please, check whether 'korge-root-krypto' is loaded prior to 'korge-root-korge'.");
    }
    root['korge-root-korge'] = factory(typeof this['korge-root-korge'] === 'undefined' ? {} : this['korge-root-korge'], this['korge-root-klogger'], this['kotlin-kotlin-stdlib-js-ir'], this['korge-root-korim'], this['korge-root-klock'], this['korge-root-korinject'], this['korge-root-korgw'], this['korge-root-korma'], this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'], this['korge-root-kmem'], this['korge-root-korio'], this['korge-root-korau'], this['korge-root-kds'], this['korge-root-krypto']);
  }
}(this, function (_, kotlin_com_soywiz_korlibs_klogger_klogger, kotlin_kotlin, kotlin_com_soywiz_korlibs_korim_korim, kotlin_com_soywiz_korlibs_klock_klock, kotlin_com_soywiz_korlibs_korinject_korinject, kotlin_com_soywiz_korlibs_korgw_korgw, kotlin_com_soywiz_korlibs_korma_korma, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_com_soywiz_korlibs_kmem_kmem, kotlin_com_soywiz_korlibs_korio_korio, kotlin_com_soywiz_korlibs_korau_korau, kotlin_com_soywiz_korlibs_kds_kds, kotlin_com_soywiz_korlibs_krypto_krypto) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Companion_getInstance = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.f;
  var protoOf = kotlin_kotlin.$_$.f9;
  var objectMeta = kotlin_kotlin.$_$.e9;
  var VOID = kotlin_kotlin.$_$.nd;
  var setMetadataFor = kotlin_kotlin.$_$.g9;
  var Unit_getInstance = kotlin_kotlin.$_$.t2;
  var CoroutineImpl = kotlin_kotlin.$_$.o7;
  var THROW_CCE = kotlin_kotlin.$_$.pc;
  var classMeta = kotlin_kotlin.$_$.a8;
  var get_RegisteredImageFormats = kotlin_com_soywiz_korlibs_korim_korim.$_$.f2;
  var Companion_getInstance_0 = kotlin_com_soywiz_korlibs_klock_klock.$_$.x;
  var AsyncInjector = kotlin_com_soywiz_korlibs_korinject_korinject.$_$.e;
  var Colors_getInstance = kotlin_com_soywiz_korlibs_korim_korim.$_$.z;
  var Quality_PERFORMANCE_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.z;
  var Size = kotlin_com_soywiz_korlibs_korma_korma.$_$.j9;
  var RGBA = kotlin_com_soywiz_korlibs_korim_korim.$_$.u1;
  var toString = kotlin_kotlin.$_$.k9;
  var toString_0 = kotlin_kotlin.$_$.ld;
  var hashCode = kotlin_kotlin.$_$.k8;
  var getStringHashCode = kotlin_kotlin.$_$.j8;
  var Size__hashCode_impl_2h1qpd = kotlin_com_soywiz_korlibs_korma_korma.$_$.v5;
  var RGBA__hashCode_impl_h59qf6 = kotlin_com_soywiz_korlibs_korim_korim.$_$.k;
  var getNumberHashCode = kotlin_kotlin.$_$.h8;
  var equals = kotlin_kotlin.$_$.c8;
  var Companion_getInstance_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.n7;
  var Companion_getInstance_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.e7;
  var Anchor = kotlin_com_soywiz_korlibs_korma_korma.$_$.y8;
  var Anchor__hashCode_impl_biqpqb = kotlin_com_soywiz_korlibs_korma_korma.$_$.x;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var isInterface = kotlin_kotlin.$_$.u8;
  var Companion_getInstance_3 = kotlin_com_soywiz_korlibs_korma_korma.$_$.q7;
  var Companion_getInstance_4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.o7;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.x6;
  var Size__component1_impl_9kmfl4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s5;
  var Size__component2_impl_93kt6x = kotlin_com_soywiz_korlibs_korma_korma.$_$.t5;
  var _Size___init__impl__aywn0g = kotlin_com_soywiz_korlibs_korma_korma.$_$.r5;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
  var _Vector2___init__impl__67w0ru = kotlin_com_soywiz_korlibs_korma_korma.$_$.j6;
  var Vector2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.k9;
  var Companion_getInstance_5 = kotlin_com_soywiz_korlibs_klock_klock.$_$.v;
  var DateTime = kotlin_com_soywiz_korlibs_klock_klock.$_$.z;
  var Kind_MOUSE_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.k;
  var Level_ERROR_getInstance = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.b;
  var printStackTrace = kotlin_kotlin.$_$.fd;
  var GameWindow = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.k6;
  var println = kotlin_kotlin.$_$.s7;
  var Companion_getInstance_6 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.b1;
  var PerformanceCounter_getInstance = kotlin_com_soywiz_korlibs_klock_klock.$_$.w;
  var configure = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.l6;
  var Companion_getInstance_7 = kotlin_com_soywiz_korlibs_klock_klock.$_$.y;
  var get_resourcesVfs = kotlin_com_soywiz_korlibs_korio_korio.$_$.m2;
  var ensureNotNull = kotlin_kotlin.$_$.xc;
  var readBitmap = kotlin_com_soywiz_korlibs_korim_korim.$_$.g;
  var AsyncInjectorContext = kotlin_com_soywiz_korlibs_korinject_korinject.$_$.d;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v;
  var AGPrint = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.y3;
  var Companion_getInstance_8 = kotlin_com_soywiz_korlibs_korio_korio.$_$.i1;
  var Dyn__set_impl_2ozvx8 = kotlin_com_soywiz_korlibs_korio_korio.$_$.z;
  var getKClass = kotlin_kotlin.$_$.b;
  var _Size___get_width__impl__58y75t = kotlin_com_soywiz_korlibs_korma_korma.$_$.z5;
  var numberToInt = kotlin_kotlin.$_$.b9;
  var _Size___get_height__impl__a04p02 = kotlin_com_soywiz_korlibs_korma_korma.$_$.w5;
  var launchImmediately = kotlin_com_soywiz_korlibs_korio_korio.$_$.x1;
  var Level_TRACE_getInstance = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.d;
  var Type_START_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.q;
  var Status_ADD_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.l;
  var Type_END_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.o;
  var Status_REMOVE_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.n;
  var Type_MOVE_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.p;
  var Status_KEEP_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.m;
  var get_nativeSoundProvider = kotlin_com_soywiz_korlibs_korau_korau.$_$.d;
  var first = kotlin_kotlin.$_$.q4;
  var MouseButton_LEFT_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.g;
  var Type_DRAG_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.i;
  var Type_UP_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.j;
  var Type_DOWN_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h;
  var get_localCurrentDirVfs = kotlin_com_soywiz_korlibs_korio_korio.$_$.l2;
  var CoroutineKey_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.m3;
  var GameWindowCreationConfig = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.j6;
  var CreateDefaultGameWindow = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h6;
  var AG = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.z5;
  var Resources = kotlin_com_soywiz_korlibs_korio_korio.$_$.l3;
  var CoroutineContext = kotlin_kotlin.$_$.n7;
  var TimeProvider = kotlin_com_soywiz_korlibs_klock_klock.$_$.a1;
  var Companion_getInstance_9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.p7;
  var TouchEvent = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.x3;
  var Companion_getInstance_10 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.l2;
  var Companion_getInstance_11 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.k2;
  var Companion_getInstance_12 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.i2;
  var Companion_getInstance_13 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.f2;
  var Companion_getInstance_14 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.o2;
  var Companion_getInstance_15 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.m2;
  var Companion_getInstance_16 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.p2;
  var Companion_getInstance_17 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.e2;
  var MouseEvent = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.u3;
  var Companion_getInstance_18 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.r2;
  var Companion_getInstance_19 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.g2;
  var Companion_getInstance_20 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h2;
  var Companion_getInstance_21 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.n2;
  var ReshapeEvent = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.w3;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
  var TimeSpan = kotlin_com_soywiz_korlibs_klock_klock.$_$.b1;
  var _Size___init__impl__aywn0g_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.q5;
  var Companion_getInstance_22 = kotlin_com_soywiz_korlibs_korio_korio.$_$.m1;
  var Companion_getInstance_23 = kotlin_com_soywiz_korlibs_korma_korma.$_$.j7;
  var Matrix__pretranslated_impl_9mjs3v = kotlin_com_soywiz_korlibs_korma_korma.$_$.t2;
  var Matrix__prescaled_impl_gy2bxt = kotlin_com_soywiz_korlibs_korma_korma.$_$.s2;
  var charSequenceLength = kotlin_kotlin.$_$.z7;
  var charSequenceGet = kotlin_kotlin.$_$.y7;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x1;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r1;
  var get_lastIndex = kotlin_kotlin.$_$.xa;
  var _Matrix___get_immutable__impl__k08qr = kotlin_com_soywiz_korlibs_korma_korma.$_$.l2;
  var Companion_getInstance_24 = kotlin_com_soywiz_korlibs_korim_korim.$_$.b1;
  var Companion_getInstance_25 = kotlin_com_soywiz_korlibs_korim_korim.$_$.a1;
  var until = kotlin_kotlin.$_$.ba;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.l3;
  var mapCapacity = kotlin_kotlin.$_$.l5;
  var coerceAtLeast = kotlin_kotlin.$_$.s9;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.n;
  var Glyph = kotlin_com_soywiz_korlibs_korim_korim.$_$.v1;
  var toIntMap = kotlin_com_soywiz_korlibs_kds_kds.$_$.x2;
  var IntMap_init_$Create$ = kotlin_com_soywiz_korlibs_kds_kds.$_$.f;
  var fromBase64 = kotlin_com_soywiz_korlibs_krypto_krypto.$_$.c;
  var openAsync = kotlin_com_soywiz_korlibs_korio_korio.$_$.r3;
  var ImageDecodingProps = kotlin_com_soywiz_korlibs_korim_korim.$_$.e2;
  var readBitmap_0 = kotlin_com_soywiz_korlibs_korim_korim.$_$.f;
  var slice = kotlin_com_soywiz_korlibs_korim_korim.$_$.s1;
  var Companion_getInstance_26 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.j2;
  var booleanArray = kotlin_kotlin.$_$.u7;
  var Key_META_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.c;
  var arraycopy = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.k3;
  var _TimeSpan___get_nanoseconds__impl__gaf49o = kotlin_com_soywiz_korlibs_klock_klock.$_$.p;
  var _TimeSpan___get_milliseconds__impl__pb0we5 = kotlin_com_soywiz_korlibs_klock_klock.$_$.m;
  var TimeSpan__minus_impl_5w5v8s = kotlin_com_soywiz_korlibs_klock_klock.$_$.o;
  var TimeSpan__compareTo_impl_zidry4 = kotlin_com_soywiz_korlibs_klock_klock.$_$.f;
  var AGOpenglFactory_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.s2;
  var Mixin = kotlin_com_soywiz_korlibs_kds_kds.$_$.w;
  var Companion_getInstance_27 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.q2;
  var _Vector2___init__impl__67w0ru_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.g6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var GamepadInfo = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.s3;
  var copyToArray = kotlin_kotlin.$_$.f4;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.i;
  var setBits = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.f6;
  var getExtraTyped = kotlin_com_soywiz_korlibs_kds_kds.$_$.f2;
  var setExtra = kotlin_com_soywiz_korlibs_kds_kds.$_$.o2;
  var KeyEvent = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.t3;
  var launchImmediately_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.w1;
  var AsyncSignal = kotlin_com_soywiz_korlibs_korio_korio.$_$.q1;
  var CancellableGroup = kotlin_com_soywiz_korlibs_korio_korio.$_$.q2;
  var Type_TYPE_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.e;
  var Type_DOWN_getInstance_0 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.d;
  var Type_UP_getInstance_0 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.f;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.id;
  var Closeable = kotlin_com_soywiz_korlibs_korio_korio.$_$.t2;
  var KProperty1 = kotlin_kotlin.$_$.ha;
  var getPropertyCallableRef = kotlin_kotlin.$_$.i8;
  var PropertyThis = kotlin_com_soywiz_korlibs_kds_kds.$_$.x;
  var valueOf = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.g;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.o;
  var split = kotlin_kotlin.$_$.hb;
  var startsWith = kotlin_kotlin.$_$.jb;
  var isBlank = kotlin_kotlin.$_$.wa;
  var charArrayOf = kotlin_kotlin.$_$.w7;
  var split_0 = kotlin_kotlin.$_$.gb;
  var isCharSequence = kotlin_kotlin.$_$.p8;
  var trim = kotlin_kotlin.$_$.cc;
  var get_lastIndex_0 = kotlin_kotlin.$_$.b5;
  var MutableMap = kotlin_kotlin.$_$.d3;
  var Pool = kotlin_com_soywiz_korlibs_kds_kds.$_$.l1;
  var FastIdentityMap = kotlin_com_soywiz_korlibs_kds_kds.$_$.z;
  var fastArrayListOf = kotlin_com_soywiz_korlibs_kds_kds.$_$.y1;
  var get = kotlin_com_soywiz_korlibs_kds_kds.$_$.h2;
  var set = kotlin_com_soywiz_korlibs_kds_kds.$_$.p2;
  var contains = kotlin_com_soywiz_korlibs_kds_kds.$_$.x1;
  var clear = kotlin_com_soywiz_korlibs_kds_kds.$_$.w1;
  var Companion_getInstance_28 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.g3;
  var MultiBitmap = kotlin_com_soywiz_korlibs_korim_korim.$_$.l1;
  var AGTexture = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.w5;
  var toLong = kotlin_kotlin.$_$.i9;
  var get_baseMipmapLevel = kotlin_com_soywiz_korlibs_korim_korim.$_$.p1;
  var get_maxMipmapLevel = kotlin_com_soywiz_korlibs_korim_korim.$_$.r1;
  var Companion_getInstance_29 = kotlin_com_soywiz_korlibs_korma_korma.$_$.a7;
  var _RectangleInt___init__impl__1g5gox = kotlin_com_soywiz_korlibs_korma_korma.$_$.x4;
  var RectSlice = kotlin_com_soywiz_korlibs_korma_korma.$_$.y7;
  var Long = kotlin_kotlin.$_$.kc;
  var FastSmallSet = kotlin_com_soywiz_korlibs_kds_kds.$_$.b1;
  var FastArrayList_init_$Create$ = kotlin_com_soywiz_korlibs_kds_kds.$_$.b;
  var getAndRemove = kotlin_com_soywiz_korlibs_kds_kds.$_$.c2;
  var get_keys = kotlin_com_soywiz_korlibs_kds_kds.$_$.k2;
  var toList = kotlin_kotlin.$_$.k6;
  var AGBuffer = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.k5;
  var Pool_init_$Create$ = kotlin_com_soywiz_korlibs_kds_kds.$_$.g;
  var Buffer = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.o2;
  var AGVertexData = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.y5;
  var AGVertexArrayObject_init_$Create$ = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.g1;
  var Uint16Buffer__set_impl_g0kliu = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.x;
  var get_f32 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.i4;
  var _Matrix___get_a__impl__f7jypo = kotlin_com_soywiz_korlibs_korma_korma.$_$.g2;
  var _Matrix___get_b__impl__dm2icj = kotlin_com_soywiz_korlibs_korma_korma.$_$.h2;
  var _Matrix___get_c__impl__slf2ke = kotlin_com_soywiz_korlibs_korma_korma.$_$.i2;
  var _Matrix___get_d__impl__87eht = kotlin_com_soywiz_korlibs_korma_korma.$_$.j2;
  var _Matrix___get_tx__impl__yc1n9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.k3;
  var _Matrix___get_ty__impl__tryipg = kotlin_com_soywiz_korlibs_korma_korma.$_$.l3;
  var Float32Buffer__get_impl_659lhu = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.i;
  var _Vector2___get_x__impl__zywdz = kotlin_com_soywiz_korlibs_korma_korma.$_$.n6;
  var Float32Buffer__set_impl_34szne = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.j;
  var _Vector2___get_y__impl__ttldg6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.p6;
  var fillArrayVal = kotlin_kotlin.$_$.e8;
  var ShaderIndices_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.k3;
  var SamplerVarType_Sampler2D_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.t;
  var Sampler = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b5;
  var VarType_Byte4_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.u;
  var Attribute_init_$Create$ = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b1;
  var VarType_Float4_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.x;
  var Varying_init_$Create$ = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.d1;
  var VarType_UByte1_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.y;
  var Precision_LOW_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.r;
  var VarType_Float1_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.v;
  var DefaultShaders_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.j3;
  var ProgramLayout_init_$Create$ = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.c1;
  var ProgramBuilderDefault = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a6;
  var VertexShader = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h5;
  var If = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.z4;
  var FragmentShader = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.z3;
  var Program = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a5;
  var get_u16 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.w6;
  var ReturnablePool = kotlin_com_soywiz_korlibs_kds_kds.$_$.o1;
  var Companion_getInstance_30 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.f3;
  var Companion_getInstance_31 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.e3;
  var _AGColorMask___init__impl__j38ai8 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.o1;
  var Companion_getInstance_32 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.c3;
  var Signal = kotlin_com_soywiz_korlibs_korio_korio.$_$.r1;
  var setFloat32 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.g6;
  var setInt32 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.h6;
  var toByte = kotlin_kotlin.$_$.h9;
  var _RGBA___get_value__impl__hhco8v = kotlin_com_soywiz_korlibs_korim_korim.$_$.p;
  var asUShortArrayInt = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.r3;
  var arraycopy_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.j3;
  var toShort = kotlin_kotlin.$_$.j9;
  var arrayadd = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.y2;
  var get_i32 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.o4;
  var arraycopy_1 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.d3;
  var arrayfill = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.m3;
  var _Matrix___get_isNotNIL__impl__wjqa0f = kotlin_com_soywiz_korlibs_korma_korma.$_$.p2;
  var Matrix = kotlin_com_soywiz_korlibs_korma_korma.$_$.e9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var contains_0 = kotlin_kotlin.$_$.n3;
  var Matrix__transformX_impl_adb2o0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.d3;
  var Matrix__transformY_impl_aucp27 = kotlin_com_soywiz_korlibs_korma_korma.$_$.e3;
  var Companion_getInstance_33 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h3;
  var Companion_getInstance_34 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b3;
  var AGBatch = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.i5;
  var AGMultiBatch = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.p5;
  var draw = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.d6;
  var IntCompanionObject_getInstance = kotlin_kotlin.$_$.l2;
  var Companion_getInstance_35 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.z;
  var allocDirect = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.t2;
  var Matrix4_init_$Create$ = kotlin_com_soywiz_korlibs_korma_korma.$_$.j;
  var _Vector2___init__impl__67w0ru_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.h6;
  var Command_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.d7;
  var Companion_getInstance_36 = kotlin_com_soywiz_korlibs_korma_korma.$_$.y6;
  var draw_0 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.c6;
  var Enum = kotlin_kotlin.$_$.hc;
  var ProjViewUB_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.i3;
  var AGFrameBuffer_init_$Create$ = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.e1;
  var AGTextureDrawer = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.v5;
  var DeviceDimensionsProvider = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.i6;
  var DEFAULT_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.l3;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.i2;
  var BufferCache = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.q5;
  var AGTextureUnits_init_$Create$ = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.f1;
  var lazy = kotlin_kotlin.$_$.dd;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.p;
  var Companion_getInstance_37 = kotlin_com_soywiz_korlibs_korma_korma.$_$.k7;
  var Companion_getInstance_38 = kotlin_com_soywiz_korlibs_korma_korma.$_$.l7;
  var toMatrix4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.q9;
  var arrayfill_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.n3;
  var arraycopy_2 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.i3;
  var arrayequal = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.l3;
  var round = kotlin_kotlin.$_$.o9;
  var coerceAtLeast_0 = kotlin_kotlin.$_$.r9;
  var AGScissor = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.s5;
  var AGProgramWithUniforms = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.r5;
  var AGFeatures = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.o5;
  var MMatrix = kotlin_com_soywiz_korlibs_korma_korma.$_$.c9;
  var _AGScissor___get_left__impl__jiavfz = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.w1;
  var _AGScissor___get_top__impl__wmf8dv = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.z1;
  var _Vector2___init__impl__67w0ru_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.i6;
  var _Matrix___get_isNIL__impl__n63x5q = kotlin_com_soywiz_korlibs_korma_korma.$_$.o2;
  var _AGScissor___get_right__impl__3hpzkc = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.x1;
  var _AGScissor___get_bottom__impl__6wmhqj = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.u1;
  var Builder = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a4;
  var get_Float1 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.e5;
  var get_Float2 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.f5;
  var get_Float4 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.g5;
  var get_out = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.m4;
  var atan = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.c4;
  var texture2D = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.q4;
  var pow = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.o4;
  var sqrt = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.p4;
  var abs = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b4;
  var fract = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.f4;
  var get_lit = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.j4;
  var vec2 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.t4;
  var vec4 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.u4;
  var get_0 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.g4;
  var get_x = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.w4;
  var get_y = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.x4;
  var get_z = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.y4;
  var get_w = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.v4;
  var unaryMinus = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.s4;
  var minus = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.l4;
  var plus = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.n4;
  var times = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.r4;
  var div = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.d4;
  var eq = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.e4;
  var lt = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.k4;
  var le = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.i4;
  var gt = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h4;
  var _SizeInt___init__impl__vivn9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.c6;
  var objectCreate = kotlin_kotlin.$_$.d9;
  var _SizeInt___get_width__impl__swntg6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.f6;
  var _SizeInt___get_height__impl__d3sy61 = kotlin_com_soywiz_korlibs_korma_korma.$_$.e6;
  var Companion_getInstance_39 = kotlin_com_soywiz_korlibs_korma_korma.$_$.m7;
  var allocNoDirect = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.u2;
  var Mountable = kotlin_com_soywiz_korlibs_korio_korio.$_$.j2;
  var MountableVfs = kotlin_com_soywiz_korlibs_korio_korio.$_$.e;
  var AsyncDependency = kotlin_com_soywiz_korlibs_korinject_korinject.$_$.b;
  var Key_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s;
  var RequestContext = kotlin_com_soywiz_korlibs_korinject_korinject.$_$.c;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
  var CancellationException = kotlin_kotlin.$_$.w6;
  var cancel_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.z2;
  var InjectorAsyncDependency = kotlin_com_soywiz_korlibs_korinject_korinject.$_$.f;
  var emptyList = kotlin_kotlin.$_$.h4;
  var getKClassFromExpression = kotlin_kotlin.$_$.a;
  var KClass = kotlin_kotlin.$_$.ca;
  var Level_INFO_getInstance = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.c;
  var launchUnscopedAndWait = kotlin_com_soywiz_korlibs_korio_korio.$_$.c;
  var launchUnscoped = kotlin_com_soywiz_korlibs_korio_korio.$_$.y1;
  var launchUnscoped_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.z1;
  var arrayListOf = kotlin_kotlin.$_$.i3;
  var toList_0 = kotlin_kotlin.$_$.l6;
  var dispatch$default = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a1;
  var dispatch = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.o3;
  var onEvents = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.p3;
  var KMutableProperty0 = kotlin_kotlin.$_$.da;
  var interfaceMeta = kotlin_kotlin.$_$.m8;
  var KProperty0 = kotlin_kotlin.$_$.ga;
  var THROW_ISE = kotlin_kotlin.$_$.rc;
  var getLocalDelegateReference = kotlin_kotlin.$_$.g8;
  var Companion_getInstance_40 = kotlin_com_soywiz_korlibs_korio_korio.$_$.l1;
  var Companion_getInstance_41 = kotlin_kotlin.$_$.s2;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.y1;
  var TimeSpan__plus_impl_qdd6zo = kotlin_com_soywiz_korlibs_klock_klock.$_$.q;
  var IntArrayList = kotlin_com_soywiz_korlibs_kds_kds.$_$.i1;
  var intercepted = kotlin_kotlin.$_$.z6;
  var get_MODE_CANCELLABLE = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var TimeSpan__div_impl_l42f2r = kotlin_com_soywiz_korlibs_klock_klock.$_$.h;
  var clamp = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.v3;
  var maxOrNull = kotlin_kotlin.$_$.n5;
  var clamp_0 = kotlin_com_soywiz_korlibs_klock_klock.$_$.d1;
  var toRatio = kotlin_com_soywiz_korlibs_korma_korma.$_$.v9;
  var returnIfSuspended = kotlin_kotlin.$_$.f;
  var TimeSpan__times_impl_86ofia = kotlin_com_soywiz_korlibs_klock_klock.$_$.s;
  var withTimeout = kotlin_com_soywiz_korlibs_korio_korio.$_$.d;
  var TimeoutCancellationException = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var Ratio = kotlin_com_soywiz_korlibs_korma_korma.$_$.r9;
  var TimeSpan__hashCode_impl_izs3k5 = kotlin_com_soywiz_korlibs_klock_klock.$_$.i;
  var interpolate = kotlin_com_soywiz_korlibs_korma_korma.$_$.u9;
  var getExtra = kotlin_com_soywiz_korlibs_kds_kds.$_$.g2;
  var _Anchor___init__impl__4yyw24 = kotlin_com_soywiz_korlibs_korma_korma.$_$.u;
  var _Anchor___init__impl__4yyw24_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s;
  var _Anchor___init__impl__4yyw24_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.t;
  var _Rectangle___get_x__impl__vgifdj = kotlin_com_soywiz_korlibs_korma_korma.$_$.u4;
  var _Rectangle___get_y__impl__aqz5je = kotlin_com_soywiz_korlibs_korma_korma.$_$.v4;
  var _Rectangle___get_width__impl__y1u79l = kotlin_com_soywiz_korlibs_korma_korma.$_$.t4;
  var _Rectangle___get_height__impl__kro6o8 = kotlin_com_soywiz_korlibs_korma_korma.$_$.d4;
  var _MatrixTransform___init__impl__7axsoi = kotlin_com_soywiz_korlibs_korma_korma.$_$.n3;
  var Matrix__toTransform_impl_lr8urh = kotlin_com_soywiz_korlibs_korma_korma.$_$.a3;
  var _MatrixTransform___get_scaleX__impl__t9pp1f = kotlin_com_soywiz_korlibs_korma_korma.$_$.r3;
  var _MatrixTransform___get_scaleY__impl__g37z8 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s3;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.ed;
  var Bitmaps_getInstance = kotlin_com_soywiz_korlibs_korim_korim.$_$.y;
  var get_Bitmaps_transparent = kotlin_com_soywiz_korlibs_korim_korim.$_$.h1;
  var get_bmp = kotlin_com_soywiz_korlibs_korim_korim.$_$.q1;
  var toIntCeil = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.p6;
  var NativeImageOrBitmap32 = kotlin_com_soywiz_korlibs_korim_korim.$_$.m1;
  var numberToDouble = kotlin_kotlin.$_$.a9;
  var _Anchor___get_sx__impl__4wuc7c = kotlin_com_soywiz_korlibs_korma_korma.$_$.y;
  var _Anchor___get_sy__impl__xqgt9j = kotlin_com_soywiz_korlibs_korma_korma.$_$.z;
  var BaseEventListener = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.n3;
  var Companion_getInstance_42 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.x2;
  var Companion_getInstance_43 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.w2;
  var Companion_getInstance_44 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.v2;
  var get_indices = kotlin_kotlin.$_$.x4;
  var AGBlending__hashCode_impl_ywnf51 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.m1;
  var anyToString = kotlin_kotlin.$_$.t7;
  var AGBlending = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.j5;
  var Ref = kotlin_com_soywiz_korlibs_kds_kds.$_$.n1;
  var Rectangle__transformed_impl_5k4zxr = kotlin_com_soywiz_korlibs_korma_korma.$_$.r4;
  var Rectangle__normalized_impl_j0pmhl = kotlin_com_soywiz_korlibs_korma_korma.$_$.j4;
  var AGScissor__toRectOrNull_impl_bkzy1a = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.y1;
  var Rectangle__intersects_impl_bpzhh2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.e4;
  var Rectangle = kotlin_com_soywiz_korlibs_korma_korma.$_$.g9;
  var _AGScissor___init__impl__g8s683 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.t1;
  var Matrix__translated_impl_3xg5y = kotlin_com_soywiz_korlibs_korma_korma.$_$.j3;
  var Matrix__scaled$default_impl_qe0yl1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.n;
  var Matrix__pretranslated_impl_9mjs3v_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.u2;
  var Matrix__prescaled$default_impl_m96zqs = kotlin_com_soywiz_korlibs_korma_korma.$_$.k;
  var compareTo = kotlin_kotlin.$_$.b8;
  var Comparator = kotlin_kotlin.$_$.gc;
  var getOrNull = kotlin_kotlin.$_$.u4;
  var sortWith = kotlin_kotlin.$_$.a6;
  var _Rectangle___get_isNIL__impl__rbtsig = kotlin_com_soywiz_korlibs_korma_korma.$_$.f4;
  var Companion_getInstance_45 = kotlin_com_soywiz_korlibs_korma_korma.$_$.g7;
  var BoundsBuilder__plus_impl_cz7f7x = kotlin_com_soywiz_korlibs_korma_korma.$_$.n1;
  var _BoundsBuilder___get_bounds__impl__s1l1gx = kotlin_com_soywiz_korlibs_korma_korma.$_$.j1;
  var clamp_1 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.w3;
  var FastArrayList_init_$Create$_0 = kotlin_com_soywiz_korlibs_kds_kds.$_$.a;
  var toFastList = kotlin_com_soywiz_korlibs_kds_kds.$_$.u2;
  var Collection = kotlin_kotlin.$_$.x2;
  var MutableIterable = kotlin_kotlin.$_$.b3;
  var List = kotlin_kotlin.$_$.z2;
  var listOf = kotlin_kotlin.$_$.j5;
  var get_niceStr = kotlin_com_soywiz_korlibs_korio_korio.$_$.i4;
  var IntDeque = kotlin_com_soywiz_korlibs_kds_kds.$_$.j1;
  var _TimeSpan___get_microsecondsInt__impl__sej7yz = kotlin_com_soywiz_korlibs_klock_klock.$_$.l;
  var roundDecimalPlaces = kotlin_com_soywiz_korlibs_korma_korma.$_$.ca;
  var convertRange = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.c4;
  var coerceAtMost = kotlin_kotlin.$_$.t9;
  var TimeSpan__div_impl_l42f2r_0 = kotlin_com_soywiz_korlibs_klock_klock.$_$.g;
  var toFrequency = kotlin_com_soywiz_korlibs_klock_klock.$_$.g1;
  var _Frequency___get_hertz__impl__9m7k6x = kotlin_com_soywiz_korlibs_klock_klock.$_$.d;
  var convertRange_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.a4;
  var ShapeBuilder = kotlin_com_soywiz_korlibs_korim_korim.$_$.s2;
  var EmptyShape_getInstance = kotlin_com_soywiz_korlibs_korim_korim.$_$.e1;
  var Resourceable = kotlin_com_soywiz_korlibs_korio_korio.$_$.k3;
  var readBitmapSlice = kotlin_com_soywiz_korlibs_korim_korim.$_$.d;
  var get_Bitmaps_white = kotlin_com_soywiz_korlibs_korim_korim.$_$.i1;
  var KMutableProperty1 = kotlin_kotlin.$_$.ea;
  var Char = kotlin_kotlin.$_$.ec;
  var Vector2__component1_impl_k3h45m = kotlin_com_soywiz_korlibs_korma_korma.$_$.k6;
  var Vector2__component2_impl_kkiqjt = kotlin_com_soywiz_korlibs_korma_korma.$_$.l6;
  var HorizontalAlign__getOffsetX_impl_urzzxf = kotlin_com_soywiz_korlibs_korim_korim.$_$.v;
  var VerticalAlign__getOffsetY_impl_iso0y6 = kotlin_com_soywiz_korlibs_korim_korim.$_$.w;
  var readFont = kotlin_com_soywiz_korlibs_korim_korim.$_$.c;
  var get_DefaultTtfFontAsBitmap = kotlin_com_soywiz_korlibs_korim_korim.$_$.x1;
  var Companion_getInstance_46 = kotlin_com_soywiz_korlibs_korim_korim.$_$.c1;
  var get_DefaultStringTextRenderer = kotlin_com_soywiz_korlibs_korim_korim.$_$.k2;
  var Text2TextRendererActions = kotlin_com_soywiz_korlibs_korim_korim.$_$.n2;
  var Entry = kotlin_com_soywiz_korlibs_korim_korim.$_$.l2;
  var FontMetrics = kotlin_com_soywiz_korlibs_korim_korim.$_$.y1;
  var TextMetrics = kotlin_com_soywiz_korlibs_korim_korim.$_$.b2;
  var BitmapFont = kotlin_com_soywiz_korlibs_korim_korim.$_$.w1;
  var Font = kotlin_com_soywiz_korlibs_korim_korim.$_$.z1;
  var getTextBounds = kotlin_com_soywiz_korlibs_korim_korim.$_$.c2;
  var TextMetricsResult = kotlin_com_soywiz_korlibs_korim_korim.$_$.a2;
  var invoke = kotlin_com_soywiz_korlibs_korim_korim.$_$.o2;
  var firstOrNull = kotlin_kotlin.$_$.o4;
  var LineInfo = kotlin_com_soywiz_korlibs_korim_korim.$_$.m2;
  var _VerticalAlign___get_ratioFake__impl__1h2fwv = kotlin_com_soywiz_korlibs_korim_korim.$_$.x;
  var Companion_getInstance_47 = kotlin_com_soywiz_korlibs_korim_korim.$_$.d1;
  var _Scale___init__impl__ov1qs1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.l5;
  var Companion_getInstance_48 = kotlin_com_soywiz_korlibs_korma_korma.$_$.f7;
  var ColorTransformMul = kotlin_com_soywiz_korlibs_korim_korim.$_$.t1;
  var _Scale___get_scaleAvg__impl__cb1hs2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.n5;
  var _Scale___get_scaleX__impl__iylwx0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.o5;
  var _Scale___get_scaleY__impl__9v0k57 = kotlin_com_soywiz_korlibs_korma_korma.$_$.p5;
  var _Rectangle___get_size__impl__14eamq = kotlin_com_soywiz_korlibs_korma_korma.$_$.l4;
  var _MatrixTransform___get_x__impl__5z12ed = kotlin_com_soywiz_korlibs_korma_korma.$_$.v3;
  var _MatrixTransform___get_y__impl__mulenu = kotlin_com_soywiz_korlibs_korma_korma.$_$.w3;
  var _MatrixTransform___get_skewX__impl__luxf0b = kotlin_com_soywiz_korlibs_korma_korma.$_$.t3;
  var _MatrixTransform___get_skewY__impl__6yp21w = kotlin_com_soywiz_korlibs_korma_korma.$_$.u3;
  var _MatrixTransform___get_rotation__impl__d5fsj = kotlin_com_soywiz_korlibs_korma_korma.$_$.o3;
  var Matrix__times_impl_aro03c = kotlin_com_soywiz_korlibs_korma_korma.$_$.z2;
  var Matrix__inverted_impl_3pqbyv = kotlin_com_soywiz_korlibs_korma_korma.$_$.m2;
  var VectorPath = kotlin_com_soywiz_korlibs_korma_korma.$_$.q8;
  var _Rectangle___get_left__impl__sgtjiw = kotlin_com_soywiz_korlibs_korma_korma.$_$.h4;
  var _Rectangle___get_top__impl__3kuxui = kotlin_com_soywiz_korlibs_korma_korma.$_$.o4;
  var _Rectangle___get_right__impl__7wa90z = kotlin_com_soywiz_korlibs_korma_korma.$_$.k4;
  var _Rectangle___get_bottom__impl__1duj44 = kotlin_com_soywiz_korlibs_korma_korma.$_$.x3;
  var _Rectangle___get_topLeft__impl__xiee25 = kotlin_com_soywiz_korlibs_korma_korma.$_$.p4;
  var _Rectangle___get_topRight__impl__6efxlk = kotlin_com_soywiz_korlibs_korma_korma.$_$.q4;
  var _Rectangle___get_bottomRight__impl__oqq9ry = kotlin_com_soywiz_korlibs_korma_korma.$_$.z3;
  var _Rectangle___get_bottomLeft__impl__2pw8cj = kotlin_com_soywiz_korlibs_korma_korma.$_$.y3;
  var Companion_getInstance_49 = kotlin_com_soywiz_korlibs_korma_korma.$_$.r7;
  var interpolate_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s9;
  var get_portableSimpleName = kotlin_com_soywiz_korlibs_korio_korio.$_$.c3;
  var _Angle___get_degreesD__impl__9qro6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.c1;
  var _Angle___get_absoluteValue__impl__4qoakv = kotlin_com_soywiz_korlibs_korma_korma.$_$.b1;
  var niceStr = kotlin_com_soywiz_korlibs_korio_korio.$_$.j4;
  var _RGBA___get_hexString__impl__kocngm = kotlin_com_soywiz_korlibs_korim_korim.$_$.l;
  var _RGBA___get_rgb__impl__tijaqt = kotlin_com_soywiz_korlibs_korim_korim.$_$.o;
  var toStringDecimal = kotlin_com_soywiz_korlibs_korio_korio.$_$.k4;
  var toStringDecimal_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.l4;
  var _Matrix___get_isIdentity__impl__oe9whb = kotlin_com_soywiz_korlibs_korma_korma.$_$.n2;
  var Rectangle__translated_impl_5ia2y0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s4;
  var _Frequency___get_timeSpan__impl__f9mrmt = kotlin_com_soywiz_korlibs_klock_klock.$_$.e;
  var TimeSpan__times_impl_86ofia_0 = kotlin_com_soywiz_korlibs_klock_klock.$_$.t;
  var TimeSpan__times_impl_86ofia_1 = kotlin_com_soywiz_korlibs_klock_klock.$_$.u;
  var NotImplementedError = kotlin_kotlin.$_$.mc;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.j;
  var _SizeInt___init__impl__vivn9_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.b6;
  var EventResult = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.q3;
  var replace = kotlin_kotlin.$_$.eb;
  var Key_F7_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b;
  var Key_F12_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a;
  var PreventDefaultException = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.v3;
  var DateTime__minus_impl_10njw8 = kotlin_com_soywiz_korlibs_klock_klock.$_$.b;
  var toFloat = kotlin_com_soywiz_korlibs_korma_korma.$_$.o9;
  var toRef = kotlin_com_soywiz_korlibs_kds_kds.$_$.z2;
  var _MatrixTransform___get_scale__impl__8ztdah = kotlin_com_soywiz_korlibs_korma_korma.$_$.p3;
  var _MatrixTransform___get_scaleAvg__impl__ku8ljx = kotlin_com_soywiz_korlibs_korma_korma.$_$.q3;
  var Event = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.r3;
  var SizeInt = kotlin_com_soywiz_korlibs_korma_korma.$_$.i9;
  var Ref_0 = kotlin_com_soywiz_korlibs_kds_kds.$_$.m1;
  var toInt = kotlin_com_soywiz_korlibs_korma_korma.$_$.p9;
  var toIntRound = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.t6;
  var _Anchor___get_doubleX__impl__n5i2d2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.v;
  var _Anchor___get_doubleY__impl__5o4ep5 = kotlin_com_soywiz_korlibs_korma_korma.$_$.w;
  var injector = kotlin_com_soywiz_korlibs_korinject_korinject.$_$.a;
  var get_lastIndex_1 = kotlin_kotlin.$_$.d5;
  var Companion_getInstance_50 = kotlin_com_soywiz_korlibs_korma_korma.$_$.i7;
  var Rectangle__expanded_impl_r32sv9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.b4;
  var Property = kotlin_com_soywiz_korlibs_kds_kds.$_$.y;
  var toIntCeil_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.o6;
  var Matrix__prescaled$default_impl_m96zqs_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.l;
  var PolylineShape = kotlin_com_soywiz_korlibs_korim_korim.$_$.r2;
  var FillShape = kotlin_com_soywiz_korlibs_korim_korim.$_$.q2;
  var TextShape = kotlin_com_soywiz_korlibs_korim_korim.$_$.t2;
  var CompoundShape = kotlin_com_soywiz_korlibs_korim_korim.$_$.p2;
  var toCurvesList = kotlin_com_soywiz_korlibs_korma_korma.$_$.w8;
  var StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.a;
  var toStrokePointsList = kotlin_com_soywiz_korlibs_korma_korma.$_$.u7;
  var BoundsBuilder__plus_impl_cz7f7x_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.p1;
  var _BoundsBuilder___get_xmax__impl__gsz0km = kotlin_com_soywiz_korlibs_korma_korma.$_$.r1;
  var _BoundsBuilder___get_xmin__impl__o2sib0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s1;
  var _BoundsBuilder___get_ymax__impl__oia4uz = kotlin_com_soywiz_korlibs_korma_korma.$_$.u1;
  var _BoundsBuilder___get_ymin__impl__5n2e8j = kotlin_com_soywiz_korlibs_korma_korma.$_$.v1;
  var toAGScissor = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.g6;
  var get_cachedPoints = kotlin_com_soywiz_korlibs_korma_korma.$_$.w7;
  var getPoints2List = kotlin_com_soywiz_korlibs_korma_korma.$_$.x7;
  var plus_0 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.f6;
  var _MarginInt___init__impl__dx1aag = kotlin_com_soywiz_korlibs_korma_korma.$_$.a2;
  var Companion_getInstance_51 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.z2;
  var AGStencilOpFunc__withEnabled_impl_mpcwmr = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.c2;
  var AGStencilOpFunc__withCompareMode$default_impl_rzbauv = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.i1;
  var AGStencilReference__withWriteMask$default_impl_b7j7b4 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.l1;
  var Companion_getInstance_52 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.d3;
  var AGStencilOpFunc__withActionOnBothPass_impl_qbn6at = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b2;
  var Companion_getInstance_53 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a3;
  var AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h1;
  var AGStencilReference__withReadMask$default_impl_7mdffx = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.j1;
  var Winding_NON_ZERO_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.g;
  var LineScaleMode_NONE_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.d;
  var LineCap_BUTT_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.b;
  var LineJoin_MITER_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.c;
  var StrokeInfo = kotlin_com_soywiz_korlibs_korma_korma.$_$.c8;
  var AGCompareMode__inverted_impl_7xxk8m = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.q1;
  var AGStencilReference__withReferenceValue$default_impl_2trj0v = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.k1;
  var _AGColorMask___init__impl__j38ai8_0 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.n1;
  var FloatCompanionObject_getInstance = kotlin_kotlin.$_$.k2;
  var AGScissor__hashCode_impl_x18ye4 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.v1;
  var Companion_getInstance_54 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.y2;
  var AGDrawType = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.n5;
  var AGColorMask = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.l5;
  var AGStencilOpFunc = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.t5;
  var AGStencilReference = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.u5;
  var AGCullFace = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.m5;
  var AGDrawType__hashCode_impl_ylaury = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.s1;
  var AGColorMask__hashCode_impl_g9082f = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.p1;
  var AGStencilOpFunc__hashCode_impl_nopebb = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a2;
  var AGStencilReference__hashCode_impl_52zufx = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.d2;
  var AGCullFace__hashCode_impl_t4e5ur = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.r1;
  var floatArrayListOf = kotlin_com_soywiz_korlibs_kds_kds.$_$.a2;
  var _Float32Buffer___init__impl__403k2m = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.g;
  var _Float32Buffer___get_buffer__impl__x5nu9x = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.h;
  var AGVertexArrayObject = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.x5;
  var Matrix__premultiplied_impl_rsndx4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.r2;
  var _RGBA___get_premultiplied__impl__3bulqc = kotlin_com_soywiz_korlibs_korim_korim.$_$.m;
  var applyMatrixBounds = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b6;
  var draw_1 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.e6;
  var UniformBlock = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.d5;
  var UniformBlockBuffer = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.c5;
  var VarType_Float2_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.w;
  var get_PI = kotlin_kotlin.$_$.l9;
  var Precision_MEDIUM_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.s;
  var Companion_getInstance_55 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.u2;
  var Companion_getInstance_56 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.t2;
  var Bitmap32 = kotlin_com_soywiz_korlibs_korim_korim.$_$.f1;
  var _RgbaPremultipliedArray___init__impl__lx83hy = kotlin_com_soywiz_korlibs_korim_korim.$_$.u;
  var Matrix__preconcated_impl_s9s2ig = kotlin_com_soywiz_korlibs_korma_korma.$_$.q2;
  var _Vector4___init__impl__rdvxwo = kotlin_com_soywiz_korlibs_korma_korma.$_$.r6;
  var GradientPaint = kotlin_com_soywiz_korlibs_korim_korim.$_$.i2;
  var Matrix__scaled_impl_ogn4b6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.w2;
  var BitmapPaint = kotlin_com_soywiz_korlibs_korim_korim.$_$.h2;
  var NonePaint = kotlin_com_soywiz_korlibs_korim_korim.$_$.j2;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(Korge$_init_$slambda_ys8r4w, 'Korge$<init>$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(Korge, 'Korge', classMeta, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(KorgeDisplayMode, 'KorgeDisplayMode', classMeta);
  setMetadataFor(KorgeRunner$invoke$slambda$slambda$slambda, 'KorgeRunner$invoke$slambda$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(KorgeRunner$invoke$slambda$slambda, 'KorgeRunner$invoke$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(ModuleArgs, 'ModuleArgs', classMeta);
  setMetadataFor(KorgeRunner$invoke$slambda, 'KorgeRunner$invoke$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(KorgeRunner$prepareViewsBase$slambda, 'KorgeRunner$prepareViewsBase$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(KorgeRunner$prepareViewsBase$slambda_1, 'KorgeRunner$prepareViewsBase$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(KorgeRunner$prepareViewsBase$lambda$slambda, 'KorgeRunner$prepareViewsBase$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($invokeCOROUTINE$0, '$invokeCOROUTINE$0', classMeta, CoroutineImpl);
  setMetadataFor($prepareViewsCOROUTINE$2, '$prepareViewsCOROUTINE$2', classMeta, CoroutineImpl);
  setMetadataFor(KorgeRunner, 'KorgeRunner', objectMeta, VOID, VOID, VOID, VOID, [1, 0, 8]);
  setMetadataFor(Korge$slambda, 'Korge$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(Korge$slambda_1, 'Korge$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(KorgeReload, 'KorgeReload', objectMeta);
  setMetadataFor(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', classMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(ReloadClassContext, 'ReloadClassContext', classMeta);
  setMetadataFor($debugBmpFontCOROUTINE$4, '$debugBmpFontCOROUTINE$4', classMeta, CoroutineImpl);
  setMetadataFor(InputKeys, 'InputKeys', classMeta);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(Input, 'Input', classMeta);
  setMetadataFor(KeysEvents$down$slambda, 'KeysEvents$down$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(KeysEvents$up$slambda, 'KeysEvents$up$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(KeysEvents$lambda$slambda, 'KeysEvents$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(KeysEvents$lambda$slambda_1, 'KeysEvents$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(KeysEvents$lambda$slambda_3, 'KeysEvents$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(KeysEvents, 'KeysEvents', classMeta, VOID, [Closeable]);
  setMetadataFor(DefaultViewport, 'DefaultViewport', objectMeta);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(Props, 'Props', classMeta, VOID, [MutableMap]);
  setMetadataFor($configureLoggerFromPropertiesCOROUTINE$5, '$configureLoggerFromPropertiesCOROUTINE$5', classMeta, CoroutineImpl);
  setMetadataFor(Entry_0, 'Entry', classMeta);
  setMetadataFor(AgAutoFreeManager, 'AgAutoFreeManager', classMeta, VOID, [Closeable]);
  setMetadataFor(BitmapTextureInfo, 'BitmapTextureInfo', classMeta);
  setMetadataFor(AgBitmapTextureManager, 'AgBitmapTextureManager', classMeta, VOID, [Closeable]);
  setMetadataFor(AgBufferManager, 'AgBufferManager', classMeta);
  setMetadataFor(AgCachedBuffer, 'AgCachedBuffer', classMeta);
  setMetadataFor(BatchBuffers, 'BatchBuffers', classMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(BatchBuilder2D, 'BatchBuilder2D', classMeta);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(LineRenderBatcher, 'LineRenderBatcher', classMeta);
  setMetadataFor(FlushKind, 'FlushKind', classMeta, Enum);
  function get_windowToGlobalScaleAvg() {
    return _Scale___get_scaleAvg__impl__cb1hs2(_MatrixTransform___get_scale__impl__8ztdah(this.uac()));
  }
  function get_globalToWindowScaleAvg() {
    return _MatrixTransform___get_scaleAvg__impl__ku8ljx(this.pac());
  }
  function windowToGlobalCoords(pos) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var tmp0_transform = this.rac();
      if (_Matrix___get_isNIL__impl__n63x5q(tmp0_transform)) {
        tmp$ret$0 = pos;
        break $l$block;
      }
      tmp$ret$0 = _Vector2___init__impl__67w0ru(_Matrix___get_a__impl__f7jypo(tmp0_transform) * _Vector2___get_x__impl__zywdz(pos) + _Matrix___get_c__impl__slf2ke(tmp0_transform) * _Vector2___get_y__impl__ttldg6(pos) + _Matrix___get_tx__impl__yc1n9(tmp0_transform), _Matrix___get_d__impl__87eht(tmp0_transform) * _Vector2___get_y__impl__ttldg6(pos) + _Matrix___get_b__impl__dm2icj(tmp0_transform) * _Vector2___get_x__impl__zywdz(pos) + _Matrix___get_ty__impl__tryipg(tmp0_transform));
    }
    return tmp$ret$0;
  }
  setMetadataFor(BoundsProvider, 'BoundsProvider', interfaceMeta);
  setMetadataFor(RenderContext, 'RenderContext', classMeta, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, Closeable]);
  setMetadataFor(RenderContext2D, 'RenderContext2D', classMeta);
  setMetadataFor(SDFShaders, 'SDFShaders', objectMeta, Builder);
  setMetadataFor(TextureBase, 'TextureBase', classMeta, VOID, [Closeable]);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(TexturedVertexArray, 'TexturedVertexArray', classMeta);
  setMetadataFor(ResourcesRoot$init$slambda, 'ResourcesRoot$init$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor($initCOROUTINE$6, '$initCOROUTINE$6', classMeta, CoroutineImpl);
  setMetadataFor(ResourcesRoot, 'ResourcesRoot', classMeta, VOID, [AsyncDependency], VOID, VOID, [0, 1]);
  setMetadataFor($initCOROUTINE$9, '$initCOROUTINE$9', classMeta, CoroutineImpl);
  setMetadataFor($sceneAfterDestroyInternalCOROUTINE$10, '$sceneAfterDestroyInternalCOROUTINE$10', classMeta, CoroutineImpl);
  setMetadataFor(Scene, 'Scene', classMeta, VOID, [InjectorAsyncDependency, CoroutineScope], VOID, VOID, [1, 0]);
  setMetadataFor(EmptyScene, 'EmptyScene', classMeta, Scene, VOID, VOID, VOID, [0, 1]);
  setMetadataFor(SceneContainer$lambda$slambda$slambda, 'SceneContainer$lambda$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(VisitEntry, 'VisitEntry', classMeta);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(SceneContainer$lambda$slambda, 'SceneContainer$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(SceneContainer$_changeTo$slambda_1, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_3, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_5, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_7, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_9, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_11, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($_changeToCOROUTINE$13, '$_changeToCOROUTINE$13', classMeta, CoroutineImpl);
  setMetadataFor($_changeToCOROUTINE$14, '$_changeToCOROUTINE$14', classMeta, CoroutineImpl);
  setMetadataFor(BaseView, 'BaseView', classMeta, BaseEventListener);
  setMetadataFor(View, 'View', classMeta, BaseView);
  setMetadataFor(Container, 'Container', classMeta, View);
  setMetadataFor(CachedContainer, 'CachedContainer', classMeta, Container);
  setMetadataFor(FixedSizeCachedContainer, 'FixedSizeCachedContainer', classMeta, CachedContainer);
  setMetadataFor(UIView, 'UIView', classMeta, FixedSizeCachedContainer);
  setMetadataFor(SceneContainer, 'SceneContainer', classMeta, UIView, [UIView, CoroutineScope], VOID, VOID, [2, 4, 6, 3]);
  function start(prev, next) {
    return Unit_getInstance();
  }
  function end(prev, next) {
    return Unit_getInstance();
  }
  function render(ctx, prev, next, ratio) {
    return Unit_getInstance();
  }
  setMetadataFor(TransitionProcess, 'TransitionProcess', interfaceMeta);
  setMetadataFor(TransitionView, 'TransitionView', classMeta, Container);
  setMetadataFor(Transition$1, VOID, classMeta, VOID, [TransitionProcess]);
  setMetadataFor(withEasing$1$create$1, VOID, classMeta, VOID, [TransitionProcess]);
  setMetadataFor(withEasing$1, VOID, classMeta);
  setMetadataFor(RCollection, 'RCollection', classMeta);
  setMetadataFor(Stats, 'Stats', classMeta);
  setMetadataFor(MsdfRender, 'MsdfRender', objectMeta);
  setMetadataFor(TimerComponents, 'TimerComponents', classMeta, VOID, VOID, VOID, VOID, [1, 0]);
  setMetadataFor(TimerRef, 'TimerRef', classMeta);
  setMetadataFor(TweenComponent, 'TweenComponent', classMeta);
  setMetadataFor(tween$slambda, 'tween$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor($tweenCOROUTINE$17, '$tweenCOROUTINE$17', classMeta, CoroutineImpl);
  setMetadataFor(V2, 'V2', classMeta);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(InternalViewAutoscaling, 'InternalViewAutoscaling', classMeta);
  setMetadataFor(RectBase, 'RectBase', classMeta, View);
  setMetadataFor(BaseImage, 'BaseImage', classMeta, RectBase);
  setMetadataFor(BaseGraphics, 'BaseGraphics', classMeta, BaseImage);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(BlendMode, 'BlendMode', classMeta);
  setMetadataFor(CacheTexture, 'CacheTexture', classMeta, VOID, [Closeable]);
  setMetadataFor(ZIndexComparator, 'ZIndexComparator', objectMeta, VOID, [Comparator]);
  setMetadataFor(ContainerCollection$iterator$1, VOID, classMeta);
  setMetadataFor(ContainerCollection, 'ContainerCollection', classMeta, VOID, [Collection, MutableIterable, List]);
  setMetadataFor(CpuGraphics, 'CpuGraphics', classMeta, BaseGraphics);
  setMetadataFor(DummyView, 'DummyView', classMeta, View);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor(FixedSizeContainer, 'FixedSizeContainer', classMeta, Container);
  setMetadataFor(SContainer, 'SContainer', classMeta, FixedSizeContainer);
  setMetadataFor(TimeSlidingWindow, 'TimeSlidingWindow', classMeta);
  setMetadataFor(GraphicsRenderer, 'GraphicsRenderer', classMeta, Enum);
  setMetadataFor(Graphics, 'Graphics', classMeta, Container);
  setMetadataFor($forceLoadSourceFileCOROUTINE$18, '$forceLoadSourceFileCOROUTINE$18', classMeta, CoroutineImpl);
  function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
    currentVfs = currentVfs === VOID ? views.d9n_1 : currentVfs;
    sourceFile = sourceFile === VOID ? null : sourceFile;
    return $super === VOID ? this.hc1(views, currentVfs, sourceFile, $completion) : $super.hc1.call(this, views, currentVfs, sourceFile, $completion);
  }
  setMetadataFor(ViewFileRef, 'ViewFileRef', interfaceMeta, VOID, VOID, VOID, VOID, [3]);
  setMetadataFor(Image, 'Image', classMeta, BaseImage, [BaseImage, ViewFileRef], VOID, VOID, [3]);
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor(Stage, 'Stage', classMeta, FixedSizeContainer, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor(Text$_renderInternal$slambda, 'Text$_renderInternal$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($forceLoadFontSourceCOROUTINE$19, '$forceLoadFontSourceCOROUTINE$19', classMeta, CoroutineImpl);
  setMetadataFor(Text, 'Text', classMeta, Container, VOID, VOID, VOID, [2]);
  setMetadataFor(ColorReference, 'ColorReference', interfaceMeta);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  function render_0(view, ctx) {
    return view.sb0(ctx);
  }
  function beforeRender(view, ctx) {
    return Unit_getInstance();
  }
  function afterRender(view, ctx) {
    return Unit_getInstance();
  }
  setMetadataFor(ViewRenderPhase, 'ViewRenderPhase', interfaceMeta);
  setMetadataFor(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, 'ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(Mixin_0, 'Mixin', classMeta, VOID, [ViewFileRef], VOID, VOID, [3]);
  setMetadataFor(Views$close$slambda, 'Views$close$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($initCOROUTINE$20, '$initCOROUTINE$20', classMeta, CoroutineImpl);
  setMetadataFor($closeSuspendCOROUTINE$21, '$closeSuspendCOROUTINE$21', classMeta, CoroutineImpl);
  setMetadataFor(Views, 'Views', classMeta, BaseEventListener, [BaseEventListener, CoroutineScope, BoundsProvider, Closeable, DeviceDimensionsProvider], VOID, VOID, [0]);
  setMetadataFor(Base, 'Base', classMeta, VOID, [BoundsProvider]);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(UpdateEvent, 'UpdateEvent', classMeta, Event);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor(ViewsUpdateEvent, 'ViewsUpdateEvent', classMeta, Event);
  setMetadataFor(Companion_16, 'Companion', objectMeta);
  setMetadataFor(ViewsResizedEvent, 'ViewsResizedEvent', classMeta, Event);
  setMetadataFor($viewsCOROUTINE$22, '$viewsCOROUTINE$22', classMeta, CoroutineImpl);
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  function get_recommendedFilterScale() {
    return 1.0;
  }
  function computeBorder(texWidth, texHeight) {
    return Companion_getInstance_50().t3f_1;
  }
  setMetadataFor(Filter, 'Filter', interfaceMeta);
  setMetadataFor(RenderToTextureResult, 'RenderToTextureResult', classMeta);
  setMetadataFor(IdentityFilter, 'IdentityFilter', classMeta, VOID, [Filter]);
  setMetadataFor(Companion_18, 'Companion', objectMeta, IdentityFilter);
  setMetadataFor(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', classMeta, VOID, [ViewRenderPhase]);
  setMetadataFor(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', classMeta, VOID, [ViewRenderPhase]);
  setMetadataFor(PointsResult, 'PointsResult', classMeta);
  setMetadataFor(GpuShapeView, 'GpuShapeView', classMeta, View);
  setMetadataFor(ScissorCommand, 'ScissorCommand', classMeta);
  setMetadataFor(ClearCommand, 'ClearCommand', classMeta);
  setMetadataFor(ShapeCommand, 'ShapeCommand', classMeta);
  setMetadataFor(GpuShapeViewCommands, 'GpuShapeViewCommands', classMeta);
  setMetadataFor(ShapeViewUB, 'ShapeViewUB', objectMeta, UniformBlock);
  setMetadataFor(PaintShader, 'PaintShader', classMeta);
  setMetadataFor(GpuShapeViewPrograms, 'GpuShapeViewPrograms', objectMeta);
  setMetadataFor(KorgeReloadInternal$1, VOID, classMeta, KorgeReloadInternalImpl);
  //endregion
  function Companion() {
    Companion_instance = this;
    this.q9i_1 = Companion_getInstance().kz('Korge');
    this.r9i_1 = 'korlibs.korge.unknown';
  }
  var Companion_instance;
  function Companion_getInstance_57() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Korge$_init_$lambda_95dffl($this$null) {
    return Unit_getInstance();
  }
  function Korge$_init_$slambda_ys8r4w(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Korge$_init_$slambda_ys8r4w).b9j = function ($this$null, $completion) {
    var tmp = this.c9j($this$null, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Korge$_init_$slambda_ys8r4w).mi = function (p1, $completion) {
    return this.b9j(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Korge$_init_$slambda_ys8r4w).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Korge$_init_$slambda_ys8r4w).c9j = function ($this$null, completion) {
    var i = new Korge$_init_$slambda_ys8r4w(completion);
    i.a9j_1 = $this$null;
    return i;
  };
  function Korge$_init_$slambda_ys8r4w_0(resultContinuation) {
    var i = new Korge$_init_$slambda_ys8r4w(resultContinuation);
    var l = function ($this$null, $completion) {
      return i.b9j($this$null, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Korge$_init_$lambda_95dffl_0(it) {
    return new Stage(it);
  }
  function Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, unit) {
    Companion_getInstance_57();
    var tmp;
    if (args === VOID) {
      var tmp$ret$2;
      var tmp$ret$2_0;
      // Inline function 'kotlin.arrayOf' call
      var tmp$ret$1;
      var tmp$ret$1_0;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = [];
      tmp$ret$0_0 = Unit_getInstance();
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$1_0 = Unit_getInstance();
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$2_0 = Unit_getInstance();
      tmp = tmp$ret$2;
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_getInstance_0() : timeProvider;
    injector = injector === VOID ? new AsyncInjector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_57().r9i_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_62().f9j_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().p9j_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_58().d3z() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().k48_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0(null);
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().j48_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    unit = unit === VOID ? Unit_getInstance() : unit;
    this.t9j_1 = args;
    this.u9j_1 = imageFormats;
    this.v9j_1 = gameWindow;
    this.w9j_1 = mainSceneClass;
    this.x9j_1 = timeProvider;
    this.y9j_1 = injector;
    this.z9j_1 = configInjector;
    this.a9k_1 = debug;
    this.b9k_1 = trace;
    this.c9k_1 = context;
    this.d9k_1 = fullscreen;
    this.e9k_1 = blocking;
    this.f9k_1 = gameId;
    this.g9k_1 = settingsFolder;
    this.h9k_1 = batchMaxQuads;
    this.i9k_1 = windowSize;
    this.j9k_1 = virtualSize;
    this.k9k_1 = displayMode;
    this.l9k_1 = title;
    this.m9k_1 = backgroundColor;
    this.n9k_1 = quality;
    this.o9k_1 = icon;
    this.p9k_1 = multithreaded;
    this.q9k_1 = forceRenderEveryFrame;
    this.r9k_1 = main;
    this.s9k_1 = debugAg;
    this.t9k_1 = debugFontExtraScale;
    this.u9k_1 = debugFontColor;
    this.v9k_1 = stageBuilder;
    this.w9k_1 = targetFps;
    this.x9k_1 = unit;
  }
  protoOf(Korge).y9k = function (entry, $completion) {
    var tmp0 = KorgeRunner_getInstance().a9l(this.z9k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, entry), $completion);
    return tmp0;
  };
  protoOf(Korge).b9l = function (args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, unit);
  };
  protoOf(Korge).z9k = function (args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, unit, $super) {
    args = args === VOID ? this.t9j_1 : args;
    imageFormats = imageFormats === VOID ? this.u9j_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.v9j_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.w9j_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.x9j_1 : timeProvider;
    injector = injector === VOID ? this.y9j_1 : injector;
    configInjector = configInjector === VOID ? this.z9j_1 : configInjector;
    debug = debug === VOID ? this.a9k_1 : debug;
    trace = trace === VOID ? this.b9k_1 : trace;
    context = context === VOID ? this.c9k_1 : context;
    fullscreen = fullscreen === VOID ? this.d9k_1 : fullscreen;
    blocking = blocking === VOID ? this.e9k_1 : blocking;
    gameId = gameId === VOID ? this.f9k_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.g9k_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.h9k_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.i9k_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.j9k_1 : virtualSize;
    displayMode = displayMode === VOID ? this.k9k_1 : displayMode;
    title = title === VOID ? this.l9k_1 : title;
    backgroundColor = backgroundColor === VOID ? this.m9k_1 : backgroundColor;
    quality = quality === VOID ? this.n9k_1 : quality;
    icon = icon === VOID ? this.o9k_1 : icon;
    multithreaded = multithreaded === VOID ? this.p9k_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.q9k_1 : forceRenderEveryFrame;
    main = main === VOID ? this.r9k_1 : main;
    debugAg = debugAg === VOID ? this.s9k_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.t9k_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.u9k_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.v9k_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.w9k_1 : targetFps;
    unit = unit === VOID ? this.x9k_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.b9l(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, unit);
    } else {
      var tmp_0 = $super.b9l;
      var tmp_1 = new Size(windowSize);
      var tmp_2 = new Size(virtualSize);
      var tmp_3 = backgroundColor;
      var tmp_4 = tmp_3 == null ? null : new RGBA(tmp_3);
      var tmp_5 = new RGBA(debugFontColor);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, tmp_1, tmp_2, displayMode, title, tmp_4, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, tmp_5, stageBuilder, targetFps, Unit_getInstance());
    }
    return tmp;
  };
  protoOf(Korge).toString = function () {
    var tmp = toString(this.t9j_1);
    var tmp_0 = toString_0(this.c9k_1);
    var tmp_1 = new Size(this.i9k_1);
    var tmp_2 = new Size(this.j9k_1);
    var tmp_3 = this.m9k_1;
    var tmp_4 = tmp_3 == null ? null : new RGBA(tmp_3);
    var tmp_5 = new RGBA(this.u9k_1);
    return 'Korge(args=' + tmp + ', imageFormats=' + this.u9j_1 + ', gameWindow=' + this.v9j_1 + ', mainSceneClass=' + this.w9j_1 + ', timeProvider=' + this.x9j_1 + ', injector=' + this.y9j_1 + ', configInjector=' + this.z9j_1 + ', debug=' + this.a9k_1 + ', trace=' + this.b9k_1 + ', context=' + tmp_0 + ', fullscreen=' + this.d9k_1 + ', blocking=' + this.e9k_1 + ', gameId=' + this.f9k_1 + ', settingsFolder=' + this.g9k_1 + ', batchMaxQuads=' + this.h9k_1 + ', windowSize=' + tmp_1 + ', virtualSize=' + tmp_2 + ', displayMode=' + this.k9k_1 + ', title=' + this.l9k_1 + ', backgroundColor=' + tmp_4 + ', quality=' + this.n9k_1 + ', icon=' + this.o9k_1 + ', multithreaded=' + this.p9k_1 + ', forceRenderEveryFrame=' + this.q9k_1 + ', main=' + this.r9k_1 + ', debugAg=' + this.s9k_1 + ', debugFontExtraScale=' + this.t9k_1 + ', debugFontColor=' + tmp_5 + ', stageBuilder=' + this.v9k_1 + ', targetFps=' + this.w9k_1 + ', unit=' + Unit_getInstance() + ')';
  };
  protoOf(Korge).hashCode = function () {
    var result = hashCode(this.t9j_1);
    result = imul(result, 31) + hashCode(this.u9j_1) | 0;
    result = imul(result, 31) + (this.v9j_1 == null ? 0 : hashCode(this.v9j_1)) | 0;
    result = imul(result, 31) + (this.w9j_1 == null ? 0 : this.w9j_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.x9j_1) | 0;
    result = imul(result, 31) + hashCode(this.y9j_1) | 0;
    result = imul(result, 31) + hashCode(this.z9j_1) | 0;
    result = imul(result, 31) + (this.a9k_1 | 0) | 0;
    result = imul(result, 31) + (this.b9k_1 | 0) | 0;
    result = imul(result, 31) + (this.c9k_1 == null ? 0 : hashCode(this.c9k_1)) | 0;
    result = imul(result, 31) + (this.d9k_1 == null ? 0 : this.d9k_1 | 0) | 0;
    result = imul(result, 31) + (this.e9k_1 | 0) | 0;
    result = imul(result, 31) + getStringHashCode(this.f9k_1) | 0;
    result = imul(result, 31) + (this.g9k_1 == null ? 0 : getStringHashCode(this.g9k_1)) | 0;
    result = imul(result, 31) + this.h9k_1 | 0;
    result = imul(result, 31) + Size__hashCode_impl_2h1qpd(this.i9k_1) | 0;
    result = imul(result, 31) + Size__hashCode_impl_2h1qpd(this.j9k_1) | 0;
    result = imul(result, 31) + this.k9k_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.l9k_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.m9k_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.m9k_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.n9k_1.hashCode() | 0;
    result = imul(result, 31) + (this.o9k_1 == null ? 0 : getStringHashCode(this.o9k_1)) | 0;
    result = imul(result, 31) + (this.p9k_1 == null ? 0 : this.p9k_1 | 0) | 0;
    result = imul(result, 31) + (this.q9k_1 | 0) | 0;
    result = imul(result, 31) + hashCode(this.r9k_1) | 0;
    result = imul(result, 31) + (this.s9k_1 | 0) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t9k_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.u9k_1) | 0;
    result = imul(result, 31) + hashCode(this.v9k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w9k_1) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_getInstance()) | 0;
    return result;
  };
  protoOf(Korge).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.t9j_1, tmp0_other_with_cast.t9j_1))
      return false;
    if (!equals(this.u9j_1, tmp0_other_with_cast.u9j_1))
      return false;
    if (!equals(this.v9j_1, tmp0_other_with_cast.v9j_1))
      return false;
    if (!equals(this.w9j_1, tmp0_other_with_cast.w9j_1))
      return false;
    if (!equals(this.x9j_1, tmp0_other_with_cast.x9j_1))
      return false;
    if (!equals(this.y9j_1, tmp0_other_with_cast.y9j_1))
      return false;
    if (!equals(this.z9j_1, tmp0_other_with_cast.z9j_1))
      return false;
    if (!(this.a9k_1 === tmp0_other_with_cast.a9k_1))
      return false;
    if (!(this.b9k_1 === tmp0_other_with_cast.b9k_1))
      return false;
    if (!equals(this.c9k_1, tmp0_other_with_cast.c9k_1))
      return false;
    if (!(this.d9k_1 == tmp0_other_with_cast.d9k_1))
      return false;
    if (!(this.e9k_1 === tmp0_other_with_cast.e9k_1))
      return false;
    if (!(this.f9k_1 === tmp0_other_with_cast.f9k_1))
      return false;
    if (!(this.g9k_1 == tmp0_other_with_cast.g9k_1))
      return false;
    if (!(this.h9k_1 === tmp0_other_with_cast.h9k_1))
      return false;
    if (!equals(this.i9k_1, tmp0_other_with_cast.i9k_1))
      return false;
    if (!equals(this.j9k_1, tmp0_other_with_cast.j9k_1))
      return false;
    if (!this.k9k_1.equals(tmp0_other_with_cast.k9k_1))
      return false;
    if (!(this.l9k_1 === tmp0_other_with_cast.l9k_1))
      return false;
    var tmp = this.m9k_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.m9k_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.n9k_1.equals(tmp0_other_with_cast.n9k_1))
      return false;
    if (!(this.o9k_1 == tmp0_other_with_cast.o9k_1))
      return false;
    if (!(this.p9k_1 == tmp0_other_with_cast.p9k_1))
      return false;
    if (!(this.q9k_1 === tmp0_other_with_cast.q9k_1))
      return false;
    if (!equals(this.r9k_1, tmp0_other_with_cast.r9k_1))
      return false;
    if (!(this.s9k_1 === tmp0_other_with_cast.s9k_1))
      return false;
    if (!equals(this.t9k_1, tmp0_other_with_cast.t9k_1))
      return false;
    if (!(this.u9k_1 === tmp0_other_with_cast.u9k_1))
      return false;
    if (!equals(this.v9k_1, tmp0_other_with_cast.v9k_1))
      return false;
    if (!equals(this.w9k_1, tmp0_other_with_cast.w9k_1))
      return false;
    if (!equals(Unit_getInstance(), Unit_getInstance()))
      return false;
    return true;
  };
  function Companion_0() {
    Companion_instance_0 = this;
    this.q9j_1 = new KorgeDisplayMode(Companion_getInstance_1().d3j_1, Companion_getInstance_2().r3a(), true);
    this.r9j_1 = new KorgeDisplayMode(Companion_getInstance_1().d3j_1, Companion_getInstance_2().r3a(), false);
    this.s9j_1 = new KorgeDisplayMode(Companion_getInstance_1().f3j_1, Companion_getInstance_2().i3a_1, false);
  }
  protoOf(Companion_0).d3z = function () {
    return this.q9j_1;
  };
  var Companion_instance_0;
  function Companion_getInstance_58() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_58();
    this.c9l_1 = scaleMode;
    this.d9l_1 = scaleAnchor;
    this.e9l_1 = clipBorders;
  }
  protoOf(KorgeDisplayMode).toString = function () {
    return 'KorgeDisplayMode(scaleMode=' + this.c9l_1 + ', scaleAnchor=' + new Anchor(this.d9l_1) + ', clipBorders=' + this.e9l_1 + ')';
  };
  protoOf(KorgeDisplayMode).hashCode = function () {
    var result = hashCode(this.c9l_1);
    result = imul(result, 31) + Anchor__hashCode_impl_biqpqb(this.d9l_1) | 0;
    result = imul(result, 31) + (this.e9l_1 | 0) | 0;
    return result;
  };
  protoOf(KorgeDisplayMode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.c9l_1, tmp0_other_with_cast.c9l_1))
      return false;
    if (!equals(this.d9l_1, tmp0_other_with_cast.d9l_1))
      return false;
    if (!(this.e9l_1 === tmp0_other_with_cast.e9l_1))
      return false;
    return true;
  };
  function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
    return it instanceof FixedSizeContainer;
  }
  function KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow, resultContinuation) {
    this.n9l_1 = $config;
    this.o9l_1 = $views;
    this.p9l_1 = $entry;
    this.q9l_1 = $gameWindow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$invoke$slambda$slambda$slambda).j1e = function ($this$coroutineScope, $completion) {
    var tmp = this.k1e($this$coroutineScope, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KorgeRunner$invoke$slambda$slambda$slambda).mi = function (p1, $completion) {
    return this.j1e((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KorgeRunner$invoke$slambda$slambda$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 7;
            if (!(this.n9l_1.w9j_1 == null)) {
              var tmp_0 = this;
              tmp_0.s9l_1 = this.o9l_1.s9n_1;
              var tmp_1 = this;
              tmp_1.t9l_1 = withEasing(get_AlphaTransition(), Companion_getInstance_3().s3z());
              var tmp_2 = this;
              tmp_2.u9l_1 = Companion_getInstance_4().k3j_1;
              this.hh_1 = 1;
              suspendResult = views(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 3;
              continue $sm;
            }

            break;
          case 1:
            this.v9l_1 = suspendResult;
            this.w9l_1 = this.u9l_1;
            this.x9l_1 = Size__component1_impl_9kmfl4(this.w9l_1);
            this.y9l_1 = Size__component2_impl_93kt6x(this.w9l_1);
            this.z9l_1 = this.x9l_1;
            this.a9m_1 = this.y9l_1;
            if (this.x9l_1 === 0.0 ? this.y9l_1 === 0.0 : false) {
              var tmp_3 = findFirstAscendant(this.s9l_1, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
              var base = (tmp_3 == null ? true : tmp_3 instanceof FixedSizeContainer) ? tmp_3 : null;
              var tmp_4 = this;
              var tmp1_safe_receiver = base;
              var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ck();
              tmp_4.z9l_1 = tmp2_elvis_lhs == null ? this.v9l_1.s9n_1.ck() : tmp2_elvis_lhs;
              var tmp_5 = this;
              var tmp3_safe_receiver = base;
              var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.dk();
              tmp_5.a9m_1 = tmp4_elvis_lhs == null ? this.v9l_1.s9n_1.dk() : tmp4_elvis_lhs;
            }

            var tmp_6 = this;
            var tmp1_addTo = new SceneContainer(this.v9l_1, this.t9l_1, 'sceneContainer', _Size___init__impl__aywn0g(this.z9l_1, this.a9m_1));
            var tmp0_apply = addTo(tmp1_addTo, this.s9l_1);
            ;
            tmp_6.b9m_1 = tmp0_apply;
            this.hh_1 = 2;
            suspendResult = this.b9m_1.o9t(this.n9l_1.w9j_1, [], VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            ;
            this.hh_1 = 3;
            continue $sm;
          case 3:
            this.hh_1 = 4;
            suspendResult = this.p9l_1(this.o9l_1.s9n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            if (this.n9l_1.e9k_1) {
              this.hh_1 = 5;
              suspendResult = this.q9l_1.b83(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 6;
              continue $sm;
            }

            break;
          case 5:
            this.hh_1 = 6;
            continue $sm;
          case 6:
            return Unit_getInstance();
          case 7:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 7) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(KorgeRunner$invoke$slambda$slambda$slambda).k1e = function ($this$coroutineScope, completion) {
    var i = new KorgeRunner$invoke$slambda$slambda$slambda(this.n9l_1, this.o9l_1, this.p9l_1, this.q9l_1, completion);
    i.r9l_1 = $this$coroutineScope;
    return i;
  };
  function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow, resultContinuation) {
    var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.j1e($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow, resultContinuation) {
    this.x9t_1 = $config;
    this.y9t_1 = $views;
    this.z9t_1 = $entry;
    this.a9u_1 = $gameWindow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$invoke$slambda$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KorgeRunner$invoke$slambda$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(KorgeRunner$invoke$slambda$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0(this.x9t_1, this.y9t_1, this.z9t_1, this.a9u_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(KorgeRunner$invoke$slambda$slambda).n1f = function (completion) {
    var i = new KorgeRunner$invoke$slambda$slambda(this.x9t_1, this.y9t_1, this.z9t_1, this.a9u_1, completion);
    return i;
  };
  function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow, resultContinuation) {
    var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function ModuleArgs(args) {
    this.b9u_1 = args;
  }
  protoOf(ModuleArgs).toString = function () {
    return 'ModuleArgs(args=' + toString(this.b9u_1) + ')';
  };
  protoOf(ModuleArgs).hashCode = function () {
    return hashCode(this.b9u_1);
  };
  protoOf(ModuleArgs).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModuleArgs))
      return false;
    var tmp0_other_with_cast = other instanceof ModuleArgs ? other : THROW_CCE();
    if (!equals(this.b9u_1, tmp0_other_with_cast.b9u_1))
      return false;
    return true;
  };
  function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
    return $views.c9u(_Vector2___init__impl__67w0ru(x, y));
  }
  function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
    input.z9u(button, true);
    input.a9v(p, false);
    input.a9v(p, true);
    $views.b9v();
    downPos._v = new Vector2(input.c9v());
    downTime._v = new DateTime(Companion_getInstance_5().si());
    input.n9u_1 = true;
  }
  function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
    input.z9u(button, false);
    input.a9v(p, false);
    $views.b9v();
    upPos._v = new Vector2($views.j9m_1.c9v());
  }
  function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
    $views.j9m_1.a9v(p, false);
    $views.j9m_1.n9u_1 = inside;
    if (!inside) {
      moveMouseOutsideInNextFrame._v = true;
    }
    $views.b9v();
    moveTime._v = new DateTime(Companion_getInstance_5().si());
  }
  function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
    $views.j9m_1.a9v(p, false);
    $views.b9v();
    moveTime._v = new DateTime(Companion_getInstance_5().si());
  }
  function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
    mouseTouchEvent.j6d_1 = 0;
    mouseTouchEvent.m6d_1 = true;
    mouseTouchEvent.k6d_1 = Companion_getInstance_5().si();
    mouseTouchEvent.l6d_1 = false;
    mouseTouchEvent.u6d(type);
    mouseTouchEvent.z6d(button.v6h_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
    mouseTouchEvent.v6d();
    $views.q6a(mouseTouchEvent);
  }
  function prepareViewsBase$gamepadUpdated(input, e) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = e.j6f_1;
    var n = 0;
    while (n < tmp0_fastForEach.length) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach[tmp0];
      input.x9u_1[tmp1__anonymous__uwfjfc.k6f_1].y6f(tmp1__anonymous__uwfjfc);
    }
    input.d9v();
  }
  function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
    try {
      $views.f9v($fixedSizeStep, $views.e9v(), event.t6e_1, event.u6e_1);
      $views.j9m_1.m9u_1 = false;
      if (moveMouseOutsideInNextFrame._v) {
        moveMouseOutsideInNextFrame._v = false;
        $views.j9m_1.m9u_1 = true;
        $views.j9m_1.n9u_1 = false;
        $views.b9v();
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        var tmp$ret$1;
        // Inline function 'korlibs.logger.Logger.error' call
        var tmp1_error = Companion_getInstance_57().q9i_1;
        var tmp0_log = Level_ERROR_getInstance();
        var tmp;
        if (tmp1_error.zz(tmp0_log)) {
          var tmp$ret$0;
          // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
          tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
          tmp1_error.a10(tmp0_log, tmp$ret$0);
          tmp = Unit_getInstance();
        }
        tmp$ret$1 = tmp;
        printStackTrace(e);
        if ($views.u9m_1)
          throw e;
      } else {
        throw $p;
      }
    }
  }
  function KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry, resultContinuation) {
    this.o9v_1 = $realGameWindow;
    this.p9v_1 = $windowSize;
    this.q9v_1 = $config;
    this.r9v_1 = $iconPath;
    this.s9v_1 = $imageFormats;
    this.t9v_1 = $entry;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$invoke$slambda).j9w = function ($this$loop, $completion) {
    var tmp = this.k9w($this$loop, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KorgeRunner$invoke$slambda).mi = function (p1, $completion) {
    return this.j9w(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KorgeRunner$invoke$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 23;
            this.v9v_1 = this.u9v_1;
            if (Companion_getInstance_6().dw()) {
              println('Korui[0]');
            }

            var tmp$ret$4;
            l$ret$5: do {
              var start = PerformanceCounter_getInstance().ij();
              var tmp$ret$2;
              l$ret$3: do {
                var tmp$ret$0;
                l$ret$1: do {
                  try {
                    var tmp0_elvis_lhs = this.q9v_1.m9k_1;
                    var tmp_0;
                    var tmp_1 = tmp0_elvis_lhs;
                    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
                      tmp_0 = Colors_getInstance().k48_1;
                    } else {
                      tmp_0 = tmp0_elvis_lhs;
                    }
                    configure(this.o9v_1, this.p9v_1, this.q9v_1.l9k_1, null, this.q9v_1.d9k_1, tmp_0);
                    tmp$ret$0 = Unit_getInstance();
                    break l$ret$1;
                  } catch ($p) {
                    var t = $p;
                    var end = PerformanceCounter_getInstance().ij();
                    var tmp0__get_microseconds__mq1imi = end - start;
                    this.v9v_1.e82('configureGameWindow', Companion_getInstance_7().nj(tmp0__get_microseconds__mq1imi));
                    throw t;
                  }
                }
                 while (false);
                var end_0 = PerformanceCounter_getInstance().ij();
                var tmp0__get_microseconds__mq1imi_0 = end_0 - start;
                this.v9v_1.e82('configureGameWindow', Companion_getInstance_7().nj(tmp0__get_microseconds__mq1imi_0));
                tmp$ret$4 = Unit_getInstance();
                break l$ret$5;
              }
               while (false);
              var end_1 = PerformanceCounter_getInstance().ij();
              var tmp0__get_microseconds__mq1imi_1 = end_1 - start;
              this.v9v_1.e82('configureGameWindow', Companion_getInstance_7().nj(tmp0__get_microseconds__mq1imi_1));
            }
             while (false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            this.x9v_1 = PerformanceCounter_getInstance().ij();
            this.hh_1 = 2;
            continue $sm;
          case 2:
            this.hh_1 = 3;
            continue $sm;
          case 3:
            this.ih_1 = 8;
            this.ih_1 = 6;
            if (!(this.r9v_1 == null)) {
              this.hh_1 = 4;
              suspendResult = readBitmap(get_resourcesVfs().ro(ensureNotNull(this.r9v_1)), this.s9v_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            this.z9v_1 = suspendResult;
            this.u9v_1.g82(this.z9v_1);
            this.hh_1 = 5;
            continue $sm;
          case 5:
            this.ih_1 = 8;
            this.hh_1 = 7;
            continue $sm;
          case 6:
            this.ih_1 = 8;
            var tmp_2 = this.kh_1;
            if (tmp_2 instanceof Error) {
              this.a9w_1 = this.kh_1;
              var tmp1_error = Companion_getInstance_57().q9i_1;
              var tmp0_log = Level_ERROR_getInstance();
              if (tmp1_error.zz(tmp0_log)) {
                tmp1_error.a10(tmp0_log, "Couldn't get the application icon");
              }
              printStackTrace(this.a9w_1);
              this.hh_1 = 7;
              continue $sm;
            } else {
              throw this.kh_1;
            }

            break;
          case 7:
            var tmp_3 = this;
            this.ih_1 = 8;
            tmp_3.y9v_1 = Unit_getInstance();
            this.ih_1 = 23;
            this.hh_1 = 9;
            var tmp_4 = this;
            continue $sm;
          case 8:
            this.ih_1 = 23;
            this.b9w_1 = this.kh_1;
            var end_2 = PerformanceCounter_getInstance().ij();
            var tmp1__get_microseconds__thg1ez = end_2 - this.x9v_1;
            this.v9v_1.e82('setIcon', Companion_getInstance_7().nj(tmp1__get_microseconds__thg1ez));
            ;
            throw this.b9w_1;
          case 9:
            var tmp_5 = this;
            var end_3 = PerformanceCounter_getInstance().ij();
            var tmp1__get_microseconds__thg1ez_0 = end_3 - this.x9v_1;
            this.v9v_1.e82('setIcon', Companion_getInstance_7().nj(tmp1__get_microseconds__thg1ez_0));
            tmp_5.w9v_1 = Unit_getInstance();
            this.hh_1 = 11;
            continue $sm;
          case 10:
            var end_4 = PerformanceCounter_getInstance().ij();
            var tmp1__get_microseconds__thg1ez_1 = end_4 - this.x9v_1;
            this.v9v_1.e82('setIcon', Companion_getInstance_7().nj(tmp1__get_microseconds__thg1ez_1));
            ;
            if (false) {
              this.hh_1 = 1;
              continue $sm;
            }

            this.hh_1 = 11;
            continue $sm;
          case 11:
            this.u9v_1.l82(this.u9v_1.m82());
            if (Companion_getInstance_6().dw()) {
              println('CanvasApplicationEx.IN[0]');
            }

            this.c9w_1 = new Input();
            this.d9w_1 = new Stats();
            var tmp_6 = this;
            tmp_6.e9w_1 = new Views(this.j4().d5(this.v9v_1.z81()).d5(new AsyncInjectorContext(this.q9v_1.y9j_1)).d5(SupervisorJob()), this.q9v_1.s9k_1 ? new AGPrint() : this.u9v_1.y81(), this.q9v_1.y9j_1, this.c9w_1, this.q9v_1.x9j_1, this.d9w_1, this.v9v_1, this.q9v_1.f9k_1, this.q9v_1.g9k_1, this.q9v_1.h9k_1, VOID, this.q9v_1.v9k_1);
            this.hh_1 = 12;
            suspendResult = this.e9w_1.p1s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            this.f9w_1 = this.e9w_1;
            if (Companion_getInstance_6().fw()) {
              Dyn__set_impl_2ozvx8(Companion_getInstance_8().u1r(), 'views', this.f9w_1);
            }

            var tmp3_mapInstance = this.q9v_1.y9j_1;
            var tmp4_mapInstance = new ModuleArgs(this.q9v_1.t9j_1);
            tmp3_mapInstance.k9g(getKClass(ModuleArgs), tmp4_mapInstance).k9g(getKClass(GameWindow), this.v9v_1).k9g(getKClass(Korge), this.q9v_1);
            ;
            this.f9w_1.v9n_1 = this.u9v_1.o82();
            this.f9w_1.l9w(this.q9v_1.t9k_1);
            this.f9w_1.m9w(this.q9v_1.u9k_1);
            this.f9w_1.m9n_1 = numberToInt(_Size___get_width__impl__58y75t(this.q9v_1.j9k_1));
            this.f9w_1.n9n_1 = numberToInt(_Size___get_height__impl__a04p02(this.q9v_1.j9k_1));
            this.f9w_1.q9n_1 = this.q9v_1.k9k_1.d9l_1;
            this.f9w_1.p9n_1 = this.q9v_1.k9k_1.c9l_1;
            this.f9w_1.r9n_1 = this.q9v_1.k9k_1.e9l_1;
            this.f9w_1.g9o_1 = this.q9v_1.w9k_1;
            this.hh_1 = 13;
            continue $sm;
          case 13:
            this.h9w_1 = PerformanceCounter_getInstance().ij();
            this.hh_1 = 14;
            continue $sm;
          case 14:
            this.hh_1 = 15;
            continue $sm;
          case 15:
            this.ih_1 = 22;
            this.hh_1 = 16;
            var tmp_7 = KorgeRunner_getInstance();
            var tmp_8 = !(new RGBA(this.u9v_1.k82()) == null);
            var tmp0_elvis_lhs_0 = this.u9v_1.k82();
            suspendResult = tmp_7.n9w(this.f9w_1, this.v9v_1, tmp_8, new RGBA(tmp0_elvis_lhs_0) == null ? Colors_getInstance().o48_1 : tmp0_elvis_lhs_0, VOID, true, this.q9v_1.q9k_1, this.q9v_1.z9j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 16:
            this.i9w_1 = suspendResult;
            this.ih_1 = 23;
            this.hh_1 = 17;
            var tmp_9 = this;
            continue $sm;
          case 17:
            var tmp_10 = this;
            var end_5 = PerformanceCounter_getInstance().ij();
            var tmp5__get_microseconds__ei1xe9 = end_5 - this.h9w_1;
            this.v9v_1.e82('prepareViews', Companion_getInstance_7().nj(tmp5__get_microseconds__ei1xe9));
            tmp_10.g9w_1 = Unit_getInstance();
            this.hh_1 = 19;
            continue $sm;
          case 18:
            var end_6 = PerformanceCounter_getInstance().ij();
            var tmp5__get_microseconds__ei1xe9_0 = end_6 - this.h9w_1;
            this.v9v_1.e82('prepareViews', Companion_getInstance_7().nj(tmp5__get_microseconds__ei1xe9_0));
            ;
            if (false) {
              this.hh_1 = 13;
              continue $sm;
            }

            this.hh_1 = 19;
            continue $sm;
          case 19:
            var tmp$ret$22;
            l$ret$23: do {
              var start_0 = PerformanceCounter_getInstance().ij();
              var tmp$ret$20;
              l$ret$21: do {
                var tmp$ret$18;
                l$ret$19: do {
                  try {
                    completeViews(this.f9w_1);
                    tmp$ret$18 = Unit_getInstance();
                    break l$ret$19;
                  } catch ($p) {
                    var t_0 = $p;
                    var end_7 = PerformanceCounter_getInstance().ij();
                    var tmp6__get_microseconds__7qnels = end_7 - start_0;
                    this.v9v_1.e82('completeViews', Companion_getInstance_7().nj(tmp6__get_microseconds__7qnels));
                    throw t_0;
                  }
                }
                 while (false);
                var end_8 = PerformanceCounter_getInstance().ij();
                var tmp6__get_microseconds__7qnels_0 = end_8 - start_0;
                this.v9v_1.e82('completeViews', Companion_getInstance_7().nj(tmp6__get_microseconds__7qnels_0));
                tmp$ret$22 = Unit_getInstance();
                break l$ret$23;
              }
               while (false);
              var end_9 = PerformanceCounter_getInstance().ij();
              var tmp6__get_microseconds__7qnels_1 = end_9 - start_0;
              this.v9v_1.e82('completeViews', Companion_getInstance_7().nj(tmp6__get_microseconds__7qnels_1));
            }
             while (false);
            launchImmediately(this.f9w_1, KorgeRunner$invoke$slambda$slambda_0(this.q9v_1, this.f9w_1, this.t9v_1, this.v9v_1, null));
            ;
            if (Companion_getInstance_6().dw()) {
              println('CanvasApplicationEx.IN[1]');
            }

            if (Companion_getInstance_6().dw()) {
              println('Korui[1]');
            }

            if (this.q9v_1.e9k_1) {
              this.hh_1 = 20;
              suspendResult = this.v9v_1.b83(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 21;
              continue $sm;
            }

            break;
          case 20:
            this.v9v_1.r82();
            this.hh_1 = 21;
            continue $sm;
          case 21:
            return Unit_getInstance();
          case 22:
            this.ih_1 = 23;
            var t_1 = this.kh_1;
            var end_10 = PerformanceCounter_getInstance().ij();
            var tmp5__get_microseconds__ei1xe9_1 = end_10 - this.h9w_1;
            this.v9v_1.e82('prepareViews', Companion_getInstance_7().nj(tmp5__get_microseconds__ei1xe9_1));
            ;
            throw t_1;
          case 23:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 23) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(KorgeRunner$invoke$slambda).k9w = function ($this$loop, completion) {
    var i = new KorgeRunner$invoke$slambda(this.o9v_1, this.p9v_1, this.q9v_1, this.r9v_1, this.s9v_1, this.t9v_1, completion);
    i.u9v_1 = $this$loop;
    return i;
  };
  function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry, resultContinuation) {
    var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry, resultContinuation);
    var l = function ($this$loop, $completion) {
      return i.j9w($this$loop, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KorgeRunner$prepareViewsBase$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$prepareViewsBase$slambda).x9w = function ($this$mapSingleton, $completion) {
    var tmp = this.y9w($this$mapSingleton, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KorgeRunner$prepareViewsBase$slambda).mi = function (p1, $completion) {
    return this.x9w(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KorgeRunner$prepareViewsBase$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          return new ResourcesRoot();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KorgeRunner$prepareViewsBase$slambda).y9w = function ($this$mapSingleton, completion) {
    var i = new KorgeRunner$prepareViewsBase$slambda(completion);
    i.w9w_1 = $this$mapSingleton;
    return i;
  };
  function KorgeRunner$prepareViewsBase$slambda_0(resultContinuation) {
    var i = new KorgeRunner$prepareViewsBase$slambda(resultContinuation);
    var l = function ($this$mapSingleton, $completion) {
      return i.x9w($this$mapSingleton, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KorgeRunner$prepareViewsBase$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$prepareViewsBase$slambda_1).i9x = function ($this$mapPrototype, $completion) {
    var tmp = this.y9w($this$mapPrototype, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KorgeRunner$prepareViewsBase$slambda_1).mi = function (p1, $completion) {
    return this.i9x(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KorgeRunner$prepareViewsBase$slambda_1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          return new EmptyScene();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KorgeRunner$prepareViewsBase$slambda_1).y9w = function ($this$mapPrototype, completion) {
    var i = new KorgeRunner$prepareViewsBase$slambda_1(completion);
    i.h9x_1 = $this$mapPrototype;
    return i;
  };
  function KorgeRunner$prepareViewsBase$slambda_2(resultContinuation) {
    var i = new KorgeRunner$prepareViewsBase$slambda_1(resultContinuation);
    var l = function ($this$mapPrototype, $completion) {
      return i.i9x($this$mapPrototype, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KorgeRunner$prepareViewsBase$lambda($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
    return function (e) {
      var tmp$ret$1;
      // Inline function 'korlibs.logger.Logger.trace' call
      var tmp1_trace = Companion_getInstance_57().q9i_1;
      var tmp0_log = Level_TRACE_getInstance();
      var tmp;
      if (tmp1_trace.zz(tmp0_log)) {
        var tmp$ret$0;
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e;
        tmp1_trace.a10(tmp0_log, tmp$ret$0);
        tmp = Unit_getInstance();
      }
      tmp$ret$1 = tmp;
      var p = prepareViewsBase$getRealXY($views, e.b6c_1, e.c6c_1, e.m6c_1);
      var tmp0_subject = e.z6b_1;
      var tmp0 = tmp0_subject.j5_1;
      var tmp_0;
      switch (tmp0) {
        case 3:
          prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.d6c_1);
          prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d6c_1, Type_START_getInstance(), Status_ADD_getInstance());
          tmp_0 = Unit_getInstance();
          break;
        case 2:
          prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.d6c_1);
          prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d6c_1, Type_END_getInstance(), Status_REMOVE_getInstance());
          tmp_0 = Unit_getInstance();
          break;
        case 1:
          prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
          prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d6c_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
          tmp_0 = Unit_getInstance();
          break;
        case 0:
          prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
          tmp_0 = Unit_getInstance();
          break;
        case 4:
          tmp_0 = Unit_getInstance();
          break;
        case 5:
          prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
          tmp_0 = Unit_getInstance();
          break;
        case 6:
          prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
          tmp_0 = Unit_getInstance();
          break;
        case 7:
          tmp_0 = Unit_getInstance();
          break;
      }
      $views.q6a(e);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_0($views) {
    return function (e) {
      var tmp$ret$1;
      // Inline function 'korlibs.logger.Logger.trace' call
      var tmp1_trace = Companion_getInstance_57().q9i_1;
      var tmp0_log = Level_TRACE_getInstance();
      var tmp;
      if (tmp1_trace.zz(tmp0_log)) {
        var tmp$ret$0;
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e;
        tmp1_trace.a10(tmp0_log, tmp$ret$0);
        tmp = Unit_getInstance();
      }
      tmp$ret$1 = tmp;
      $views.q6a(e);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_1($views) {
    return function (e) {
      var tmp$ret$1;
      // Inline function 'korlibs.logger.Logger.trace' call
      var tmp1_trace = Companion_getInstance_57().q9i_1;
      var tmp0_log = Level_TRACE_getInstance();
      var tmp;
      if (tmp1_trace.zz(tmp0_log)) {
        var tmp$ret$0;
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e;
        tmp1_trace.a10(tmp0_log, tmp$ret$0);
        tmp = Unit_getInstance();
      }
      tmp$ret$1 = tmp;
      $views.q6a(e);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_2($views) {
    return function (e) {
      $views.q6a(e);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_3($views) {
    return function (e) {
      $views.q6a(e);
      get_nativeSoundProvider().k91(false);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_4($views) {
    return function (e) {
      $views.q6a(e);
      get_nativeSoundProvider().k91(true);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_5($views) {
    return function (e) {
      $views.q6a(e);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda$slambda($views, resultContinuation) {
    this.r9x_1 = $views;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$prepareViewsBase$lambda$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KorgeRunner$prepareViewsBase$lambda$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(KorgeRunner$prepareViewsBase$lambda$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          this.r9x_1.c1c();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KorgeRunner$prepareViewsBase$lambda$slambda).n1f = function (completion) {
    var i = new KorgeRunner$prepareViewsBase$lambda$slambda(this.r9x_1, completion);
    return i;
  };
  function KorgeRunner$prepareViewsBase$lambda$slambda_0($views, resultContinuation) {
    var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function KorgeRunner$prepareViewsBase$lambda_6($views) {
    return function (e) {
      var tmp;
      try {
        $views.q6a(e);
        tmp = Unit_getInstance();
      }finally {
        launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views, null));
      }
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_7($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
    return function (e) {
      var tmp$ret$1;
      // Inline function 'korlibs.logger.Logger.trace' call
      var tmp1_trace = Companion_getInstance_57().q9i_1;
      var tmp0_log = Level_TRACE_getInstance();
      var tmp;
      if (tmp1_trace.zz(tmp0_log)) {
        var tmp$ret$0;
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e;
        tmp1_trace.a10(tmp0_log, tmp$ret$0);
        tmp = Unit_getInstance();
      }
      tmp$ret$1 = tmp;
      $input.s9x(e);
      var ee = $input.f9u_1;
      var tmp0_iterator = ee.r6d().g();
      while (tmp0_iterator.h()) {
        var t = tmp0_iterator.i();
        t.v6c_1 = prepareViewsBase$getRealXY($views, t.b6d(), t.c6d(), e.l6d_1);
      }
      $views.q6a(ee);
      var tmp_0;
      if (ee.s6d() === 1) {
        var start = ee.c6e();
        var end = ee.d6e();
        var t_0 = first(ee.r6d());
        var p = t_0.v6c_1;
        var x = t_0.b6d();
        var y = t_0.c6d();
        var button = MouseButton_LEFT_getInstance();
        if (start) {
          prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
        } else if (end) {
          prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
        } else {
          prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
        }
        var tmp$ret$2;
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        $touchMouseEvent.a6c_1 = 0;
        $touchMouseEvent.d6c_1 = button;
        $touchMouseEvent.e6c_1 = end ? 0 : 1 << button.v6h_1;
        $touchMouseEvent.b6c_1 = numberToInt(x);
        $touchMouseEvent.c6c_1 = numberToInt(y);
        $touchMouseEvent.m6c_1 = false;
        $touchMouseEvent.n6c_1 = true;
        $touchMouseEvent.z6b_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
        tmp$ret$2 = $touchMouseEvent;
        $views.q6a(tmp$ret$2);
        var tmp_1;
        if (end) {
          $moveMouseOutsideInNextFrame._v = true;
          tmp_1 = Unit_getInstance();
        }
        tmp_0 = tmp_1;
      }
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_8($views) {
    return function (e) {
      var tmp$ret$1;
      // Inline function 'korlibs.logger.Logger.trace' call
      var tmp1_trace = Companion_getInstance_57().q9i_1;
      var tmp0_log = Level_TRACE_getInstance();
      var tmp;
      if (tmp1_trace.zz(tmp0_log)) {
        var tmp$ret$0;
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e;
        tmp1_trace.a10(tmp0_log, tmp$ret$0);
        tmp = Unit_getInstance();
      }
      tmp$ret$1 = tmp;
      $views.q6a(e);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_9($views, $input) {
    return function (e) {
      prepareViewsBase$gamepadUpdated($input, e);
      $views.q6a(e);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_10($views, $ag) {
    return function (e) {
      $views.t9x($ag.e6i_1.e6k_1, $ag.e6i_1.f6k_1);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_11($views) {
    return function (it) {
      $views.q6a(it);
      return Unit_getInstance();
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_12($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
    return function (event) {
      var tmp;
      if (!event.u6e_1) {
        prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
        tmp = Unit_getInstance();
      } else {
        var tmp1_doRender = $views.f9n_1;
        tmp1_doRender.b9y_1.dt();
        tmp1_doRender.u9x_1.k6i();
        var tmp_0;
        try {
          var tmp0_setFrameBufferTemporally = tmp1_doRender.f9z();
          tmp1_doRender.g9z(tmp0_setFrameBufferTemporally);
          var tmp_1;
          try {
            if (!$renderShown._v) {
              $renderShown._v = true;
              $firstRenderDeferred.n15(Unit_getInstance());
            }
            prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
            tmp_1 = Unit_getInstance();
          }finally {
            tmp1_doRender.h9z();
          }
          tmp_0 = tmp_1;
        }finally {
          tmp1_doRender.u9x_1.v6d();
        }
        tmp = tmp_0;
      }
      return Unit_getInstance();
    };
  }
  function $invokeCOROUTINE$0(_this__u8e3s4, config, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q9z_1 = _this__u8e3s4;
    this.r9z_1 = config;
  }
  protoOf($invokeCOROUTINE$0).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            get_RegisteredImageFormats().c5q([this.r9z_1.u9j_1]);
            this.s9z_1 = this.r9z_1.o9k_1;
            this.t9z_1 = this.r9z_1.u9j_1;
            this.u9z_1 = this.r9z_1.r9k_1;
            this.v9z_1 = this.r9z_1.p9k_1;
            this.w9z_1 = this.r9z_1.i9k_1;
            if (!Companion_getInstance_6().fw()) {
              this.hh_1 = 1;
              suspendResult = configureLoggerFromProperties(get_localCurrentDirVfs().ro('klogger.properties'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this.hh_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.r9z_1.v9j_1;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              tmp_1 = this.j4().w4(CoroutineKey_getInstance());
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            var tmp1_elvis_lhs = tmp_1;
            tmp_0.x9z_1 = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(new GameWindowCreationConfig(this.v9z_1, VOID, VOID, VOID, VOID, VOID, this.r9z_1.d9k_1)) : tmp1_elvis_lhs;
            var tmp2_elvis_lhs = this.r9z_1.m9k_1;
            var tmp_2;
            var tmp_3 = tmp2_elvis_lhs;
            if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
              tmp_2 = Colors_getInstance().k48_1;
            } else {
              tmp_2 = tmp2_elvis_lhs;
            }

            this.x9z_1.j82(tmp_2);
            this.hh_1 = 3;
            suspendResult = this.x9z_1.c83(KorgeRunner$invoke$slambda_0(this.x9z_1, this.w9z_1, this.r9z_1, this.s9z_1, this.t9z_1, this.u9z_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $prepareViewsCOROUTINE$2(_this__u8e3s4, views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, forceRenderEveryFrame, configInjector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ga0_1 = _this__u8e3s4;
    this.ha0_1 = views;
    this.ia0_1 = eventDispatcher;
    this.ja0_1 = clearEachFrame;
    this.ka0_1 = bgcolor;
    this.la0_1 = fixedSizeStep;
    this.ma0_1 = waitForFirstRender;
    this.na0_1 = forceRenderEveryFrame;
    this.oa0_1 = configInjector;
  }
  protoOf($prepareViewsCOROUTINE$2).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.pa0_1 = this.ga0_1.qa0(this.ha0_1, this.ia0_1, this.ja0_1, this.ka0_1, this.la0_1, this.na0_1, this.oa0_1);
            if (this.ma0_1) {
              this.hh_1 = 1;
              suspendResult = this.pa0_1.d13(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this.hh_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function KorgeRunner() {
    KorgeRunner_instance = this;
  }
  protoOf(KorgeRunner).a9l = function (config, $completion) {
    var tmp = new $invokeCOROUTINE$0(this, config, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KorgeRunner).qa0 = function (views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    KorgeReload_getInstance().sa0(eventDispatcher);
    var injector = views.i9m_1;
    var tmp$ret$0;
    // Inline function 'korlibs.inject.AsyncInjector.mapInstance' call
    tmp$ret$0 = injector.k9g(getKClass(Views), views);
    var tmp$ret$1;
    // Inline function 'korlibs.inject.AsyncInjector.mapInstance' call
    var tmp0_mapInstance = views.h9m_1;
    tmp$ret$1 = injector.k9g(getKClass(AG), tmp0_mapInstance);
    injector.k9g(getKClass(Resources), views.ta0());
    var tmp = getKClass(ResourcesRoot);
    injector.m9g(tmp, KorgeRunner$prepareViewsBase$slambda_0(null));
    var tmp$ret$2;
    // Inline function 'korlibs.inject.AsyncInjector.mapInstance' call
    var tmp1_mapInstance = views.j9m_1;
    tmp$ret$2 = injector.k9g(getKClass(Input), tmp1_mapInstance);
    var tmp$ret$3;
    // Inline function 'korlibs.inject.AsyncInjector.mapInstance' call
    var tmp2_mapInstance = views.l9m_1;
    tmp$ret$3 = injector.k9g(getKClass(Stats), tmp2_mapInstance);
    injector.k9g(getKClass(CoroutineContext), views.g9m_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.n9g(tmp_0, KorgeRunner$prepareViewsBase$slambda_2(null));
    injector.k9g(getKClass(TimeProvider), views.k9m_1);
    configInjector(injector);
    var input = views.j9m_1;
    var ag = views.h9m_1;
    var downPos = {_v: new Vector2(Companion_getInstance_9().h3b_1)};
    var upPos = {_v: new Vector2(Companion_getInstance_9().h3b_1)};
    var downTime = {_v: new DateTime(Companion_getInstance_5().oi_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_5().oi_1)};
    var upTime = Companion_getInstance_5().oi_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.ua0(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_10().t6b_1.slice();
    eventDispatcher.p6a(tmp_1, KorgeRunner$prepareViewsBase$lambda(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_11().f6b_1.slice();
    eventDispatcher.p6a(tmp_2, KorgeRunner$prepareViewsBase$lambda_0(views));
    var tmp_3 = Companion_getInstance_12().y6a_1.slice();
    eventDispatcher.p6a(tmp_3, KorgeRunner$prepareViewsBase$lambda_1(views));
    var tmp_4 = Companion_getInstance_13().l6e_1.slice();
    eventDispatcher.p6a(tmp_4, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_5 = Companion_getInstance_14();
    eventDispatcher.h6a(tmp_5, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_6 = Companion_getInstance_15();
    eventDispatcher.h6a(tmp_6, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_7 = Companion_getInstance_16();
    eventDispatcher.h6a(tmp_7, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_8 = Companion_getInstance_17();
    eventDispatcher.h6a(tmp_8, KorgeRunner$prepareViewsBase$lambda_6(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_18().e6d_1.slice();
    eventDispatcher.p6a(tmp_9, KorgeRunner$prepareViewsBase$lambda_7(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_19().e6g_1.slice();
    eventDispatcher.p6a(tmp_10, KorgeRunner$prepareViewsBase$lambda_8(views));
    var tmp_11 = Companion_getInstance_20();
    eventDispatcher.h6a(tmp_11, KorgeRunner$prepareViewsBase$lambda_9(views, input));
    var tmp_12 = Companion_getInstance_21();
    eventDispatcher.h6a(tmp_12, KorgeRunner$prepareViewsBase$lambda_10(views, ag));
    eventDispatcher.q6a(new ReshapeEvent(0, 0, views.va0(), views.wa0()));
    var tmp_13 = Companion_getInstance_59();
    eventDispatcher.h6a(tmp_13, KorgeRunner$prepareViewsBase$lambda_11(views));
    var renderShown = {_v: false};
    views.g9n_1 = clearEachFrame;
    views.h9n_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.m9m_1.c82(KorgeRunner$prepareViewsBase$lambda_12(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  };
  protoOf(KorgeRunner).xa0 = function (views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, forceRenderEveryFrame, configInjector, $completion) {
    var tmp = new $prepareViewsCOROUTINE$2(this, views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, forceRenderEveryFrame, configInjector, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KorgeRunner).n9w = function (views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, forceRenderEveryFrame, configInjector, $completion, $super) {
    clearEachFrame = clearEachFrame === VOID ? true : clearEachFrame;
    bgcolor = bgcolor === VOID ? Colors_getInstance().o48_1 : bgcolor;
    fixedSizeStep = fixedSizeStep === VOID ? Companion_getInstance_7().zi_1 : fixedSizeStep;
    waitForFirstRender = waitForFirstRender === VOID ? true : waitForFirstRender;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    return $super === VOID ? this.xa0(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, forceRenderEveryFrame, configInjector, $completion) : $super.xa0.call(this, views, eventDispatcher, clearEachFrame, new RGBA(bgcolor), new TimeSpan(fixedSizeStep), waitForFirstRender, forceRenderEveryFrame, configInjector, $completion);
  };
  var KorgeRunner_instance;
  function KorgeRunner_getInstance() {
    if (KorgeRunner_instance == null)
      new KorgeRunner();
    return KorgeRunner_instance;
  }
  function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, entry, $completion) {
    var tmp;
    if (args === VOID) {
      var tmp$ret$2;
      var tmp$ret$2_0;
      // Inline function 'kotlin.arrayOf' call
      var tmp$ret$1;
      var tmp$ret$1_0;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = [];
      tmp$ret$0_0 = Unit_getInstance();
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$1_0 = Unit_getInstance();
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$2_0 = Unit_getInstance();
      tmp = tmp$ret$2;
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_getInstance_0() : timeProvider;
    injector = injector === VOID ? new AsyncInjector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$lambda;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_57().r9i_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_62().f9j_1 : batchMaxQuads;
    windowWidth = windowWidth === VOID ? numberToInt(_Size___get_width__impl__58y75t(DefaultViewport_getInstance().p9j_1)) : windowWidth;
    windowHeight = windowHeight === VOID ? numberToInt(_Size___get_height__impl__a04p02(DefaultViewport_getInstance().p9j_1)) : windowHeight;
    windowSize = windowSize === VOID ? _Size___init__impl__aywn0g_0(windowWidth, windowHeight) : windowSize;
    virtualWidth = virtualWidth === VOID ? numberToInt(_Size___get_width__impl__58y75t(windowSize)) : virtualWidth;
    virtualHeight = virtualHeight === VOID ? numberToInt(_Size___get_height__impl__a04p02(windowSize)) : virtualHeight;
    virtualSize = virtualSize === VOID ? _Size___init__impl__aywn0g_0(virtualWidth, virtualHeight) : virtualSize;
    scaleMode = scaleMode === VOID ? Companion_getInstance_1().d3j_1 : scaleMode;
    scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_2().r3a() : scaleAnchor;
    clipBorders = clipBorders === VOID ? true : clipBorders;
    displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
    title = title === VOID ? 'Game' : title;
    bgcolor = bgcolor === VOID ? Colors_getInstance().k48_1 : bgcolor;
    backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$slambda_0(null);
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().j48_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$lambda_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    var tmp_3;
    if (entry === VOID) {
      tmp_3 = Korge$slambda_2(null);
    } else {
      tmp_3 = entry;
    }
    entry = tmp_3;
    var tmp0_unit = Unit_getInstance();
    var tmp0 = (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, tmp0_unit)).y9k(entry, $completion);
    return tmp0;
  }
  function Korge$lambda($this$null) {
    return Unit_getInstance();
  }
  function Korge$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Korge$slambda).b9j = function ($this$null, $completion) {
    var tmp = this.c9j($this$null, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Korge$slambda).mi = function (p1, $completion) {
    return this.b9j(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Korge$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Korge$slambda).c9j = function ($this$null, completion) {
    var i = new Korge$slambda(completion);
    i.ga1_1 = $this$null;
    return i;
  };
  function Korge$slambda_0(resultContinuation) {
    var i = new Korge$slambda(resultContinuation);
    var l = function ($this$null, $completion) {
      return i.b9j($this$null, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Korge$lambda_0(it) {
    return new Stage(it);
  }
  function Korge$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Korge$slambda_1).b9j = function ($this$null, $completion) {
    var tmp = this.c9j($this$null, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Korge$slambda_1).mi = function (p1, $completion) {
    return this.b9j(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Korge$slambda_1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Korge$slambda_1).c9j = function ($this$null, completion) {
    var i = new Korge$slambda_1(completion);
    i.pa1_1 = $this$null;
    return i;
  };
  function Korge$slambda_2(resultContinuation) {
    var i = new Korge$slambda_1(resultContinuation);
    var l = function ($this$null, $completion) {
      return i.b9j($this$null, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KorgeReload() {
    KorgeReload_instance = this;
    this.ra0_1 = null;
  }
  protoOf(KorgeReload).sa0 = function (eventDispatcher) {
    if (!Companion_getInstance_6().bw().iw() ? true : !(Companion_getInstance_22().ro('KORGE_AUTORELOAD') === 'true'))
      return Unit_getInstance();
    this.ra0_1 = eventDispatcher;
  };
  protoOf(KorgeReload).qa1 = function () {
    if (!Companion_getInstance_6().bw().iw())
      return Unit_getInstance();
    if (!(this.ra0_1 == null))
      this.ra0_1 = null;
  };
  var KorgeReload_instance;
  function KorgeReload_getInstance() {
    if (KorgeReload_instance == null)
      new KorgeReload();
    return KorgeReload_instance;
  }
  function KorgeReloadInternalImpl() {
  }
  protoOf(KorgeReloadInternalImpl).ra1 = function (clazz, context) {
    return clazz;
  };
  protoOf(KorgeReloadInternalImpl).sa1 = function (old, new_0) {
    return Unit_getInstance();
  };
  function Companion_1() {
    Companion_instance_1 = this;
  }
  var Companion_instance_1;
  function Companion_getInstance_59() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function ReloadClassContext(injector, refreshedClasses, rootFolders) {
    this.ta1_1 = injector;
    this.ua1_1 = refreshedClasses;
    this.va1_1 = rootFolders;
  }
  function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
    m = m === VOID ? Companion_getInstance_23().v3f_1 : m;
    colMul = colMul === VOID ? Colors_getInstance().j48_1 : colMul;
    blendMode = blendMode === VOID ? Companion_getInstance_67().xa1_1 : blendMode;
    filtering = filtering === VOID ? true : filtering;
    drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
  }
  function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
    m = m === VOID ? Companion_getInstance_23().v3f_1 : m;
    colMul = colMul === VOID ? Colors_getInstance().j48_1 : colMul;
    blendMode = blendMode === VOID ? Companion_getInstance_67().xa1_1 : blendMode;
    filtering = filtering === VOID ? true : filtering;
    var scale = textSize / _this__u8e3s4.b4p();
    var m2 = Matrix__prescaled_impl_gy2bxt(Matrix__pretranslated_impl_9mjs3v(m, x, y), scale, scale);
    var dx = 0.0;
    var dy = 0.0;
    var tmp$ret$3;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var tmp$ret$2;
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var tmp1_use = ctx.u9y_1;
    var tmp0_useBatcher = tmp1_use.qa2_1;
    if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
      tmp0_useBatcher.y9y_1 = tmp1_use;
      tmp0_useBatcher.va3();
    }
    var inductionVariable = 0;
    var last = charSequenceLength(str) - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
        if (c1 === 10) {
          dx = 0.0;
          dy = dy + _this__u8e3s4.b4p();
          continue $l$loop;
        }
        var tmp$ret$1;
        // Inline function 'kotlin.text.getOrElse' call
        var tmp0_getOrElse = n + 1 | 0;
        var tmp_0;
        if (tmp0_getOrElse >= 0 ? tmp0_getOrElse <= get_lastIndex(str) : false) {
          tmp_0 = charSequenceGet(str, tmp0_getOrElse);
        } else {
          var tmp$ret$0;
          // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
          tmp$ret$0 = _Char___init__impl__6a9atx(32);
          tmp_0 = tmp$ret$0;
        }
        tmp$ret$1 = tmp_0;
        var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
        var glyph = _this__u8e3s4.k(c1);
        var tex = glyph.p4o_1;
        var tmp1_tex = ctx.wa3(tex);
        var tmp2_x = dx + glyph.q4o_1;
        var tmp3_y = dy + glyph.r4o_1;
        var tmp4_width = tex.s3r_1;
        var tmp5_height = tex.t3r_1;
        var tmp6_m = _Matrix___get_immutable__impl__k08qr(m2);
        tmp1_use.xa3(tmp1_tex, tmp2_x, tmp3_y, tmp4_width, tmp5_height, tmp6_m, filtering, colMul, blendMode);
        var tmp7_safe_receiver = _this__u8e3s4.f4p().k(Companion_getInstance_24().m4o(c1, c2));
        var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.z4o_1;
        var kerningOffset = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
        dx = dx + (glyph.s4o_1 + kerningOffset | 0);
      }
       while (inductionVariable <= last);
      tmp = Unit_getInstance();
    }
    tmp$ret$2 = tmp;
    tmp$ret$3 = tmp$ret$2;
  }
  var debugBmpFontOrNull;
  function debugBmpFont($completion) {
    var tmp = new $debugBmpFontCOROUTINE$4($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function debugBmpFont_0(tex) {
    var fntAdvance = 7.0;
    var fntWidth = 8.0;
    var fntHeight = 8.0;
    var fntBlockX = 2.0;
    var fntBlockY = 2.0;
    var fntBlockWidth = 12.0;
    var fntBlockHeight = 12.0;
    var tmp = Companion_getInstance_25();
    var tmp_0 = fntHeight - 1.0;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.associateWith' call
    var tmp0_associateWith = until(0, 256);
    var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateWith, 10)), 16));
    var tmp$ret$1;
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = tmp0_associateWith.a1_1;
    var last = tmp0_associateWith.b1_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
        var x = element % 16 | 0;
        var y = element / 16 | 0;
        tmp$ret$0 = new Glyph(fntHeight, element, tex.t3s(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
        result.x3(element, tmp$ret$0);
      }
       while (!(element === last));
    tmp$ret$1 = result;
    tmp$ret$2 = tmp$ret$1;
    return tmp.w4o(fntHeight, fntHeight, tmp_0, toIntMap(tmp$ret$2), IntMap_init_$Create$());
  }
  function get_DEBUG_FONT_BYTES() {
    return fromBase64('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');
  }
  function $debugBmpFontCOROUTINE$4(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($debugBmpFontCOROUTINE$4).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            if (debugBmpFontOrNull == null) {
              this.hh_1 = 1;
              suspendResult = readBitmap_0(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = slice(ARGUMENT);
            var ARGUMENT_1 = debugBmpFont_0(ARGUMENT_0);
            debugBmpFontOrNull = ARGUMENT_1;
            this.hh_1 = 2;
            continue $sm;
          case 2:
            return ensureNotNull(debugBmpFontOrNull);
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function InputKeys() {
    this.ga4_1 = booleanArray(Companion_getInstance_26().u6g_1);
    this.ha4_1 = booleanArray(Companion_getInstance_26().u6g_1);
    this.ia4_1 = false;
    this.ja4_1 = false;
    this.ka4_1 = false;
    this.la4_1 = false;
  }
  protoOf(InputKeys).ma4 = function (key) {
    return this.na4(key);
  };
  protoOf(InputKeys).na4 = function (key) {
    return this.ga4_1[key.j5_1];
  };
  protoOf(InputKeys).oa4 = function (e) {
    var tmp0_subject = e.i6b_1;
    var tmp0 = tmp0_subject.j5_1;
    switch (tmp0) {
      case 0:
        this.ga4_1[e.k6b_1.j5_1] = false;
        ;
        break;
      case 1:
        this.ga4_1[e.k6b_1.j5_1] = true;
        ;
        break;
      default:
        ;
        break;
    }
    this.ia4_1 = (e.n6b_1 ? true : this.ma4(Companion_getInstance_26().i6h())) ? true : this.ma4(Companion_getInstance_26().j6h());
    this.ja4_1 = (e.o6b_1 ? true : this.ma4(Companion_getInstance_26().g6h())) ? true : this.ma4(Companion_getInstance_26().h6h());
    this.ka4_1 = (e.p6b_1 ? true : this.ma4(Companion_getInstance_26().k6h())) ? true : this.ma4(Companion_getInstance_26().l6h());
    this.la4_1 = e.q6b_1 ? true : this.ma4(Key_META_getInstance());
  };
  protoOf(InputKeys).pa4 = function (delta) {
  };
  protoOf(InputKeys).qa4 = function (delta) {
    arraycopy(this.ga4_1, 0, this.ha4_1, 0, this.ga4_1.length);
  };
  function Companion_2() {
    Companion_instance_2 = this;
    this.ra4_1 = 256;
  }
  var Companion_instance_2;
  function Companion_getInstance_60() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function endFrameOldKeys($this, delta) {
    var inductionVariable = 0;
    Companion_getInstance_60();
    var last = 256;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var prev = $this.r9u_1[n];
        var curr = $this.q9u_1[n];
        $this.w9u_1[n] = prev ? !curr : false;
        $this.v9u_1[n] = !prev ? curr : false;
        if (curr) {
          var tmp1_array = $this.s9u_1;
          var tmp2_index0 = n;
          tmp1_array[tmp2_index0] = tmp1_array[tmp2_index0] + _TimeSpan___get_nanoseconds__impl__gaf49o(delta);
        } else {
          $this.s9u_1[n] = 0.0;
          $this.t9u_1[n] = 0.0;
        }
        var triggerPress = false;
        var tmp$ret$0;
        // Inline function 'korlibs.time.nanoseconds' call
        var tmp0__get_nanoseconds__hup2jk = $this.s9u_1[n];
        tmp$ret$0 = Companion_getInstance_7().mj(tmp0__get_nanoseconds__hup2jk);
        var pressingTime = tmp$ret$0;
        if ($this.s9u_1[n] > 0.0) {
          var tmp3_subject = _TimeSpan___get_milliseconds__impl__pb0we5(pressingTime);
          var tmp;
          if (0.0 <= tmp3_subject ? tmp3_subject <= 1.0 : false) {
            var tmp$ret$1;
            // Inline function 'korlibs.time.milliseconds' call
            tmp$ret$1 = Companion_getInstance_7().bj(0.0);
            tmp = tmp$ret$1;
          } else if (1.0 <= tmp3_subject ? tmp3_subject <= 300.0 : false) {
            var tmp$ret$2;
            // Inline function 'korlibs.time.milliseconds' call
            tmp$ret$2 = Companion_getInstance_7().bj(100.0);
            tmp = tmp$ret$2;
          } else if (300.0 <= tmp3_subject ? tmp3_subject <= 1000.0 : false) {
            var tmp$ret$3;
            // Inline function 'korlibs.time.milliseconds' call
            tmp$ret$3 = Companion_getInstance_7().bj(50.0);
            tmp = tmp$ret$3;
          } else {
            var tmp$ret$4;
            // Inline function 'korlibs.time.milliseconds' call
            tmp$ret$4 = Companion_getInstance_7().bj(20.0);
            tmp = tmp$ret$4;
          }
          var timeBarrier = tmp;
          var tmp$ret$5;
          // Inline function 'korlibs.time.nanoseconds' call
          var tmp1__get_nanoseconds__vth17j = $this.t9u_1[n];
          tmp$ret$5 = Companion_getInstance_7().mj(tmp1__get_nanoseconds__vth17j);
          var elapsedTime = TimeSpan__minus_impl_5w5v8s(pressingTime, tmp$ret$5);
          if (TimeSpan__compareTo_impl_zidry4(elapsedTime, timeBarrier) >= 0) {
            triggerPress = true;
          }
        }
        if (triggerPress) {
          $this.t9u_1[n] = $this.s9u_1[n];
        }
        $this.u9u_1[n] = triggerPress;
      }
       while (inductionVariable < last);
    Companion_getInstance_60();
    arraycopy($this.q9u_1, 0, $this.r9u_1, 0, 256);
  }
  function Input$_isTouchDeviceGen$lambda() {
    return AGOpenglFactory_getInstance().h84();
  }
  function Input() {
    Companion_getInstance_60();
    this.d9u_1 = new Mixin();
    this.e9u_1 = Companion_getInstance_27().s6c_1;
    this.f9u_1 = new TouchEvent();
    var tmp = this;
    tmp.g9u_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    var tmp$ret$0;
    // Inline function 'korlibs.time.milliseconds' call
    tmp$ret$0 = Companion_getInstance_7().bj(400.0);
    tmp_0.h9u_1 = tmp$ret$0;
    this.i9u_1 = 20.0;
    this.j9u_1 = _Vector2___init__impl__67w0ru_0(-1000.0, -1000.0);
    this.k9u_1 = _Vector2___init__impl__67w0ru_0(-1000.0, -1000.0);
    this.l9u_1 = 0;
    this.m9u_1 = false;
    this.n9u_1 = true;
    this.o9u_1 = false;
    this.p9u_1 = new InputKeys();
    var tmp_1 = this;
    Companion_getInstance_60();
    tmp_1.q9u_1 = booleanArray(256);
    var tmp_2 = this;
    Companion_getInstance_60();
    tmp_2.r9u_1 = booleanArray(256);
    var tmp_3 = this;
    Companion_getInstance_60();
    tmp_3.s9u_1 = new Float64Array(256);
    var tmp_4 = this;
    Companion_getInstance_60();
    tmp_4.t9u_1 = new Float64Array(256);
    var tmp_5 = this;
    Companion_getInstance_60();
    tmp_5.u9u_1 = booleanArray(256);
    var tmp_6 = this;
    Companion_getInstance_60();
    tmp_6.v9u_1 = booleanArray(256);
    var tmp_7 = this;
    Companion_getInstance_60();
    tmp_7.w9u_1 = booleanArray(256);
    var tmp_8 = this;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map = until(0, 8);
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_map, 10));
    var inductionVariable = tmp1_map.a1_1;
    var last = tmp1_map.b1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$1;
        // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
        tmp$ret$1 = new GamepadInfo(item);
        tmp0_mapTo.b(tmp$ret$1);
      }
       while (!(item === last));
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    var tmp2_toTypedArray = tmp$ret$3;
    tmp$ret$4 = copyToArray(tmp2_toTypedArray);
    tmp_8.x9u_1 = tmp$ret$4;
    var tmp_9 = this;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$5 = ArrayList_init_$Create$_0();
    tmp_9.y9u_1 = tmp$ret$5;
  }
  protoOf(Input).lu = function (_set____db54di) {
    this.d9u_1.lu(_set____db54di);
  };
  protoOf(Input).mu = function () {
    return this.d9u_1.mu();
  };
  protoOf(Input).s9x = function (touchEvent) {
    this.f9u_1.b6e(touchEvent);
  };
  protoOf(Input).c9v = function () {
    return this.j9u_1;
  };
  protoOf(Input).a9v = function (p, down) {
    if (down)
      this.k9u_1 = p;
    else
      this.j9u_1 = p;
  };
  protoOf(Input).z9u = function (button, down) {
    this.l9u_1 = setBits(this.l9u_1, button.w6h_1, down);
  };
  protoOf(Input).d9v = function () {
    this.y9u_1.v2();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.x9u_1;
    var n = 0;
    while (n < tmp0_fastForEach.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach[tmp0];
      if (tmp1__anonymous__uwfjfc.l6f_1) {
        var tmp0_this = this;
        // Inline function 'kotlin.collections.plusAssign' call
        var tmp0_plusAssign = tmp0_this.y9u_1;
        tmp0_plusAssign.b(tmp1__anonymous__uwfjfc);
      }
    }
  };
  protoOf(Input).sa4 = function (keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.q9u_1.length - 1 | 0) : false) {
      this.q9u_1[pKeyCode] = b;
    }
  };
  protoOf(Input).pa4 = function (delta) {
    var tmp0_safe_receiver = this.mu();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.clear' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_safe_receiver;
      tmp$ret$0.clear();
    }
    this.p9u_1.pa4(delta);
  };
  protoOf(Input).qa4 = function (delta) {
    this.o9u_1 = false;
    this.p9u_1.qa4(delta);
    endFrameOldKeys(this, delta);
  };
  protoOf(Input).ta4 = function (e) {
    var tmp0_subject = e.i6b_1;
    var tmp0 = tmp0_subject.j5_1;
    switch (tmp0) {
      case 1:
        this.sa4(e.l6b_1, true);
        ;
        break;
      case 0:
        this.sa4(e.l6b_1, false);
        ;
        break;
      case 2:
        break;
    }
  };
  function get_keys_0(_this__u8e3s4) {
    _init_properties_KeysEvents_kt__ekyd0z();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var tmp0_getValue = keys$factory();
      var tmp0_elvis_lhs = keys$delegate.pu_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp0_getValue.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = keys$delegate.qu_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = keys$delegate.pu_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp0_getValue.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var keys$delegate;
  function KeysEvents$down$slambda($callback, resultContinuation) {
    this.ca5_1 = $callback;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KeysEvents$down$slambda).ea5 = function (e, $completion) {
    var tmp = this.fa5(e, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KeysEvents$down$slambda).mi = function (p1, $completion) {
    return this.ea5(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KeysEvents$down$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.ca5_1(this.da5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(KeysEvents$down$slambda).fa5 = function (e, completion) {
    var i = new KeysEvents$down$slambda(this.ca5_1, completion);
    i.da5_1 = e;
    return i;
  };
  function KeysEvents$down$slambda_0($callback, resultContinuation) {
    var i = new KeysEvents$down$slambda($callback, resultContinuation);
    var l = function (e, $completion) {
      return i.ea5(e, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KeysEvents$up$slambda($callback, resultContinuation) {
    this.oa5_1 = $callback;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KeysEvents$up$slambda).ea5 = function (e, $completion) {
    var tmp = this.fa5(e, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KeysEvents$up$slambda).mi = function (p1, $completion) {
    return this.ea5(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KeysEvents$up$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.oa5_1(this.pa5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(KeysEvents$up$slambda).fa5 = function (e, completion) {
    var i = new KeysEvents$up$slambda(this.oa5_1, completion);
    i.pa5_1 = e;
    return i;
  };
  function KeysEvents$up$slambda_0($callback, resultContinuation) {
    var i = new KeysEvents$up$slambda($callback, resultContinuation);
    var l = function (e, $completion) {
      return i.ea5(e, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KeysEvents$lambda$slambda(this$0, $event, resultContinuation) {
    this.ya5_1 = this$0;
    this.za5_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KeysEvents$lambda$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KeysEvents$lambda$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(KeysEvents$lambda$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.ya5_1.ea6_1.r1h(this.za5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(KeysEvents$lambda$slambda).n1f = function (completion) {
    var i = new KeysEvents$lambda$slambda(this.ya5_1, this.za5_1, completion);
    return i;
  };
  function KeysEvents$lambda$slambda_0(this$0, $event, resultContinuation) {
    var i = new KeysEvents$lambda$slambda(this$0, $event, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function KeysEvents$lambda(this$0) {
    return function (event) {
      var tmp = this$0;
      var tmp_0 = event.v6a_1;
      tmp.ba6_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
      var tmp_1 = this$0.ga6().g9m_1;
      launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_0(this$0, event, null));
      return Unit_getInstance();
    };
  }
  function KeysEvents$lambda$slambda_1(this$0, $event, resultContinuation) {
    this.pa6_1 = this$0;
    this.qa6_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KeysEvents$lambda$slambda_1).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KeysEvents$lambda$slambda_1).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(KeysEvents$lambda$slambda_1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.pa6_1.ca6_1.r1h(this.qa6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(KeysEvents$lambda$slambda_1).n1f = function (completion) {
    var i = new KeysEvents$lambda$slambda_1(this.pa6_1, this.qa6_1, completion);
    return i;
  };
  function KeysEvents$lambda$slambda_2(this$0, $event, resultContinuation) {
    var i = new KeysEvents$lambda$slambda_1(this$0, $event, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function KeysEvents$lambda_0(this$0) {
    return function (event) {
      var tmp = this$0;
      var tmp_0 = event.v6a_1;
      tmp.ba6_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
      var tmp_1 = this$0.ga6().g9m_1;
      launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event, null));
      return Unit_getInstance();
    };
  }
  function KeysEvents$lambda$slambda_3(this$0, $event, resultContinuation) {
    this.za6_1 = this$0;
    this.aa7_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KeysEvents$lambda$slambda_3).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(KeysEvents$lambda$slambda_3).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(KeysEvents$lambda$slambda_3).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.za6_1.da6_1.r1h(this.aa7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(KeysEvents$lambda$slambda_3).n1f = function (completion) {
    var i = new KeysEvents$lambda$slambda_3(this.za6_1, this.aa7_1, completion);
    return i;
  };
  function KeysEvents$lambda$slambda_4(this$0, $event, resultContinuation) {
    var i = new KeysEvents$lambda$slambda_3(this$0, $event, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function KeysEvents$lambda_1(this$0) {
    return function (event) {
      var tmp = this$0;
      var tmp_0 = event.v6a_1;
      tmp.ba6_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
      var tmp_1 = this$0.ga6().g9m_1;
      launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event, null));
      return Unit_getInstance();
    };
  }
  function KeysEvents(view) {
    this.aa6_1 = view;
    this.ca6_1 = new AsyncSignal();
    this.da6_1 = new AsyncSignal();
    this.ea6_1 = new AsyncSignal();
    this.fa6_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.aa6_1.h6a(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.aa6_1.h6a(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.aa6_1.h6a(tmp_1, KeysEvents$lambda_1(this));
  }
  protoOf(KeysEvents).ga6 = function () {
    var tmp = this.ba6_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  protoOf(KeysEvents).ba7 = function (callback) {
    return this.ca6_1.q1h(KeysEvents$down$slambda_0(callback, null));
  };
  protoOf(KeysEvents).ca7 = function (callback) {
    return this.da6_1.q1h(KeysEvents$up$slambda_0(callback, null));
  };
  protoOf(KeysEvents).c1c = function () {
    this.fa6_1.c1c();
  };
  function keys$delegate$lambda($this$$receiver) {
    _init_properties_KeysEvents_kt__ekyd0z();
    return new KeysEvents($this$$receiver);
  }
  function keys$factory() {
    return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
      return get_keys_0(receiver);
    }, null);
  }
  var properties_initialized_KeysEvents_kt_1mffin;
  function _init_properties_KeysEvents_kt__ekyd0z() {
    if (properties_initialized_KeysEvents_kt_1mffin) {
    } else {
      properties_initialized_KeysEvents_kt_1mffin = true;
      keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
    }
  }
  function DefaultViewport() {
    DefaultViewport_instance = this;
    this.n9j_1 = 1280;
    this.o9j_1 = 720;
    this.p9j_1 = _Size___init__impl__aywn0g_0(1280, 720);
  }
  var DefaultViewport_instance;
  function DefaultViewport_getInstance() {
    if (DefaultViewport_instance == null)
      new DefaultViewport();
    return DefaultViewport_instance;
  }
  function configureLoggerFromProperties(file, $completion) {
    var tmp = new $configureLoggerFromPropertiesCOROUTINE$5(file, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function configureLoggerFromProperties_0(str) {
    var props = Companion_getInstance_61().ma7(str);
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = props.o().g();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h()) {
      var tmp1_loop_parameter = tmp0_iterator.i();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.component1' call
      tmp$ret$1 = tmp1_loop_parameter.p();
      var key = tmp$ret$1;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.component2' call
      tmp$ret$2 = tmp1_loop_parameter.q();
      var value = tmp$ret$2;
      try {
        var tmp = Companion_getInstance().kz(key);
        var tmp$ret$4;
        // Inline function 'kotlin.text.toUpperCase' call
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = value;
        tmp$ret$4 = tmp$ret$3.toUpperCase();
        tmp.sz(valueOf(tmp$ret$4));
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
    }
  }
  function Companion_3() {
    Companion_instance_3 = this;
  }
  protoOf(Companion_3).ma7 = function (str) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    tmp0_apply.oa7(str);
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  };
  var Companion_instance_3;
  function Companion_getInstance_61() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function Props(props) {
    Companion_getInstance_61();
    props = props === VOID ? LinkedHashMap_init_$Create$_0() : props;
    this.na7_1 = props;
  }
  protoOf(Props).o = function () {
    return this.na7_1.o();
  };
  protoOf(Props).a2 = function () {
    return this.na7_1.a2();
  };
  protoOf(Props).j = function () {
    return this.na7_1.j();
  };
  protoOf(Props).eb = function () {
    return this.na7_1.eb();
  };
  protoOf(Props).v2 = function () {
    this.na7_1.v2();
  };
  protoOf(Props).qo = function (key) {
    return this.na7_1.v1(key);
  };
  protoOf(Props).v1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.qo((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(Props).ro = function (key) {
    return this.na7_1.z1(key);
  };
  protoOf(Props).z1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.ro((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(Props).l = function () {
    return this.na7_1.l();
  };
  protoOf(Props).pa7 = function (key, value) {
    return this.na7_1.x3(key, value);
  };
  protoOf(Props).x3 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.pa7(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(Props).to = function (key) {
    return this.na7_1.fb(key);
  };
  protoOf(Props).fb = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.to((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(Props).qa7 = function (str) {
    var tmp0_iterator = split(str, ['\n']).g();
    $l$loop_0: while (tmp0_iterator.h()) {
      var line = tmp0_iterator.i();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      var tmp$ret$0;
      // Inline function 'kotlin.text.trim' call
      var tmp0_trim = parts.k(0);
      tmp$ret$0 = toString(trim(isCharSequence(tmp0_trim) ? tmp0_trim : THROW_CCE()));
      var key = tmp$ret$0;
      var tmp$ret$3;
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.getOrElse' call
      var tmp;
      if (1 <= get_lastIndex_0(parts)) {
        tmp = parts.k(1);
      } else {
        var tmp$ret$1;
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp$ret$1 = ' ';
        tmp = tmp$ret$1;
      }
      tmp$ret$2 = tmp;
      var tmp1_trim = tmp$ret$2;
      tmp$ret$3 = toString(trim(isCharSequence(tmp1_trim) ? tmp1_trim : THROW_CCE()));
      var value = tmp$ret$3;
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.na7_1;
      tmp2_set.x3(key, value);
    }
  };
  protoOf(Props).oa7 = function (str) {
    this.v2();
    this.qa7(str);
  };
  function $configureLoggerFromPropertiesCOROUTINE$5(file, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.la7_1 = file;
  }
  protoOf($configureLoggerFromPropertiesCOROUTINE$5).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.la7_1.a1z(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            configureLoggerFromProperties_0(ARGUMENT);
            this.ih_1 = 3;
            this.hh_1 = 4;
            continue $sm;
          case 2:
            this.ih_1 = 3;
            var tmp_0 = this.kh_1;
            if (tmp_0 instanceof Error) {
              var e = this.kh_1;
              this.hh_1 = 4;
              continue $sm;
            } else {
              throw this.kh_1;
            }

            break;
          case 3:
            throw this.kh_1;
          case 4:
            this.ih_1 = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.ih_1 === 3) {
          throw e_0;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e_0;
        }
      }
     while (true);
  };
  function Entry_0(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.ra7_1 = closeable;
  }
  protoOf(Entry_0).sa7 = function () {
    var tmp0_safe_receiver = this.ra7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c1c();
    }
    this.ra7_1 = null;
  };
  protoOf(Entry_0).dt = function () {
    this.ra7_1 = null;
  };
  function AgAutoFreeManager$entryPool$lambda(it) {
    it.dt();
    return Unit_getInstance();
  }
  function AgAutoFreeManager$entryPool$lambda_0(it) {
    return new Entry_0();
  }
  function AgAutoFreeManager() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.ta7_1 = new Pool(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.ua7_1 = FastIdentityMap();
    this.va7_1 = fastArrayListOf([]);
    this.wa7_1 = 0;
    this.xa7_1 = 60;
  }
  protoOf(AgAutoFreeManager).ya7 = function (closeable) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var tmp0_getOrPut = this.ua7_1;
      var res = get(tmp0_getOrPut, closeable);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var tmp$ret$2;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.also' call
      var tmp0_also = this.ta7_1.os();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      tmp0_also.ra7_1 = closeable;
      tmp$ret$1 = tmp0_also;
      tmp$ret$2 = tmp$ret$1;
      var out = tmp$ret$2;
      set(tmp0_getOrPut, closeable, out);
      tmp$ret$0 = out;
    }
  };
  protoOf(AgAutoFreeManager).za7 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.wa7_1;
    tmp0_this.wa7_1 = tmp1 + 1 | 0;
    if (this.wa7_1 >= this.xa7_1) {
      this.wa7_1 = 0;
      this.aa8();
    }
  };
  protoOf(AgAutoFreeManager).aa8 = function () {
    var tmp0_iterator = this.va7_1.g();
    while (tmp0_iterator.h()) {
      var entry = tmp0_iterator.i();
      if (!contains(this.ua7_1, entry.ra7_1)) {
        var tmp1_safe_receiver = entry.ra7_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.c1c();
        }
        this.ta7_1.ps(entry);
      }
    }
    this.va7_1.v2();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var tmp1_fastValueForEach = this.ua7_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp1_fastValueForEach;
    var mapIterator = tmp$ret$0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var tmp0__anonymous__q1qw7t = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var tmp2__anonymous__z9zvc9 = ensureNotNull(get(tmp1_fastValueForEach, tmp0__anonymous__q1qw7t));
      this.va7_1.b(tmp2__anonymous__z9zvc9);
    }
    clear(this.ua7_1);
  };
  protoOf(AgAutoFreeManager).c1c = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    var tmp3_fastForEach = this.va7_1;
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = tmp3_fastForEach.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var array = tmp$ret$2;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      var tmp$ret$6;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1_get = tmp0;
      var tmp$ret$3;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$3 = array;
      tmp$ret$4 = tmp$ret$3[tmp1_get];
      var tmp2_unsafeCast = tmp$ret$4;
      var tmp$ret$5;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$5 = tmp2_unsafeCast;
      tmp$ret$6 = tmp$ret$5;
      var tmp4__anonymous__pkmkx7 = tmp$ret$6;
      tmp4__anonymous__pkmkx7.sa7();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var tmp6_fastValueForEach = this.ua7_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    var tmp$ret$7;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$7 = tmp6_fastValueForEach;
    var mapIterator = tmp$ret$7.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var tmp5__anonymous__kpxxpo = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      var tmp7__anonymous__b0knam = ensureNotNull(get(tmp6_fastValueForEach, tmp5__anonymous__kpxxpo));
      tmp7__anonymous__b0knam.sa7();
    }
    this.va7_1.v2();
    this.ta7_1.v2();
    clear(this.ua7_1);
  };
  function BitmapTextureInfo() {
    this.ba8_1 = 0;
    this.ca8_1 = TextureBase_init_$Create$(null, 0, 0);
    this.da8_1 = FastIdentityMap();
  }
  protoOf(BitmapTextureInfo).dt = function () {
    this.ca8_1.ea8_1 = null;
    this.ca8_1.ga8_1 = -1;
    this.ca8_1.ha8(0);
    this.ca8_1.ia8(0);
    clear(this.da8_1);
  };
  function getTextureInfo($this, bitmap) {
    if ($this.sa8_1 === bitmap ? ensureNotNull($this.ta8_1).ca8_1.ga8_1 === bitmap.b47_1 : false)
      return ensureNotNull($this.ta8_1);
    if ($this.ua8_1 === bitmap ? ensureNotNull($this.va8_1).ca8_1.ga8_1 === bitmap.b47_1 : false)
      return ensureNotNull($this.va8_1);
    $this.ma8_1.fq(bitmap);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var tmp0_getOrPut = $this.ra8_1;
      var res = get(tmp0_getOrPut, bitmap);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var tmp$ret$2;
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.also' call
      var tmp0_also = $this.qa8_1.os();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
      var base = tmp0_also.ca8_1;
      base.ga8_1 = -1;
      var tmp = base;
      var tmp0_subject = bitmap;
      var tmp_0;
      if (tmp0_subject instanceof MultiBitmap) {
        tmp_0 = Companion_getInstance_28().u6l_1;
      } else {
        tmp_0 = Companion_getInstance_28().s6l_1;
      }
      tmp.ea8_1 = new AGTexture(tmp_0);
      base.ha8(bitmap.r46_1);
      base.ia8(bitmap.s46_1);
      tmp$ret$1 = tmp0_also;
      tmp$ret$2 = tmp$ret$1;
      var out = tmp$ret$2;
      set(tmp0_getOrPut, bitmap, out);
      tmp$ret$0 = out;
    }
    var textureInfo = tmp$ret$0;
    $this.ua8_1 = $this.sa8_1;
    $this.va8_1 = $this.ta8_1;
    var base_0 = textureInfo.ca8_1;
    $this.sa8_1 = bitmap;
    $this.ta8_1 = textureInfo;
    if (!(bitmap.b47_1 === base_0.ga8_1)) {
      base_0.ga8_1 = bitmap.b47_1;
      var tmp0_this = $this;
      var tmp_1 = tmp0_this;
      var tmp$ret$3;
      // Inline function 'kotlin.Long.minus' call
      var tmp1_minus = tmp0_this.pa8_1;
      var tmp2_minus = textureInfo.ba8_1;
      tmp$ret$3 = tmp1_minus.w(toLong(tmp2_minus));
      tmp_1.pa8_1 = tmp$ret$3;
      try {
        base_0.ba9(bitmap, bitmap.d47_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
      }finally {
        textureInfo.ba8_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
        var tmp1_this = $this;
        var tmp_2 = tmp1_this;
        var tmp$ret$4;
        // Inline function 'kotlin.Long.plus' call
        var tmp3_plus = tmp1_this.pa8_1;
        var tmp4_plus = textureInfo.ba8_1;
        tmp$ret$4 = tmp3_plus.m5(toLong(tmp4_plus));
        tmp_2.pa8_1 = tmp$ret$4;
      }
      bitmap.d48();
    }
    return textureInfo;
  }
  function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
    return imul(_this__u8e3s4.s46_1, imul(_this__u8e3s4.r46_1, _this__u8e3s4.t46_1) / 8 | 0);
  }
  function _getTexture($this, slice) {
    if ($this.wa8_1 === slice)
      return ensureNotNull($this.xa8_1);
    if ($this.ya8_1 === slice)
      return ensureNotNull($this.za8_1);
    var info = getTextureInfo($this, slice.l3s());
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var tmp0_getOrPut = info.da8_1;
      var res = get(tmp0_getOrPut, slice);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var tmp$ret$1;
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
      var tmp;
      if (slice instanceof RectSlice) {
        tmp = Texture_1(info.ca8_1).v3s(_RectangleInt___init__impl__1g5gox(slice.k3f(), slice.l3f(), slice.ck(), slice.dk()));
      } else {
        tmp = Companion_getInstance_29().e3t(info.ca8_1, slice);
      }
      tmp$ret$1 = tmp;
      var out = tmp$ret$1;
      set(tmp0_getOrPut, slice, out);
      tmp$ret$0 = out;
    }
    var texture = tmp$ret$0;
    $this.ya8_1 = $this.wa8_1;
    $this.za8_1 = $this.xa8_1;
    $this.wa8_1 = slice;
    $this.xa8_1 = texture;
    return texture;
  }
  function clearFastCacheAccess($this) {
    $this.sa8_1 = null;
    $this.ta8_1 = null;
    $this.ua8_1 = null;
    $this.va8_1 = null;
    $this.wa8_1 = null;
    $this.xa8_1 = null;
    $this.ya8_1 = null;
    $this.za8_1 = null;
  }
  function AgBitmapTextureManager$textureInfoPool$lambda(it) {
    it.dt();
    return Unit_getInstance();
  }
  function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
    return new BitmapTextureInfo();
  }
  function AgBitmapTextureManager(ag) {
    this.ja8_1 = ag;
    this.ka8_1 = new Long(0, 0);
    this.la8_1 = new FastSmallSet();
    this.ma8_1 = new FastSmallSet();
    this.na8_1 = FastArrayList_init_$Create$();
    this.oa8_1 = 60;
    this.pa8_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.qa8_1 = new Pool(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.ra8_1 = FastIdentityMap();
    this.sa8_1 = null;
    this.ta8_1 = null;
    this.ua8_1 = null;
    this.va8_1 = null;
    this.wa8_1 = null;
    this.xa8_1 = null;
    this.ya8_1 = null;
    this.za8_1 = null;
    this.aa9_1 = 0;
  }
  protoOf(AgBitmapTextureManager).ca9 = function (bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).ca8_1);
  };
  protoOf(AgBitmapTextureManager).da9 = function (slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  };
  protoOf(AgBitmapTextureManager).ea9 = function (slice) {
    return _getTexture(this, slice);
  };
  protoOf(AgBitmapTextureManager).za7 = function () {
    clearFastCacheAccess(this);
    var tmp0_this = this;
    var tmp1 = tmp0_this.aa9_1;
    tmp0_this.aa9_1 = tmp1 + 1 | 0;
    if (this.aa9_1 >= this.oa8_1) {
      this.aa9_1 = 0;
      this.aa8();
    }
  };
  protoOf(AgBitmapTextureManager).aa8 = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    var tmp3_fastForEach = this.na8_1;
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = tmp3_fastForEach.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var array = tmp$ret$2;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      var tmp$ret$6;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1_get = tmp0;
      var tmp$ret$3;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$3 = array;
      tmp$ret$4 = tmp$ret$3[tmp1_get];
      var tmp2_unsafeCast = tmp$ret$4;
      var tmp$ret$5;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$5 = tmp2_unsafeCast;
      tmp$ret$6 = tmp$ret$5;
      var tmp4__anonymous__pkmkx7 = tmp$ret$6;
      if (this.ma8_1.d1(tmp4__anonymous__pkmkx7))
      ;
      else if (this.ka8_1.v(this.pa8_1) < 0) {
        this.fa9(tmp4__anonymous__pkmkx7, 'GC');
      } else {
        this.la8_1.fq(tmp4__anonymous__pkmkx7);
      }
    }
    this.na8_1.v2();
    this.na8_1.m(this.ma8_1.eq());
    this.na8_1.m(this.la8_1.eq());
    this.ma8_1.v2();
  };
  protoOf(AgBitmapTextureManager).fa9 = function (bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.ra8_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    this.ma8_1.gq(bmp);
    if (this.ta8_1 === info ? true : this.va8_1 === info) {
      clearFastCacheAccess(this);
    }
    info.ca8_1.c1c();
    this.qa8_1.ps(info);
    var tmp1_this = this;
    var tmp_0 = tmp1_this;
    var tmp$ret$0;
    // Inline function 'kotlin.Long.minus' call
    var tmp0_minus = tmp1_this.pa8_1;
    var tmp1_minus = info.ba8_1;
    tmp$ret$0 = tmp0_minus.w(toLong(tmp1_minus));
    tmp_0.pa8_1 = tmp$ret$0;
    this.la8_1.gq(bmp);
  };
  protoOf(AgBitmapTextureManager).c1c = function () {
    clearFastCacheAccess(this);
    var tmp0_iterator = toList(get_keys(this.ra8_1)).g();
    while (tmp0_iterator.h()) {
      var bmp = tmp0_iterator.i();
      this.fa9(bmp, 'close');
    }
    clear(this.ra8_1);
    this.na8_1.v2();
    this.ma8_1.v2();
    this.la8_1.v2();
    this.qa8_1.v2();
  };
  function removeCache($this) {
  }
  function AgBufferManager$bufferPool$lambda(it) {
    return new AGBuffer();
  }
  function AgBufferManager(ag) {
    this.ga9_1 = ag;
    this.ha9_1 = FastIdentityMap();
    this.ia9_1 = new FastSmallSet();
    var tmp = this;
    tmp.ja9_1 = Pool_init_$Create$(VOID, AgBufferManager$bufferPool$lambda);
    this.ka9_1 = 0;
    this.la9_1 = 60;
    this.ma9_1 = Buffer(0);
  }
  protoOf(AgBufferManager).na9 = function (cached) {
    this.ia9_1.fq(cached);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var tmp0_getOrPut = this.ha9_1;
      var res = get(tmp0_getOrPut, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var tmp$ret$2;
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.also' call
      var tmp0_also = this.ja9_1.os();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>.<anonymous>' call
      tmp0_also.b6n(cached.oa9_1);
      tmp$ret$1 = tmp0_also;
      tmp$ret$2 = tmp$ret$1;
      var out = tmp$ret$2;
      set(tmp0_getOrPut, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  };
  protoOf(AgBufferManager).za7 = function () {
    removeCache(this);
    var tmp0_this = this;
    var tmp1 = tmp0_this.ka9_1;
    tmp0_this.ka9_1 = tmp1 + 1 | 0;
    if (this.ka9_1 >= this.la9_1) {
      this.ka9_1 = 0;
      this.aa8();
    }
  };
  protoOf(AgBufferManager).aa8 = function () {
    this.pa9(this.ia9_1.eq());
    this.ia9_1.v2();
  };
  protoOf(AgBufferManager).pa9 = function (buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.j()) {
      // Inline function 'korlibs.korge.render.AgBufferManager.delete.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp0__anonymous__q1qw7t = buffer.k(tmp0);
      this.qa9(tmp0__anonymous__q1qw7t);
    }
  };
  protoOf(AgBufferManager).qa9 = function (buffer) {
    var buf = getAndRemove(this.ha9_1, buffer);
    var tmp0_safe_receiver = buf;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp0_safe_receiver.b6n(this.ma9_1);
      this.ja9_1.ps(buf);
      tmp$ret$0 = Unit_getInstance();
    }
  };
  function AgCachedBuffer(data) {
    this.oa9_1 = data;
  }
  function get_logger() {
    _init_properties_BatchBuilder2D_kt__vdn94j();
    return logger;
  }
  var logger;
  function get_BB_MAX_TEXTURES() {
    _init_properties_BatchBuilder2D_kt__vdn94j();
    return BB_MAX_TEXTURES;
  }
  var BB_MAX_TEXTURES;
  function BatchBuilder2D$Companion$createTextureLookup$lambda($builder) {
    return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
      $this$IF_ELSE_BINARY_LOOKUP.s6v($this$IF_ELSE_BINARY_LOOKUP.t6v(), $this$IF_ELSE_BINARY_LOOKUP.z6v(Companion_getInstance_62().d9j_1[n], $this$IF_ELSE_BINARY_LOOKUP.y6v($builder.g6y(), 'xy')));
      return Unit_getInstance();
    };
  }
  function BatchBuffers() {
    this.ra9_1 = new AGBuffer();
    this.sa9_1 = new AGBuffer();
    this.ta9_1 = new AGBuffer();
    this.ua9_1 = AGVertexArrayObject_init_$Create$([new AGVertexData(Companion_getInstance_62().k9j_1, this.ra9_1), new AGVertexData(Companion_getInstance_62().l9j_1, this.sa9_1)], false);
  }
  function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
    return 6;
  }
  function applyMatrix($this, matrix, idx, vcount) {
    var f32 = get_f32($this.ya2_1);
    var idx_0 = idx;
    var ma = _Matrix___get_a__impl__f7jypo(matrix);
    var mb = _Matrix___get_b__impl__dm2icj(matrix);
    var mc = _Matrix___get_c__impl__slf2ke(matrix);
    var md = _Matrix___get_d__impl__87eht(matrix);
    var mtx = _Matrix___get_tx__impl__yc1n9(matrix);
    var mty = _Matrix___get_ty__impl__tryipg(matrix);
    var inductionVariable = 0;
    if (inductionVariable < vcount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var p = _Vector2___init__impl__67w0ru(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
        var pt = Companion_getInstance_23().i3g(ma, mb, mc, md, mtx, mty, p);
        Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, _Vector2___get_x__impl__zywdz(pt));
        Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, _Vector2___get_y__impl__ttldg6(pt));
        idx_0 = idx_0 + get_VERTEX_INDEX_SIZE() | 0;
      }
       while (inductionVariable < vcount);
  }
  function checkAvailable($this, indices, vertices) {
    return ($this.ea3_1 + indices | 0) < $this.xa2_1 ? ($this.da3_1 + vertices | 0) < $this.wa2_1 : false;
  }
  function Companion_4() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(tmp_1), null);
    var tmp_2 = tmp$ret$0;
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp$ret$1;
      // Inline function 'korlibs.korge.render.Companion.u_TexN.<anonymous>' call
      var tmp_4 = 'u_Tex' + tmp_3;
      ShaderIndices_getInstance();
      tmp$ret$1 = new Sampler(tmp_4, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_2[tmp_3] = tmp$ret$1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.d9j_1 = tmp_2;
    this.e9j_1 = 16383;
    this.f9j_1 = 8192;
    var tmp$ret$3;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace = get_logger();
    var tmp0_log = Level_TRACE_getInstance();
    var tmp_5;
    if (tmp1_trace.zz(tmp0_log)) {
      var tmp$ret$2;
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      tmp1_trace.a10(tmp0_log, tmp$ret$2);
      tmp_5 = Unit_getInstance();
    }
    tmp$ret$3 = tmp_5;
    this.g9j_1 = Attribute_init_$Create$('a_Col2', VarType_Byte4_getInstance(), true, VOID, 3);
    var tmp$ret$5;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_0 = get_logger();
    var tmp0_log_0 = Level_TRACE_getInstance();
    var tmp_6;
    if (tmp1_trace_0.zz(tmp0_log_0)) {
      var tmp$ret$4;
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      tmp1_trace_0.a10(tmp0_log_0, tmp$ret$4);
      tmp_6 = Unit_getInstance();
    }
    tmp$ret$5 = tmp_6;
    this.h9j_1 = Varying_init_$Create$('v_Col2', VarType_Float4_getInstance());
    this.i9j_1 = Attribute_init_$Create$('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.j9j_1 = Varying_init_$Create$('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    var tmp$ret$7;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_1 = get_logger();
    var tmp0_log_1 = Level_TRACE_getInstance();
    var tmp_7;
    if (tmp1_trace_1.zz(tmp0_log_1)) {
      var tmp$ret$6;
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      tmp1_trace_1.a10(tmp0_log_1, tmp$ret$6);
      tmp_7 = Unit_getInstance();
    }
    tmp$ret$7 = tmp_7;
    this.k9j_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l6s_1, DefaultShaders_getInstance().m6s_1, this.va9(), this.g9j_1]);
    this.l9j_1 = ProgramLayout_init_$Create$([this.i9j_1]);
    var tmp$ret$9;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_2 = get_logger();
    var tmp0_log_2 = Level_TRACE_getInstance();
    var tmp_8;
    if (tmp1_trace_2.zz(tmp0_log_2)) {
      var tmp$ret$8;
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      tmp1_trace_2.a10(tmp0_log_2, tmp$ret$8);
      tmp_8 = Unit_getInstance();
    }
    tmp$ret$9 = tmp_8;
    var tmp_9 = this;
    var tmp$ret$11;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    var tmp$ret$10;
    // Inline function 'kotlin.also' call
    var tmp0_also = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    tmp0_also.s6v(tmp0_also.g6y(), tmp0_also.h6y());
    tmp0_also.s6v(Companion_getInstance_62().j9j_1, Companion_getInstance_62().i9j_1);
    tmp0_also.s6v(Companion_getInstance_62().wa9(), tmp0_also.v6v([tmp0_also.k6y(tmp0_also.y6v(Companion_getInstance_62().va9(), 'rgb'), tmp0_also.y6v(Companion_getInstance_62().va9(), 'a')), tmp0_also.y6v(Companion_getInstance_62().va9(), 'a')]));
    tmp0_also.s6v(Companion_getInstance_62().h9j_1, Companion_getInstance_62().g9j_1);
    tmp0_also.s6v(tmp0_also.t6v(), tmp0_also.k6y(tmp0_also.k6y(tmp0_also.r6x(), tmp0_also.s6x()), tmp0_also.v6v([tmp0_also.l6y(), tmp0_also.u6v(0.0), tmp0_also.u6v(1.0)])));
    tmp$ret$10 = tmp0_also;
    tmp$ret$11 = VertexShader(tmp$ret$10.w6v());
    var tmp_10 = tmp$ret$11;
    var tmp$ret$14;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    var tmp$ret$13;
    // Inline function 'kotlin.also' call
    var tmp1_also = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_62().xa9(tmp1_also);
    tmp1_also.s6v(tmp1_also.t6v(), tmp1_also.k6y(tmp1_also.t6v(), Companion_getInstance_62().wa9()));
    var tmp$ret$12;
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var tmp1_IF = tmp1_also.b70(tmp1_also.y6v(tmp1_also.t6v(), 'a'), tmp1_also.u6v(0.0));
    var body = tmp1_also.q6y();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.g6z();
    var stmIf = new If(tmp1_IF, body.s6y());
    var tmp0_this = tmp1_also;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.r6v_1;
    tmp0_plusAssign.b(stmIf);
    tmp$ret$12 = stmIf;
    tmp$ret$13 = tmp1_also;
    tmp$ret$14 = FragmentShader(tmp$ret$13.w6v());
    tmp_9.m9j_1 = new Program(tmp_10, tmp$ret$14, 'BatchBuilder2D.Tinted');
    var tmp$ret$16;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_3 = get_logger();
    var tmp0_log_3 = Level_TRACE_getInstance();
    var tmp_11;
    if (tmp1_trace_3.zz(tmp0_log_3)) {
      var tmp$ret$15;
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      tmp1_trace_3.a10(tmp0_log_3, tmp$ret$15);
      tmp_11 = Unit_getInstance();
    }
    tmp$ret$16 = tmp_11;
  }
  protoOf(Companion_4).va9 = function () {
    return DefaultShaders_getInstance().n6s_1;
  };
  protoOf(Companion_4).wa9 = function () {
    return DefaultShaders_getInstance().p6s_1;
  };
  protoOf(Companion_4).xa9 = function (builder) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_62().j9j_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.e6z(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
    tmp$ret$0 = builder;
  };
  var Companion_instance_4;
  function Companion_getInstance_62() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function BatchBuilder2D$lambda(this$0) {
    return function (it) {
      var tmp0_subject = it;
      var tmp0 = tmp0_subject.j5_1;
      var tmp;
      if (tmp0 === 0) {
        this$0.za9();
        tmp = Unit_getInstance();
      } else if (tmp0 === 1) {
        this$0.ya9();
        tmp = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function BatchBuilder2D$buffers$lambda(it) {
    return new BatchBuffers();
  }
  function BatchBuilder2D(ctx, reqMaxQuads) {
    Companion_getInstance_62();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_62().f9j_1 : reqMaxQuads;
    this.qa2_1 = ctx;
    this.ra2_1 = reqMaxQuads;
    this.sa2_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.ra2_1;
    var tmp1_min = Companion_getInstance_62().e9j_1;
    tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
    tmp.ta2_1 = tmp$ret$0;
    this.ua2_1 = this.qa2_1.n9y_1;
    this.va2_1 = this.qa2_1.u9x_1;
    var tmp$ret$2;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace = get_logger();
    var tmp0_log = Level_TRACE_getInstance();
    var tmp_0;
    if (tmp1_trace.zz(tmp0_log)) {
      var tmp$ret$1;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$1 = 'BatchBuilder2D[0]';
      tmp1_trace.a10(tmp0_log, tmp$ret$1);
      tmp_0 = Unit_getInstance();
    }
    tmp$ret$2 = tmp_0;
    this.qa2_1.p9y_1.m1g(BatchBuilder2D$lambda(this));
    this.wa2_1 = imul(this.ta2_1, 4);
    this.xa2_1 = imul(this.ta2_1, 6);
    var tmp$ret$4;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_0 = get_logger();
    var tmp0_log_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (tmp1_trace_0.zz(tmp0_log_0)) {
      var tmp$ret$3;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$3 = 'BatchBuilder2D[1]';
      tmp1_trace_0.a10(tmp0_log_0, tmp$ret$3);
      tmp_1 = Unit_getInstance();
    }
    tmp$ret$4 = tmp_1;
    this.ya2_1 = Buffer(imul(24, this.wa2_1));
    this.za2_1 = new Int8Array(this.wa2_1);
    this.aa3_1 = Buffer(imul(2, this.xa2_1));
    this.ba3_1 = get_u16(this.aa3_1);
    var tmp$ret$6;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_1 = get_logger();
    var tmp0_log_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (tmp1_trace_1.zz(tmp0_log_1)) {
      var tmp$ret$5;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$5 = 'BatchBuilder2D[2]';
      tmp1_trace_1.a10(tmp0_log_1, tmp$ret$5);
      tmp_2 = Unit_getInstance();
    }
    tmp$ret$6 = tmp_2;
    this.ca3_1 = 0;
    this.da3_1 = 0;
    this.ea3_1 = 0;
    this.fa3_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.sa2_1;
    var tmp$ret$7;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$7 = fillArrayVal(Array(tmp_5), null);
    var tmp_6 = tmp$ret$7;
    while (tmp_4 < tmp_5) {
      var tmp_7 = tmp_4;
      var tmp$ret$8;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.currentTexN.<anonymous>' call
      tmp$ret$8 = null;
      tmp_6[tmp_7] = tmp$ret$8;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.ga3_1 = tmp_6;
    this.ha3_1 = false;
    this.ia3_1 = Companion_getInstance_67().wa1_1;
    this.ja3_1 = Companion_getInstance_62().m9j_1;
    var tmp$ret$10;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_2 = get_logger();
    var tmp0_log_2 = Level_TRACE_getInstance();
    var tmp_8;
    if (tmp1_trace_2.zz(tmp0_log_2)) {
      var tmp$ret$9;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$9 = 'BatchBuilder2D[3]';
      tmp1_trace_2.a10(tmp0_log_2, tmp$ret$9);
      tmp_8 = Unit_getInstance();
    }
    tmp$ret$10 = tmp_8;
    var tmp_9 = this;
    tmp_9.ka3_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    var tmp$ret$12;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_3 = get_logger();
    var tmp0_log_3 = Level_TRACE_getInstance();
    var tmp_10;
    if (tmp1_trace_3.zz(tmp0_log_3)) {
      var tmp$ret$11;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$11 = 'BatchBuilder2D[4]';
      tmp1_trace_3.a10(tmp0_log_3, tmp$ret$11);
      tmp_10 = Unit_getInstance();
    }
    tmp$ret$12 = tmp_10;
    this.la3_1 = Companion_getInstance_30().d6j_1;
    this.ma3_1 = Companion_getInstance_31().f6j_1;
    var tmp$ret$14;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_4 = get_logger();
    var tmp0_log_4 = Level_TRACE_getInstance();
    var tmp_11;
    if (tmp1_trace_4.zz(tmp0_log_4)) {
      var tmp$ret$13;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$13 = 'BatchBuilder2D[5]';
      tmp1_trace_4.a10(tmp0_log_4, tmp$ret$13);
      tmp_11 = Unit_getInstance();
    }
    tmp$ret$14 = tmp_11;
    this.na3_1 = _AGColorMask___init__impl__j38ai8();
    var tmp$ret$16;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_5 = get_logger();
    var tmp0_log_5 = Level_TRACE_getInstance();
    var tmp_12;
    if (tmp1_trace_5.zz(tmp0_log_5)) {
      var tmp$ret$15;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$15 = 'BatchBuilder2D[6]';
      tmp1_trace_5.a10(tmp0_log_5, tmp$ret$15);
      tmp_12 = Unit_getInstance();
    }
    tmp$ret$16 = tmp_12;
    this.oa3_1 = Companion_getInstance_32().r6j_1;
    var tmp$ret$18;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_6 = get_logger();
    var tmp0_log_6 = Level_TRACE_getInstance();
    var tmp_13;
    if (tmp1_trace_6.zz(tmp0_log_6)) {
      var tmp$ret$17;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$17 = 'BatchBuilder2D[7]';
      tmp1_trace_6.a10(tmp0_log_6, tmp$ret$17);
      tmp_13 = Unit_getInstance();
    }
    tmp$ret$18 = tmp_13;
    var tmp$ret$20;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_7 = get_logger();
    var tmp0_log_7 = Level_TRACE_getInstance();
    var tmp_14;
    if (tmp1_trace_7.zz(tmp0_log_7)) {
      var tmp$ret$19;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      tmp$ret$19 = 'BatchBuilder2D[11]';
      tmp1_trace_7.a10(tmp0_log_7, tmp$ret$19);
      tmp_14 = Unit_getInstance();
    }
    tmp$ret$20 = tmp_14;
    this.pa3_1 = new Signal();
    this.qa3_1 = new Signal();
    this.ra3_1 = fastArrayListOf([]);
    this.sa3_1 = 0;
    this.ta3_1 = 0;
    this.ua3_1 = 0;
  }
  protoOf(BatchBuilder2D).aaa = function () {
    return this.qa2_1.i9y_1;
  };
  protoOf(BatchBuilder2D).baa = function (value) {
    this.ca3_1 = value;
  };
  protoOf(BatchBuilder2D).caa = function () {
    return this.ca3_1;
  };
  protoOf(BatchBuilder2D).daa = function () {
    var inductionVariable = 0;
    var last = this.sa2_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ga3_1[n] = null;
      }
       while (inductionVariable < last);
    this.fa3_1 = 0;
  };
  protoOf(BatchBuilder2D).za7 = function () {
    this.ka3_1.dt();
  };
  protoOf(BatchBuilder2D).eaa = function () {
    return this.oa3_1;
  };
  protoOf(BatchBuilder2D).faa = function (vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.za2_1[vp / 6 | 0] = toByte(texIndex);
    return get_TEXTURED_ARRAY_COMPONENTS_PER_VERTEX();
  };
  protoOf(BatchBuilder2D).gaa = function (x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.haa(6, 4);
    this.iaa();
    var vp = this.da3_1;
    var vd = this.ya2_1;
    vp = vp + this.faa(vd, vp, x0, y0, tex.o3q(), tex.p3q(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.faa(vd, vp, x1, y1, tex.q3q(), tex.r3q(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.faa(vd, vp, x2, y2, tex.s3q(), tex.t3q(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.faa(vd, vp, x3, y3, tex.u3q(), tex.v3q(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.da3_1 = vp;
    var tmp0_this = this;
    tmp0_this.baa(tmp0_this.caa() + 4 | 0);
  };
  protoOf(BatchBuilder2D).jaa = function (x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.fa3_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.gaa(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.gaa.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).kaa = function (vc) {
    var tmp0_this = this;
    tmp0_this.ea3_1 = tmp0_this.ea3_1 + _addIndices(this, this.ba3_1, this.ea3_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  };
  protoOf(BatchBuilder2D).iaa = function (vc, $super) {
    vc = vc === VOID ? this.caa() : vc;
    var tmp;
    if ($super === VOID) {
      this.kaa(vc);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.kaa.call(this, vc);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).laa = function (array, matrix, vcount, icount, texIndex) {
    this.haa(icount, vcount);
    var i16 = this.ba3_1;
    var ip = this.ea3_1;
    var vc = this.caa();
    var arrayIndices = array.maa_1;
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = array.paa_1;
    tmp$ret$0 = Math.min(icount, tmp0_min);
    var icount_0 = tmp$ret$0;
    arraycopy_0(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.da3_1;
    var src = get_i32(array.qaa_1);
    var dst = get_i32(this.ya2_1);
    arraycopy_1(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.da3_1 / 6 | 0;
    arrayfill(this.za2_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (_Matrix___get_isNotNIL__impl__wjqa0f(matrix)) {
      applyMatrix(this, matrix, this.da3_1, vcount);
    }
    var tmp0_this = this;
    tmp0_this.ca3_1 = tmp0_this.ca3_1 + vcount | 0;
    var tmp1_this = this;
    tmp1_this.da3_1 = tmp1_this.da3_1 + imul(vcount, 6) | 0;
    var tmp2_this = this;
    tmp2_this.ea3_1 = tmp2_this.ea3_1 + icount_0 | 0;
  };
  protoOf(BatchBuilder2D).taa = function (array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.oaa_1 : vcount;
    icount = icount === VOID ? array.paa_1 : icount;
    texIndex = texIndex === VOID ? this.fa3_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.laa(array, matrix, vcount, icount, texIndex);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.laa.call(this, array, new Matrix(matrix), vcount, icount, texIndex);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).haa = function (indices, vertices) {
    if (indices === 0 ? vertices === 0 : false)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.uaa();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var tmp0_error = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException_init_$Create$(toString(tmp0_error));
    }
    return doFlush;
  };
  protoOf(BatchBuilder2D).vaa = function (tex, smoothing, blendMode, program, icount, vcount) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tmp0_setStateFast = tex.ea8_1;
      this.haa(icount, vcount);
      var tmp0_elvis_lhs = program;
      var pprogram = tmp0_elvis_lhs == null ? Companion_getInstance_62().m9j_1 : tmp0_elvis_lhs;
      if (this.waa(tmp0_setStateFast, smoothing, blendMode, pprogram)) {
        tmp$ret$0 = Unit_getInstance();
        break $l$block;
      }
      this.za9();
      if (!contains_0(this.ga3_1, tmp0_setStateFast)) {
        this.fa3_1 = 0;
        this.ga3_1[0] = tmp0_setStateFast;
      }
      this.ha3_1 = smoothing;
      this.ia3_1 = blendMode;
      this.ja3_1 = pprogram;
    }
  };
  protoOf(BatchBuilder2D).xaa = function (tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.ga3_1;
    var n = 0;
    while (n < tmp0_fastForEach.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach[tmp0];
      if (tmp1__anonymous__uwfjfc === tex)
        return true;
    }
    return false;
  };
  protoOf(BatchBuilder2D).waa = function (tex, smoothing, blendMode, program) {
    var hasTex = this.xaa(tex);
    if (!(this.ga3_1[0] === null) ? !hasTex : false) {
      var inductionVariable = 1;
      var last = this.ga3_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.ga3_1[n] === null) {
            this.ga3_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.ga3_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.ga3_1[n_0]) {
          this.fa3_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return ((hasTex ? this.ha3_1 === smoothing : false) ? this.ia3_1 === blendMode : false) ? this.ja3_1 === program : false;
  };
  protoOf(BatchBuilder2D).yaa = function (tex, smoothing, blendMode, program, icount, vcount) {
    this.vaa(this.ua2_1.ca9(tex), smoothing, blendMode, program, icount, vcount);
  };
  protoOf(BatchBuilder2D).zaa = function (tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.aab(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_getInstance());
  };
  protoOf(BatchBuilder2D).xa3 = function (tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.ck() : width;
    height = height === VOID ? tex.dk() : height;
    m = m === VOID ? Companion_getInstance_23().v3f_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().j48_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_67().wa1_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.zaa(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.zaa.call(this, tex, x, y, width, height, new Matrix(m), filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).aab = function (tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.vaa(tex.l3s(), filtering, blendMode, program, 6, 4);
    this.bab(x, y, width, height, m, tex, colorMul);
  };
  protoOf(BatchBuilder2D).bab = function (x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.jaa(Matrix__transformX_impl_adb2o0(m, x0, y0), Matrix__transformY_impl_aucp27(m, x0, y0), Matrix__transformX_impl_adb2o0(m, x1, y0), Matrix__transformY_impl_aucp27(m, x1, y0), Matrix__transformX_impl_adb2o0(m, x1, y1), Matrix__transformY_impl_aucp27(m, x1, y1), Matrix__transformX_impl_adb2o0(m, x0, y1), Matrix__transformY_impl_aucp27(m, x0, y1), tex, colorMul);
  };
  protoOf(BatchBuilder2D).cab = function () {
    this.ka3_1.ct_1.ta9_1.c6n(this.aa3_1, 0, imul(this.ea3_1, 2));
  };
  protoOf(BatchBuilder2D).dab = function () {
    this.qa2_1.dab();
    var inductionVariable = 0;
    var last = this.sa2_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_33().k6n(VOID, this.ha3_1);
        this.qa2_1.d9y_1.p6n(Companion_getInstance_62().d9j_1[n], this.ga3_1[n], info);
      }
       while (inductionVariable < last);
  };
  protoOf(BatchBuilder2D).za9 = function () {
    if (this.sa3_1 === this.ea3_1)
      return Unit_getInstance();
    this.dab();
    var tmp0_this = this;
    var tmp1 = tmp0_this.ta3_1;
    tmp0_this.ta3_1 = tmp1 + 1 | 0;
    var tmp2_this = this;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp2_this.ra3_1;
    var tmp3_frameBuffer = this.qa2_1.z9y_1.x6j_1;
    var tmp4_frameBufferInfo = this.qa2_1.z9y_1.k6k();
    var tmp5_vertexData = this.ka3_1.ct_1.ua9_1;
    var tmp6_indices = this.ka3_1.ct_1.ta9_1;
    var tmp7_program = this.ja3_1;
    var tmp8_drawType = Companion_getInstance_34().i6t_1;
    var tmp9_blending = this.ia3_1.eab_1;
    var tmp10_uniformBlocks = this.qa2_1.hab(this.ja3_1, false);
    var tmp11_textureUnits = this.qa2_1.d9y_1.dn();
    var tmp12_stencilOpFunc = this.ma3_1;
    var tmp13_stencilRef = this.la3_1;
    var tmp14_colorMask = this.na3_1;
    var tmp15_scissor = this.oa3_1;
    var tmp16_drawOffset = imul(this.sa3_1, 2);
    var tmp17_vertexCount = this.ea3_1 - this.sa3_1 | 0;
    var tmp1_plusAssign = new AGBatch(tmp3_frameBuffer, tmp4_frameBufferInfo, tmp5_vertexData, tmp6_indices, VOID, tmp7_program, tmp10_uniformBlocks, tmp11_textureUnits, tmp9_blending, tmp12_stencilOpFunc, tmp13_stencilRef, tmp14_colorMask, VOID, tmp15_scissor, VOID, tmp8_drawType, tmp16_drawOffset, tmp17_vertexCount);
    tmp0_plusAssign.b(tmp1_plusAssign);
    this.sa3_1 = this.ea3_1;
  };
  protoOf(BatchBuilder2D).iab = function (uploadVertices, uploadIndices) {
    this.jab(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.sa2_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ga3_1[n] = null;
      }
       while (inductionVariable < last);
    this.fa3_1 = 0;
  };
  protoOf(BatchBuilder2D).ya9 = function (uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.iab(uploadVertices, uploadIndices);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.iab.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).jab = function (uploadVertices, uploadIndices) {
    this.za9();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp0_isNotEmpty = this.ra3_1;
    tmp$ret$0 = !tmp0_isNotEmpty.l();
    if (tmp$ret$0) {
      if (uploadVertices) {
        this.ka3_1.ct_1.ra9_1.c6n(this.ya2_1, 0, imul(this.da3_1, 4));
        this.ka3_1.ct_1.sa9_1.a6n(this.za2_1, 0, this.da3_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.cab();
      }
      this.qa2_1.kab();
      draw(this.va2_1, new AGMultiBatch(toList(this.ra3_1)));
      this.ra3_1.v2();
      this.pa3_1.o1g(this);
      var tmp0_this = this;
      var tmp1 = tmp0_this.ua3_1;
      tmp0_this.ua3_1 = tmp1 + 1 | 0;
      this.qa2_1.lab();
      this.ka3_1.i();
    }
    this.baa(0);
    this.da3_1 = 0;
    this.sa3_1 = 0;
    this.ea3_1 = 0;
  };
  protoOf(BatchBuilder2D).uaa = function (uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.jab(uploadVertices, uploadIndices);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.jab.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).mab = function (vertexCount) {
    var oldVertexCount = this.caa();
    this.baa(vertexCount);
    try {
      this.pa3_1.o1g(this);
    }finally {
      this.baa(oldVertexCount);
    }
  };
  var properties_initialized_BatchBuilder2D_kt_532b2j;
  function _init_properties_BatchBuilder2D_kt__vdn94j() {
    if (properties_initialized_BatchBuilder2D_kt_532b2j) {
    } else {
      properties_initialized_BatchBuilder2D_kt_532b2j = true;
      logger = Companion_getInstance().kz('BatchBuilder2D');
      BB_MAX_TEXTURES = ((Companion_getInstance_6().xv() ? Companion_getInstance_6().zv().wu_1 : false) ? Companion_getInstance_6().zv().bv() : false) ? 1 : 4;
    }
  }
  function get_debugLineRenderContext(_this__u8e3s4) {
    _init_properties_LineRenderBatcher_kt__ezqewb();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var tmp0_getValue = debugLineRenderContext$factory();
      var tmp0_elvis_lhs = debugLineRenderContext$delegate.pu_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp0_getValue.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = debugLineRenderContext$delegate.qu_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = debugLineRenderContext$delegate.pu_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp0_getValue.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var debugLineRenderContext$delegate;
  function Companion_5() {
    Companion_instance_5 = this;
    this.nab_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l6s_1, DefaultShaders_getInstance().n6s_1]);
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = new ProgramBuilderDefault();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.s6v(builder.t6v(), builder.k6y(builder.k6y(tmp0_apply.r6x(), tmp0_apply.s6x()), builder.v6v([tmp0_apply.l6s_1, builder.u6v(0.0), builder.u6v(1.0)])));
    builder.s6v(tmp0_apply.p6s_1, tmp0_apply.n6s_1);
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = VertexShader(builder.w6v());
    tmp.oab_1 = tmp$ret$1;
    var tmp_0 = this;
    var tmp$ret$3;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = new ProgramBuilderDefault();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    var tmp$ret$2;
    // Inline function 'kotlin.apply' call
    var tmp0_apply_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.s6v(builder_0.t6v(), tmp0_apply_0.p6s_1);
    tmp$ret$2 = tmp0_apply_0;
    tmp$ret$3 = FragmentShader(builder_0.w6v());
    tmp_0.pab_1 = tmp$ret$3;
    this.qab_1 = new Program(this.oab_1, this.pab_1);
  }
  var Companion_instance_5;
  function Companion_getInstance_63() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function addVertex($this, x, y, color, m) {
    setFloat32($this.yab_1, $this.bac_1 + 0 | 0, Matrix__transformX_impl_adb2o0(m, x, y));
    setFloat32($this.yab_1, $this.bac_1 + 1 | 0, Matrix__transformY_impl_aucp27(m, x, y));
    setInt32($this.yab_1, $this.bac_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
    var tmp0_this = $this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this.bac_1;
    var tmp_1 = Companion_getInstance_63().nab_1.q6w_1;
    IntCompanionObject_getInstance();
    tmp.bac_1 = tmp_0 + (tmp_1 / 4 | 0) | 0;
    var tmp1_this = $this;
    var tmp2 = tmp1_this.aac_1;
    tmp1_this.aac_1 = tmp2 + 1 | 0;
  }
  function LineRenderBatcher$lambda(this$0) {
    return function (it) {
      this$0.hd();
      return Unit_getInstance();
    };
  }
  function LineRenderBatcher(ctx) {
    Companion_getInstance_63();
    this.rab_1 = ctx;
    this.sab_1 = new Signal();
    this.rab_1.p9y_1.m1g(LineRenderBatcher$lambda(this));
    this.tab_1 = this.rab_1.u9x_1;
    this.uab_1 = Colors_getInstance().z4d_1;
    this.vab_1 = new AGBuffer();
    this.wab_1 = AGVertexArrayObject_init_$Create$([new AGVertexData(Companion_getInstance_63().nab_1, this.vab_1)], false);
    this.xab_1 = 1024;
    this.yab_1 = allocDirect(Companion_getInstance_35(), imul(24, this.xab_1));
    this.zab_1 = Matrix4_init_$Create$();
    this.aac_1 = 0;
    this.bac_1 = 0;
    this.cac_1 = Companion_getInstance_67().wa1_1;
    this.dac_1 = Companion_getInstance_23().g3g();
  }
  protoOf(LineRenderBatcher).eac = function (p0, p1, color0, color1, m) {
    return this.fac(_Vector2___get_x__impl__zywdz(p0), _Vector2___get_y__impl__ttldg6(p0), _Vector2___get_x__impl__zywdz(p1), _Vector2___get_y__impl__ttldg6(p1), this.uab_1, color1, m);
  };
  protoOf(LineRenderBatcher).gac = function (p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.uab_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.dac_1 : m;
    var tmp;
    if ($super === VOID) {
      this.eac(p0, p1, color0, color1, m);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.eac.call(this, new Vector2(p0), new Vector2(p1), new RGBA(color0), new RGBA(color1), new Matrix(m));
    }
    return tmp;
  };
  protoOf(LineRenderBatcher).fac = function (x0, y0, x1, y1, color0, color1, m) {
    if (this.aac_1 >= (this.xab_1 - 2 | 0)) {
      this.hd();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  };
  protoOf(LineRenderBatcher).hac = function (x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.uab_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.dac_1 : m;
    var tmp;
    if ($super === VOID) {
      this.fac(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.fac.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), new Matrix(m));
    }
    return tmp;
  };
  protoOf(LineRenderBatcher).iac = function (path, m) {
    var lastPos = {_v: new Vector2(_Vector2___init__impl__67w0ru_1())};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = _Vector2___init__impl__67w0ru_1();
    var l = _Vector2___init__impl__67w0ru_1();
    var tmp$ret$0;
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    tmp$ret$0 = Unit_getInstance();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = path.z3n_1;
    var n_0 = 0;
    while (n_0 < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.ek(tmp0);
      var tmp0_subject = tmp1__anonymous__uwfjfc;
      Command_getInstance();
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = path.a3o_1.k(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var tmp2__anonymous__z9zvc9 = _Vector2___init__impl__67w0ru(tmp, path.a3o_1.k(tmp2));
        i = tmp2__anonymous__z9zvc9;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
        if (false) {
          this.gac(lastPos._v.m3j_1, tmp2__anonymous__z9zvc9, VOID, VOID, m);
        }
        lastPos._v = new Vector2(tmp2__anonymous__z9zvc9);
        l = tmp2__anonymous__z9zvc9;
      } else {
        Command_getInstance();
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = path.a3o_1.k(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var tmp3__anonymous__ufb84q = _Vector2___init__impl__67w0ru(tmp_0, path.a3o_1.k(tmp4));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          {
            this.gac(lastPos._v.m3j_1, tmp3__anonymous__ufb84q, VOID, VOID, m);
          }
          lastPos._v = new Vector2(tmp3__anonymous__ufb84q);
          l = tmp3__anonymous__ufb84q;
          var tmp$ret$1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          tmp$ret$1 = Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = path.a3o_1.k(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var tmp4__anonymous__pkmkx7 = _Vector2___init__impl__67w0ru(tmp_1, path.a3o_1.k(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = path.a3o_1.k(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var tmp5__anonymous__kpxxpo = _Vector2___init__impl__67w0ru(tmp_2, path.a3o_1.k(tmp8));
            var sum = Companion_getInstance_9().p3j(l, tmp4__anonymous__pkmkx7) + Companion_getInstance_9().p3j(tmp4__anonymous__pkmkx7, tmp5__anonymous__kpxxpo);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call
            var tmp0_approximateCurve = numberToInt(sum);
            var tmp$ret$2;
            // Inline function 'kotlin.math.max' call
            tmp$ret$2 = Math.max(tmp0_approximateCurve, 20);
            var rcurveSteps = tmp$ret$2;
            var dt = 1.0 / rcurveSteps;
            var lastPos_0 = {_v: new Vector2(_Vector2___init__impl__67w0ru_1())};
            var prevPos = {_v: new Vector2(_Vector2___init__impl__67w0ru_1())};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var tmp1__anonymous__uwfjfc_0 = Companion_getInstance_36().l3l(l, tmp4__anonymous__pkmkx7, tmp5__anonymous__kpxxpo, 0.0);
            lastPos_0._v = new Vector2(tmp1__anonymous__uwfjfc_0);
            var nStart = false ? 0 : 1;
            var nEnd = rcurveSteps;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio = n_1 * dt;
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var tmp2__anonymous__z9zvc9_0 = Companion_getInstance_36().l3l(l, tmp4__anonymous__pkmkx7, tmp5__anonymous__kpxxpo, ratio);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                {
                  this.gac(lastPos._v.m3j_1, tmp2__anonymous__z9zvc9_0, VOID, VOID, m);
                }
                lastPos._v = new Vector2(tmp2__anonymous__z9zvc9_0);
                var tmp0_0 = emittedCount._v;
                emittedCount._v = tmp0_0 + 1 | 0;
                lastPos_0._v = prevPos._v;
                prevPos._v = new Vector2(tmp2__anonymous__z9zvc9_0);
              }
               while (!(n_1 === nEnd));
            l = tmp5__anonymous__kpxxpo;
            var tmp$ret$3;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            tmp$ret$3 = Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = path.a3o_1.k(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var tmp6__anonymous__fv9ai5 = _Vector2___init__impl__67w0ru(tmp_3, path.a3o_1.k(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = path.a3o_1.k(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var tmp7__anonymous__b0knam = _Vector2___init__impl__67w0ru(tmp_4, path.a3o_1.k(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = path.a3o_1.k(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var tmp8__anonymous__65w033 = _Vector2___init__impl__67w0ru(tmp_5, path.a3o_1.k(tmp14));
              var sum_0 = Companion_getInstance_9().p3j(l, tmp6__anonymous__fv9ai5) + Companion_getInstance_9().p3j(tmp6__anonymous__fv9ai5, tmp7__anonymous__b0knam) + Companion_getInstance_9().p3j(tmp7__anonymous__b0knam, tmp8__anonymous__65w033);
              // Inline function 'korlibs.math.geom.shape.approximateCurve' call
              var tmp0_approximateCurve_0 = numberToInt(sum_0);
              var tmp$ret$4;
              // Inline function 'kotlin.math.max' call
              tmp$ret$4 = Math.max(tmp0_approximateCurve_0, 20);
              var rcurveSteps_0 = tmp$ret$4;
              var dt_0 = 1.0 / rcurveSteps_0;
              var lastPos_1 = {_v: new Vector2(_Vector2___init__impl__67w0ru_1())};
              var prevPos_0 = {_v: new Vector2(_Vector2___init__impl__67w0ru_1())};
              var emittedCount_0 = {_v: 0};
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var tmp1__anonymous__uwfjfc_1 = Companion_getInstance_36().k3l(l, tmp6__anonymous__fv9ai5, tmp7__anonymous__b0knam, tmp8__anonymous__65w033, 0.0);
              lastPos_1._v = new Vector2(tmp1__anonymous__uwfjfc_1);
              var nStart_0 = false ? 0 : 1;
              var nEnd_0 = rcurveSteps_0;
              var inductionVariable_0 = nStart_0;
              if (inductionVariable_0 <= nEnd_0)
                do {
                  var n_2 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var ratio_0 = n_2 * dt_0;
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                  var tmp2__anonymous__z9zvc9_1 = Companion_getInstance_36().k3l(l, tmp6__anonymous__fv9ai5, tmp7__anonymous__b0knam, tmp8__anonymous__65w033, ratio_0);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                  {
                    this.gac(lastPos._v.m3j_1, tmp2__anonymous__z9zvc9_1, VOID, VOID, m);
                  }
                  lastPos._v = new Vector2(tmp2__anonymous__z9zvc9_1);
                  var tmp0_1 = emittedCount_0._v;
                  emittedCount_0._v = tmp0_1 + 1 | 0;
                  lastPos_1._v = prevPos_0._v;
                  prevPos_0._v = new Vector2(tmp2__anonymous__z9zvc9_1);
                }
                 while (!(n_2 === nEnd_0));
              l = tmp8__anonymous__65w033;
              var tmp$ret$5;
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              tmp$ret$5 = Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                var tmp9__anonymous__1b7cvk = i;
                {
                  this.gac(lastPos._v.m3j_1, tmp9__anonymous__1b7cvk, VOID, VOID, m);
                }
                lastPos._v = new Vector2(tmp9__anonymous__1b7cvk);
                var tmp$ret$6;
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                tmp$ret$6 = Unit_getInstance();
                var tmp$ret$7;
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                tmp$ret$7 = Unit_getInstance();
              }
            }
          }
        }
      }
    }
    var tmp$ret$8;
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    tmp$ret$8 = Unit_getInstance();
  };
  protoOf(LineRenderBatcher).hd = function () {
    if (this.aac_1 > 0) {
      this.sab_1.o1g(this);
      this.vab_1.c6n(this.yab_1, 0, imul(this.bac_1, 4));
      this.rab_1.dab();
      var tmp0_$receiver = this.tab_1;
      var tmp1_frameBuffer = this.rab_1.z9y_1;
      var tmp2_vertexData = this.wab_1;
      var tmp3_program = Companion_getInstance_63().qab_1;
      var tmp4_drawType = Companion_getInstance_34().h6t_1;
      var tmp5_vertexCount = this.aac_1;
      var tmp6_uniformBlocks = this.rab_1.jac(Companion_getInstance_63().qab_1);
      var tmp7_blending = this.cac_1.eab_1;
      draw_0(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.aac_1 = 0;
    this.bac_1 = 0;
  };
  function debugLineRenderContext$delegate$lambda($this$$receiver) {
    _init_properties_LineRenderBatcher_kt__ezqewb();
    return new LineRenderBatcher($this$$receiver);
  }
  function debugLineRenderContext$factory() {
    return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
      return get_debugLineRenderContext(receiver);
    }, null);
  }
  var properties_initialized_LineRenderBatcher_kt_urwcod;
  function _init_properties_LineRenderBatcher_kt__ezqewb() {
    if (properties_initialized_LineRenderBatcher_kt_urwcod) {
    } else {
      properties_initialized_LineRenderBatcher_kt_urwcod = true;
      debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
    }
  }
  var FlushKind_STATE_instance;
  var FlushKind_FULL_instance;
  var FlushKind_entriesInitialized;
  function FlushKind_initEntries() {
    if (FlushKind_entriesInitialized)
      return Unit_getInstance();
    FlushKind_entriesInitialized = true;
    FlushKind_STATE_instance = new FlushKind('STATE', 0);
    FlushKind_FULL_instance = new FlushKind('FULL', 1);
  }
  function FlushKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RenderContext$tempTexturePool$lambda(it) {
    return new AGTexture();
  }
  function RenderContext$projViewMatUB$delegate$lambda(this$0) {
    return function () {
      return this$0.i6p(ProjViewUB_getInstance());
    };
  }
  function RenderContext$dynamicVertexBufferPool$lambda(it) {
    return new AGBuffer();
  }
  function RenderContext$frameBuffers$lambda(it) {
    return AGFrameBuffer_init_$Create$(VOID, it);
  }
  function RenderContext$textureDrawer$delegate$lambda(this$0) {
    return function () {
      return new AGTextureDrawer(this$0.u9x_1);
    };
  }
  function RenderContext$drawTempTexture$delegate$lambda() {
    return new AGTexture();
  }
  function FlushKind_FULL_getInstance() {
    FlushKind_initEntries();
    return FlushKind_FULL_instance;
  }
  function RenderContext(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_getInstance() : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_62().f9j_1 : batchMaxQuads;
    this.u9x_1 = ag;
    this.v9x_1 = bp;
    this.w9x_1 = deviceDimensionsProvider;
    this.x9x_1 = stats;
    this.y9x_1 = coroutineContext;
    this.z9x_1 = batchMaxQuads;
    this.a9y_1 = new Mixin();
    this.b9y_1 = new BufferCache();
    this.c9y_1 = FastIdentityMap();
    this.d9y_1 = AGTextureUnits_init_$Create$();
    this.e9y_1 = Companion_getInstance_23().g3g();
    this.f9y_1 = Companion_getInstance_23().g3g();
    this.g9y_1 = Matrix4_init_$Create$();
    this.h9y_1 = Matrix4_init_$Create$();
    this.i9y_1 = Companion_getInstance_23().g3g();
    this.j9y_1 = true;
    var tmp_0 = this;
    tmp_0.k9y_1 = Pool_init_$Create$(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.l9y_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.m9y_1 = new AgAutoFreeManager();
    this.n9y_1 = new AgBitmapTextureManager(this.u9x_1);
    this.o9y_1 = new AgBufferManager(this.u9x_1);
    this.p9y_1 = new Signal();
    var tmp_2 = this;
    var tmp_3 = this.v9x_1;
    tmp_2.q9y_1 = tmp_3 instanceof Views ? tmp_3 : null;
    this.r9y_1 = null;
    this.s9y_1 = 1.0;
    this.t9y_1 = Colors_getInstance().j48_1;
    this.u9y_1 = new BatchBuilder2D(this, this.z9x_1);
    var tmp_4 = this;
    tmp_4.v9y_1 = Pool_init_$Create$(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.w9y_1 = new RenderContext2D(this.u9y_1, this.n9y_1);
    this.x9y_1 = true;
    this.y9y_1 = null;
    this.z9y_1 = this.u9x_1.e6i_1;
    this.a9z_1 = LinkedHashSet_init_$Create$();
    var tmp_5 = this;
    tmp_5.b9z_1 = Pool_init_$Create$(VOID, RenderContext$frameBuffers$lambda);
    this.c9z_1 = FastArrayList_init_$Create$();
    var tmp_6 = this;
    tmp_6.d9z_1 = lazy(RenderContext$textureDrawer$delegate$lambda(this));
    var tmp_7 = this;
    tmp_7.e9z_1 = lazy(RenderContext$drawTempTexture$delegate$lambda);
  }
  protoOf(RenderContext).lu = function (_set____db54di) {
    this.a9y_1.lu(_set____db54di);
  };
  protoOf(RenderContext).mu = function () {
    return this.a9y_1.mu();
  };
  protoOf(RenderContext).kac = function (_set____db54di) {
    this.v9x_1.kac(_set____db54di);
  };
  protoOf(RenderContext).lac = function (_set____db54di) {
    this.v9x_1.lac(_set____db54di);
  };
  protoOf(RenderContext).mac = function () {
    return this.v9x_1.mac();
  };
  protoOf(RenderContext).nac = function () {
    return this.v9x_1.nac();
  };
  protoOf(RenderContext).oac = function (_set____db54di) {
    this.v9x_1.oac(_set____db54di);
  };
  protoOf(RenderContext).pac = function () {
    return this.v9x_1.pac();
  };
  protoOf(RenderContext).qac = function (_set____db54di) {
    this.v9x_1.qac(_set____db54di);
  };
  protoOf(RenderContext).rac = function () {
    return this.v9x_1.rac();
  };
  protoOf(RenderContext).sac = function () {
    return this.v9x_1.sac();
  };
  protoOf(RenderContext).tac = function (_set____db54di) {
    this.v9x_1.tac(_set____db54di);
  };
  protoOf(RenderContext).uac = function () {
    return this.v9x_1.uac();
  };
  protoOf(RenderContext).c9u = function (pos) {
    return this.v9x_1.c9u(pos);
  };
  protoOf(RenderContext).z6h = function () {
    return this.u9x_1.z6h();
  };
  protoOf(RenderContext).a6i = function () {
    return this.u9x_1.a6i();
  };
  protoOf(RenderContext).x6h = function () {
    return this.u9x_1.x6h();
  };
  protoOf(RenderContext).k7x = function () {
    return this.w9x_1.k7x();
  };
  protoOf(RenderContext).h7x = function () {
    return this.w9x_1.h7x();
  };
  protoOf(RenderContext).i7x = function () {
    return this.w9x_1.i7x();
  };
  protoOf(RenderContext).j7x = function () {
    return this.w9x_1.j7x();
  };
  protoOf(RenderContext).lab = function () {
  };
  protoOf(RenderContext).vac = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = projViewMatUB$factory();
    tmp$ret$0 = this.l9y_1.q();
    return tmp$ret$0;
  };
  protoOf(RenderContext).dab = function () {
    if (this.j9y_1 ? this.z9y_1.l6o() : false) {
      this.g9y_1 = Companion_getInstance_37().l3h(Companion_getInstance_38().r3i(0, this.z9y_1.f6k_1, this.z9y_1.e6k_1, 0), -1.0, 1.0);
    } else {
      this.g9y_1 = Companion_getInstance_37().l3h(Companion_getInstance_38().r3i(0, 0, this.z9y_1.e6k_1, this.z9y_1.f6k_1), -1.0, 1.0);
      this.g9y_1 = this.g9y_1.m3h(toMatrix4(this.e9y_1));
    }
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var tmp0_push = this.vac();
      var tmp0_this = tmp0_push;
      var tmp1 = tmp0_this.x6q();
      tmp0_this.a7b(tmp1 + 1 | 0);
      tmp0_push.tn(tmp0_push.x6q() + 1 | 0);
      var blockSize = tmp0_push.a6p_1;
      var index0 = imul(tmp0_push.x6q() - 1 | 0, blockSize);
      var index1 = imul(tmp0_push.x6q(), blockSize);
      var texBlockSize = tmp0_push.y6o_1.t6x().j();
      var texIndex0 = imul(tmp0_push.x6q() - 1 | 0, texBlockSize);
      var texIndex1 = imul(tmp0_push.x6q(), texBlockSize);
      if (tmp0_push.x6q() > 0) {
        arraycopy_2(tmp0_push.c6p_1, index0, tmp0_push.c6p_1, index1, blockSize);
      } else {
        arrayfill_0(tmp0_push.c6p_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var tmp1__anonymous__uwfjfc = tmp0_push.y6o_1;
      var tmp2__anonymous__z9zvc9 = tmp0_push.d6p_1;
      tmp2__anonymous__z9zvc9.h7b(tmp1__anonymous__uwfjfc.r6x(), this.g9y_1);
      tmp2__anonymous__z9zvc9.h7b(tmp1__anonymous__uwfjfc.s6x(), this.h9y_1);
      if (tmp0_push.x6q() >= 1) {
        var equals = arrayequal(tmp0_push.c6p_1, index0, tmp0_push.c6p_1, index1, blockSize);
        if (equals) {
          var tmp2_this = tmp0_push;
          var tmp3 = tmp2_this.x6q();
          tmp2_this.a7b(tmp3 - 1 | 0);
          tmp$ret$0 = false;
          break $l$block;
        }
      }
      tmp$ret$0 = true;
    }
  };
  protoOf(RenderContext).wac = function () {
    return coerceAtLeast_0(round(this.k7x() * this.s9y_1), 1.0);
  };
  protoOf(RenderContext).xac = function (kind) {
    this.p9y_1.o1g(kind);
  };
  protoOf(RenderContext).va3 = function (kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.xac(kind);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.xac.call(this, kind);
    }
    return tmp;
  };
  protoOf(RenderContext).yac = function () {
    var tmp0_elvis_lhs = this.z9y_1;
    return tmp0_elvis_lhs == null ? this.f9z() : tmp0_elvis_lhs;
  };
  protoOf(RenderContext).zac = function () {
    return this.yac() === this.f9z();
  };
  protoOf(RenderContext).f9z = function () {
    return this.u9x_1.e6i_1;
  };
  protoOf(RenderContext).aad = function (color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.u9x_1.l6i(this.z9y_1.x6j_1, this.z9y_1.k6k(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  };
  protoOf(RenderContext).bad = function (color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().o48_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_32().r6j_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.aad(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.aad.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, new AGScissor(scissor));
    }
    return tmp;
  };
  protoOf(RenderContext).i6i = function () {
    this.u9x_1.i6i();
    this.b9z_1.qs(this.a9z_1);
    var tmp$ret$0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp0_isNotEmpty = this.a9z_1;
    tmp$ret$0 = !tmp0_isNotEmpty.l();
    if (tmp$ret$0) {
      this.a9z_1.v2();
    }
  };
  protoOf(RenderContext).wa3 = function (bmp) {
    return this.n9y_1.da9(bmp);
  };
  protoOf(RenderContext).cad = function (bmp) {
    return this.n9y_1.ea9(bmp);
  };
  protoOf(RenderContext).na9 = function (buffer) {
    return this.o9y_1.na9(buffer);
  };
  protoOf(RenderContext).dad = function (closeable) {
    return this.m9y_1.ya7(closeable);
  };
  protoOf(RenderContext).daa = function () {
    this.u9y_1.daa();
  };
  protoOf(RenderContext).za7 = function () {
    this.va3();
    this.i6i();
    this.u9y_1.za7();
    this.m9y_1.za7();
    this.n9y_1.za7();
    this.o9y_1.za7();
  };
  protoOf(RenderContext).c1c = function () {
    this.n9y_1.c1c();
    this.m9y_1.c1c();
  };
  protoOf(RenderContext).ead = function (width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    tmp$ret$0 = Math.max(width, 64);
    var realWidth = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.math.max' call
    tmp$ret$1 = Math.max(height, 64);
    var realHeight = tmp$ret$1;
    var rb = this.b9z_1.os();
    if (onlyThisFrame) {
      var tmp0_this = this;
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp0_plusAssign = tmp0_this.a9z_1;
      tmp0_plusAssign.b(rb);
    }
    rb.s6o(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.u6o(hasDepth, hasStencil);
    rb.t6o(msamples);
    return rb;
  };
  protoOf(RenderContext).fad = function (width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.ead(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.ead.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  };
  protoOf(RenderContext).gad = function (rb) {
    if (this.a9z_1.t2(rb)) {
    }
    this.b9z_1.ps(rb);
  };
  protoOf(RenderContext).g9z = function (frameBuffer) {
    this.c9z_1.b(this.z9y_1);
    this.z9y_1 = frameBuffer;
  };
  protoOf(RenderContext).h9z = function () {
    this.z9y_1 = this.c9z_1.u2(this.c9z_1.j() - 1 | 0);
  };
  protoOf(RenderContext).i6p = function (uniformBlock) {
    return this.b9y_1.i6p(uniformBlock);
  };
  protoOf(RenderContext).had = function (program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var tmp0_getOrPut = this.c9y_1;
      var res = get(tmp0_getOrPut, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var tmp$ret$1;
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      tmp$ret$1 = new AGProgramWithUniforms(program, this.b9y_1);
      var out = tmp$ret$1;
      set(tmp0_getOrPut, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  };
  protoOf(RenderContext).hab = function (program, autoUpload) {
    if (autoUpload) {
      this.kab();
    }
    return this.had(program).w6q();
  };
  protoOf(RenderContext).jac = function (program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.hab(program, autoUpload) : $super.hab.call(this, program, autoUpload);
  };
  protoOf(RenderContext).kab = function () {
    this.b9y_1.g6p();
  };
  function projViewMatUB$factory() {
    return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
      return receiver.vac();
    }, null);
  }
  function get_logger_0() {
    _init_properties_RenderContext2D_kt__7o43tz();
    return logger_0;
  }
  var logger_0;
  function RenderContext2D$mpool$lambda(it) {
    return new MMatrix();
  }
  function RenderContext2D(batch, agBitmapTextureManager) {
    this.iad_1 = batch;
    this.jad_1 = agBitmapTextureManager;
    this.kad_1 = new Mixin();
    var tmp$ret$1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace = get_logger_0();
    var tmp0_log = Level_TRACE_getInstance();
    var tmp;
    if (tmp1_trace.zz(tmp0_log)) {
      var tmp$ret$0;
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      tmp$ret$0 = 'RenderContext2D[0]';
      tmp1_trace.a10(tmp0_log, tmp$ret$0);
      tmp = Unit_getInstance();
    }
    tmp$ret$1 = tmp;
    this.lad_1 = _Size___init__impl__aywn0g_0(0, 0);
    var tmp_0 = this;
    tmp_0.mad_1 = Pool_init_$Create$(VOID, RenderContext2D$mpool$lambda);
    var tmp$ret$3;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_0 = get_logger_0();
    var tmp0_log_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (tmp1_trace_0.zz(tmp0_log_0)) {
      var tmp$ret$2;
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      tmp$ret$2 = 'RenderContext2D[1]';
      tmp1_trace_0.a10(tmp0_log_0, tmp$ret$2);
      tmp_1 = Unit_getInstance();
    }
    tmp$ret$3 = tmp_1;
    this.nad_1 = Companion_getInstance_23().v3f_1;
    this.oad_1 = Companion_getInstance_67().wa1_1;
    this.pad_1 = Colors_getInstance().j48_1;
    this.qad_1 = true;
    var tmp$ret$5;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace_1 = get_logger_0();
    var tmp0_log_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (tmp1_trace_1.zz(tmp0_log_1)) {
      var tmp$ret$4;
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      tmp$ret$4 = 'RenderContext2D[2]';
      tmp1_trace_1.a10(tmp0_log_1, tmp$ret$4);
      tmp_2 = Unit_getInstance();
    }
    tmp$ret$5 = tmp_2;
  }
  protoOf(RenderContext2D).lu = function (_set____db54di) {
    this.kad_1.lu(_set____db54di);
  };
  protoOf(RenderContext2D).mu = function () {
    return this.kad_1.mu();
  };
  protoOf(RenderContext2D).rad = function (scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var tmp0_transform = this.nad_1;
      var tmp1_transform = _Vector2___init__impl__67w0ru_2(_AGScissor___get_left__impl__jiavfz(scissor), _AGScissor___get_top__impl__wmf8dv(scissor));
      if (_Matrix___get_isNIL__impl__n63x5q(tmp0_transform)) {
        tmp$ret$0 = tmp1_transform;
        break $l$block;
      }
      tmp$ret$0 = _Vector2___init__impl__67w0ru(_Matrix___get_a__impl__f7jypo(tmp0_transform) * _Vector2___get_x__impl__zywdz(tmp1_transform) + _Matrix___get_c__impl__slf2ke(tmp0_transform) * _Vector2___get_y__impl__ttldg6(tmp1_transform) + _Matrix___get_tx__impl__yc1n9(tmp0_transform), _Matrix___get_d__impl__87eht(tmp0_transform) * _Vector2___get_y__impl__ttldg6(tmp1_transform) + _Matrix___get_b__impl__dm2icj(tmp0_transform) * _Vector2___get_x__impl__zywdz(tmp1_transform) + _Matrix___get_ty__impl__tryipg(tmp0_transform));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var tmp2_transform = this.nad_1;
      var tmp3_transform = _Vector2___init__impl__67w0ru_2(_AGScissor___get_right__impl__3hpzkc(scissor), _AGScissor___get_bottom__impl__6wmhqj(scissor));
      if (_Matrix___get_isNIL__impl__n63x5q(tmp2_transform)) {
        tmp$ret$1 = tmp3_transform;
        break $l$block_0;
      }
      tmp$ret$1 = _Vector2___init__impl__67w0ru(_Matrix___get_a__impl__f7jypo(tmp2_transform) * _Vector2___get_x__impl__zywdz(tmp3_transform) + _Matrix___get_c__impl__slf2ke(tmp2_transform) * _Vector2___get_y__impl__ttldg6(tmp3_transform) + _Matrix___get_tx__impl__yc1n9(tmp2_transform), _Matrix___get_d__impl__87eht(tmp2_transform) * _Vector2___get_y__impl__ttldg6(tmp3_transform) + _Matrix___get_b__impl__dm2icj(tmp2_transform) * _Vector2___get_x__impl__zywdz(tmp3_transform) + _Matrix___get_ty__impl__tryipg(tmp2_transform));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_32().e6s(_Vector2___get_x__impl__zywdz(tl), _Vector2___get_y__impl__ttldg6(tl), _Vector2___get_x__impl__zywdz(br), _Vector2___get_y__impl__ttldg6(br));
  };
  var properties_initialized_RenderContext2D_kt_ica10b;
  function _init_properties_RenderContext2D_kt__7o43tz() {
    if (properties_initialized_RenderContext2D_kt_ica10b) {
    } else {
      properties_initialized_RenderContext2D_kt_ica10b = true;
      logger_0 = Companion_getInstance().kz('RenderContext2D');
    }
  }
  function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
    $this$FUNC.h6z($this$FUNC.g7i(a, b, c));
    return Unit_getInstance();
  }
  function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
    $this$FUNC.h6z($this$FUNC.d7i(a, b));
    return Unit_getInstance();
  }
  function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
    $this$FUNC.h6z($this$FUNC.e7i(a, b));
    return Unit_getInstance();
  }
  function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
    $this$FUNC.h6z($this$FUNC.e7i(a, $this$FUNC.w6z(b)));
    return Unit_getInstance();
  }
  function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
    $this$FUNC.h6z($this$FUNC.x6z(d, r));
    return Unit_getInstance();
  }
  function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
    $this$FUNC.h6z($this$FUNC.x6z($this$FUNC.o6z(d), r));
    return Unit_getInstance();
  }
  function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
    var tmp$ret$0;
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var tmp1_IF = $this$FUNC.m7i(d, 0.0);
    var body = $this$FUNC.q6y();
    // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
    body.h6z(d);
    var stmIf = new If(tmp1_IF, body.s6y());
    var tmp0_this = $this$FUNC;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.r6v_1;
    tmp0_plusAssign.b(stmIf);
    tmp$ret$0 = stmIf;
    var tmp = tmp$ret$0;
    $this$FUNC.d6z(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
    return Unit_getInstance();
  }
  function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
    return function ($this$null) {
      $this$null.h6z($this$null.x6z($this$null.o6z($d), $r));
      return Unit_getInstance();
    };
  }
  function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
    $this$FUNC.h6z($this$FUNC.i7i(1.0, $this$FUNC.c7i($this$FUNC.k7i($this$FUNC.p6y(d, $this$FUNC.f7i(d)), 0.5), $this$FUNC.u6v(0.0), $this$FUNC.u6v(1.0))));
    return Unit_getInstance();
  }
  function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
    $this$FUNC.h6z($this$FUNC.c7i($this$FUNC.k7i($this$FUNC.p6y(d, $this$FUNC.f7i(d)), 0.5), $this$FUNC.u6v(0.0), $this$FUNC.u6v(1.0)));
    return Unit_getInstance();
  }
  function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
    var h = $this$FUNC.z7h($this$FUNC.k6z());
    $this$FUNC.s6v(h, $this$FUNC.c7i($this$FUNC.j7i(0.5, $this$FUNC.p6y($this$FUNC.l7i(0.5, $this$FUNC.x6z(d2, d1)), k)), $this$FUNC.u6v(0.0), $this$FUNC.u6v(1.0)));
    $this$FUNC.h6z($this$FUNC.x6z($this$FUNC.g7i(d2, d1, h), $this$FUNC.k6y($this$FUNC.k6y(k, h), $this$FUNC.i7i(1.0, h))));
    return Unit_getInstance();
  }
  function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
    var h = $this$FUNC.z7h($this$FUNC.k6z());
    $this$FUNC.s6v(h, $this$FUNC.c7i($this$FUNC.i7i(0.5, $this$FUNC.p6y($this$FUNC.l7i(0.5, $this$FUNC.y6z(d2, d1)), k)), $this$FUNC.u6v(0.0), $this$FUNC.u6v(1.0)));
    $this$FUNC.h6z($this$FUNC.y6z($this$FUNC.g7i(d2, $this$FUNC.w6z(d1), h), $this$FUNC.k6y($this$FUNC.k6y(k, h), $this$FUNC.i7i(1.0, h))));
    return Unit_getInstance();
  }
  function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
    var h = $this$FUNC.z7h($this$FUNC.k6z());
    $this$FUNC.s6v(h, $this$FUNC.c7i($this$FUNC.i7i(0.5, $this$FUNC.p6y($this$FUNC.l7i(0.5, $this$FUNC.x6z(d2, d1)), k)), $this$FUNC.u6v(0.0), $this$FUNC.u6v(1.0)));
    $this$FUNC.h6z($this$FUNC.y6z($this$FUNC.g7i(d2, d1, h), $this$FUNC.k6y($this$FUNC.k6y(k, h), $this$FUNC.i7i(1.0, h))));
    return Unit_getInstance();
  }
  function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
    $this$FUNC.h6z($this$FUNC.x6z($this$FUNC.h7i(p), r));
    return Unit_getInstance();
  }
  function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
    var q = $this$FUNC.z7h($this$FUNC.a7i());
    $this$FUNC.s6v($this$FUNC.y6v(r, 'xy'), $this$FUNC.b7i($this$FUNC.m7i($this$FUNC.s6z(p), 0.0), $this$FUNC.y6v(r, 'xy'), $this$FUNC.y6v(r, 'zw')));
    $this$FUNC.s6v($this$FUNC.s6z(r), $this$FUNC.b7i($this$FUNC.m7i($this$FUNC.t6z(p), 0.0), $this$FUNC.s6z(r), $this$FUNC.t6z(r)));
    $this$FUNC.s6v(q, $this$FUNC.y6z($this$FUNC.x6z($this$FUNC.o6z(p), b), $this$FUNC.s6z(r)));
    $this$FUNC.h6z($this$FUNC.x6z($this$FUNC.y6z($this$FUNC.d7i($this$FUNC.e7i($this$FUNC.s6z(q), $this$FUNC.t6z(q)), $this$FUNC.u6v(0.0)), $this$FUNC.h7i($this$FUNC.e7i(q, $this$FUNC.u6v(0.0)))), $this$FUNC.s6z(r)));
    return Unit_getInstance();
  }
  function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
    var d = $this$FUNC.z7h($this$FUNC.a7i());
    $this$FUNC.s6v(d, $this$FUNC.x6z($this$FUNC.o6z(p), b));
    $this$FUNC.h6z($this$FUNC.y6z($this$FUNC.h7i($this$FUNC.e7i(d, $this$FUNC.u6v(0.0))), $this$FUNC.d7i($this$FUNC.e7i($this$FUNC.s6z(d), $this$FUNC.t6z(d)), $this$FUNC.u6v(0.0))));
    return Unit_getInstance();
  }
  function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
    $this$FUNC.h6z($this$FUNC.y6z(src, $this$FUNC.k6y(dst, $this$FUNC.i7i(1.0, $this$FUNC.n6y(src)))));
    return Unit_getInstance();
  }
  function SDFShaders() {
    SDFShaders_instance = this;
    Builder.call(this);
    var tmp = this;
    var tmp_0 = this.k6z();
    var tmp_1 = this.k6z();
    var tmp_2 = this.k6z();
    var tmp_3 = this.k6z();
    tmp.uad_1 = this.a6z(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).f6y(this, opInterpolate$factory());
    var tmp_4 = this;
    var tmp_5 = this.k6z();
    var tmp_6 = this.k6z();
    var tmp_7 = this.k6z();
    tmp_4.vad_1 = this.y6y(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).f6y(this, opUnion$factory());
    var tmp_8 = this;
    var tmp_9 = this.k6z();
    var tmp_10 = this.k6z();
    var tmp_11 = this.k6z();
    tmp_8.wad_1 = this.y6y(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).f6y(this, opIntersect$factory());
    var tmp_12 = this;
    var tmp_13 = this.k6z();
    var tmp_14 = this.k6z();
    var tmp_15 = this.k6z();
    tmp_12.xad_1 = this.y6y(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).f6y(this, opSubtract$factory());
    var tmp_16 = this;
    var tmp_17 = this.k6z();
    var tmp_18 = this.k6z();
    var tmp_19 = this.k6z();
    tmp_16.yad_1 = this.y6y(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).f6y(this, opRound$factory());
    var tmp_20 = this;
    var tmp_21 = this.k6z();
    var tmp_22 = this.k6z();
    var tmp_23 = this.k6z();
    tmp_20.zad_1 = this.y6y(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).f6y(this, opBorder$factory());
    var tmp_24 = this;
    var tmp_25 = this.k6z();
    var tmp_26 = this.k6z();
    var tmp_27 = this.k6z();
    tmp_24.aae_1 = this.y6y(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).f6y(this, opBorderInner$factory());
    var tmp_28 = this;
    var tmp_29 = this.k6z();
    var tmp_30 = this.k6z();
    tmp_28.bae_1 = this.w6y(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).f6y(this, opAA$factory());
    var tmp_31 = this;
    var tmp_32 = this.k6z();
    var tmp_33 = this.k6z();
    tmp_31.cae_1 = this.w6y(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).f6y(this, opAARev$factory());
    var tmp_34 = this;
    var tmp_35 = this.k6z();
    var tmp_36 = this.k6z();
    var tmp_37 = this.k6z();
    var tmp_38 = this.k6z();
    tmp_34.dae_1 = this.a6z(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).f6y(this, opSmoothUnion$factory());
    var tmp_39 = this;
    var tmp_40 = this.k6z();
    var tmp_41 = this.k6z();
    var tmp_42 = this.k6z();
    var tmp_43 = this.k6z();
    tmp_39.eae_1 = this.a6z(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).f6y(this, opSmoothSubtraction$factory());
    var tmp_44 = this;
    var tmp_45 = this.k6z();
    var tmp_46 = this.k6z();
    var tmp_47 = this.k6z();
    var tmp_48 = this.k6z();
    tmp_44.fae_1 = this.a6z(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).f6y(this, opSmoothIntersection$factory());
    var tmp_49 = this;
    var tmp_50 = this.a7i();
    var tmp_51 = this.k6z();
    var tmp_52 = this.k6z();
    tmp_49.gae_1 = this.y6y(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).f6y(this, circle$factory());
    var tmp_53 = this;
    var tmp_54 = this.a7i();
    var tmp_55 = this.a7i();
    var tmp_56 = this.d7k();
    var tmp_57 = this.k6z();
    tmp_53.hae_1 = this.a6z(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).f6y(this, roundedBox$factory());
    var tmp_58 = this;
    var tmp_59 = this.a7i();
    var tmp_60 = this.a7i();
    var tmp_61 = this.k6z();
    tmp_58.iae_1 = this.y6y(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).f6y(this, box$factory());
    var tmp_62 = this;
    var tmp_63 = this.d7k();
    var tmp_64 = this.d7k();
    var tmp_65 = this.d7k();
    tmp_62.jae_1 = this.y6y(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).f6y(this, opCombinePremultipliedColors$factory());
  }
  protoOf(SDFShaders).kae = function () {
    return this.uad_1.r5(this, opInterpolate$factory_0());
  };
  protoOf(SDFShaders).lae = function () {
    return this.vad_1.r5(this, opUnion$factory_0());
  };
  protoOf(SDFShaders).mae = function () {
    return this.wad_1.r5(this, opIntersect$factory_0());
  };
  protoOf(SDFShaders).nae = function () {
    return this.xad_1.r5(this, opSubtract$factory_0());
  };
  protoOf(SDFShaders).oae = function () {
    return this.yad_1.r5(this, opRound$factory_0());
  };
  protoOf(SDFShaders).pae = function () {
    return this.zad_1.r5(this, opBorder$factory_0());
  };
  protoOf(SDFShaders).qae = function () {
    return this.aae_1.r5(this, opBorderInner$factory_0());
  };
  protoOf(SDFShaders).rae = function () {
    return this.bae_1.r5(this, opAA$factory_0());
  };
  protoOf(SDFShaders).sae = function () {
    return this.cae_1.r5(this, opAARev$factory_0());
  };
  protoOf(SDFShaders).tae = function () {
    return this.dae_1.r5(this, opSmoothUnion$factory_0());
  };
  protoOf(SDFShaders).uae = function () {
    return this.eae_1.r5(this, opSmoothSubtraction$factory_0());
  };
  protoOf(SDFShaders).vae = function () {
    return this.fae_1.r5(this, opSmoothIntersection$factory_0());
  };
  protoOf(SDFShaders).wae = function () {
    return this.gae_1.r5(this, circle$factory_0());
  };
  protoOf(SDFShaders).xae = function () {
    return this.hae_1.r5(this, roundedBox$factory_0());
  };
  protoOf(SDFShaders).yae = function () {
    return this.iae_1.r5(this, box$factory_0());
  };
  protoOf(SDFShaders).zae = function () {
    return this.jae_1.r5(this, opCombinePremultipliedColors$factory_0());
  };
  var SDFShaders_instance;
  function SDFShaders_getInstance() {
    if (SDFShaders_instance == null)
      new SDFShaders();
    return SDFShaders_instance;
  }
  function opInterpolate$factory() {
    return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
      return receiver.kae();
    }, null);
  }
  function opUnion$factory() {
    return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
      return receiver.lae();
    }, null);
  }
  function opIntersect$factory() {
    return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
      return receiver.mae();
    }, null);
  }
  function opSubtract$factory() {
    return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
      return receiver.nae();
    }, null);
  }
  function opRound$factory() {
    return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
      return receiver.oae();
    }, null);
  }
  function opBorder$factory() {
    return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
      return receiver.pae();
    }, null);
  }
  function opBorderInner$factory() {
    return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
      return receiver.qae();
    }, null);
  }
  function opAA$factory() {
    return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
      return receiver.rae();
    }, null);
  }
  function opAARev$factory() {
    return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
      return receiver.sae();
    }, null);
  }
  function opSmoothUnion$factory() {
    return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
      return receiver.tae();
    }, null);
  }
  function opSmoothSubtraction$factory() {
    return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
      return receiver.uae();
    }, null);
  }
  function opSmoothIntersection$factory() {
    return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
      return receiver.vae();
    }, null);
  }
  function circle$factory() {
    return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
      return receiver.wae();
    }, null);
  }
  function roundedBox$factory() {
    return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
      return receiver.xae();
    }, null);
  }
  function box$factory() {
    return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
      return receiver.yae();
    }, null);
  }
  function opCombinePremultipliedColors$factory() {
    return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
      return receiver.zae();
    }, null);
  }
  function opInterpolate$factory_0() {
    return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
      return receiver.kae();
    }, null);
  }
  function opUnion$factory_0() {
    return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
      return receiver.lae();
    }, null);
  }
  function opIntersect$factory_0() {
    return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
      return receiver.mae();
    }, null);
  }
  function opSubtract$factory_0() {
    return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
      return receiver.nae();
    }, null);
  }
  function opRound$factory_0() {
    return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
      return receiver.oae();
    }, null);
  }
  function opBorder$factory_0() {
    return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
      return receiver.pae();
    }, null);
  }
  function opBorderInner$factory_0() {
    return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
      return receiver.qae();
    }, null);
  }
  function opAA$factory_0() {
    return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
      return receiver.rae();
    }, null);
  }
  function opAARev$factory_0() {
    return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
      return receiver.sae();
    }, null);
  }
  function opSmoothUnion$factory_0() {
    return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
      return receiver.tae();
    }, null);
  }
  function opSmoothSubtraction$factory_0() {
    return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
      return receiver.uae();
    }, null);
  }
  function opSmoothIntersection$factory_0() {
    return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
      return receiver.vae();
    }, null);
  }
  function circle$factory_0() {
    return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
      return receiver.wae();
    }, null);
  }
  function roundedBox$factory_0() {
    return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
      return receiver.xae();
    }, null);
  }
  function box$factory_0() {
    return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
      return receiver.yae();
    }, null);
  }
  function opCombinePremultipliedColors$factory_0() {
    return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
      return receiver.zae();
    }, null);
  }
  function TextureBase_init_$Init$(base, width, height, $this) {
    TextureBase.call($this, base, _SizeInt___init__impl__vivn9(width, height));
    return $this;
  }
  function TextureBase_init_$Create$(base, width, height) {
    return TextureBase_init_$Init$(base, width, height, objectCreate(protoOf(TextureBase)));
  }
  function TextureBase(base, size) {
    this.ea8_1 = base;
    this.fa8_1 = size;
    this.ga8_1 = -1;
  }
  protoOf(TextureBase).k3s = function () {
    return this.fa8_1;
  };
  protoOf(TextureBase).ha8 = function (width) {
    this.fa8_1 = _SizeInt___init__impl__vivn9(width, this.dk());
  };
  protoOf(TextureBase).ck = function () {
    return _SizeInt___get_width__impl__swntg6(this.fa8_1);
  };
  protoOf(TextureBase).ia8 = function (height) {
    this.fa8_1 = _SizeInt___init__impl__vivn9(this.ck(), height);
  };
  protoOf(TextureBase).dk = function () {
    return _SizeInt___get_height__impl__d3sy61(this.fa8_1);
  };
  protoOf(TextureBase).c1c = function () {
    var tmp0_safe_receiver = this.ea8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c1c();
    }
    this.ea8_1 = null;
  };
  protoOf(TextureBase).ba9 = function (bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.ea8_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.m6m(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  };
  protoOf(TextureBase).toString = function () {
    return 'TextureBase(' + this.ea8_1 + ')';
  };
  function Texture(frameBuffer) {
    return Texture_0(frameBuffer.p6o(), frameBuffer.e6k_1, frameBuffer.f6k_1);
  }
  function Texture_0(agBase, width, height) {
    return new RectSlice(new TextureBase(agBase, _SizeInt___init__impl__vivn9(width, height)), _RectangleInt___init__impl__1g5gox(0, 0, width, height));
  }
  function Texture_1(base, left, top, right, bottom) {
    left = left === VOID ? 0 : left;
    top = top === VOID ? 0 : top;
    right = right === VOID ? base.ck() : right;
    bottom = bottom === VOID ? base.dk() : bottom;
    return new RectSlice(base, Companion_getInstance_39().w3i(left, top, right, bottom));
  }
  function get_TEXTURED_ARRAY_QUAD_INDICES() {
    _init_properties_TexturedVertexArray_kt__kev7cq();
    return TEXTURED_ARRAY_QUAD_INDICES;
  }
  var TEXTURED_ARRAY_QUAD_INDICES;
  var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
  var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
  function get_TEXTURED_ARRAY_COMPONENTS_PER_VERTEX() {
    return TEXTURED_ARRAY_COMPONENTS_PER_VERTEX;
  }
  var TEXTURED_ARRAY_COMPONENTS_PER_VERTEX;
  function Companion_6() {
    Companion_instance_6 = this;
    this.aaf_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
  var Companion_instance_6;
  function Companion_getInstance_64() {
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function TexturedVertexArray(vcount, indices, icount) {
    Companion_getInstance_64();
    icount = icount === VOID ? indices.length : icount;
    this.maa_1 = indices;
    this.naa_1 = vcount;
    this.oaa_1 = vcount;
    this.paa_1 = icount;
    this.qaa_1 = allocNoDirect(Companion_getInstance_35(), imul(imul(6, this.naa_1), 4));
    this.raa_1 = this.qaa_1;
    this.saa_1 = 0;
  }
  protoOf(TexturedVertexArray).baf = function (fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  };
  protoOf(TexturedVertexArray).caf = function (index, x, y, width, height, matrix, bmp, colMul) {
    this.daf(index, x, y, width, height, matrix, bmp.o3q(), bmp.p3q(), bmp.q3q(), bmp.r3q(), bmp.u3q(), bmp.v3q(), bmp.s3q(), bmp.t3q(), colMul);
  };
  protoOf(TexturedVertexArray).daf = function (index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = _Matrix___get_a__impl__f7jypo(matrix);
    var cf = _Matrix___get_c__impl__slf2ke(matrix);
    var txf = _Matrix___get_tx__impl__yc1n9(matrix);
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = _Matrix___get_d__impl__87eht(matrix);
    var bf = _Matrix___get_b__impl__dm2icj(matrix);
    var tyf = _Matrix___get_ty__impl__tryipg(matrix);
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.raa_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.baf(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.baf(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.baf(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.baf(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  };
  function get_VERTEX_INDEX_SIZE() {
    return VERTEX_INDEX_SIZE;
  }
  var VERTEX_INDEX_SIZE;
  var properties_initialized_TexturedVertexArray_kt_ouua70;
  function _init_properties_TexturedVertexArray_kt__kev7cq() {
    if (properties_initialized_TexturedVertexArray_kt_ouua70) {
    } else {
      properties_initialized_TexturedVertexArray_kt_ouua70 = true;
      var tmp$ret$0;
      // Inline function 'kotlin.shortArrayOf' call
      tmp$ret$0 = new Int16Array([0, 1, 2, 3, 0, 2]);
      TEXTURED_ARRAY_QUAD_INDICES = tmp$ret$0;
      TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
      TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
    }
  }
  function _get_root__dd8asp($this) {
    var tmp = $this.eaf_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('root');
    }
  }
  function _get_mountable__707cy($this) {
    var tmp = $this.faf_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('mountable');
    }
  }
  function ResourcesRoot$init$slambda(this$0, resultContinuation) {
    this.oaf_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ResourcesRoot$init$slambda).qaf = function ($this$MountableVfs, $completion) {
    var tmp = this.raf($this$MountableVfs, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(ResourcesRoot$init$slambda).mi = function (p1, $completion) {
    return this.qaf((!(p1 == null) ? isInterface(p1, Mountable) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ResourcesRoot$init$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          this.oaf_1.faf_1 = this.paf_1;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ResourcesRoot$init$slambda).raf = function ($this$MountableVfs, completion) {
    var i = new ResourcesRoot$init$slambda(this.oaf_1, completion);
    i.paf_1 = $this$MountableVfs;
    return i;
  };
  function ResourcesRoot$init$slambda_0(this$0, resultContinuation) {
    var i = new ResourcesRoot$init$slambda(this$0, resultContinuation);
    var l = function ($this$MountableVfs, $completion) {
      return i.qaf($this$MountableVfs, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $initCOROUTINE$6(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aag_1 = _this__u8e3s4;
  }
  protoOf($initCOROUTINE$6).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = MountableVfs(VOID, ResourcesRoot$init$slambda_0(this.aag_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.aag_1.eaf_1 = ARGUMENT;
            this.aag_1.bag('/', get_resourcesVfs());
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function ResourcesRoot() {
  }
  protoOf(ResourcesRoot).bag = function (path, file) {
    _get_mountable__707cy(this).k23(path, file);
  };
  protoOf(ResourcesRoot).p1s = function ($completion) {
    var tmp = new $initCOROUTINE$6(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(ResourcesRoot).toString = function () {
    return 'ResourcesRoot[' + _get_root__dd8asp(this) + ']';
  };
  function Scene$coroutineContext$delegate$lambda(this$0) {
    return function () {
      return this$0.ga6().g9m_1.d5(new AsyncInjectorContext(this$0.mag())).d5(Job(this$0.ga6().g9m_1.w4(Key_getInstance())));
    };
  }
  function Scene$sceneView$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$0;
      // Inline function 'kotlin.apply' call
      var tmp0_apply = this$0.pag(this$0.nag().oag());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
      var tmp0_this = this$0;
      tmp0_this.hag_1.zai(tmp0_apply);
      tmp$ret$0 = tmp0_apply;
      return tmp$ret$0;
    };
  }
  function Scene$resources$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$0;
      // Inline function 'korlibs.inject.AsyncInjector.getSync' call
      var tmp0_getSync = this$0.mag();
      var tmp1_getSync = new RequestContext(getKClass(Resources));
      tmp$ret$0 = tmp0_getSync.o9g(getKClass(Resources), tmp1_getSync);
      return tmp$ret$0;
    };
  }
  function $initCOROUTINE$9(_this__u8e3s4, injector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.iaj_1 = _this__u8e3s4;
    this.jaj_1 = injector;
  }
  protoOf($initCOROUTINE$9).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.iaj_1.dag_1 = this.jaj_1;
            this.hh_1 = 1;
            suspendResult = this.jaj_1.r9g(getKClass(Views), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.kaj_1 = suspendResult;
            this.iaj_1.maj(this.kaj_1);
            this.hh_1 = 2;
            suspendResult = this.jaj_1.r9g(getKClass(SceneContainer), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.laj_1 = suspendResult;
            this.iaj_1.fag_1 = this.laj_1;
            this.hh_1 = 3;
            suspendResult = this.jaj_1.r9g(getKClass(ResourcesRoot), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            this.iaj_1.gag_1 = ARGUMENT;
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $sceneAfterDestroyInternalCOROUTINE$10(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vaj_1 = _this__u8e3s4;
  }
  protoOf($sceneAfterDestroyInternalCOROUTINE$10).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.hh_1 = 1;
            suspendResult = this.vaj_1.waj(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ih_1 = 2;
            cancel(this.vaj_1.h10());
            ;
            this.ih_1 = 4;
            this.hh_1 = 3;
            continue $sm;
          case 2:
            this.ih_1 = 4;
            var tmp_0 = this.kh_1;
            if (tmp_0 instanceof Error) {
              var e = this.kh_1;
              if (e instanceof CancellationException)
                throw e;
              printStackTrace(e);
              this.hh_1 = 3;
              continue $sm;
            } else {
              throw this.kh_1;
            }

            break;
          case 3:
            this.ih_1 = 4;
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.ih_1 === 4) {
          throw e_0;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e_0;
        }
      }
     while (true);
  };
  function Scene() {
    this.cag_1 = new Mixin();
    this.hag_1 = new Container();
    this.iag_1 = new CancellableGroup();
    var tmp = this;
    tmp.jag_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.kag_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.lag_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  protoOf(Scene).lu = function (_set____db54di) {
    this.cag_1.lu(_set____db54di);
  };
  protoOf(Scene).mu = function () {
    return this.cag_1.mu();
  };
  protoOf(Scene).mag = function () {
    var tmp = this.dag_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  };
  protoOf(Scene).maj = function (_set____db54di) {
    this.eag_1 = _set____db54di;
  };
  protoOf(Scene).ga6 = function () {
    var tmp = this.eag_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  protoOf(Scene).nag = function () {
    var tmp = this.fag_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  };
  protoOf(Scene).h10 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = coroutineContext$factory();
    tmp$ret$0 = this.jag_1.q();
    return tmp$ret$0;
  };
  protoOf(Scene).xaj = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = sceneView$factory();
    tmp$ret$0 = this.kag_1.q();
    return tmp$ret$0;
  };
  protoOf(Scene).pag = function (size) {
    return new SContainer(size);
  };
  protoOf(Scene).v9f = function (injector, $completion) {
    var tmp = new $initCOROUTINE$9(this, injector, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Scene).yaj = function (_this__u8e3s4, $completion) {
    return Unit_getInstance();
  };
  protoOf(Scene).zaj = function (_this__u8e3s4, $completion) {
    return Unit_getInstance();
  };
  protoOf(Scene).aak = function ($completion) {
    return Unit_getInstance();
  };
  protoOf(Scene).bak = function ($completion) {
    return Unit_getInstance();
  };
  protoOf(Scene).cak = function ($completion) {
    return Unit_getInstance();
  };
  protoOf(Scene).dak = function ($completion) {
    cancel_0(this.iag_1);
    var tmp0 = this.mag().j9g($completion);
    return tmp0;
  };
  protoOf(Scene).waj = function ($completion) {
    return Unit_getInstance();
  };
  protoOf(Scene).eak = function ($completion) {
    var tmp = new $sceneAfterDestroyInternalCOROUTINE$10(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function EmptyScene() {
    Scene.call(this);
  }
  protoOf(EmptyScene).zaj = function (_this__u8e3s4, $completion) {
    return Unit_getInstance();
  };
  function delay(_this__u8e3s4, time, $completion) {
    var tmp0 = delay_0(_this__u8e3s4.xaj(), time, $completion);
    return tmp0;
  }
  function coroutineContext$factory() {
    return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
      return receiver.h10();
    }, null);
  }
  function sceneView$factory() {
    return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
      return receiver.xaj();
    }, null);
  }
  function SceneContainer$lambda$slambda$slambda($sceneInjector, $sceneClass, $event, $scene, resultContinuation) {
    this.xak_1 = $sceneInjector;
    this.yak_1 = $sceneClass;
    this.zak_1 = $event;
    this.aal_1 = $scene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$lambda$slambda$slambda).cal = function ($this$mapPrototype, $completion) {
    var tmp = this.y9w($this$mapPrototype, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$lambda$slambda$slambda).mi = function (p1, $completion) {
    return this.cal(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SceneContainer$lambda$slambda$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.xak_1.r9g(this.yak_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_also = suspendResult;
            try {
              this.zak_1.sa1(this.aal_1, tmp0_also);
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                printStackTrace(e);
              } else {
                throw $p;
              }
            }

            return tmp0_also;
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.ih_1 === 2) {
          throw e_0;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$lambda$slambda$slambda).y9w = function ($this$mapPrototype, completion) {
    var i = new SceneContainer$lambda$slambda$slambda(this.xak_1, this.yak_1, this.zak_1, this.aal_1, completion);
    i.bal_1 = $this$mapPrototype;
    return i;
  };
  function SceneContainer$lambda$slambda$slambda_0($sceneInjector, $sceneClass, $event, $scene, resultContinuation) {
    var i = new SceneContainer$lambda$slambda$slambda($sceneInjector, $sceneClass, $event, $scene, resultContinuation);
    var l = function ($this$mapPrototype, $completion) {
      return i.cal($this$mapPrototype, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function _changeTo($this, clazz, injects, time, transition, $completion) {
    var tmp = new $_changeToCOROUTINE$13($this, clazz, injects, time, transition, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function VisitEntry(clazz, injects) {
    this.zal_1 = clazz;
    this.aam_1 = injects;
  }
  protoOf(VisitEntry).toString = function () {
    return 'VisitEntry(clazz=' + this.zal_1 + ', injects=' + this.aam_1 + ')';
  };
  protoOf(VisitEntry).hashCode = function () {
    var result = this.zal_1.hashCode();
    result = imul(result, 31) + hashCode(this.aam_1) | 0;
    return result;
  };
  protoOf(VisitEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.zal_1.equals(tmp0_other_with_cast.zal_1))
      return false;
    if (!equals(this.aam_1, tmp0_other_with_cast.aam_1))
      return false;
    return true;
  };
  function Companion_7() {
    Companion_instance_7 = this;
    this.bam_1 = Companion_getInstance().kz('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    var tmp$ret$0;
    // Inline function 'kotlin.collections.listOf' call
    tmp$ret$0 = emptyList();
    tmp.cam_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
  var Companion_instance_7;
  function Companion_getInstance_65() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function setCurrent($this, entry) {
    while ($this.m9t_1.j() <= $this.n9t_1) {
      $this.m9t_1.b(Companion_getInstance_65().cam_1);
    }
    $this.m9t_1.r2($this.n9t_1, entry);
  }
  function SceneContainer$lambda$lambda(this$0) {
    return function (it) {
      var tmp;
      if (it instanceof SceneContainer) {
        tmp = !equals(it, this$0);
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function SceneContainer$lambda$slambda(this$0, $event, resultContinuation) {
    this.lam_1 = this$0;
    this.mam_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$lambda$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$lambda$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(SceneContainer$lambda$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 6;
            this.nam_1 = this.lam_1.l9t_1;
            if (!(this.nam_1 == null)) {
              println('[ReloadEvent] Reloading ' + this.lam_1.l9t_1 + ' . doFullReload=' + this.mam_1.uam());
              var tmp_0 = this;
              var tmp_1;
              if (this.mam_1.uam()) {
                tmp_1 = this.mam_1.vam(getKClassFromExpression(this.nam_1), this.nam_1.mag());
              } else {
                tmp_1 = getKClassFromExpression(this.nam_1);
              }
              var tmp_2 = tmp_1;
              tmp_0.oam_1 = isInterface(tmp_2, KClass) ? tmp_2 : THROW_CCE();
              var tmp_3 = this;
              tmp_3.pam_1 = Companion_getInstance_7().ej(0.0);
              var tmp_4 = this;
              tmp_4.qam_1 = this.lam_1.j9t_1;
              this.ram_1 = this.lam_1.i9t_1.i9m_1.l9g().k9g(getKClass(SceneContainer), this.lam_1).k9g(getKClass(Resources), new Resources(this.lam_1.h10(), this.lam_1.i9t_1.ta0().v2g_1, this.lam_1.i9t_1.ta0()));
              var n = 0;
              while (n < [].length) {
                var tmp0 = n;
                n = tmp0 + 1 | 0;
                var tmp0__anonymous__q1qw7t = [][tmp0];
                var tmp_5 = getKClassFromExpression(tmp0__anonymous__q1qw7t);
                this.ram_1.k9g(isInterface(tmp_5, KClass) ? tmp_5 : THROW_CCE(), tmp0__anonymous__q1qw7t);
              }
              this.hh_1 = 1;
              suspendResult = this.ram_1.r9g(this.oam_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 5;
              continue $sm;
            }

            break;
          case 1:
            this.sam_1 = suspendResult;
            try {
              this.mam_1.sa1(this.nam_1, this.sam_1);
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                printStackTrace(e);
              } else {
                throw $p;
              }
            }

            this.tam_1 = this.sam_1;
            var tmp2_info = Companion_getInstance_65().bam_1;
            var tmp1_log = Level_INFO_getInstance();
            if (tmp2_info.zz(tmp1_log)) {
              tmp2_info.a10(tmp1_log, 'Changing scene to... ' + this.oam_1 + ' ... ' + this.tam_1);
            }

            if (false) {
              this.hh_1 = 2;
              suspendResult = this.tam_1.v9f(this.ram_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            var tmp_6 = getKClassFromExpression(this.tam_1);
            var tmp_7 = isInterface(tmp_6, KClass) ? tmp_6 : THROW_CCE();
            this.lam_1.i9t_1.i9m_1.n9g(tmp_7, SceneContainer$lambda$slambda$slambda_0(this.ram_1, this.oam_1, this.mam_1, this.nam_1, null));
            ;
            this.hh_1 = 3;
            continue $sm;
          case 3:
            this.hh_1 = 4;
            suspendResult = this.lam_1.wam(this.tam_1, this.pam_1, this.qam_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var scene = suspendResult;
            scene.ga6().xam(scene.xaj());
            this.hh_1 = 5;
            continue $sm;
          case 5:
            return Unit_getInstance();
          case 6:
            throw this.kh_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.ih_1 === 6) {
          throw e_0;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$lambda$slambda).n1f = function (completion) {
    var i = new SceneContainer$lambda$slambda(this.lam_1, this.mam_1, completion);
    return i;
  };
  function SceneContainer$lambda$slambda_0(this$0, $event, resultContinuation) {
    var i = new SceneContainer$lambda$slambda(this$0, $event, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$lambda(this$0) {
    return function (event) {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp0_isNotEmpty = descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0));
      tmp$ret$0 = !tmp0_isNotEmpty.l();
      var hasChildScenes = tmp$ret$0;
      var tmp;
      if (hasChildScenes) {
        println('[ReloadEvent] Scene ' + this$0.l9t_1 + ' not reloaded because has child scenes...');
        return Unit_getInstance();
      }
      launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event, null));
      return Unit_getInstance();
    };
  }
  function SceneContainer$_changeTo$slambda($sceneInjector, $clazz, resultContinuation) {
    this.gan_1 = $sceneInjector;
    this.han_1 = $clazz;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda).jan = function ($this$mapPrototype, $completion) {
    var tmp = this.y9w($this$mapPrototype, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$_changeTo$slambda).mi = function (p1, $completion) {
    return this.jan(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SceneContainer$_changeTo$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.gan_1.r9g(this.han_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda).y9w = function ($this$mapPrototype, completion) {
    var i = new SceneContainer$_changeTo$slambda(this.gan_1, this.han_1, completion);
    i.ian_1 = $this$mapPrototype;
    return i;
  };
  function SceneContainer$_changeTo$slambda_0($sceneInjector, $clazz, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda($sceneInjector, $clazz, resultContinuation);
    var l = function ($this$mapPrototype, $completion) {
      return i.jan($this$mapPrototype, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function SceneContainer$_changeTo$slambda_1($newScene, resultContinuation) {
    this.san_1 = $newScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_1).uan = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$_changeTo$slambda_1).ai = function ($completion) {
    return this.uan($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            var tmp_0 = this;
            tmp_0.tan_1 = this.san_1.xaj();
            this.hh_1 = 1;
            suspendResult = this.san_1.yaj(this.tan_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            ;
            return this.tan_1;
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_1).n1f = function (completion) {
    var i = new SceneContainer$_changeTo$slambda_1(this.san_1, completion);
    return i;
  };
  function SceneContainer$_changeTo$slambda_2($newScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_1($newScene, resultContinuation);
    var l = function ($completion) {
      return i.uan($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$_changeTo$slambda_3($newScene, resultContinuation) {
    this.dao_1 = $newScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_3).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$_changeTo$slambda_3).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_3).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            var tmp_0 = this;
            tmp_0.eao_1 = this.dao_1.xaj();
            this.hh_1 = 1;
            suspendResult = this.dao_1.zaj(this.eao_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            ;
            ;
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_3).n1f = function (completion) {
    var i = new SceneContainer$_changeTo$slambda_3(this.dao_1, completion);
    return i;
  };
  function SceneContainer$_changeTo$slambda_4($newScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_3($newScene, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$_changeTo$slambda_5($oldScene, resultContinuation) {
    this.nao_1 = $oldScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_5).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$_changeTo$slambda_5).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_5).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.nao_1.bak(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_5).n1f = function (completion) {
    var i = new SceneContainer$_changeTo$slambda_5(this.nao_1, completion);
    return i;
  };
  function SceneContainer$_changeTo$slambda_6($oldScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_5($oldScene, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function _interpolateFloat$ref() {
    var l = function (p0, p1, p2) {
      return _interpolateFloat(p0.k42_1, p1, p2);
    };
    l.callableName = '_interpolateFloat';
    return l;
  }
  function SceneContainer$_changeTo$slambda_7($oldScene, resultContinuation) {
    this.wao_1 = $oldScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_7).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$_changeTo$slambda_7).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_7).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.hh_1 = 1;
            suspendResult = this.wao_1.cak(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hh_1 = 2;
            suspendResult = this.wao_1.dak(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_7).n1f = function (completion) {
    var i = new SceneContainer$_changeTo$slambda_7(this.wao_1, completion);
    return i;
  };
  function SceneContainer$_changeTo$slambda_8($oldScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_7($oldScene, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$_changeTo$slambda_9($oldScene, resultContinuation) {
    this.fap_1 = $oldScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_9).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$_changeTo$slambda_9).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_9).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.fap_1.eak(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_9).n1f = function (completion) {
    var i = new SceneContainer$_changeTo$slambda_9(this.fap_1, completion);
    return i;
  };
  function SceneContainer$_changeTo$slambda_10($oldScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_9($oldScene, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$_changeTo$slambda_11($newScene, resultContinuation) {
    this.oap_1 = $newScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_11).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(SceneContainer$_changeTo$slambda_11).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_11).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.oap_1.aak(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_11).n1f = function (completion) {
    var i = new SceneContainer$_changeTo$slambda_11(this.oap_1, completion);
    return i;
  };
  function SceneContainer$_changeTo$slambda_12($newScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_11($newScene, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $_changeToCOROUTINE$13(_this__u8e3s4, clazz, injects, time, transition, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ral_1 = _this__u8e3s4;
    this.sal_1 = clazz;
    this.tal_1 = injects;
    this.ual_1 = time;
    this.val_1 = transition;
  }
  protoOf($_changeToCOROUTINE$13).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 5;
            var tmp_0 = this;
            tmp_0.wal_1 = this.tal_1.slice();
            this.xal_1 = this.ral_1.i9t_1.i9m_1.l9g().k9g(getKClass(SceneContainer), this.ral_1).k9g(getKClass(Resources), new Resources(this.ral_1.h10(), this.ral_1.i9t_1.ta0().v2g_1, this.ral_1.i9t_1.ta0()));
            var n = 0;
            while (n < this.wal_1.length) {
              var tmp0 = n;
              n = tmp0 + 1 | 0;
              var tmp0__anonymous__q1qw7t = this.wal_1[tmp0];
              var tmp_1 = getKClassFromExpression(tmp0__anonymous__q1qw7t);
              this.xal_1.k9g(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), tmp0__anonymous__q1qw7t);
            }

            this.hh_1 = 1;
            suspendResult = this.xal_1.r9g(this.sal_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.yal_1 = suspendResult;
            var tmp2_info = Companion_getInstance_65().bam_1;
            var tmp1_log = Level_INFO_getInstance();
            if (tmp2_info.zz(tmp1_log)) {
              tmp2_info.a10(tmp1_log, 'Changing scene to... ' + this.sal_1 + ' ... ' + this.yal_1);
            }

            if (false) {
              this.hh_1 = 2;
              suspendResult = this.yal_1.v9f(this.xal_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            var tmp_2 = getKClassFromExpression(this.yal_1);
            var tmp_3 = isInterface(tmp_2, KClass) ? tmp_2 : THROW_CCE();
            this.ral_1.i9t_1.i9m_1.n9g(tmp_3, SceneContainer$_changeTo$slambda_0(this.xal_1, this.sal_1, null));
            ;
            this.hh_1 = 3;
            continue $sm;
          case 3:
            this.hh_1 = 4;
            suspendResult = this.ral_1.wam(this.yal_1, this.ual_1, this.val_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 5) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $_changeToCOROUTINE$14(_this__u8e3s4, newScene, time, transition, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xap_1 = _this__u8e3s4;
    this.yap_1 = newScene;
    this.zap_1 = time;
    this.aaq_1 = transition;
  }
  protoOf($_changeToCOROUTINE$14).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 10;
            this.baq_1 = this.xap_1.l9t_1;
            this.xap_1.l9t_1 = this.yap_1;
            this.xap_1.k9t_1.oas(this.yap_1.hag_1, this.aaq_1);
            this.ih_1 = 2;
            this.hh_1 = 1;
            var tmp_0 = this.yap_1.h10();
            suspendResult = launchUnscopedAndWait(tmp_0, SceneContainer$_changeTo$slambda_2(this.yap_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            ;
            this.ih_1 = 10;
            this.hh_1 = 3;
            continue $sm;
          case 2:
            this.ih_1 = 10;
            var tmp_1 = this.kh_1;
            if (tmp_1 instanceof Error) {
              this.caq_1 = this.kh_1;
              var tmp_2 = this.caq_1;
              if (tmp_2 instanceof CancellationException)
                throw this.caq_1;
              printStackTrace(this.caq_1);
              this.hh_1 = 3;
              continue $sm;
            } else {
              throw this.kh_1;
            }

            break;
          case 3:
            this.ih_1 = 10;
            launchUnscoped(this.yap_1, SceneContainer$_changeTo$slambda_4(this.yap_1, null));
            if (!(this.baq_1 == null)) {
              this.hh_1 = 4;
              var tmp_3 = this.baq_1.h10();
              suspendResult = launchUnscopedAndWait(tmp_3, SceneContainer$_changeTo$slambda_6(this.baq_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            this.hh_1 = 5;
            continue $sm;
          case 5:
            if (TimeSpan__compareTo_impl_zidry4(this.zap_1, Companion_getInstance_7().ej(0.0)) > 0) {
              this.hh_1 = 6;
              var tmp2_get = ratio$factory(this.xap_1.k9t_1);
              var tmp0_get = 0.0;
              var tmp1_get = 1.0;
              suspendResult = tween(this.xap_1.k9t_1, [new V2(tmp2_get, tmp0_get, tmp1_get, _interpolateFloat$ref(), true)], this.zap_1, VOID, VOID, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.xap_1.k9t_1.pas(1.0);
              this.hh_1 = 7;
              continue $sm;
            }

            break;
          case 6:
            this.hh_1 = 7;
            continue $sm;
          case 7:
            this.xap_1.k9t_1.qas();
            if (!(this.baq_1 == null)) {
              this.hh_1 = 8;
              var tmp_4 = this.baq_1.h10();
              suspendResult = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(this.baq_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 9;
              continue $sm;
            }

            break;
          case 8:
            launchUnscoped(this.baq_1, SceneContainer$_changeTo$slambda_10(this.baq_1, null));
            this.hh_1 = 9;
            continue $sm;
          case 9:
            var tmp_5 = this.yap_1.h10();
            launchUnscoped_0(tmp_5, SceneContainer$_changeTo$slambda_12(this.yap_1, null));
            return this.yap_1;
          case 10:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 10) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function SceneContainer(views, defaultTransition, name, size) {
    Companion_getInstance_65();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), Companion_getInstance_3().s3z()) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.s9n_1.oag() : size;
    UIView.call(this, size);
    this.i9t_1 = views;
    this.j9t_1 = defaultTransition;
    this.e9p_1 = name;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new TransitionView();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    this.zai(tmp0_also);
    tmp$ret$0 = tmp0_also;
    tmp.k9t_1 = tmp$ret$0;
    this.l9t_1 = null;
    var tmp_0 = Companion_getInstance_59();
    this.h6a(tmp_0, SceneContainer$lambda(this));
    this.m9t_1 = arrayListOf([Companion_getInstance_65().cam_1]);
    this.n9t_1 = 0;
  }
  protoOf(SceneContainer).h10 = function () {
    return this.i9t_1.g9m_1;
  };
  protoOf(SceneContainer).ras = function (clazz, injects, time, transition, $completion) {
    setCurrent(this, new VisitEntry(clazz, toList_0(injects)));
    var tmp0 = _changeTo(this, clazz, injects.slice(), time, transition, $completion);
    return tmp0;
  };
  protoOf(SceneContainer).o9t = function (clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance_7().ej(0.0);
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.j9t_1 : transition;
    return $super === VOID ? this.ras(clazz, injects, time, transition, $completion) : $super.ras.call(this, clazz, injects, new TimeSpan(time), transition, $completion);
  };
  protoOf(SceneContainer).wam = function (newScene, time, transition, $completion) {
    var tmp = new $_changeToCOROUTINE$14(this, newScene, time, transition, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function ratio$factory($b0) {
    return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
      return $b0.kb1();
    }, function (value) {
      return $b0.pas(value);
    });
  }
  function get_AlphaTransition() {
    _init_properties_Transition_kt__s6zoln();
    return AlphaTransition;
  }
  var AlphaTransition;
  function Transition(name, render) {
    name = name === VOID ? 'Transition' : name;
    _init_properties_Transition_kt__s6zoln();
    return new Transition$1(render, name);
  }
  function TransitionProcess() {
  }
  function withEasing(_this__u8e3s4, easing) {
    _init_properties_Transition_kt__s6zoln();
    return new withEasing$1(_this__u8e3s4, easing);
  }
  function _get_transitionProcess__5hlux5($this) {
    var tmp = $this.nas_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('transitionProcess');
    }
  }
  function TransitionView() {
    Container.call(this);
    dummyView(this);
    dummyView(this);
    this.mas_1 = get_AlphaTransition();
  }
  protoOf(TransitionView).ob1 = function () {
    return this.k(0);
  };
  protoOf(TransitionView).pb1 = function () {
    return this.k(1);
  };
  protoOf(TransitionView).oas = function (next, transition) {
    this.mas_1 = transition;
    this.pas(0.0);
    this.nas_1 = transition.qb1();
    this.rb1(this.pb1(), next);
    _get_transitionProcess__5hlux5(this).lb1(this.ob1(), this.pb1());
  };
  protoOf(TransitionView).toString = function () {
    return protoOf(Container).toString.call(this) + (':ratio=' + this.kb1() + ':transition=' + this.mas_1);
  };
  protoOf(TransitionView).qas = function () {
    this.pas(1.0);
    _get_transitionProcess__5hlux5(this).mb1(this.ob1(), this.pb1());
    this.rb1(dummyView(this), this.pb1());
  };
  protoOf(TransitionView).rb1 = function (prev, next) {
    this.qay();
    this.ray(prev);
    this.ray(next);
  };
  protoOf(TransitionView).qav = function (ctx) {
    if (this.kb1() <= 0.0) {
      this.ob1().mav(ctx);
    } else if (this.kb1() >= 1.0) {
      this.pb1().mav(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).nb1(ctx, this.ob1(), this.pb1(), this.kb1());
    }
  };
  function AlphaTransition$lambda(ctx, prev, next, ratio) {
    _init_properties_Transition_kt__s6zoln();
    var prevAlpha = prev.fb0();
    var nextAlpha = next.fb0();
    try {
      prev.eb0(1.0 - ratio);
      next.eb0(ratio);
      prev.mav(ctx);
      next.mav(ctx);
    }finally {
      prev.eb0(prevAlpha);
      next.eb0(nextAlpha);
    }
    return Unit_getInstance();
  }
  function Transition$1($render, $name) {
    this.sb1_1 = $render;
    this.tb1_1 = $name;
  }
  protoOf(Transition$1).qb1 = function () {
    return this;
  };
  protoOf(Transition$1).nb1 = function (ctx, prev, next, ratio) {
    return this.sb1_1(ctx, prev, next, ratio);
  };
  protoOf(Transition$1).toString = function () {
    return this.tb1_1;
  };
  function withEasing$1$create$1($process, $easing) {
    this.ub1_1 = $process;
    this.vb1_1 = $easing;
  }
  protoOf(withEasing$1$create$1).lb1 = function (prev, next) {
    return this.ub1_1.lb1(prev, next);
  };
  protoOf(withEasing$1$create$1).mb1 = function (prev, next) {
    return this.ub1_1.mb1(prev, next);
  };
  protoOf(withEasing$1$create$1).nb1 = function (ctx, prev, next, ratio) {
    return this.ub1_1.nb1(ctx, prev, next, this.vb1_1.z3z(ratio));
  };
  function withEasing$1($this_withEasing, $easing) {
    this.wb1_1 = $this_withEasing;
    this.xb1_1 = $easing;
  }
  protoOf(withEasing$1).toString = function () {
    return '' + this.wb1_1 + '.withEasing';
  };
  protoOf(withEasing$1).qb1 = function () {
    var process = this.wb1_1.qb1();
    return new withEasing$1$create$1(process, this.xb1_1);
  };
  var properties_initialized_Transition_kt_wb2qvd;
  function _init_properties_Transition_kt__s6zoln() {
    if (properties_initialized_Transition_kt_wb2qvd) {
    } else {
      properties_initialized_Transition_kt_wb2qvd = true;
      AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
    }
  }
  function RCollection() {
    this.yb1_1 = ArrayList_init_$Create$_0();
    this.zb1_1 = LinkedHashMap_init_$Create$_0();
  }
  function Stats() {
    this.ab2_1 = new RCollection();
    this.bb2_1 = new RCollection();
  }
  protoOf(Stats).k6i = function () {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.ab2_1.yb1_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      tmp1__anonymous__uwfjfc.k6i();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp2_fastForEach = this.bb2_1.yb1_1;
    var n_0 = 0;
    while (n_0 < tmp2_fastForEach.j()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var tmp3__anonymous__ufb84q = tmp2_fastForEach.k(tmp0_0);
      tmp3__anonymous__ufb84q.k6i();
    }
  };
  function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
    return $median$delegate.r5(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
  }
  function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
    $this$FUNC.h6z($this$FUNC.e7i($this$FUNC.d7i(a, b), $this$FUNC.d7i($this$FUNC.e7i(a, b), c)));
    return Unit_getInstance();
  }
  function MsdfRender$createProgram$lambda_0($tmp0_also) {
    return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
      $this$IF_ELSE_BINARY_LOOKUP.s6v($this$IF_ELSE_BINARY_LOOKUP.t6v(), $this$IF_ELSE_BINARY_LOOKUP.z6v(Companion_getInstance_62().d9j_1[n], $this$IF_ELSE_BINARY_LOOKUP.y6v($tmp0_also.g6y(), 'xy')));
      return Unit_getInstance();
    };
  }
  function MsdfRender() {
    MsdfRender_instance = this;
    this.jb2_1 = this.nb2(true, VOID, false);
    this.kb2_1 = this.nb2(true, VOID, true);
    this.lb2_1 = this.ob2(false, 'r', false);
    this.mb2_1 = this.ob2(false, 'a', false);
  }
  protoOf(MsdfRender).ob2 = function (msdf, sdf, inverted) {
    var tmp$ret$2;
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var tmp1_buildShader = Companion_getInstance_69();
    var tmp2_buildShader = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_62().m9j_1;
    var tmp0_elvis_lhs = tmp2_buildShader;
    var tmp2_name = tmp0_elvis_lhs == null ? Companion_getInstance_62().m9j_1.u6p_1 : tmp0_elvis_lhs;
    var tmp$ret$1;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = tmp0_also.k6z();
    var tmp_0 = tmp0_also.k6z();
    var tmp_1 = tmp0_also.k6z();
    var tmp_2 = tmp0_also.k6z();
    var median$delegate = tmp0_also.a6z(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).f6y(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_62().j9j_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    tmp0_also.e6z(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(tmp0_also));
    var d = tmp0_also.s6z(tmp0_also.o6y());
    var alpha = tmp0_also.t6z(tmp0_also.o6y());
    tmp0_also.s6v(tmp0_also.t6v(), tmp0_also.x6z(tmp0_also.t6v(), tmp0_also.v6v([tmp0_also.u6v(0.5)])));
    if (msdf) {
      tmp0_also.s6v(d, tmp0_also.c6z(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), tmp0_also.y6v(tmp0_also.t6v(), 'r'), tmp0_also.y6v(tmp0_also.t6v(), 'g'), tmp0_also.y6v(tmp0_also.t6v(), 'b')));
    } else {
      tmp0_also.s6v(d, tmp0_also.y6v(tmp0_also.t6v(), sdf));
    }
    tmp0_also.s6v(alpha, tmp0_also.b6z(SDFShaders_getInstance().sae(), d));
    if (inverted) {
      tmp0_also.s6v(alpha, tmp0_also.x6z(tmp0_also.u6v(1.0), alpha));
    }
    tmp0_also.s6v(tmp0_also.t6v(), tmp0_also.k6y(tmp0_also.i6y(), alpha));
    tmp$ret$0 = tmp0_also;
    tmp$ret$1 = FragmentShader(tmp$ret$0.w6v());
    var tmp3_fragment = tmp$ret$1;
    tmp$ret$2 = tmp1_$this.a7j(VOID, tmp3_fragment, tmp2_name);
    return tmp$ret$2;
  };
  protoOf(MsdfRender).nb2 = function (msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.ob2(msdf, sdf, inverted) : $super.ob2.call(this, msdf, sdf, inverted);
  };
  var MsdfRender_instance;
  function MsdfRender_getInstance() {
    if (MsdfRender_instance == null)
      new MsdfRender();
    return MsdfRender_instance;
  }
  function get_timers(_this__u8e3s4) {
    _init_properties_TimerComponents_kt__j84oeh();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var tmp0_getValue = timers$factory();
      var tmp0_elvis_lhs = timers$delegate.pu_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp0_getValue.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = timers$delegate.qu_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = timers$delegate.pu_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp0_getValue.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var timers$delegate;
  function ensureUpdater($this) {
    if (!($this.tb2_1 == null))
      return Unit_getInstance();
    var tmp = $this;
    tmp.tb2_1 = addUpdater_0($this.pb2_1, TimerComponents$ensureUpdater$lambda($this));
  }
  function addTimer($this, autoRemove, callback) {
    if ($this.sb2_1.ao()) {
      var index = $this.sb2_1.u2($this.sb2_1.j() - 1 | 0);
      $this.qb2_1.r2(index, callback);
      var tmp$ret$0;
      // Inline function 'korlibs.memory.toInt' call
      tmp$ret$0 = autoRemove ? 1 : 0;
      $this.rb2_1.yn(index, tmp$ret$0);
      ensureUpdater($this);
      return _TimerRef___init__impl__cysrar(index);
    }
    var tmp0_this = $this;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.qb2_1;
    tmp0_plusAssign.b(callback);
    var tmp$ret$1;
    // Inline function 'korlibs.memory.toInt' call
    tmp$ret$1 = autoRemove ? 1 : 0;
    $this.rb2_1.un(tmp$ret$1);
    ensureUpdater($this);
    return _TimerRef___init__impl__cysrar($this.qb2_1.j() - 1 | 0);
  }
  function removeTimer($this, ref) {
    $this.qb2_1.r2(_TimerRef___get_index__impl__pnrx4q(ref), null);
    $this.rb2_1.yn(_TimerRef___get_index__impl__pnrx4q(ref), 0);
    $this.sb2_1.un(_TimerRef___get_index__impl__pnrx4q(ref));
  }
  function _interval($this, time, repeat, callback) {
    var tmp$ret$0;
    // Inline function 'korlibs.time.milliseconds' call
    tmp$ret$0 = Companion_getInstance_7().bj(0.0);
    var elapsed = {_v: new TimeSpan(tmp$ret$0)};
    var ref = {_v: new TimerRef(_TimerRef___init__impl__cysrar(-1))};
    ref._v = new TimerRef(addTimer($this, false, TimerComponents$_interval$lambda(elapsed, time, repeat, $this, ref, callback)));
    var tmp = Companion_getInstance_40();
    return tmp.i2a(TimerComponents$_interval$lambda_0($this, ref));
  }
  function TimerComponents$ensureUpdater$lambda(this$0) {
    return function ($this$addUpdater, dt) {
      var tmp0_fastForEachWithIndex = this$0.qb2_1;
      var n = 0;
      while (n < tmp0_fastForEachWithIndex.j()) {
        // Inline function 'korlibs.korge.time.TimerComponents.ensureUpdater.<anonymous>.<anonymous>' call
        var tmp1__anonymous__uwfjfc = n;
        var tmp2__anonymous__z9zvc9 = tmp0_fastForEachWithIndex.k(n);
        var tmp0_safe_receiver = tmp2__anonymous__z9zvc9;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(dt);
        if (!(this$0.rb2_1.k(tmp1__anonymous__uwfjfc) === 0)) {
          removeTimer(this$0, _TimerRef___init__impl__cysrar(tmp1__anonymous__uwfjfc));
        }
        var tmp0 = n;
        n = tmp0 + 1 | 0;
      }
      var tmp;
      if (this$0.qb2_1.l()) {
        var tmp0_safe_receiver_0 = this$0.tb2_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.c1c();
        }
        this$0.tb2_1 = null;
        tmp = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function TimerComponents$wait$lambda($cancellable) {
    return function () {
      var tmp$ret$1;
      // Inline function 'kotlin.coroutines.resume' call
      var tmp$ret$0;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success = Companion_getInstance_41();
      tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_getInstance());
      $cancellable.h4(tmp$ret$0);
      tmp$ret$1 = Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function TimerComponents$_interval$lambda($elapsed, $time, $repeat, this$0, $ref, $callback) {
    return function (dt) {
      $elapsed._v = new TimeSpan(TimeSpan__plus_impl_qdd6zo($elapsed._v.lj_1, dt.lj_1));
      $l$loop: while (TimeSpan__compareTo_impl_zidry4($elapsed._v.lj_1, $time) >= 0) {
        if (!$repeat) {
          removeTimer(this$0, $ref._v.ub2_1);
        }
        $elapsed._v = new TimeSpan(TimeSpan__minus_impl_5w5v8s($elapsed._v.lj_1, $time));
        $callback();
        if (!$repeat)
          break $l$loop;
      }
      return Unit_getInstance();
    };
  }
  function TimerComponents$_interval$lambda_0(this$0, $ref) {
    return function () {
      removeTimer(this$0, $ref._v.ub2_1);
      return Unit_getInstance();
    };
  }
  function TimerComponents(view) {
    this.pb2_1 = view;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$_0();
    tmp.qb2_1 = tmp$ret$0;
    this.rb2_1 = new IntArrayList();
    this.sb2_1 = new IntArrayList();
    this.tb2_1 = null;
  }
  protoOf(TimerComponents).vb2 = function (time, $completion) {
    var tmp$ret$0;
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var tmp0__anonymous__q1qw7t = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(tmp0__anonymous__q1qw7t), get_MODE_CANCELLABLE());
    cancellable.w14();
    // Inline function 'korlibs.korge.time.TimerComponents.wait.<anonymous>' call
    this.wb2(time, TimerComponents$wait$lambda(cancellable));
    tmp$ret$0 = cancellable.i12();
    var tmp0 = tmp$ret$0;
    return tmp0;
  };
  protoOf(TimerComponents).wb2 = function (time, callback) {
    return _interval(this, time, false, callback);
  };
  function _TimerRef___init__impl__cysrar(index) {
    return index;
  }
  function _TimerRef___get_index__impl__pnrx4q($this) {
    return $this;
  }
  function TimerRef__toString_impl_8hh2j7($this) {
    return 'TimerRef(index=' + $this + ')';
  }
  function TimerRef__hashCode_impl_d9ou9o($this) {
    return $this;
  }
  function TimerRef__equals_impl_2fvpr4($this, other) {
    if (!(other instanceof TimerRef))
      return false;
    var tmp0_other_with_cast = other instanceof TimerRef ? other.ub2_1 : THROW_CCE();
    if (!($this === tmp0_other_with_cast))
      return false;
    return true;
  }
  function TimerRef(index) {
    this.ub2_1 = index;
  }
  protoOf(TimerRef).toString = function () {
    return TimerRef__toString_impl_8hh2j7(this.ub2_1);
  };
  protoOf(TimerRef).hashCode = function () {
    return TimerRef__hashCode_impl_d9ou9o(this.ub2_1);
  };
  protoOf(TimerRef).equals = function (other) {
    return TimerRef__equals_impl_2fvpr4(this.ub2_1, other);
  };
  function delay_0(_this__u8e3s4, time, $completion) {
    var tmp0 = get_timers(_this__u8e3s4).vb2(time, $completion);
    return tmp0;
  }
  function timers$delegate$lambda($this$$receiver) {
    _init_properties_TimerComponents_kt__j84oeh();
    return new TimerComponents($this$$receiver);
  }
  function timers$factory() {
    return getPropertyCallableRef('timers', 1, KProperty1, function (receiver) {
      return get_timers(receiver);
    }, null);
  }
  var properties_initialized_TimerComponents_kt_v7ywzv;
  function _init_properties_TimerComponents_kt__j84oeh() {
    if (properties_initialized_TimerComponents_kt_v7ywzv) {
    } else {
      properties_initialized_TimerComponents_kt_v7ywzv = true;
      timers$delegate = new PropertyThis('__ViewTimerComponents', timers$delegate$lambda);
    }
  }
  function get_DEFAULT_EASING() {
    _init_properties_tween_kt__1g7sex();
    return DEFAULT_EASING;
  }
  var DEFAULT_EASING;
  function get_DEFAULT_TIME() {
    _init_properties_tween_kt__1g7sex();
    return DEFAULT_TIME;
  }
  var DEFAULT_TIME;
  function tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
    time = time === VOID ? get_DEFAULT_TIME() : time;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    waitTime = waitTime === VOID ? Companion_getInstance_7().zi_1 : waitTime;
    timeout = timeout === VOID ? false : timeout;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    var tmp;
    if (callback === VOID) {
      tmp = tween$lambda;
    } else {
      tmp = callback;
    }
    callback = tmp;
    var tmp_0 = new $tweenCOROUTINE$17(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion);
    tmp_0.jh_1 = Unit_getInstance();
    tmp_0.kh_1 = null;
    return tmp_0.ph();
  }
  function _update($this, dt) {
    if ($this.vb3_1) {
      $this.ob3_1.fay();
    }
    if ($this.yb3_1) {
      return $this.gb4();
    }
    var tmp0_this = $this;
    tmp0_this.wb3_1 = TimeSpan__plus_impl_qdd6zo(tmp0_this.wb3_1, dt);
    var ratio = clamp(TimeSpan__div_impl_l42f2r($this.wb3_1, $this.xb3_1), 0.0, 1.0);
    $this.hb4($this.wb3_1);
    $this.sb3_1($this.rb3_1.z3z(ratio));
    if (!equals($this.ub3_1, Companion_getInstance_7().zi_1) ? TimeSpan__compareTo_impl_zidry4($this.wb3_1, $this.ub3_1) >= 0 : false) {
      $this.ib4();
    }
    if (ratio >= 1.0) {
      return $this.gb4();
    }
  }
  function TweenComponent$updater$lambda(this$0) {
    return function (it) {
      _update(this$0, it.lb4_1);
      return Unit_getInstance();
    };
  }
  function TweenComponent$lambda(this$0) {
    return function (it) {
      this$0.yb3_1 = true;
      return Unit_getInstance();
    };
  }
  function TweenComponent(view, vs, time, easing, callback, c, waitTime, autoInvalidate) {
    time = time === VOID ? Companion_getInstance_7().zi_1 : time;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    waitTime = waitTime === VOID ? Companion_getInstance_7().zi_1 : waitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.ob3_1 = view;
    this.pb3_1 = vs;
    this.qb3_1 = time;
    this.rb3_1 = easing;
    this.sb3_1 = callback;
    this.tb3_1 = c;
    this.ub3_1 = waitTime;
    this.vb3_1 = autoInvalidate;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'korlibs.time.milliseconds' call
    tmp$ret$0 = Companion_getInstance_7().bj(0.0);
    tmp.wb3_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp_1;
    if (!equals(this.qb3_1, Companion_getInstance_7().zi_1)) {
      tmp_1 = this.qb3_1;
    } else {
      var tmp$ret$4;
      // Inline function 'korlibs.time.nanoseconds' call
      var tmp$ret$3;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = this.pb3_1;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_map, 10));
      var tmp0_iterator = tmp1_map.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        var tmp$ret$1;
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        tmp$ret$1 = _TimeSpan___get_nanoseconds__impl__gaf49o(item.ub4_1);
        tmp0_mapTo.b(tmp$ret$1);
      }
      tmp$ret$2 = tmp0_mapTo;
      tmp$ret$3 = tmp$ret$2;
      var tmp0_elvis_lhs = maxOrNull(tmp$ret$3);
      var tmp2__get_nanoseconds__p8v23m = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      tmp$ret$4 = Companion_getInstance_7().mj(tmp2__get_nanoseconds__p8v23m);
      tmp_1 = tmp$ret$4;
    }
    tmp_0.xb3_1 = tmp_1;
    this.yb3_1 = false;
    this.zb3_1 = false;
    this.ab4_1 = false;
    var tmp_2 = this;
    var tmp_3 = Companion_getInstance_72();
    tmp_2.bb4_1 = this.ob3_1.h6a(tmp_3, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.tb3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.m13(TweenComponent$lambda(this));
    }
    _update(this, Companion_getInstance_7().yi_1);
  }
  protoOf(TweenComponent).ib4 = function () {
    if (this.ab4_1)
      return Unit_getInstance();
    this.ab4_1 = true;
    var tmp0_safe_receiver = this.tb3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$1;
      // Inline function 'kotlin.coroutines.resume' call
      var tmp$ret$0;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success = Companion_getInstance_41();
      tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_getInstance());
      tmp0_safe_receiver.h4(tmp$ret$0);
      tmp$ret$1 = Unit_getInstance();
    }
  };
  protoOf(TweenComponent).gb4 = function () {
    if (this.zb3_1)
      return Unit_getInstance();
    this.zb3_1 = true;
    var tmp0_safe_receiver = this.bb4_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c1c();
    }
    this.bb4_1 = null;
    this.ib4();
  };
  protoOf(TweenComponent).hb4 = function (elapsed) {
    var tmp = new TimeSpan(elapsed);
    var tmp$ret$0;
    // Inline function 'korlibs.time.milliseconds' call
    tmp$ret$0 = Companion_getInstance_7().bj(0.0);
    if (equals(tmp, new TimeSpan(tmp$ret$0))) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var tmp0_fastForEach = this.pb3_1;
      var n = 0;
      while (n < tmp0_fastForEach.j()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
        tmp1__anonymous__uwfjfc.vb4();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp2_fastForEach = this.pb3_1;
    var n_0 = 0;
    while (n_0 < tmp2_fastForEach.j()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var tmp3__anonymous__ufb84q = tmp2_fastForEach.k(tmp0_0);
      var tmp$ret$2;
      // Inline function 'korlibs.time.coalesce' call
      var tmp0_coalesce = tmp3__anonymous__ufb84q.sb4_1;
      var tmp_0;
      if (!equals(tmp0_coalesce, Companion_getInstance_7().zi_1)) {
        tmp_0 = tmp0_coalesce;
      } else {
        var tmp$ret$1;
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>.<anonymous>' call
        tmp$ret$1 = TimeSpan__minus_impl_5w5v8s(this.xb3_1, tmp3__anonymous__ufb84q.rb4_1);
        tmp_0 = tmp$ret$1;
      }
      tmp$ret$2 = tmp_0;
      var durationInTween = tmp$ret$2;
      var tmp_1 = TimeSpan__minus_impl_5w5v8s(elapsed, tmp3__anonymous__ufb84q.rb4_1);
      var tmp$ret$3;
      // Inline function 'korlibs.time.milliseconds' call
      tmp$ret$3 = Companion_getInstance_7().bj(0.0);
      var elapsedInTween = clamp_0(tmp_1, tmp$ret$3, durationInTween);
      var ratioInTween = (TimeSpan__compareTo_impl_zidry4(durationInTween, Companion_getInstance_7().yi_1) <= 0 ? true : TimeSpan__compareTo_impl_zidry4(elapsedInTween, durationInTween) >= 0) ? 1.0 : TimeSpan__div_impl_l42f2r(elapsedInTween, durationInTween);
      var easedRatioInTween = this.rb3_1.z3z(ratioInTween);
      tmp3__anonymous__ufb84q.wb4(toRatio(easedRatioInTween));
    }
  };
  protoOf(TweenComponent).toString = function () {
    return 'TweenComponent(' + this.ob3_1 + ')';
  };
  function tween$lambda(it) {
    _init_properties_tween_kt__1g7sex();
    return Unit_getInstance();
  }
  function tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate, resultContinuation) {
    this.fb5_1 = $this_tween;
    this.gb5_1 = $tc;
    this.hb5_1 = $vs;
    this.ib5_1 = $time;
    this.jb5_1 = $easing;
    this.kb5_1 = $callback;
    this.lb5_1 = $waitTime;
    this.mb5_1 = $autoInvalidate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(tween$slambda).j1e = function ($this$withTimeout, $completion) {
    var tmp = this.k1e($this$withTimeout, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(tween$slambda).mi = function (p1, $completion) {
    return this.j1e((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(tween$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            var tmp0__anonymous__q1qw7t = this;
            var cancellable = new CancellableContinuationImpl(intercepted(tmp0__anonymous__q1qw7t), get_MODE_CANCELLABLE());
            cancellable.w14();
            var view = this.fb5_1;
            this.gb5_1._v = new TweenComponent(view, toList_0(this.hb5_1), this.ib5_1, this.jb5_1, this.kb5_1, cancellable, this.lb5_1, this.mb5_1);
            ;
            suspendResult = returnIfSuspended(cancellable.i12(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(tween$slambda).k1e = function ($this$withTimeout, completion) {
    var i = new tween$slambda(this.fb5_1, this.gb5_1, this.hb5_1, this.ib5_1, this.jb5_1, this.kb5_1, this.lb5_1, this.mb5_1, completion);
    i.nb5_1 = $this$withTimeout;
    return i;
  };
  function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate, resultContinuation) {
    var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate, resultContinuation);
    var l = function ($this$withTimeout, $completion) {
      return i.j1e($this$withTimeout, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $tweenCOROUTINE$17(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fb3_1 = _this__u8e3s4;
    this.gb3_1 = vs;
    this.hb3_1 = time;
    this.ib3_1 = easing;
    this.jb3_1 = waitTime;
    this.kb3_1 = timeout;
    this.lb3_1 = autoInvalidate;
    this.mb3_1 = callback;
  }
  protoOf($tweenCOROUTINE$17).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 5;
            if (!(this.fb3_1 == null)) {
              this.nb3_1 = {_v: null};
              this.ih_1 = 2;
              this.hh_1 = 1;
              var tmp_0;
              if (this.kb3_1) {
                var tmp_1 = TimeSpan__times_impl_86ofia(this.hb3_1, 2);
                tmp_0 = TimeSpan__plus_impl_qdd6zo(tmp_1, Companion_getInstance_7().bj(300.0));
              } else {
                tmp_0 = Companion_getInstance_7().zi_1;
              }
              var tmp_2 = tmp_0;
              suspendResult = withTimeout(tmp_2, tween$slambda_0(this.fb3_1, this.nb3_1, this.gb3_1, this.hb3_1, this.ib3_1, this.mb3_1, this.jb3_1, this.lb3_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            this.ih_1 = 5;
            this.hh_1 = 3;
            continue $sm;
          case 2:
            this.ih_1 = 5;
            var tmp_3 = this.kh_1;
            if (tmp_3 instanceof TimeoutCancellationException) {
              var e = this.kh_1;
              var tmp0_safe_receiver = this.nb3_1._v;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.hb4(this.hb3_1);
              }
              this.hh_1 = 3;
              continue $sm;
            } else {
              throw this.kh_1;
            }

            break;
          case 3:
            this.ih_1 = 5;
            this.hh_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this.kh_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.ih_1 === 5) {
          throw e_0;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e_0;
        }
      }
     while (true);
  };
  var properties_initialized_tween_kt_p0n8nv;
  function _init_properties_tween_kt__1g7sex() {
    if (properties_initialized_tween_kt_p0n8nv) {
    } else {
      properties_initialized_tween_kt_p0n8nv = true;
      DEFAULT_EASING = Companion_getInstance_3().s3z();
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance_7().ej(1.0);
      DEFAULT_TIME = tmp$ret$0;
    }
  }
  function V2(key, initial, end, interpolator, includeStart, startTime, duration, initialization) {
    var tmp;
    if (startTime === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'korlibs.time.nanoseconds' call
      tmp$ret$0 = Companion_getInstance_7().mj(0.0);
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = startTime;
    }
    startTime = tmp;
    duration = duration === VOID ? Companion_getInstance_7().zi_1 : duration;
    initialization = initialization === VOID ? null : initialization;
    this.mb4_1 = key;
    this.nb4_1 = initial;
    this.ob4_1 = end;
    this.pb4_1 = interpolator;
    this.qb4_1 = includeStart;
    this.rb4_1 = startTime;
    this.sb4_1 = duration;
    this.tb4_1 = initialization;
    var tmp_0 = this;
    var tmp$ret$3;
    // Inline function 'korlibs.time.coalesce' call
    var tmp0_coalesce = this.sb4_1;
    var tmp_1;
    if (!equals(tmp0_coalesce, Companion_getInstance_7().zi_1)) {
      tmp_1 = tmp0_coalesce;
    } else {
      var tmp$ret$2;
      // Inline function 'korlibs.korge.tween.V2.endTime.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'korlibs.time.nanoseconds' call
      tmp$ret$1 = Companion_getInstance_7().mj(0.0);
      tmp$ret$2 = tmp$ret$1;
      tmp_1 = tmp$ret$2;
    }
    tmp$ret$3 = tmp_1;
    tmp_0.ub4_1 = TimeSpan__plus_impl_qdd6zo(this.rb4_1, tmp$ret$3);
  }
  protoOf(V2).vb4 = function () {
    if (!this.qb4_1) {
      this.nb4_1 = this.mb4_1.get();
    }
    var tmp0_safe_receiver = this.tb4_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  };
  protoOf(V2).wb4 = function (ratio) {
    this.mb4_1.set(this.pb4_1(new Ratio(ratio), this.nb4_1, this.ob4_1));
  };
  protoOf(V2).toString = function () {
    return 'V2(key=' + this.mb4_1.callableName + ', range=[' + this.nb4_1 + '-' + this.ob4_1 + '], startTime=' + new TimeSpan(this.rb4_1) + ', duration=' + new TimeSpan(this.sb4_1) + ')';
  };
  protoOf(V2).hashCode = function () {
    var result = hashCode(this.mb4_1);
    result = imul(result, 31) + (this.nb4_1 == null ? 0 : hashCode(this.nb4_1)) | 0;
    result = imul(result, 31) + (this.ob4_1 == null ? 0 : hashCode(this.ob4_1)) | 0;
    result = imul(result, 31) + hashCode(this.pb4_1) | 0;
    result = imul(result, 31) + (this.qb4_1 | 0) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl_izs3k5(this.rb4_1) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl_izs3k5(this.sb4_1) | 0;
    result = imul(result, 31) + (this.tb4_1 == null ? 0 : hashCode(this.tb4_1)) | 0;
    return result;
  };
  protoOf(V2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.mb4_1, tmp0_other_with_cast.mb4_1))
      return false;
    if (!equals(this.nb4_1, tmp0_other_with_cast.nb4_1))
      return false;
    if (!equals(this.ob4_1, tmp0_other_with_cast.ob4_1))
      return false;
    if (!equals(this.pb4_1, tmp0_other_with_cast.pb4_1))
      return false;
    if (!(this.qb4_1 === tmp0_other_with_cast.qb4_1))
      return false;
    if (!equals(this.rb4_1, tmp0_other_with_cast.rb4_1))
      return false;
    if (!equals(this.sb4_1, tmp0_other_with_cast.sb4_1))
      return false;
    if (!equals(this.tb4_1, tmp0_other_with_cast.tb4_1))
      return false;
    return true;
  };
  function _interpolateFloat(ratio, l, r) {
    return interpolate(ratio, l, r);
  }
  function registerUISupportOnce($this) {
    if ($this.kav_1)
      return Unit_getInstance();
    var tmp0_elvis_lhs = $this.hb0();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stage = tmp;
    $this.kav_1 = true;
    if (equals(getExtra(stage, 'uiSupport'), true))
      return Unit_getInstance();
    setExtra(stage, 'uiSupport', true);
    var tmp$ret$2;
    // Inline function 'korlibs.korge.input.keys' call
    var tmp$ret$1;
    // Inline function 'kotlin.run' call
    var tmp0_run = get_keys_0(stage);
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
    tmp$ret$0 = Unit_getInstance();
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
  }
  function Companion_8() {
    Companion_instance_8 = this;
    this.ob5_1 = 90.0;
    this.pb5_1 = 32.0;
    this.qb5_1 = _Size___init__impl__aywn0g(90.0, 32.0);
  }
  var Companion_instance_8;
  function Companion_getInstance_66() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function UIView(size, cache) {
    Companion_getInstance_66();
    size = size === VOID ? Companion_getInstance_66().qb5_1 : size;
    cache = cache === VOID ? false : cache;
    FixedSizeCachedContainer.call(this, size, cache, false);
    this.jav_1 = size;
    this.kav_1 = false;
  }
  protoOf(UIView).lav = function () {
    return this.jav_1;
  };
  protoOf(UIView).nav = function () {
    return Companion_getInstance_38().s3f(0.0, 0.0, this.ab0(), this.bb0());
  };
  protoOf(UIView).oav = function () {
    this.pav();
  };
  protoOf(UIView).pav = function () {
    this.jay();
  };
  protoOf(UIView).qav = function (ctx) {
    registerUISupportOnce(this);
    protoOf(FixedSizeCachedContainer).qav.call(this, ctx);
  };
  function anchor(_this__u8e3s4, anchor) {
    _this__u8e3s4.ib8(anchor);
    return _this__u8e3s4;
  }
  function anchor_0(_this__u8e3s4, ax, ay) {
    return anchor(_this__u8e3s4, _Anchor___init__impl__4yyw24(ax, ay));
  }
  function anchor_1(_this__u8e3s4, ax, ay) {
    return anchor(_this__u8e3s4, _Anchor___init__impl__4yyw24_0(ax, ay));
  }
  function anchor_2(_this__u8e3s4, ax, ay) {
    return anchor(_this__u8e3s4, _Anchor___init__impl__4yyw24_1(ax, ay));
  }
  function _get_bitmapWidth__ndy7bu($this) {
    return $this.t5n().ck();
  }
  function _get_bitmapHeight__5t1vx1($this) {
    return $this.t5n().dk();
  }
  function _getLocalBoundsInternal($this, strokes) {
    var bounds = boundsUnsafe($this, strokes);
    return Companion_getInstance_38().o3i(_Rectangle___get_x__impl__vgifdj(bounds) - $this.zay(), _Rectangle___get_y__impl__aqz5je(bounds) - $this.aaz(), _Rectangle___get_width__impl__y1u79l(bounds), _Rectangle___get_height__impl__kro6o8(bounds));
  }
  function _getLocalBoundsInternal$default($this, strokes, $super) {
    strokes = strokes === VOID ? $this.nbd_1 : strokes;
    return _getLocalBoundsInternal($this, strokes);
  }
  function boundsUnsafe($this, strokes) {
    if ($this.jbd_1) {
      $this.jbd_1 = false;
      $this.pbd_1 = $this.qbd(false);
      $this.obd_1 = $this.qbd(true);
    }
    return strokes ? $this.obd_1 : $this.pbd_1;
  }
  function InternalViewAutoscaling() {
    this.rbd_1 = 1.0;
    this.sbd_1 = 1.0;
    this.tbd_1 = 1.0;
    this.ubd_1 = 1.0;
    this.vbd_1 = 1.0;
    this.wbd_1 = _MatrixTransform___init__impl__7axsoi();
  }
  protoOf(InternalViewAutoscaling).xbd = function (autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.wbd_1 = Matrix__toTransform_impl_lr8urh(_Matrix___get_immutable__impl__k08qr(globalMatrix));
      var tmp$ret$0;
      // Inline function 'kotlin.math.abs' call
      var tmp0_abs = _MatrixTransform___get_scaleX__impl__t9pp1f(this.wbd_1);
      tmp$ret$0 = Math.abs(tmp0_abs);
      var sx = tmp$ret$0;
      var tmp$ret$1;
      // Inline function 'kotlin.math.abs' call
      var tmp1_abs = _MatrixTransform___get_scaleY__impl__g37z8(this.wbd_1);
      tmp$ret$1 = Math.abs(tmp1_abs);
      var sy = tmp$ret$1;
      var tmp$ret$2;
      // Inline function 'kotlin.math.max' call
      tmp$ret$2 = Math.max(sx, sy);
      var sxy = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.math.abs' call
      var tmp2_abs = sx / this.tbd_1 - 1.0;
      tmp$ret$3 = Math.abs(tmp2_abs);
      var diffX = tmp$ret$3;
      var tmp$ret$4;
      // Inline function 'kotlin.math.abs' call
      var tmp3_abs = sy / this.ubd_1 - 1.0;
      tmp$ret$4 = Math.abs(tmp3_abs);
      var diffY = tmp$ret$4;
      var tmp0_subject = autoScalingPrecise;
      var tmp;
      switch (tmp0_subject) {
        case true:
          tmp = diffX > 0.0 ? true : diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 ? true : diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.tbd_1 = sx;
        this.ubd_1 = sy;
        this.vbd_1 = sxy;
        this.rbd_1 = 1.0 / sx;
        this.sbd_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.tbd_1 = 1.0;
      this.ubd_1 = 1.0;
      this.vbd_1 = 1.0;
      this.rbd_1 = 1.0;
      this.sbd_1 = 1.0;
    }
    return false;
  };
  function BaseGraphics(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
    tmp$ret$0 = get_Bitmaps_transparent();
    BaseImage_init_$Init$(tmp$ret$0, VOID, VOID, VOID, this);
    this.bbd_1 = autoScaling;
    this.cbd_1 = true;
    this.dbd_1 = false;
    this.ebd_1 = false;
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$1 = ArrayList_init_$Create$_0();
    tmp.fbd_1 = tmp$ret$1;
    this.gbd_1 = new InternalViewAutoscaling();
    this.hbd_1 = 1;
    this.ibd_1 = true;
    this.jbd_1 = true;
    this.kbd_1 = 1.0;
    this.lbd_1 = 1.0;
    this.mbd_1 = true;
    this.nbd_1 = true;
    this.obd_1 = Companion_getInstance_38().p3i();
    this.pbd_1 = Companion_getInstance_38().p3i();
  }
  protoOf(BaseGraphics).ybd = function (value) {
    this.cbd_1 = value;
    this.zbd();
  };
  protoOf(BaseGraphics).zbd = function () {
    this.ibd_1 = true;
    this.jbd_1 = true;
    this.qb0();
  };
  protoOf(BaseGraphics).qav = function (ctx) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.fbd_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.korge.view.BaseGraphics.renderInternal.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      var tmp$ret$0;
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
      tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp1__anonymous__uwfjfc, get_bmp(tmp$ret$0))) {
        ctx.n9y_1.fa9(tmp1__anonymous__uwfjfc, 'BaseGraphics');
      }
    }
    this.fbd_1.v2();
    if (this.abe()) {
    }
    protoOf(BaseImage).qav.call(this, ctx);
  };
  protoOf(BaseGraphics).abe = function () {
    if (this.gbd_1.xbd(this.bbd_1, this.dbd_1, this.kb0())) {
      this.ibd_1 = true;
    }
    if (!this.ibd_1)
      return false;
    this.ibd_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    var tmp$ret$1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    tmp$ret$0 = this.fbd_1.b(this.t5n().l3s());
    tmp$ret$1 = tmp$ret$0;
    var tmp$ret$6;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(_Rectangle___get_width__impl__y1u79l(boundsWithShapes) * this.gbd_1.tbd_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(_Rectangle___get_height__impl__kro6o8(boundsWithShapes) * this.gbd_1.ubd_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.hbd_1 | 0, imageHeight + this.hbd_1 | 0, this.cbd_1, true);
    this.kbd_1 = this.gbd_1.tbd_1;
    this.lbd_1 = this.gbd_1.ubd_1;
    var tmp$ret$5;
    // Inline function 'korlibs.image.bitmap.context2d' call
    var tmp$ret$4;
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var tmp0_lock = image.w46_1;
    {
      image.f47();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.b4f(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        var tmp$ret$2;
        // Inline function 'korlibs.image.vector.Context2d.scale' call
        var tmp0_scale = this.kbd_1;
        var tmp1_scale = this.lbd_1;
        ctx.v5k(numberToDouble(tmp0_scale), numberToDouble(tmp1_scale));
        tmp$ret$2 = Unit_getInstance();
        var tmp$ret$3;
        // Inline function 'korlibs.image.vector.Context2d.translate' call
        var tmp2_translate = -_Rectangle___get_x__impl__vgifdj(boundsWithShapes);
        var tmp3_translate = -_Rectangle___get_y__impl__aqz5je(boundsWithShapes);
        ctx.f51(numberToDouble(tmp2_translate), numberToDouble(tmp3_translate));
        tmp$ret$3 = Unit_getInstance();
        this.bbe(ctx);
      }finally {
        ctx.p13();
      }
    }finally {
      result = image.x47(tmp0_lock);
    }
    tmp$ret$4 = result;
    tmp$ret$5 = image;
    this.cbe(slice(image));
    tmp$ret$6 = Unit_getInstance();
    return true;
  };
  protoOf(BaseGraphics).dbe = function () {
    return _get_bitmapWidth__ndy7bu(this) / this.kbd_1;
  };
  protoOf(BaseGraphics).ebe = function () {
    return _get_bitmapHeight__5t1vx1(this) / this.lbd_1;
  };
  protoOf(BaseGraphics).o3s = function () {
    return this.dbe();
  };
  protoOf(BaseGraphics).p3s = function () {
    return this.ebe();
  };
  protoOf(BaseGraphics).zay = function () {
    return _Anchor___get_sx__impl__4wuc7c(this.mbg()) * this.dbe();
  };
  protoOf(BaseGraphics).aaz = function () {
    return _Anchor___get_sy__impl__xqgt9j(this.mbg()) * this.ebe();
  };
  protoOf(BaseGraphics).nbg = function () {
    return _Rectangle___get_x__impl__vgifdj(_getLocalBoundsInternal(this, this.mbd_1));
  };
  protoOf(BaseGraphics).obg = function () {
    return _Rectangle___get_y__impl__aqz5je(_getLocalBoundsInternal(this, this.mbd_1));
  };
  protoOf(BaseGraphics).nav = function () {
    return _getLocalBoundsInternal$default(this);
  };
  function BaseView() {
    BaseEventListener.call(this);
  }
  protoOf(BaseView).fay = function () {
  };
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_42().w6i_1;
    tmp.wa1_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.xa1_1 = this.wa1_1.wbg(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_42().f6u(Companion_getInstance_43().w6t_1, Companion_getInstance_43().d6u_1);
    tmp_0.ya1_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_42().y6i_1;
    tmp_1.za1_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_42().f6u(Companion_getInstance_43().v6t_1, Companion_getInstance_43().z6t_1);
    tmp_2.aa2_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_42().f6u(Companion_getInstance_43().w6t_1, Companion_getInstance_43().a6u_1);
    tmp_3.ba2_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_42().f6u(Companion_getInstance_43().d6u_1, Companion_getInstance_43().z6t_1);
    tmp_4.ca2_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_42().f6u(Companion_getInstance_43().d6u_1, Companion_getInstance_43().b6u_1);
    tmp_5.da2_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_42().f6u(Companion_getInstance_43().x6t_1, Companion_getInstance_43().u6t_1);
    tmp_6.ea2_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_42().e6u(Companion_getInstance_43().b6u_1, Companion_getInstance_43().u6t_1, Companion_getInstance_43().w6t_1, Companion_getInstance_43().w6t_1, Companion_getInstance_44().j6u_1);
    tmp_7.fa2_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_42().f6u(Companion_getInstance_43().y6t_1, Companion_getInstance_43().d6u_1);
    tmp_8.ga2_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_42().e6u(Companion_getInstance_43().b6u_1, Companion_getInstance_43().u6t_1, Companion_getInstance_43().w6t_1, Companion_getInstance_43().w6t_1);
    tmp_9.ha2_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_42().e6u(Companion_getInstance_43().b6u_1, Companion_getInstance_43().u6t_1, Companion_getInstance_43().w6t_1, Companion_getInstance_43().w6t_1);
    tmp_10.ia2_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_42().e6u(Companion_getInstance_43().b6u_1, Companion_getInstance_43().u6t_1, Companion_getInstance_43().w6t_1, Companion_getInstance_43().w6t_1);
    tmp_11.ja2_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_42().e6u(Companion_getInstance_43().b6u_1, Companion_getInstance_43().u6t_1, Companion_getInstance_43().w6t_1, Companion_getInstance_43().w6t_1);
    tmp_12.ka2_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_42().e6u(Companion_getInstance_43().b6u_1, Companion_getInstance_43().u6t_1, Companion_getInstance_43().w6t_1, Companion_getInstance_43().w6t_1);
    tmp_13.la2_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.xa1_1, this.ya1_1, this.wa1_1, this.za1_1, this.aa2_1, this.ba2_1, this.ca2_1, this.da2_1, this.ea2_1, this.fa2_1, this.ga2_1, this.ha2_1, this.ia2_1, this.ja2_1, this.ka2_1, this.la2_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp_14.ma2_1 = tmp$ret$2;
    var tmp_15 = this;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy = this.ma2_1;
    var capacity = coerceAtLeast(mapCapacity(tmp1_associateBy.length), 16);
    var tmp$ret$4;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap_init_$Create$(capacity);
    var indexedObject = tmp1_associateBy;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$3;
      // Inline function 'korlibs.korge.view.Companion.BY_NAME.<anonymous>' call
      tmp$ret$3 = ensureNotNull(element.fab_1);
      tmp0_associateByTo.x3(tmp$ret$3, element);
    }
    tmp$ret$4 = tmp0_associateByTo;
    tmp$ret$5 = tmp$ret$4;
    tmp_15.na2_1 = tmp$ret$5;
    this.oa2_1 = toList_0(this.ma2_1);
    var tmp_16 = this;
    var tmp$ret$8;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy_0 = get_indices(this.ma2_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associateBy_0, 10)), 16);
    var tmp$ret$7;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo_0 = LinkedHashMap_init_$Create$(capacity_0);
    var inductionVariable_0 = tmp1_associateBy_0.a1_1;
    var last_0 = tmp1_associateBy_0.b1_1;
    if (inductionVariable_0 <= last_0)
      do {
        var element_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp$ret$6;
        // Inline function 'korlibs.korge.view.Companion.TO_ORDINAL.<anonymous>' call
        tmp$ret$6 = Companion_getInstance_67().ma2_1[element_0];
        tmp0_associateByTo_0.x3(tmp$ret$6, element_0);
      }
       while (!(element_0 === last_0));
    tmp$ret$7 = tmp0_associateByTo_0;
    tmp$ret$8 = tmp$ret$7;
    tmp_16.pa2_1 = tmp$ret$8;
  }
  var Companion_instance_9;
  function Companion_getInstance_67() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function BlendMode(factors, name) {
    Companion_getInstance_67();
    name = name === VOID ? null : name;
    this.eab_1 = factors;
    this.fab_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.eab_1);
    var tmp$ret$0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_hashCode = this.fab_1;
    var tmp0_safe_receiver = tmp0_hashCode;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.gab_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  protoOf(BlendMode).hashCode = function () {
    return this.gab_1;
  };
  protoOf(BlendMode).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.eab_1 === other.eab_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.fab_1 == other.fab_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(BlendMode).toString = function () {
    var tmp0_elvis_lhs = this.fab_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  };
  protoOf(BlendMode).xbg = function (factors, name) {
    return new BlendMode(factors, name);
  };
  protoOf(BlendMode).wbg = function (factors, name, $super) {
    factors = factors === VOID ? this.eab_1 : factors;
    name = name === VOID ? this.fab_1 : name;
    return $super === VOID ? this.xbg(factors, name) : $super.xbg.call(this, new AGBlending(factors), name);
  };
  function FixedSizeCachedContainer(size, cache, clip) {
    size = size === VOID ? _Size___init__impl__aywn0g_0(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    CachedContainer.call(this, cache);
    this.fb8_1 = clip;
    this.gb8_1 = size;
    this.hb8_1 = Ref(false);
  }
  protoOf(FixedSizeCachedContainer).lav = function () {
    return this.gb8_1;
  };
  protoOf(FixedSizeCachedContainer).nav = function () {
    return Companion_getInstance_38().o3i(0.0, 0.0, this.ck(), this.dk());
  };
  protoOf(FixedSizeCachedContainer).qav = function (ctx) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var tmp2_renderClipped = Companion_getInstance_68();
      var tmp3_renderClipped = this.fb8_1;
      var tmp4_renderClipped = this.hb8_1;
      if (tmp4_renderClipped.q()) {
        protoOf(CachedContainer).qav.call(this, ctx);
        tmp$ret$0 = Unit_getInstance();
        break $l$block_0;
      }
      if (tmp3_renderClipped) {
        var m = this.kb0();
        var hasRotation = !(_Matrix___get_b__impl__dm2icj(m) === 0.0) ? true : !(_Matrix___get_c__impl__slf2ke(m) === 0.0);
        if (hasRotation) {
          var old = tmp4_renderClipped.q();
          try {
            tmp4_renderClipped.wt(true);
            renderFiltered(this, ctx, Companion_getInstance_76());
          }finally {
            tmp4_renderClipped.wt(old);
          }
          tmp$ret$0 = Unit_getInstance();
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var tmp0_useBatcher = ctx.u9y_1;
        if (!(ctx.y9y_1 === tmp0_useBatcher)) {
          ctx.y9y_1 = tmp0_useBatcher;
          ctx.va3();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var tmp1__anonymous__uwfjfc = ctx.w9y_1;
        var bounds = Rectangle__normalized_impl_j0pmhl(Rectangle__transformed_impl_5k4zxr(this.bb1(ctx), ctx.i9y_1));
        var rect = AGScissor__toRectOrNull_impl_bkzy1a(tmp1__anonymous__uwfjfc.iad_1.eaa());
        var intersects = true;
        var tmp = rect;
        if (!((tmp == null ? null : new Rectangle(tmp)) == null)) {
          intersects = Rectangle__intersects_impl_bpzhh2(bounds, rect);
        }
        if (intersects) {
          var tmp$ret$2;
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var tmp2_scissor = Companion_getInstance_32().f6s(bounds);
          var tmp$ret$1;
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var tmp0_scissor = tmp1__anonymous__uwfjfc.iad_1;
            var tmp1_scissor = tmp1__anonymous__uwfjfc.rad(tmp2_scissor);
            var temp = tmp0_scissor.oa3_1;
            tmp0_scissor.uaa();
            tmp0_scissor.oa3_1 = tmp1_scissor;
            try {
              protoOf(CachedContainer).qav.call(this, ctx);
              tmp$ret$1 = Unit_getInstance();
              break $l$block_1;
            }finally {
              tmp0_scissor.uaa();
              tmp0_scissor.oa3_1 = temp;
            }
          }
          tmp$ret$2 = tmp$ret$1;
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          protoOf(CachedContainer).qav.call(this, ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        protoOf(CachedContainer).qav.call(this, ctx);
      }
    }
  };
  function CacheTexture($outer, ctx) {
    this.cbh_1 = $outer;
    this.ybg_1 = ctx;
    this.zbg_1 = this.ybg_1.fad(16, 16, VOID, VOID, VOID, false);
    this.abh_1 = TextureBase_init_$Create$(this.zbg_1.p6o(), 16, 16);
    this.bbh_1 = Texture_1(this.abh_1);
  }
  protoOf(CacheTexture).dbh = function (width, height) {
    this.zbg_1.r6o(0, 0, width, height);
    this.abh_1.ha8(width);
    this.abh_1.ia8(height);
    this.bbh_1 = Texture_1(this.abh_1);
  };
  protoOf(CacheTexture).c1c = function () {
    this.cbh_1.bay_1 = null;
    this.ybg_1.gad(this.zbg_1);
  };
  function CachedContainer(cache) {
    cache = cache === VOID ? true : cache;
    Container.call(this);
    this.aay_1 = cache;
    this.bay_1 = null;
    this.cay_1 = true;
    this.day_1 = -1.0;
    this.eay_1 = Companion_getInstance_38().p3i();
  }
  protoOf(CachedContainer).fay = function () {
    protoOf(Container).fay.call(this);
    this.cay_1 = true;
  };
  protoOf(CachedContainer).qav = function (ctx) {
    if (!this.ib0())
      return Unit_getInstance();
    if (!this.aay_1) {
      return protoOf(Container).qav.call(this, ctx);
    }
    if (this.bay_1 == null) {
      this.bay_1 = new CacheTexture(this, ctx);
      this.cay_1 = true;
    }
    var cache = ensureNotNull(this.bay_1);
    ctx.dad(cache);
    var tmp0_safe_receiver = ctx.q9y_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m9m_1;
    var tmp2_subject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m82();
    var tmp0 = tmp2_subject == null ? -1 : tmp2_subject.j5_1;
    var renderScale = tmp0 === 0 ? 1.0 : ctx.h7x();
    if (this.cay_1 ? true : !(this.day_1 === renderScale)) {
      this.day_1 = renderScale;
      this.eay_1 = this.jb1(VOID, false);
      this.cay_1 = false;
      var texWidth = coerceAtLeast(numberToInt(_Rectangle___get_width__impl__y1u79l(this.eay_1) * renderScale), 1);
      var texHeight = coerceAtLeast(numberToInt(_Rectangle___get_height__impl__kro6o8(this.eay_1) * renderScale), 1);
      cache.dbh(texWidth, texHeight);
      ctx.va3();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var tmp0_renderToFrameBuffer = cache.zbg_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.g9z(tmp0_renderToFrameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        var tmp$ret$3;
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var tmp$ret$2;
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var tmp1_use = ctx.u9y_1;
        var tmp0_useBatcher = tmp1_use.qa2_1;
        if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
          tmp0_useBatcher.y9y_1 = tmp1_use;
          tmp0_useBatcher.va3();
        }
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var tmp0_scissor = _AGScissor___init__impl__g8s683(0, 0, tmp0_renderToFrameBuffer.e6k_1, tmp0_renderToFrameBuffer.f6k_1);
          var temp = tmp1_use.oa3_1;
          tmp1_use.uaa();
          tmp1_use.oa3_1 = tmp0_scissor;
          try {
            {
              ctx.bad(Colors_getInstance().o48_1);
            }
            var tmp3_setViewMatrixTemp = Matrix__scaled$default_impl_qe0yl1(Matrix__translated_impl_3xg5y(this.lb0(), -_Rectangle___get_x__impl__vgifdj(this.eay_1), -_Rectangle___get_y__impl__aqz5je(this.eay_1)), renderScale);
            ctx.va3();
            var temp4 = ctx.h9y_1;
            var temp2d = ctx.i9y_1;
            ctx.i9y_1 = tmp3_setViewMatrixTemp;
            ctx.h9y_1 = toMatrix4(tmp3_setViewMatrixTemp);
            var tmp$ret$0;
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var tmp0_push = ctx.i6p(ProjViewUB_getInstance());
              var tmp0_this = tmp0_push;
              var tmp1 = tmp0_this.x6q();
              tmp0_this.a7b(tmp1 + 1 | 0);
              tmp0_push.tn(tmp0_push.x6q() + 1 | 0);
              var blockSize = tmp0_push.a6p_1;
              var index0 = imul(tmp0_push.x6q() - 1 | 0, blockSize);
              var index1 = imul(tmp0_push.x6q(), blockSize);
              var texBlockSize = tmp0_push.y6o_1.t6x().j();
              var texIndex0 = imul(tmp0_push.x6q() - 1 | 0, texBlockSize);
              var texIndex1 = imul(tmp0_push.x6q(), texBlockSize);
              if (tmp0_push.x6q() > 0) {
                arraycopy_2(tmp0_push.c6p_1, index0, tmp0_push.c6p_1, index1, blockSize);
              } else {
                arrayfill_0(tmp0_push.c6p_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var tmp1__anonymous__uwfjfc = tmp0_push.y6o_1;
              var tmp2__anonymous__z9zvc9 = tmp0_push.d6p_1;
              tmp2__anonymous__z9zvc9.h7b(tmp1__anonymous__uwfjfc.s6x(), ctx.h9y_1);
              if (tmp0_push.x6q() >= 1) {
                var equals = arrayequal(tmp0_push.c6p_1, index0, tmp0_push.c6p_1, index1, blockSize);
                if (equals) {
                  var tmp2_this = tmp0_push;
                  var tmp3 = tmp2_this.x6q();
                  tmp2_this.a7b(tmp3 - 1 | 0);
                  tmp$ret$0 = false;
                  break $l$block;
                }
              }
              tmp$ret$0 = true;
            }
            var tmp;
            try {
              protoOf(Container).qav.call(this, ctx);
              tmp = Unit_getInstance();
            }finally {
              ctx.va3();
              ctx.h9y_1 = temp4;
              ctx.i9y_1 = temp2d;
              ctx.i6p(ProjViewUB_getInstance()).b7b();
            }
            tmp$ret$1 = tmp;
            break $l$block_0;
          }finally {
            tmp1_use.uaa();
            tmp1_use.oa3_1 = temp;
          }
        }
        tmp$ret$2 = tmp$ret$1;
        tmp$ret$3 = tmp$ret$2;
      }finally {
        ctx.h9z();
      }
    }
    var tmp$ret$5;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var tmp$ret$4;
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var tmp2_use = ctx.u9y_1;
    var tmp1_useBatcher = tmp2_use.qa2_1;
    if (!(tmp1_useBatcher.y9y_1 === tmp2_use)) {
      tmp1_useBatcher.y9y_1 = tmp2_use;
      tmp1_useBatcher.va3();
    }
    tmp2_use.xa3(cache.bbh_1, VOID, VOID, VOID, VOID, Matrix__prescaled$default_impl_m96zqs(Matrix__pretranslated_impl_9mjs3v_0(this.kb0(), _Rectangle___get_x__impl__vgifdj(this.eay_1), _Rectangle___get_y__impl__aqz5je(this.eay_1)), 1.0 / renderScale), VOID, this.ob0(), this.f9p_1);
    tmp$ret$4 = Unit_getInstance();
    tmp$ret$5 = tmp$ret$4;
  };
  protoOf(CachedContainer).gay = function () {
    return this;
  };
  protoOf(CachedContainer).hay = function (view) {
    this.cay_1 = true;
    var tmp0_safe_receiver = this.u1y();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d9p_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.hay(view);
    }
  };
  function ZIndexComparator() {
    ZIndexComparator_instance = this;
  }
  protoOf(ZIndexComparator).ebh = function (a, b) {
    return compareTo(a.jaz(), b.jaz());
  };
  protoOf(ZIndexComparator).compare = function (a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.ebh(tmp, b instanceof View ? b : THROW_CCE());
  };
  var ZIndexComparator_instance;
  function ZIndexComparator_getInstance() {
    if (ZIndexComparator_instance == null)
      new ZIndexComparator();
    return ZIndexComparator_instance;
  }
  function Container$renderChildrenInternal$lambda(it) {
    var tmp;
    if (it instanceof FixedSizeContainer) {
      tmp = it.s64();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function Container(cull) {
    cull = cull === VOID ? false : cull;
    View.call(this, true);
    this.rai_1 = cull;
    this.sai_1 = FastArrayList_init_$Create$();
    this.tai_1 = new ContainerCollection(this, this.sai_1);
    this.uai_1 = null;
    this.vai_1 = new MMatrix();
    this.wai_1 = false;
    this.xai_1 = false;
    this.yai_1 = FastArrayList_init_$Create$();
  }
  protoOf(Container).iay = function () {
    return this.sai_1;
  };
  protoOf(Container).jay = function () {
    protoOf(View).jay.call(this);
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.tai_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      if (tmp1__anonymous__uwfjfc.h9q_1) {
        tmp1__anonymous__uwfjfc.jay();
      }
    }
  };
  protoOf(Container).kay = function () {
    protoOf(View).kay.call(this);
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.tai_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      if (tmp1__anonymous__uwfjfc.i9q_1) {
        tmp1__anonymous__uwfjfc.kay();
      }
    }
  };
  protoOf(Container).lay = function () {
    return this.sai_1.j();
  };
  protoOf(Container).may = function (view) {
  };
  protoOf(Container).nay = function (index) {
    return this.sai_1.k(index);
  };
  protoOf(Container).oay = function (index) {
    return getOrNull(this.sai_1, index);
  };
  protoOf(Container).pay = function (index) {
    return this.yay(this.oay(index));
  };
  protoOf(Container).qay = function () {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.tai_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      tmp1__anonymous__uwfjfc.faz(null);
      tmp1__anonymous__uwfjfc.baz(-1);
    }
    this.sai_1.v2();
    this.vay();
  };
  protoOf(Container).ray = function (view) {
    return this.xay(view, this.lay());
  };
  protoOf(Container).zai = function (view) {
    this.xay(view, this.lay());
  };
  protoOf(Container).k = function (index) {
    return this.nay(index);
  };
  protoOf(Container).qav = function (ctx) {
    if (!this.ib0())
      return Unit_getInstance();
    this.say(ctx);
  };
  protoOf(Container).say = function (ctx) {
    if (!this.rai_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.wai_1) {
        this.wai_1 = true;
        this.yai_1.v2();
        this.yai_1.m(this.tai_1);
        if (this.uay())
          this.xai_1 = false;
      }
      if (!this.xai_1) {
        this.xai_1 = true;
        sortWith(this.yai_1, ZIndexComparator_getInstance());
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      var tmp3_fastForEach = this.yai_1;
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast = tmp3_fastForEach.vp_1;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_unsafeCast;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      var array = tmp$ret$2;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        var tmp$ret$6;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$4;
        // Inline function 'korlibs.datastructure.get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp1_get = tmp0;
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = array;
        tmp$ret$4 = tmp$ret$3[tmp1_get];
        var tmp2_unsafeCast = tmp$ret$4;
        var tmp$ret$5;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$5 = tmp2_unsafeCast;
        tmp$ret$6 = tmp$ret$5;
        var tmp4__anonymous__pkmkx7 = tmp$ret$6;
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        tmp4__anonymous__pkmkx7.mav(ctx);
      }
      return Unit_getInstance();
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp0_safe_receiver = clippingContainer;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.eb1();
    var tmp_0;
    var tmp_1 = tmp1_elvis_lhs;
    if ((tmp_1 == null ? null : new Rectangle(tmp_1)) == null) {
      tmp_0 = Companion_getInstance_38().e3b();
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var bounds = tmp_0;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.wai_1) {
      this.wai_1 = true;
      this.yai_1.v2();
      this.yai_1.m(this.tai_1);
      if (this.uay())
        this.xai_1 = false;
    }
    if (!this.xai_1) {
      this.xai_1 = true;
      sortWith(this.yai_1, ZIndexComparator_getInstance());
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    var tmp8_fastForEach = this.yai_1;
    var tmp$ret$9;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$8;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp5_unsafeCast = tmp8_fastForEach.vp_1;
    var tmp$ret$7;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$7 = tmp5_unsafeCast;
    tmp$ret$8 = tmp$ret$7;
    tmp$ret$9 = tmp$ret$8;
    var array_0 = tmp$ret$9;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      var tmp$ret$13;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$11;
      // Inline function 'korlibs.datastructure.get' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var tmp6_get = tmp0_0;
      var tmp$ret$10;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$10 = array_0;
      tmp$ret$11 = tmp$ret$10[tmp6_get];
      var tmp7_unsafeCast = tmp$ret$11;
      var tmp$ret$12;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$12 = tmp7_unsafeCast;
      tmp$ret$13 = tmp$ret$12;
      var tmp9__anonymous__1b7cvk = tmp$ret$13;
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      if (_Rectangle___get_isNIL__impl__rbtsig(bounds) ? true : Rectangle__intersects_impl_bpzhh2(bounds, tmp9__anonymous__1b7cvk.db1(true))) {
        tmp9__anonymous__1b7cvk.mav(ctx);
        var tmp0_1 = renderedCount;
        renderedCount = tmp0_1 + 1 | 0;
      } else {
        var tmp1 = culledCount;
        culledCount = tmp1 + 1 | 0;
      }
    }
  };
  protoOf(Container).tay = function (ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.wai_1) {
      this.wai_1 = true;
      this.yai_1.v2();
      this.yai_1.m(this.tai_1);
      if (this.uay())
        this.xai_1 = false;
    }
    if (!this.xai_1) {
      this.xai_1 = true;
      sortWith(this.yai_1, ZIndexComparator_getInstance());
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    var tmp3_fastForEach = this.yai_1;
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = tmp3_fastForEach.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var array = tmp$ret$2;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      var tmp$ret$6;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1_get = tmp0;
      var tmp$ret$3;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$3 = array;
      tmp$ret$4 = tmp$ret$3[tmp1_get];
      var tmp2_unsafeCast = tmp$ret$4;
      var tmp$ret$5;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$5 = tmp2_unsafeCast;
      tmp$ret$6 = tmp$ret$5;
      var tmp4__anonymous__pkmkx7 = tmp$ret$6;
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      tmp4__anonymous__pkmkx7.tay(ctx);
    }
    protoOf(View).tay.call(this, ctx);
  };
  protoOf(Container).nav = function () {
    var bb = Companion_getInstance_45().f3b();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.tai_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, tmp1__anonymous__uwfjfc.hb1(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  };
  protoOf(Container).uay = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    var tmp3_fastForEach = this.sai_1;
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = tmp3_fastForEach.vp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var array = tmp$ret$2;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      var tmp$ret$6;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1_get = tmp0;
      var tmp$ret$3;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$3 = array;
      tmp$ret$4 = tmp$ret$3[tmp1_get];
      var tmp2_unsafeCast = tmp$ret$4;
      var tmp$ret$5;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$5 = tmp2_unsafeCast;
      tmp$ret$6 = tmp$ret$5;
      var tmp4__anonymous__pkmkx7 = tmp$ret$6;
      if (!(tmp4__anonymous__pkmkx7.jaz() === 0.0)) {
        return true;
      }
    }
    return false;
  };
  protoOf(Container).vay = function () {
    this.wai_1 = false;
    this.way();
  };
  protoOf(Container).way = function () {
    var tmp0_safe_receiver = this.hb0();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ga6();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.hay(this);
    }
  };
  protoOf(Container).xay = function (view, index) {
    var tmp0_safe_receiver = view.u1y();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vay();
    }
    view.xb0();
    var aindex = clamp_1(index, 0, this.lay());
    view.baz(aindex);
    var children = this.sai_1;
    children.q2(aindex, view);
    var inductionVariable = aindex + 1 | 0;
    var last = children.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.k(n).baz(n);
      }
       while (inductionVariable < last);
    view.faz(this);
    view.jay();
    this.may(view);
    this.vay();
    this.way();
    this.qb0();
  };
  protoOf(Container).yay = function (view) {
    var tmp0_safe_receiver = view;
    if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u1y()) === this))
      return false;
    var inductionVariable = view.c6g() + 1 | 0;
    var last = this.lay();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2_this = this.sai_1.k(i);
        var tmp3 = tmp2_this.c6g();
        tmp2_this.baz(tmp3 - 1 | 0);
      }
       while (inductionVariable < last);
    this.sai_1.u2(view.c6g());
    view.faz(null);
    view.baz(-1);
    this.vay();
    this.way();
    this.qb0();
    return true;
  };
  protoOf(Container).l6a = function (type, event, result) {
    if (this.uai_1 == null)
      this.uai_1 = FastArrayList_init_$Create$_0(this.tai_1.j());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var tmp3_fastForEachWithTemp = this.sai_1;
    var tmp4_fastForEachWithTemp = ensureNotNull(this.uai_1);
    toFastList(tmp3_fastForEachWithTemp, tmp4_fastForEachWithTemp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast = tmp4_fastForEachWithTemp.vp_1;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_unsafeCast;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      var array = tmp$ret$2;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        var tmp$ret$6;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$4;
        // Inline function 'korlibs.datastructure.get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp1_get = tmp0;
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = array;
        tmp$ret$4 = tmp$ret$3[tmp1_get];
        var tmp2_unsafeCast = tmp$ret$4;
        var tmp$ret$5;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$5 = tmp2_unsafeCast;
        tmp$ret$6 = tmp$ret$5;
        var tmp5__anonymous__kpxxpo = tmp$ret$6;
        tmp5__anonymous__kpxxpo.j6a(type, event, result);
      }
    }finally {
      tmp4_fastForEachWithTemp.v2();
    }
  };
  function addTo(_this__u8e3s4, parent) {
    parent.zai(_this__u8e3s4);
    return _this__u8e3s4;
  }
  function ContainerCollection$iterator$1(this$0) {
    this.kbm_1 = this$0;
    this.jbm_1 = 0;
  }
  protoOf(ContainerCollection$iterator$1).h = function () {
    return this.jbm_1 < this.kbm_1.hbm_1.lay();
  };
  protoOf(ContainerCollection$iterator$1).i = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.jbm_1;
    tmp0_this.jbm_1 = tmp1 + 1 | 0;
    return this.kbm_1.hbm_1.nay(tmp1);
  };
  protoOf(ContainerCollection$iterator$1).y3 = function () {
    var tmp0_this = this;
    tmp0_this.jbm_1 = tmp0_this.jbm_1 - 1 | 0;
    this.kbm_1.hbm_1.pay(tmp0_this.jbm_1);
  };
  function ContainerCollection(container, children) {
    this.hbm_1 = container;
    this.ibm_1 = children;
  }
  protoOf(ContainerCollection).k = function (index) {
    return this.ibm_1.k(index);
  };
  protoOf(ContainerCollection).z2 = function (index) {
    return this.ibm_1.z2(index);
  };
  protoOf(ContainerCollection).j = function () {
    return this.hbm_1.lay();
  };
  protoOf(ContainerCollection).lbm = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.l();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        var tmp$ret$1;
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        tmp$ret$1 = element.u1y() === this.hbm_1;
        if (!tmp$ret$1) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(ContainerCollection).h1 = function (elements) {
    return this.lbm(elements);
  };
  protoOf(ContainerCollection).l = function () {
    return this.hbm_1.lay() === 0;
  };
  protoOf(ContainerCollection).mbm = function (element) {
    this.hbm_1.ray(element);
    return true;
  };
  protoOf(ContainerCollection).b = function (element) {
    return this.mbm(element instanceof View ? element : THROW_CCE());
  };
  protoOf(ContainerCollection).nbm = function (elements) {
    if (elements.l())
      return false;
    var tmp0_iterator = elements.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      this.hbm_1.ray(element);
    }
    return true;
  };
  protoOf(ContainerCollection).m = function (elements) {
    return this.nbm(elements);
  };
  protoOf(ContainerCollection).g = function () {
    return new ContainerCollection$iterator$1(this);
  };
  function CpuGraphics(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    BaseGraphics.call(this, autoScaling);
    this.mbp_1 = 0;
    this.nbp_1 = null;
    this.obp_1 = true;
    this.pbp_1 = -1;
    this.qbp_1 = -1;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$_0();
    tmp.rbp_1 = tmp$ret$0;
    this.sbp_1 = null;
    this.tbp_1 = null;
    this.o9q_1 = true;
  }
  protoOf(CpuGraphics).ubp = function (value) {
    this.nbp_1 = value;
    var tmp0_this = this;
    var tmp1 = tmp0_this.mbp_1;
    tmp0_this.mbp_1 = tmp1 + 1 | 0;
    this.zbd();
  };
  protoOf(CpuGraphics).vbg = function (value) {
    var tmp = this;
    var tmp0_safe_receiver = value;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp$ret$0 = listOf(tmp0_safe_receiver);
      tmp$ret$1 = tmp$ret$0;
      tmp_0 = tmp$ret$1;
    }
    tmp.tbp_1 = tmp_0;
  };
  protoOf(CpuGraphics).bbe = function (ctx) {
    var tmp0_safe_receiver = this.nbp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n52(ctx);
    }
  };
  protoOf(CpuGraphics).qbd = function (includeStrokes) {
    var tmp0_safe_receiver = this.nbp_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k64(includeStrokes);
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Rectangle(tmp_0)) == null) {
      tmp = Companion_getInstance_38().b3b_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  function DummyView() {
    View_init_$Init$(this);
  }
  protoOf(DummyView).qav = function (ctx) {
    return Unit_getInstance();
  };
  function dummyView(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new DummyView();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
    _this__u8e3s4.ray(tmp0_also);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function Companion_10() {
    Companion_instance_10 = this;
  }
  var Companion_instance_10;
  function Companion_getInstance_68() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function FixedSizeContainer(size, clip) {
    Companion_getInstance_68();
    size = size === VOID ? _Size___init__impl__aywn0g_0(100, 100) : size;
    clip = clip === VOID ? false : clip;
    Container.call(this);
    this.obj_1 = clip;
    this.pbj_1 = size;
    this.qbj_1 = Ref(false);
  }
  protoOf(FixedSizeContainer).s64 = function () {
    return this.obj_1;
  };
  protoOf(FixedSizeContainer).lav = function () {
    return this.pbj_1;
  };
  protoOf(FixedSizeContainer).nav = function () {
    return Companion_getInstance_38().o3i(0.0, 0.0, this.ck(), this.dk());
  };
  protoOf(FixedSizeContainer).toString = function () {
    var out = protoOf(Container).toString.call(this);
    out = out + (':size=(' + get_niceStr(this.ck()) + 'x' + get_niceStr(this.dk()) + ')');
    return out;
  };
  protoOf(FixedSizeContainer).qav = function (ctx) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var tmp2_renderClipped = Companion_getInstance_68();
      var tmp3_renderClipped = this.s64();
      var tmp4_renderClipped = this.qbj_1;
      if (tmp4_renderClipped.q()) {
        protoOf(Container).qav.call(this, ctx);
        tmp$ret$0 = Unit_getInstance();
        break $l$block_0;
      }
      if (tmp3_renderClipped) {
        var m = this.kb0();
        var hasRotation = !(_Matrix___get_b__impl__dm2icj(m) === 0.0) ? true : !(_Matrix___get_c__impl__slf2ke(m) === 0.0);
        if (hasRotation) {
          var old = tmp4_renderClipped.q();
          try {
            tmp4_renderClipped.wt(true);
            renderFiltered(this, ctx, Companion_getInstance_76());
          }finally {
            tmp4_renderClipped.wt(old);
          }
          tmp$ret$0 = Unit_getInstance();
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var tmp0_useBatcher = ctx.u9y_1;
        if (!(ctx.y9y_1 === tmp0_useBatcher)) {
          ctx.y9y_1 = tmp0_useBatcher;
          ctx.va3();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var tmp1__anonymous__uwfjfc = ctx.w9y_1;
        var bounds = Rectangle__normalized_impl_j0pmhl(Rectangle__transformed_impl_5k4zxr(this.bb1(ctx), ctx.i9y_1));
        var rect = AGScissor__toRectOrNull_impl_bkzy1a(tmp1__anonymous__uwfjfc.iad_1.eaa());
        var intersects = true;
        var tmp = rect;
        if (!((tmp == null ? null : new Rectangle(tmp)) == null)) {
          intersects = Rectangle__intersects_impl_bpzhh2(bounds, rect);
        }
        if (intersects) {
          var tmp$ret$2;
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var tmp2_scissor = Companion_getInstance_32().f6s(bounds);
          var tmp$ret$1;
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var tmp0_scissor = tmp1__anonymous__uwfjfc.iad_1;
            var tmp1_scissor = tmp1__anonymous__uwfjfc.rad(tmp2_scissor);
            var temp = tmp0_scissor.oa3_1;
            tmp0_scissor.uaa();
            tmp0_scissor.oa3_1 = tmp1_scissor;
            try {
              protoOf(Container).qav.call(this, ctx);
              tmp$ret$1 = Unit_getInstance();
              break $l$block_1;
            }finally {
              tmp0_scissor.uaa();
              tmp0_scissor.oa3_1 = temp;
            }
          }
          tmp$ret$2 = tmp$ret$1;
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          protoOf(Container).qav.call(this, ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        protoOf(Container).qav.call(this, ctx);
      }
    }
  };
  function SContainer(size, clip) {
    size = size === VOID ? _Size___init__impl__aywn0g_0(100, 100) : size;
    clip = clip === VOID ? false : clip;
    FixedSizeContainer.call(this, size, clip);
  }
  function installFpsDebugOverlay(_this__u8e3s4) {
    var longWindow = new TimeSlidingWindow(240);
    var shortWindow = new TimeSlidingWindow(10);
    var previousTime = {_v: new TimeSpan(PerformanceCounter_getInstance().kj())};
    var frames = {_v: 0};
    var batchCount = {_v: 0};
    var vertexCount = {_v: 0};
    var instanceCount = {_v: 0};
    var tmp = _this__u8e3s4.ga6().e9o_1;
    tmp.n1g(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
    var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.ga6().f9n_1).sab_1;
    tmp_0.n1g(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
    var tmp_1 = _this__u8e3s4.ga6().f9n_1.u9y_1.pa3_1;
    tmp_1.n1g(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
    var tmp_2 = _this__u8e3s4.ga6().f9n_1.u9y_1.qa3_1;
    tmp_2.n1g(installFpsDebugOverlay$lambda_2(instanceCount));
    var tmp_3 = _this__u8e3s4.ga6();
    tmp_3.wbr(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
  }
  function TimeSlidingWindow(capacity) {
    this.xbr_1 = capacity;
    this.ybr_1 = new IntDeque(this.xbr_1);
    this.zbr_1 = 0;
  }
  protoOf(TimeSlidingWindow).j = function () {
    return this.ybr_1.j();
  };
  protoOf(TimeSlidingWindow).abs = function () {
    var tmp$ret$0;
    // Inline function 'korlibs.time.microseconds' call
    var tmp0__get_microseconds__mq1imi = this.zbr_1 / this.ybr_1.j();
    tmp$ret$0 = Companion_getInstance_7().nj(tmp0__get_microseconds__mq1imi);
    return tmp$ret$0;
  };
  protoOf(TimeSlidingWindow).bbs = function () {
    var tmp$ret$0;
    // Inline function 'korlibs.time.seconds' call
    tmp$ret$0 = Companion_getInstance_7().ej(1.0);
    return TimeSpan__div_impl_l42f2r(tmp$ret$0, this.abs());
  };
  protoOf(TimeSlidingWindow).cbs = function (index) {
    var tmp$ret$0;
    // Inline function 'korlibs.time.microseconds' call
    var tmp0__get_microseconds__mq1imi = this.ybr_1.k(index);
    tmp$ret$0 = Companion_getInstance_7().nj(tmp0__get_microseconds__mq1imi);
    return tmp$ret$0;
  };
  protoOf(TimeSlidingWindow).dbs = function (value) {
    var intValue = _TimeSpan___get_microsecondsInt__impl__sej7yz(value);
    this.ybr_1.sp(intValue);
    var tmp0_this = this;
    tmp0_this.zbr_1 = tmp0_this.zbr_1 + intValue | 0;
    if (this.ybr_1.j() > this.xbr_1) {
      var tmp1_this = this;
      tmp1_this.zbr_1 = tmp1_this.zbr_1 - this.ybr_1.n2() | 0;
    }
  };
  function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
    return function (it) {
      $batchCount._v = 0;
      $vertexCount._v = 0;
      $instanceCount._v = 0;
      return Unit_getInstance();
    };
  }
  function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
    return function (it) {
      var tmp0 = $batchCount._v;
      $batchCount._v = tmp0 + 1 | 0;
      $vertexCount._v = $vertexCount._v + it.aac_1 | 0;
      return Unit_getInstance();
    };
  }
  function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
    return function (it) {
      var tmp0 = $batchCount._v;
      $batchCount._v = tmp0 + 1 | 0;
      $vertexCount._v = $vertexCount._v + it.caa() | 0;
      return Unit_getInstance();
    };
  }
  function installFpsDebugOverlay$lambda_2($instanceCount) {
    return function (it) {
      $instanceCount._v = $instanceCount._v + it | 0;
      return Unit_getInstance();
    };
  }
  function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, matrix, fontSize, text, x, y) {
    var tmp0_font = $this_addDebugRenderer.ebs();
    var tmp1_colMul = $ctx.t9y_1;
    var tmp2_m = _Matrix___get_immutable__impl__k08qr(matrix);
    var tmp3_blendMode = Companion_getInstance_67().ga2_1;
    drawText($ctx, tmp0_font, fontSize, text, x, y, tmp2_m, tmp1_colMul, tmp3_blendMode, false);
  }
  function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
    return function ($this$addDebugRenderer, ctx) {
      var scale = ctx.wac();
      var fontSize = 8.0 * scale;
      var currentTime = PerformanceCounter_getInstance().kj();
      var elapsedTime = TimeSpan__minus_impl_5w5v8s(currentTime, $previousTime._v.lj_1);
      var tmp;
      if ($frames._v > 3) {
        var tmp_0;
        var tmp$ret$0;
        // Inline function 'korlibs.time.milliseconds' call
        tmp$ret$0 = Companion_getInstance_7().bj(4.0);
        if (TimeSpan__compareTo_impl_zidry4(elapsedTime, tmp$ret$0) > 0) {
          $longWindow.dbs(elapsedTime);
          $shortWindow.dbs(elapsedTime);
          tmp_0 = Unit_getInstance();
        }
        tmp = tmp_0;
      }
      var tmp0 = $frames._v;
      $frames._v = tmp0 + 1 | 0;
      $previousTime._v = new TimeSpan(currentTime);
      var matrix = $this$addDebugRenderer.t9m_1.rac();
      invoke$drawTextWithShadow($this$addDebugRenderer, ctx, matrix, fontSize, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.bbs(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_6().cw() + ')'), 0, 0);
      var graphLeft = 1.0;
      var graphTop = fontSize * 2;
      var overlayLines = 60;
      var overlayWidth = 120.0 * scale;
      var overlayHeight = 30 * scale;
      var overlayHeightGap = 5.0;
      var tmp$ret$9;
      // Inline function 'korlibs.korge.render.useLineBatcher' call
      var tmp2_useLineBatcher = $this$addDebugRenderer.f9n_1;
      var tmp$ret$8;
      // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
      var tmp1_use = get_debugLineRenderContext(tmp2_useLineBatcher);
      var tmp0_useBatcher = tmp1_use.rab_1;
      if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
        tmp0_useBatcher.y9y_1 = tmp1_use;
        tmp0_useBatcher.va3();
      }
      var tmp$ret$7;
      // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
      var tmp1_drawWithGlobalMatrix = get_debugLineRenderContext(tmp2_useLineBatcher);
      var tmp$ret$6;
      $l$block_0: {
        // Inline function 'korlibs.datastructure.keep' call
        var tmp0_keep = currentMatrix$factory(tmp1_drawWithGlobalMatrix);
        var temp = tmp0_keep.get().z3f_1;
        try {
          var tmp$ret$5;
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
          if (!(new Matrix(matrix) == null))
            tmp1_drawWithGlobalMatrix.dac_1 = matrix;
          var tmp$ret$4;
          $l$block: {
            // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
            var tmp0_blending = Companion_getInstance_67().ga2_1;
            var doUpdate = !(tmp1_use.cac_1 === tmp0_blending);
            var old = tmp1_use.cac_1;
            try {
              if (doUpdate) {
                tmp1_use.rab_1.va3();
                tmp1_use.cac_1 = tmp0_blending;
              }
              // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
              var tmp0_color = Colors_getInstance().z4d_1;
              var oldColor = tmp1_use.uab_1;
              tmp1_use.uab_1 = tmp0_color;
              try {
                // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                tmp1_use.hac(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
                tmp1_use.hac(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
              }finally {
                tmp1_use.uab_1 = oldColor;
              }
              var inductionVariable = 0;
              var tmp_1;
              if (inductionVariable <= 0) {
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var color = index === 0 ? Colors_getInstance().j48_1 : Colors_getInstance().k48_1;
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                  var oldColor_0 = tmp1_use.uab_1;
                  tmp1_use.uab_1 = color;
                  try {
                    // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ratio = $longWindow.j() / $longWindow.xbr_1;
                    var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                    if ($longWindow.j() > 0) {
                      var previousX = 0.0;
                      var previousY = 0.0;
                      var minFps = 0.0;
                      var maxFps = 150.0;
                      var inductionVariable_0 = 0;
                      if (inductionVariable_0 < totalOverlayLines)
                        do {
                          var n = inductionVariable_0;
                          inductionVariable_0 = inductionVariable_0 + 1 | 0;
                          var tmp$ret$3;
                          // Inline function 'kotlin.run' call
                          // Inline function 'kotlin.contracts.contract' call
                          var tmp$ret$2;
                          // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                          var p0 = convertRange(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.j(), 1));
                          var p1 = convertRange(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.j(), 1));
                          var plen = 0;
                          var tmp$ret$1;
                          // Inline function 'korlibs.time.milliseconds' call
                          tmp$ret$1 = Companion_getInstance_7().bj(0.0);
                          var timeSum = tmp$ret$1;
                          var inductionVariable_1 = p0;
                          var last = coerceAtMost(p1, $longWindow.j());
                          if (inductionVariable_1 < last)
                            do {
                              var m = inductionVariable_1;
                              inductionVariable_1 = inductionVariable_1 + 1 | 0;
                              timeSum = TimeSpan__plus_impl_qdd6zo(timeSum, $longWindow.cbs(m));
                              var tmp1 = plen;
                              plen = tmp1 + 1 | 0;
                            }
                             while (inductionVariable_1 < last);
                          if (plen === 0) {
                            timeSum = TimeSpan__plus_impl_qdd6zo(timeSum, $longWindow.cbs(p0));
                            var tmp2 = plen;
                            plen = tmp2 + 1 | 0;
                          }
                          var time = TimeSpan__div_impl_l42f2r_0(timeSum, plen);
                          var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                          tmp$ret$2 = fps;
                          tmp$ret$3 = tmp$ret$2;
                          var fps_0 = tmp$ret$3;
                          var scaledFreq = convertRange_0(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                          var y = graphTop + overlayHeight - scaledFreq;
                          var x = graphLeft + n * overlayWidth / overlayLines;
                          if (n > 0) {
                            tmp1_use.hac(previousX, previousY + index, x, y + index);
                          }
                          previousY = y;
                          previousX = x;
                        }
                         while (inductionVariable_0 < totalOverlayLines);
                    }
                  }finally {
                    tmp1_use.uab_1 = oldColor_0;
                  }
                }
                 while (inductionVariable <= 0);
                tmp_1 = Unit_getInstance();
              }
              tmp$ret$4 = tmp_1;
              break $l$block;
            }finally {
              if (doUpdate) {
                tmp1_use.rab_1.va3();
              }
              tmp1_use.cac_1 = old;
            }
          }
          tmp$ret$5 = tmp$ret$4;
          tmp$ret$6 = tmp$ret$5;
          break $l$block_0;
        }finally {
          tmp0_keep.set(new Matrix(temp));
        }
      }
      tmp$ret$7 = tmp$ret$6;
      tmp$ret$8 = tmp$ret$7;
      tmp$ret$9 = tmp$ret$8;
      return Unit_getInstance();
    };
  }
  function currentMatrix$factory($b0) {
    return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
      return new Matrix($b0.dac_1);
    }, function (value) {
      $b0.dac_1 = value.z3f_1;
      return Unit_getInstance();
    });
  }
  var GraphicsRenderer_SYSTEM_instance;
  var GraphicsRenderer_CPU_instance;
  var GraphicsRenderer_GPU_instance;
  var GraphicsRenderer_entriesInitialized;
  function GraphicsRenderer_initEntries() {
    if (GraphicsRenderer_entriesInitialized)
      return Unit_getInstance();
    GraphicsRenderer_entriesInitialized = true;
    GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
    GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
    GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
  }
  function GraphicsRenderer(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function _get_anchorable__ebfoik($this) {
    var tmp0_elvis_lhs = $this.obu_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? $this.pbu_1 : tmp0_elvis_lhs);
  }
  function ensure($this) {
    var tmp0_subject = $this.vbu_1;
    var tmp0 = tmp0_subject.j5_1;
    if (tmp0 === 2) {
      if (!($this.obu_1 == null)) {
        var tmp1_safe_receiver = $this.obu_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.xb0();
        }
        $this.obu_1 = null;
      }
      if ($this.pbu_1 == null) {
        var tmp = $this;
        var tmp$ret$6;
        // Inline function 'kotlin.also' call
        var tmp$ret$5;
        // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
        var tmp$ret$4;
        // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
        var tmp$ret$3;
        // Inline function 'kotlin.also' call
        var tmp0_also = new GpuShapeView(EmptyShape_getInstance(), true);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
        var tmp$ret$2;
        // Inline function 'korlibs.image.vector.buildShape' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$1;
        // Inline function 'kotlin.apply' call
        var tmp0_apply = new ShapeBuilder(null, null);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
        // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
        var tmp$ret$0;
        // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
        tmp$ret$0 = Unit_getInstance();
        tmp$ret$1 = tmp0_apply;
        tmp$ret$2 = tmp$ret$1.b4w();
        tmp0_also.wbx(tmp$ret$2);
        tmp$ret$3 = tmp0_also;
        tmp$ret$4 = addTo(tmp$ret$3, $this);
        tmp$ret$5 = tmp$ret$4;
        var tmp1_also = tmp$ret$5;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
        tmp1_also.xbx($this.qbu_1);
        tmp1_also.xbw_1 = $this.tbu_1;
        tmp1_also.zbw_1 = $this.sbu_1;
        tmp1_also.wbx($this.ubu_1);
        tmp$ret$6 = tmp1_also;
        tmp.pbu_1 = tmp$ret$6;
      }
    } else {
      if (!($this.pbu_1 == null)) {
        var tmp2_safe_receiver = $this.pbu_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.xb0();
        }
        $this.pbu_1 = null;
      }
      if ($this.obu_1 == null) {
        var tmp_0 = $this;
        var tmp$ret$13;
        // Inline function 'kotlin.also' call
        var tmp$ret$12;
        // Inline function 'korlibs.korge.view.cpuGraphics' call
        var tmp$ret$11;
        // Inline function 'kotlin.also' call
        var tmp2_also = addTo(new CpuGraphics(false), $this);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
        var tmp$ret$10;
        // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
        var tmp$ret$9;
        // Inline function 'korlibs.image.vector.buildShape' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$8;
        // Inline function 'kotlin.apply' call
        var tmp0_apply_0 = new ShapeBuilder(null, null);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
        // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
        var tmp$ret$7;
        // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
        tmp$ret$7 = Unit_getInstance();
        tmp$ret$8 = tmp0_apply_0;
        tmp$ret$9 = tmp$ret$8.b4w();
        tmp2_also.ubp(tmp$ret$9);
        if (false) {
          tmp2_also.abe();
        }
        tmp2_also.jbd_1 = true;
        tmp2_also.qb0();
        tmp$ret$10 = tmp2_also;
        tmp2_also.abe();
        tmp$ret$11 = tmp2_also;
        tmp$ret$12 = tmp$ret$11;
        var tmp3_also = tmp$ret$12;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
        tmp3_also.obp_1 = $this.qbu_1;
        tmp3_also.bbd_1 = $this.tbu_1;
        tmp3_also.gbg_1 = $this.sbu_1;
        tmp3_also.ubp($this.ubu_1);
        tmp$ret$13 = tmp3_also;
        tmp_0.obu_1 = tmp$ret$13;
      }
      var tmp3_safe_receiver = $this.obu_1;
      if (tmp3_safe_receiver == null) {
      } else {
        tmp3_safe_receiver.ybd($this.vbu_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
      }
    }
  }
  function Graphics(shape, renderer) {
    shape = shape === VOID ? EmptyShape_getInstance() : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    Container.call(this);
    this.obu_1 = null;
    this.pbu_1 = null;
    this.qbu_1 = true;
    this.rbu_1 = false;
    this.sbu_1 = true;
    this.tbu_1 = true;
    this.ubu_1 = EmptyShape_getInstance();
    this.vbu_1 = renderer;
    this.wbx(shape);
  }
  protoOf(Graphics).ybx = function () {
    var tmp0_elvis_lhs = this.obu_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.pbu_1 : tmp0_elvis_lhs);
  };
  protoOf(Graphics).ib8 = function (value) {
    _get_anchorable__ebfoik(this).ib8(value);
    this.fay();
  };
  protoOf(Graphics).zay = function () {
    return this.ybx().zay();
  };
  protoOf(Graphics).aaz = function () {
    return this.ybx().aaz();
  };
  protoOf(Graphics).zbx = function (value) {
    if (this.sbu_1 === value)
      return Unit_getInstance();
    this.sbu_1 = value;
    var tmp0_safe_receiver = this.obu_1;
    if (tmp0_safe_receiver == null) {
    } else
      tmp0_safe_receiver.gbg_1 = value;
    var tmp1_safe_receiver = this.pbu_1;
    if (tmp1_safe_receiver == null) {
    } else
      tmp1_safe_receiver.zbw_1 = value;
    this.fay();
  };
  protoOf(Graphics).aby = function (value) {
    if (this.tbu_1 === value)
      return Unit_getInstance();
    this.tbu_1 = value;
    var tmp0_safe_receiver = this.obu_1;
    if (tmp0_safe_receiver == null) {
    } else
      tmp0_safe_receiver.bbd_1 = value;
    var tmp1_safe_receiver = this.pbu_1;
    if (tmp1_safe_receiver == null) {
    } else
      tmp1_safe_receiver.xbw_1 = value;
    this.fay();
  };
  protoOf(Graphics).wbx = function (value) {
    if (this.ubu_1 === value)
      return Unit_getInstance();
    this.ubu_1 = value;
    ensure(this);
    var tmp0_safe_receiver = this.obu_1;
    if (tmp0_safe_receiver == null) {
    } else {
      tmp0_safe_receiver.ubp(value);
    }
    var tmp1_safe_receiver = this.pbu_1;
    if (tmp1_safe_receiver == null) {
    } else {
      tmp1_safe_receiver.wbx(value);
    }
    this.fay();
  };
  protoOf(Graphics).bby = function () {
    ensure(this);
    var tmp0_safe_receiver = this.obu_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zbd();
    }
    var tmp1_safe_receiver = this.obu_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.abe();
  };
  function GraphicsRenderer_SYSTEM_getInstance() {
    GraphicsRenderer_initEntries();
    return GraphicsRenderer_SYSTEM_instance;
  }
  function GraphicsRenderer_GPU_getInstance() {
    GraphicsRenderer_initEntries();
    return GraphicsRenderer_GPU_instance;
  }
  function Image_init_$Init$(bitmap, anchor, hitShape, smoothing, $this) {
    anchor = anchor === VOID ? Companion_getInstance_2().i3a_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    Image.call($this, Resourceable(bitmap), anchor, hitShape, smoothing);
    return $this;
  }
  function Image_init_$Create$(bitmap, anchor, hitShape, smoothing) {
    return Image_init_$Init$(bitmap, anchor, hitShape, smoothing, objectCreate(protoOf(Image)));
  }
  function $forceLoadSourceFileCOROUTINE$18(_this__u8e3s4, views, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kby_1 = _this__u8e3s4;
    this.lby_1 = views;
    this.mby_1 = currentVfs;
    this.nby_1 = sourceFile;
  }
  protoOf($forceLoadSourceFileCOROUTINE$18).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 5;
            this.hh_1 = 1;
            suspendResult = this.kby_1.zc0(this.kby_1, this.lby_1, this.mby_1, this.nby_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ih_1 = 3;
            this.hh_1 = 2;
            suspendResult = readBitmapSlice(this.mby_1.ro('' + this.nby_1), VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.kby_1.cbe(ARGUMENT);
            this.kby_1.ac1(1.0);
            this.ih_1 = 5;
            this.hh_1 = 4;
            continue $sm;
          case 3:
            this.ih_1 = 5;
            var tmp_0 = this.kh_1;
            if (tmp_0 instanceof Error) {
              var e = this.kh_1;
              var tmp0__get_white__j8g7zy = Bitmaps_getInstance();
              this.kby_1.cbe(get_Bitmaps_white());
              this.kby_1.ac1(100.0);
              this.hh_1 = 4;
              continue $sm;
            } else {
              throw this.kh_1;
            }

            break;
          case 4:
            this.ih_1 = 5;
            return Unit_getInstance();
          case 5:
            throw this.kh_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.ih_1 === 5) {
          throw e_0;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e_0;
        }
      }
     while (true);
  };
  function Image(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_2().i3a_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    BaseImage.call(this, bitmap, anchor, hitShape, smoothing);
    this.xc0_1 = new Mixin_0();
    this.yc0_1 = sourceFile$factory(this);
  }
  protoOf(Image).bc1 = function (_set____db54di) {
    this.xc0_1.bc1(_set____db54di);
  };
  protoOf(Image).ec1 = function () {
    return this.xc0_1.dc1_1;
  };
  protoOf(Image).fc1 = function (_set____db54di) {
    this.xc0_1.cc1_1 = _set____db54di;
  };
  protoOf(Image).gc1 = function (ctx, view) {
    this.xc0_1.gc1(ctx, view);
  };
  protoOf(Image).zc0 = function (_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    var tmp0 = this.xc0_1.zc0(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
    return tmp0;
  };
  protoOf(Image).qav = function (ctx) {
    this.gc1(ctx, this);
    protoOf(BaseImage).qav.call(this, ctx);
  };
  protoOf(Image).hc1 = function (views, currentVfs, sourceFile, $completion) {
    var tmp = new $forceLoadSourceFileCOROUTINE$18(this, views, currentVfs, sourceFile, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function BaseImage_init_$Init$(bmpCoords, anchor, hitShape, smoothing, $this) {
    anchor = anchor === VOID ? Companion_getInstance_2().i3a_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    BaseImage.call($this, Resourceable(bmpCoords), anchor, hitShape, smoothing);
    return $this;
  }
  function trySetSourceActually($this) {
    var source = $this.rba_1.t2g();
    if (!(source == null)) {
      $this.qba_1 = true;
      $this.sbg(source);
    }
  }
  function BaseImage(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_2().i3a_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    RectBase.call(this, anchor, hitShape, smoothing);
    this.qba_1 = false;
    this.rba_1 = bitmap;
    this.pbg();
  }
  protoOf(BaseImage).cbe = function (value) {
    if (equals(this.hbg_1, value))
      return Unit_getInstance();
    this.qba_1 = true;
    this.sbg(value);
  };
  protoOf(BaseImage).t5n = function () {
    return this.hbg_1;
  };
  protoOf(BaseImage).pbg = function () {
    if (this.qba_1)
      return Unit_getInstance();
    trySetSourceActually(this);
  };
  protoOf(BaseImage).qav = function (ctx) {
    this.pbg();
    protoOf(RectBase).qav.call(this, ctx);
  };
  protoOf(BaseImage).dbe = function () {
    return this.hbg_1.ck();
  };
  protoOf(BaseImage).ebe = function () {
    return this.hbg_1.dk();
  };
  protoOf(BaseImage).b3t = function () {
    return this.hbg_1.b3t();
  };
  protoOf(BaseImage).c3t = function () {
    return this.hbg_1.c3t();
  };
  protoOf(BaseImage).o3s = function () {
    return this.hbg_1.o3s();
  };
  protoOf(BaseImage).p3s = function () {
    return this.hbg_1.p3s();
  };
  protoOf(BaseImage).qbg = function () {
    return _Anchor___get_sx__impl__4wuc7c(this.mbg()) * this.o3s();
  };
  protoOf(BaseImage).rbg = function () {
    return _Anchor___get_sy__impl__xqgt9j(this.mbg()) * this.p3s();
  };
  protoOf(BaseImage).zay = function () {
    return this.qbg() - this.b3t();
  };
  protoOf(BaseImage).aaz = function () {
    return this.rbg() - this.c3t();
  };
  protoOf(BaseImage).nav = function () {
    return Companion_getInstance_38().o3i(-this.qbg(), -this.rbg(), this.o3s(), this.p3s());
  };
  protoOf(BaseImage).toString = function () {
    return protoOf(RectBase).toString.call(this) + (':bitmap=' + this.t5n());
  };
  function sourceFile$factory($b0) {
    return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
      return $b0.ec1();
    }, function (value) {
      return $b0.bc1(value);
    });
  }
  function RectBase(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_2().i3a_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    View_init_$Init$(this);
    this.gbg_1 = smoothing;
    this.vbg(hitShape);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    var tmp0__get_white__j8g7zy = Bitmaps_getInstance();
    tmp$ret$0 = get_Bitmaps_white();
    tmp.hbg_1 = tmp$ret$0;
    this.ibg_1 = anchor;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    var tmp0__get_QUAD_INDICES__35d4te = Companion_getInstance_64();
    tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.jbg_1 = new TexturedVertexArray(4, tmp$ret$1);
    this.kbg_1 = null;
    this.lbg_1 = null;
  }
  protoOf(RectBase).sbg = function (v) {
    if (!(this.hbg_1 === v)) {
      this.hbg_1 = v;
      this.e9q_1 = true;
      this.fay();
    }
  };
  protoOf(RectBase).ib8 = function (v) {
    if (!equals(this.ibg_1, v)) {
      this.ibg_1 = v;
      this.e9q_1 = true;
      this.fay();
    }
  };
  protoOf(RectBase).mbg = function () {
    return this.ibg_1;
  };
  protoOf(RectBase).dbe = function () {
    return 0.0;
  };
  protoOf(RectBase).ebe = function () {
    return 0.0;
  };
  protoOf(RectBase).zay = function () {
    return _Anchor___get_sx__impl__4wuc7c(this.mbg()) * this.dbe();
  };
  protoOf(RectBase).aaz = function () {
    return _Anchor___get_sy__impl__xqgt9j(this.mbg()) * this.ebe();
  };
  protoOf(RectBase).nbg = function () {
    return -this.zay();
  };
  protoOf(RectBase).obg = function () {
    return -this.aaz();
  };
  protoOf(RectBase).qav = function (ctx) {
    if (!this.ib0())
      return Unit_getInstance();
    var tmp = this.hbg_1;
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
    tmp$ret$0 = get_Bitmaps_transparent();
    if (tmp === tmp$ret$0)
      return Unit_getInstance();
    if (this.e9q_1) {
      this.e9q_1 = false;
      this.ubg();
    }
    this.tbg(ctx);
  };
  protoOf(RectBase).tbg = function (ctx) {
    var tmp$ret$2;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var tmp$ret$1;
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var tmp1_use = ctx.u9y_1;
    var tmp0_useBatcher = tmp1_use.qa2_1;
    if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
      tmp0_useBatcher.y9y_1 = tmp1_use;
      tmp0_useBatcher.va3();
    }
    var tmp0_safe_receiver = this.lbg_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var tmp1_drawVertices = this.jbg_1;
    var tmp2_drawVertices = ctx.cad(this.hbg_1).l3s();
    var tmp3_drawVertices = this.gbg_1;
    var tmp4_drawVertices = this.nb0();
    var tmp5_drawVertices = this.kbg_1;
    var tmp6_drawVertices = tmp1_drawVertices.oaa_1;
    var tmp7_drawVertices = tmp1_drawVertices.paa_1;
    var tmp8_drawVertices = Companion_getInstance_23().w3f_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tmp0_setStateFast = tmp2_drawVertices.ea8_1;
      tmp1_use.haa(tmp7_drawVertices, tmp6_drawVertices);
      var tmp0_elvis_lhs = tmp5_drawVertices;
      var pprogram = tmp0_elvis_lhs == null ? Companion_getInstance_62().m9j_1 : tmp0_elvis_lhs;
      if (tmp1_use.waa(tmp0_setStateFast, tmp3_drawVertices, tmp4_drawVertices, pprogram)) {
        tmp$ret$0 = Unit_getInstance();
        break $l$block;
      }
      tmp1_use.za9();
      if (!contains_0(tmp1_use.ga3_1, tmp0_setStateFast)) {
        tmp1_use.fa3_1 = 0;
        tmp1_use.ga3_1[0] = tmp0_setStateFast;
      }
      tmp1_use.ha3_1 = tmp3_drawVertices;
      tmp1_use.ia3_1 = tmp4_drawVertices;
      tmp1_use.ja3_1 = pprogram;
    }
    tmp1_use.taa(tmp1_drawVertices, tmp8_drawVertices, tmp6_drawVertices, tmp7_drawVertices);
    tmp$ret$1 = Unit_getInstance();
    tmp$ret$2 = tmp$ret$1;
  };
  protoOf(RectBase).ubg = function () {
    this.jbg_1.caf(0, this.nbg(), this.obg(), this.dbe(), this.ebe(), this.kb0(), this.hbg_1, this.ob0());
  };
  protoOf(RectBase).nav = function () {
    return Companion_getInstance_38().o3i(this.nbg(), this.obg(), this.dbe(), this.ebe());
  };
  protoOf(RectBase).toString = function () {
    var out = protoOf(View).toString.call(this);
    if (!equals(this.mbg(), Companion_getInstance_2().i3a_1))
      out = out + (':anchor=(' + this.ub0(_Anchor___get_sx__impl__4wuc7c(this.mbg())) + ', ' + this.ub0(_Anchor___get_sy__impl__xqgt9j(this.mbg())) + ')');
    return out;
  };
  function Companion_11() {
    Companion_instance_11 = this;
  }
  var Companion_instance_11;
  function Companion_getInstance_69() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function Stage(views) {
    FixedSizeContainer.call(this);
    this.dbm_1 = views;
    this.ebm_1 = views.q9m_1;
    this.fbm_1 = clipBorders$factory(this.ga6());
    this.gbm_1 = virtualSizeFloat$factory(this.ga6());
    this.caz(this);
    this.daz(this);
  }
  protoOf(Stage).ga6 = function () {
    return this.dbm_1;
  };
  protoOf(Stage).h10 = function () {
    return this.dbm_1.g9m_1;
  };
  protoOf(Stage).kac = function (_set____db54di) {
    this.ebm_1.kac(_set____db54di);
  };
  protoOf(Stage).lac = function (_set____db54di) {
    this.ebm_1.lac(_set____db54di);
  };
  protoOf(Stage).mac = function () {
    return this.ebm_1.mac();
  };
  protoOf(Stage).nac = function () {
    return this.ebm_1.nac();
  };
  protoOf(Stage).oac = function (_set____db54di) {
    this.ebm_1.oac(_set____db54di);
  };
  protoOf(Stage).pac = function () {
    return this.ebm_1.pac();
  };
  protoOf(Stage).qac = function (_set____db54di) {
    this.ebm_1.qac(_set____db54di);
  };
  protoOf(Stage).rac = function () {
    return this.ebm_1.rac();
  };
  protoOf(Stage).sac = function () {
    return this.ebm_1.sac();
  };
  protoOf(Stage).tac = function (_set____db54di) {
    this.ebm_1.tac(_set____db54di);
  };
  protoOf(Stage).uac = function () {
    return this.ebm_1.uac();
  };
  protoOf(Stage).c9u = function (pos) {
    return this.ebm_1.c9u(pos);
  };
  protoOf(Stage).kc1 = function (_set____db54di) {
    var tmp0_setValue = clip$factory();
    return this.fbm_1.set(_set____db54di);
  };
  protoOf(Stage).s64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = clip$factory_0();
    tmp$ret$0 = this.fbm_1.get();
    return tmp$ret$0;
  };
  protoOf(Stage).lc1 = function (_set____db54di) {
    var tmp0_setValue = unscaledSize$factory();
    return this.gbm_1.set(new Size(_set____db54di));
  };
  protoOf(Stage).lav = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = unscaledSize$factory_0();
    tmp$ret$0 = this.gbm_1.get().b3j_1;
    return tmp$ret$0;
  };
  protoOf(Stage).mag = function () {
    return this.ga6().i9m_1;
  };
  protoOf(Stage).hb0 = function () {
    return this;
  };
  protoOf(Stage).gay = function () {
    return this;
  };
  protoOf(Stage).hay = function (view) {
    this.ga6().hay(view);
  };
  protoOf(Stage).toString = function () {
    return 'Stage';
  };
  function clipBorders$factory($b0) {
    return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
      return $b0.r9n_1;
    }, function (value) {
      $b0.r9n_1 = value;
      return Unit_getInstance();
    });
  }
  function virtualSizeFloat$factory($b0) {
    return getPropertyCallableRef('virtualSizeFloat', 0, KMutableProperty0, function () {
      return new Size($b0.mc1());
    }, function (value) {
      return $b0.nc1(value.b3j_1);
    });
  }
  function clip$factory() {
    return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
      return receiver.s64();
    }, function (receiver, value) {
      return receiver.kc1(value);
    });
  }
  function clip$factory_0() {
    return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
      return receiver.s64();
    }, function (receiver, value) {
      return receiver.kc1(value);
    });
  }
  function unscaledSize$factory() {
    return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
      return new Size(receiver.lav());
    }, function (receiver, value) {
      return receiver.lc1(value.b3j_1);
    });
  }
  function unscaledSize$factory_0() {
    return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
      return new Size(receiver.lav());
    }, function (receiver, value) {
      return receiver.lc1(value.b3j_1);
    });
  }
  function get_agProgram(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4.d4p();
    switch (tmp0_subject) {
      case 'msdf':
        return MsdfRender_getInstance().jb2_1;
      case 'psdf':
        return MsdfRender_getInstance().mb2_1;
      case 'sdf':
        return MsdfRender_getInstance().mb2_1;
      default:
        return null;
    }
  }
  function Companion_12() {
    Companion_instance_12 = this;
    this.oc1_1 = 16.0;
    this.pc1_1 = true;
  }
  var Companion_instance_12;
  function Companion_getInstance_70() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function updateLineCount($this) {
    var tmp = $this;
    var tmp$ret$1;
    // Inline function 'kotlin.text.count' call
    var tmp0_count = $this.kc5();
    var count = 0;
    var indexedObject = tmp0_count;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
      tmp$ret$0 = equals(new Char(element), new Char(_Char___init__impl__6a9atx(10)));
      if (tmp$ret$0) {
        count = count + 1 | 0;
      }
    }
    tmp$ret$1 = count;
    tmp.dc4_1 = tmp$ret$1 + 1 | 0;
  }
  function setContainerPosition($this, pos, baseline) {
    var tmp0_container = pos;
    var x = Vector2__component1_impl_k3h45m(tmp0_container);
    var y = Vector2__component2_impl_kkiqjt(tmp0_container);
    if ($this.tc4_1) {
      setRealContainerPosition($this, x, y);
    } else {
      setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.lc4_1.r4y_1, _Rectangle___get_width__impl__y1u79l($this.sc4_1)), y - VerticalAlign__getOffsetY_impl_iso0y6($this.lc4_1.s4y_1, _Rectangle___get_height__impl__kro6o8($this.sc4_1), baseline));
    }
  }
  function setRealContainerPosition($this, x, y) {
    position($this.mc4_1, x, y);
  }
  function Text$_renderInternal$slambda(this$0, $ctx, $fontSource, resultContinuation) {
    this.tc5_1 = this$0;
    this.uc5_1 = $ctx;
    this.vc5_1 = $fontSource;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Text$_renderInternal$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Text$_renderInternal$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(Text$_renderInternal$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.tc5_1.wc5(ensureNotNull(this.uc5_1.q9y_1).d9n_1, this.vc5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(Text$_renderInternal$slambda).n1f = function (completion) {
    var i = new Text$_renderInternal$slambda(this.tc5_1, this.uc5_1, this.vc5_1, completion);
    return i;
  };
  function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource, resultContinuation) {
    var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $forceLoadFontSourceCOROUTINE$19(_this__u8e3s4, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fc6_1 = _this__u8e3s4;
    this.gc6_1 = currentVfs;
    this.hc6_1 = sourceFile;
  }
  protoOf($forceLoadFontSourceCOROUTINE$19).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.fc6_1.ic6(this.hc6_1);
            this.fc6_1.oc4_1 = true;
            if (!(this.hc6_1 == null)) {
              this.hh_1 = 1;
              suspendResult = readFont(this.gc6_1.ro('' + this.hc6_1), VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.fc6_1.jc6(ARGUMENT);
            this.hh_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function Text(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    Companion_getInstance_70();
    textSize = textSize === VOID ? Companion_getInstance_70().oc1_1 : textSize;
    color = color === VOID ? Colors_getInstance().j48_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_46().z4w_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_getInstance_70().pc1_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    Container.call(this);
    this.zc3_1 = true;
    this.ac4_1 = -1;
    this.bc4_1 = -1;
    this.cc4_1 = 0;
    this.dc4_1 = 0;
    this.ec4_1 = text;
    updateLineCount(this);
    var tmp = this;
    var tmp0_elvis_lhs = fill;
    tmp.fc4_1 = tmp0_elvis_lhs == null ? new RGBA(color) : tmp0_elvis_lhs;
    this.gc4_1 = stroke;
    this.hc4_1 = font;
    this.ic4_1 = textSize;
    this.jc4_1 = textSize$factory(this);
    this.kc4_1 = renderer;
    this.lc4_1 = alignment;
    var tmp_0 = this;
    var tmp$ret$3;
    // Inline function 'korlibs.korge.view.container' call
    var tmp$ret$2;
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp1_addTo = new Container(false);
    var tmp$ret$1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(tmp1_addTo, this);
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp$ret$0 = Unit_getInstance();
    tmp$ret$1 = tmp0_apply;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$3 = tmp$ret$2;
    tmp_0.mc4_1 = tmp$ret$3;
    this.nc4_1 = new Text2TextRendererActions();
    this.oc4_1 = false;
    this.pc4_1 = autoScaling;
    this.qc4_1 = false;
    this.rc4_1 = null;
    this.sc4_1 = Companion_getInstance_38().n3i(0, 0, 2048, 2048);
    this.tc4_1 = true;
    this.uc4_1 = -1;
    this.vc4_1 = new MMatrix();
    this.wc4_1 = -1;
    this.xc4_1 = null;
    this.yc4_1 = new Entry();
    this.zc4_1 = new FontMetrics();
    this.ac5_1 = new TextMetrics();
    this.bc5_1 = null;
    this.cc5_1 = null;
    this.dc5_1 = null;
    this.ec5_1 = null;
    this.fc5_1 = new MMatrix();
    this.gc5_1 = GraphicsRenderer_SYSTEM_getInstance();
    this.hc5_1 = true;
    this.ic5_1 = null;
    this.jc5_1 = fontSource$factory(this);
  }
  protoOf(Text).kc6 = function (value) {
    if (!(this.ec4_1 === value)) {
      this.ec4_1 = value;
      updateLineCount(this);
      var tmp0_this = this;
      var tmp1 = tmp0_this.cc4_1;
      tmp0_this.cc4_1 = tmp1 + 1 | 0;
      this.jay();
      this.fay();
    }
  };
  protoOf(Text).kc5 = function () {
    return this.ec4_1;
  };
  protoOf(Text).r5h = function () {
    var tmp = this.fc4_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.q4n_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().j48_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  };
  protoOf(Text).jc6 = function (value) {
    if (!equals(this.hc4_1, value)) {
      this.hc4_1 = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this.cc4_1;
      tmp0_this.cc4_1 = tmp1 + 1 | 0;
      this.jay();
    }
  };
  protoOf(Text).lc6 = function (value) {
    if (!(this.ic4_1 === value)) {
      this.ic4_1 = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this.cc4_1;
      tmp0_this.cc4_1 = tmp1 + 1 | 0;
      this.jay();
    }
  };
  protoOf(Text).mc6 = function (_set____db54di) {
    var tmp0_setValue = fontSize$factory();
    return this.jc4_1.set(_set____db54di);
  };
  protoOf(Text).b4p = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = fontSize$factory_0();
    tmp$ret$0 = this.jc4_1.get();
    return tmp$ret$0;
  };
  protoOf(Text).z5z = function () {
    return this.lc4_1.s4y_1;
  };
  protoOf(Text).ic6 = function (value) {
    this.rc4_1 = value;
    this.oc4_1 = false;
    this.jay();
  };
  protoOf(Text).wc5 = function (currentVfs, sourceFile, $completion) {
    var tmp = new $forceLoadFontSourceCOROUTINE$19(this, currentVfs, sourceFile, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Text).nav = function () {
    this.nc6(null);
    if (!(get_filter(this) == null) ? true : !(get_backdropFilter(this) == null)) {
      return protoOf(Container).nav.call(this);
    } else {
      return this.sc4_1;
    }
  };
  protoOf(Text).qav = function (ctx) {
    this.nc6(ctx);
    var tva = this.ec5_1;
    if (!(tva == null)) {
      this.vc4_1.h3d(this.kb0());
      this.vc4_1.i3d(this.mc4_1.haz(), this.mc4_1.iaz());
      var tmp$ret$1;
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var tmp$ret$0;
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var tmp1_use = ctx.u9y_1;
      var tmp0_useBatcher = tmp1_use.qa2_1;
      if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
        tmp0_useBatcher.y9y_1 = tmp1_use;
        tmp0_useBatcher.va3();
      }
      var tmp = this.hc4_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.g4p();
      tmp1_use.yaa(tex, this.zc3_1, this.nb0(), get_agProgram(bmpfont), tva.paa_1, tva.oaa_1);
      tmp1_use.taa(tva, this.vc4_1.e3d());
      tmp$ret$0 = Unit_getInstance();
      tmp$ret$1 = tmp$ret$0;
    } else {
      protoOf(Container).qav.call(this, ctx);
    }
  };
  protoOf(Text).nc6 = function (ctx) {
    if (!(ctx == null)) {
      var fontSource = this.rc4_1;
      if (!this.oc4_1 ? !(fontSource == null) : false) {
        this.oc4_1 = true;
        launchImmediately_0(ctx.y9x_1, Text$_renderInternal$slambda_0(this, ctx, fontSource, null));
      }
    }
    var font = this.hc4_1.t2g();
    var tmp;
    var tmp_0;
    if (this.tc4_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.uc4_1 === this.cc4_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.uc4_1 = this.cc4_1;
      var metrics = getTextBounds(font, this.ic4_1, this.kc5(), this.ac5_1, this.kc4_1, this.lc4_1);
      this.sc4_1 = Companion_getInstance_38().o3i(metrics.k3f(), VerticalAlign__getOffsetY_impl_iso0y6(this.lc4_1.s4y_1, metrics.dk(), -metrics.z4y()), metrics.ck(), font.k4p(this.ic4_1, this.zc4_1).c4p() * this.dc4_1);
    }
    var tmp0_subject = font;
    if (tmp0_subject == null)
    ;
    else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, BitmapFont) : false) {
        var rversion = this.kc4_1.s5y();
        if ((!(this.cc5_1 === this.zc3_1) ? true : !(this.ac4_1 === this.cc4_1)) ? true : !(this.bc4_1 === rversion)) {
          this.cc5_1 = this.zc3_1;
          this.bc4_1 = rversion;
          this.ac4_1 = this.cc4_1;
          if (!(this.ic5_1 == null)) {
            this.ic5_1 = null;
            this.mc4_1.qay();
          }
          this.nc4_1.d60();
          this.nc4_1.q5z_1 = Companion_getInstance_46().d4x_1;
          invoke(this.kc4_1, this.nc4_1, this.kc5(), this.ic4_1, font);
          while (this.mc4_1.lay() < this.nc4_1.j()) {
            var tmp$ret$4;
            // Inline function 'korlibs.korge.view.image' call
            var tmp3_image = this.mc4_1;
            var tmp$ret$0;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
            tmp$ret$0 = get_Bitmaps_transparent();
            var tmp4_image = tmp$ret$0;
            var tmp5_image = Companion_getInstance_2().i3a_1;
            var tmp$ret$3;
            // Inline function 'korlibs.korge.view.addTo' call
            var tmp2_addTo = Image_init_$Create$(tmp4_image, tmp5_image);
            var tmp$ret$2;
            // Inline function 'kotlin.apply' call
            var tmp1_apply = addTo(tmp2_addTo, tmp3_image);
            // Inline function 'kotlin.contracts.contract' call
            var tmp$ret$1;
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
            tmp$ret$1 = Unit_getInstance();
            tmp$ret$2 = tmp1_apply;
            tmp$ret$3 = tmp$ret$2;
            tmp$ret$4 = tmp$ret$3;
          }
          while (this.mc4_1.lay() > this.nc4_1.j()) {
            this.mc4_1.k(this.mc4_1.lay() - 1 | 0).xb0();
          }
          var bounds = this.nc4_1.w3l();
          var firstBounds = this.nc4_1.b60(0);
          var lineInfos = this.nc4_1.a60();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          var tmp$ret$6;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0.0;
          var tmp0_iterator = lineInfos.g();
          while (tmp0_iterator.h()) {
            var element = tmp0_iterator.i();
            var tmp_1 = sum;
            var tmp$ret$5;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            tmp$ret$5 = element.z5y_1;
            sum = tmp_1 + tmp$ret$5;
          }
          tmp$ret$6 = sum;
          var totalHeight = tmp$ret$6;
          var textWidth = _Rectangle___get_width__impl__y1u79l(bounds);
          var textHeight = _Rectangle___get_height__impl__kro6o8(bounds);
          var dx = _Rectangle___get_x__impl__vgifdj(this.sc4_1);
          var tmp2_subject = this.z5z();
          var dy = equals(tmp2_subject, Companion_getInstance_47().g5y_1) ? 0.0 : equals(tmp2_subject, Companion_getInstance_47().d5y_1) ? firstLineInfos.x5y_1 : firstLineInfos.x5y_1 - totalHeight * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.z5z());
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.nc4_1.j();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.nc4_1.c60(n, this.yc4_1);
              var tmp_2 = this.mc4_1.k(n);
              var it = tmp_2 instanceof Image ? tmp_2 : THROW_CCE();
              it.kbg_1 = program;
              it.i4n(this.r5h());
              anchor_2(it, 0, 0);
              it.gbg_1 = this.zc3_1;
              it.cbe(entry.a5z_1);
              it.l51(_Vector2___init__impl__67w0ru(entry.b5z_1 + dx, entry.c5z_1 + dy));
              it.saz(_Scale___init__impl__ov1qs1(entry.d5z_1, entry.e5z_1));
              it.jc1(entry.f5z_1);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.cc5_1 === this.zc3_1) ? true : !(this.dc5_1 === this.hc5_1)) {
          var tmp4_this = this;
          var tmp5 = tmp4_this.cc4_1;
          tmp4_this.cc4_1 = tmp5 + 1 | 0;
          this.dc5_1 = this.hc5_1;
          this.bc5_1 = this.pc4_1;
          this.cc5_1 = this.zc3_1;
        }
        if (!(this.ac4_1 === this.cc4_1)) {
          this.ac4_1 = this.cc4_1;
          var realTextSize = this.ic4_1;
          if (this.ic5_1 == null) {
            this.mc4_1.qay();
            var tmp_3 = this;
            var tmp$ret$12;
            // Inline function 'korlibs.korge.view.graphics' call
            var tmp7_graphics = this.mc4_1;
            var tmp8_graphics = this.gc5_1;
            var tmp$ret$11;
            // Inline function 'kotlin.also' call
            var tmp6_also = addTo(new Graphics(EmptyShape_getInstance(), tmp8_graphics), tmp7_graphics);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            var tmp$ret$10;
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            var tmp$ret$9;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp$ret$8;
            // Inline function 'kotlin.apply' call
            var tmp0_apply = new ShapeBuilder(null, null);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            var tmp$ret$7;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            tmp$ret$7 = Unit_getInstance();
            result = tmp$ret$7;
            tmp$ret$8 = tmp0_apply;
            tmp$ret$9 = tmp$ret$8.b4w();
            tmp6_also.wbx(tmp$ret$9);
            tmp$ret$10 = result;
            tmp6_also.bby();
            tmp$ret$11 = tmp6_also;
            tmp$ret$12 = tmp$ret$11;
            tmp_3.ic5_1 = tmp$ret$12;
            var tmp6_safe_receiver = this.ic5_1;
            if (tmp6_safe_receiver == null) {
            } else {
              tmp6_safe_receiver.aby(true);
            }
          }
          var tmp$ret$16;
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var tmp10_updateShape = ensureNotNull(this.ic5_1);
          var result_0;
          var tmp$ret$15;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp$ret$14;
          // Inline function 'kotlin.apply' call
          var tmp9_apply = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          var tmp$ret$13;
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.kc5();
          var tmp1_pos = Companion_getInstance_9().h3b_1;
          var tmp2_paint = this.r5h();
          var tmp3_renderer = this.kc4_1;
          var tmp4_align = this.lc4_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.fc4_1;
          var tmp7_stroke = this.gc4_1;
          tmp$ret$13 = tmp9_apply.l63(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke);
          result_0 = tmp$ret$13;
          tmp$ret$14 = tmp9_apply;
          tmp$ret$15 = tmp$ret$14.b4w();
          tmp10_updateShape.wbx(tmp$ret$15);
          tmp$ret$16 = result_0;
          var metrics_0 = tmp$ret$16;
          this.wc4_1 = this.cc4_1;
          this.xc4_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_9().h3b_1, font.k4p(this.b4p(), this.zc4_1).o4p_1);
        }
        var tmp7_safe_receiver = this.ic5_1;
        if (tmp7_safe_receiver == null) {
        } else {
          tmp7_safe_receiver.zbx(this.zc3_1);
        }
      }
    }
  };
  function textSize$factory($b0) {
    return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
      return $b0.ic4_1;
    }, function (value) {
      return $b0.lc6(value);
    });
  }
  function fontSource$factory($b0) {
    return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
      return $b0.rc4_1;
    }, function (value) {
      return $b0.ic6(value);
    });
  }
  function fontSize$factory() {
    return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
      return receiver.b4p();
    }, function (receiver, value) {
      return receiver.mc6(value);
    });
  }
  function fontSize$factory_0() {
    return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
      return receiver.b4p();
    }, function (receiver, value) {
      return receiver.mc6(value);
    });
  }
  function View_init_$Init$($this) {
    View.call($this, false);
    return $this;
  }
  function ColorReference() {
  }
  function Companion_13() {
    Companion_instance_13 = this;
  }
  protoOf(Companion_13).oc6 = function (left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 ? true : rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        var tmp0 = lCount;
        lCount = tmp0 - 1 | 0;
        var tmp1_safe_receiver = l;
        l = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u1y();
      }
      if (rdec) {
        var tmp2 = rCount;
        rCount = tmp2 - 1 | 0;
        var tmp3_safe_receiver = r;
        r = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.u1y();
      }
    }
    return null;
  };
  var Companion_instance_13;
  function Companion_getInstance_71() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function setXY($this, x, y) {
    $this.gb0();
    if (!($this.g9p_1 === x) ? true : !($this.h9p_1 === y)) {
      $this.g9p_1 = x;
      $this.h9p_1 = y;
      $this.pb0();
    }
  }
  function updateRenderColorTransform($this) {
    $this.b9q_1 = $this.g9q_1;
    $this.i9q_1 = true;
    var parent = $this.u1y();
    var tmp0_safe_receiver = parent;
    if (!((tmp0_safe_receiver == null ? null : get_filter(tmp0_safe_receiver)) == null)) {
      $this.a9q_1.l4n($this.z9p_1);
    } else {
      var tmp;
      if (!(parent == null)) {
        tmp = !isInterface($this, ColorReference);
      } else {
        tmp = false;
      }
      if (tmp) {
        $this.a9q_1.m4n($this.z9p_1, parent.mb0());
      } else {
        $this.a9q_1.l4n($this.z9p_1);
      }
    }
  }
  function updateRenderColorTransformIfRequired($this) {
    if ($this.b9q_1 === $this.g9q_1)
      return Unit_getInstance();
    updateRenderColorTransform($this);
  }
  function updateRenderBlendMode($this) {
    $this.d9q_1 = $this.f9q_1;
    $this.h9q_1 = true;
    var tmp = $this;
    var tmp0_subject = $this.f9p_1;
    var tmp_0;
    if (tmp0_subject.equals(Companion_getInstance_67().xa1_1)) {
      var tmp1_safe_receiver = $this.u1y();
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.nb0();
      tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_67().wa1_1 : tmp2_elvis_lhs;
    } else {
      tmp_0 = $this.f9p_1;
    }
    tmp.c9q_1 = tmp_0;
  }
  function updateRenderBlendModeIfRequired($this) {
    if ($this.d9q_1 === $this.f9q_1)
      return Unit_getInstance();
    updateRenderBlendMode($this);
  }
  function View$bviewAll$delegate$lambda(this$0) {
    return function () {
      return listOf(this$0);
    };
  }
  function View(isContainer) {
    Companion_getInstance_71();
    BaseView.call(this);
    this.s9o_1 = isContainer;
    var tmp = this;
    tmp.t9o_1 = lazy(View$bviewAll$delegate$lambda(this));
    this.u9o_1 = true;
    this.v9o_1 = null;
    this.w9o_1 = null;
    this.x9o_1 = null;
    this.y9o_1 = 0.0;
    this.z9o_1 = 0;
    this.a9p_1 = null;
    this.b9p_1 = 1.0;
    this.c9p_1 = null;
    this.d9p_1 = null;
    this.e9p_1 = null;
    this.f9p_1 = Companion_getInstance_67().xa1_1;
    this.g9p_1 = 0.0;
    this.h9p_1 = 0.0;
    this.i9p_1 = 1.0;
    this.j9p_1 = 1.0;
    this.k9p_1 = Companion_getInstance_48().v3a_1;
    this.l9p_1 = Companion_getInstance_48().v3a_1;
    this.m9p_1 = Companion_getInstance_48().v3a_1;
    this.n9p_1 = 0.0;
    this.o9p_1 = alpha$factory(this);
    this.p9p_1 = false;
    this.q9p_1 = true;
    this.r9p_1 = true;
    this.s9p_1 = true;
    this.t9p_1 = true;
    this.u9p_1 = Companion_getInstance_23().v3f_1;
    this.v9p_1 = Companion_getInstance_23().v3f_1;
    this.w9p_1 = -1;
    this.x9p_1 = Companion_getInstance_23().v3f_1;
    this.y9p_1 = -1;
    this.z9p_1 = new ColorTransformMul();
    this.a9q_1 = new ColorTransformMul();
    this.b9q_1 = -1;
    this.c9q_1 = Companion_getInstance_67().xa1_1;
    this.d9q_1 = -1;
    this.e9q_1 = true;
    this.f9q_1 = 0;
    this.g9q_1 = 0;
    this.h9q_1 = false;
    this.i9q_1 = false;
    this.j9q_1 = null;
    this.k9q_1 = false;
    this.l9q_1 = null;
    this.m9q_1 = 0;
    this.n9q_1 = true;
    this.o9q_1 = null;
  }
  protoOf(View).zay = function () {
    return 0.0;
  };
  protoOf(View).aaz = function () {
    return 0.0;
  };
  protoOf(View).pc6 = function () {
    return this.zay();
  };
  protoOf(View).qc6 = function () {
    return this.aaz();
  };
  protoOf(View).iay = function () {
    return null;
  };
  protoOf(View).vbg = function (_set____db54di) {
    this.w9o_1 = _set____db54di;
  };
  protoOf(View).pas = function (_set____db54di) {
    this.y9o_1 = _set____db54di;
  };
  protoOf(View).kb1 = function () {
    return this.y9o_1;
  };
  protoOf(View).baz = function (value) {
    this.z9o_1 = value;
  };
  protoOf(View).c6g = function () {
    return this.z9o_1;
  };
  protoOf(View).caz = function (value) {
    if (this.c9p_1 === value)
      return Unit_getInstance();
    this.c9p_1 = value;
    var tmp$ret$0;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.iay();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.j()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp0__anonymous__q1qw7t = tmp0_safe_receiver.k(tmp0);
        tmp0__anonymous__q1qw7t.caz(value);
      }
      tmp = Unit_getInstance();
    }
    tmp$ret$0 = tmp;
  };
  protoOf(View).daz = function (value) {
    if (this.d9p_1 === value)
      return Unit_getInstance();
    this.d9p_1 = value;
    var parent = this.gay();
    var tmp$ret$0;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.iay();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.j()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp0__anonymous__q1qw7t = tmp0_safe_receiver.k(tmp0);
        tmp0__anonymous__q1qw7t.daz(parent);
      }
      tmp = Unit_getInstance();
    }
    tmp$ret$0 = tmp;
  };
  protoOf(View).gay = function () {
    return this.d9p_1;
  };
  protoOf(View).eaz = function () {
    var tmp0_safe_receiver = this.a9p_1;
    this.daz(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gay());
  };
  protoOf(View).faz = function (value) {
    if (this.a9p_1 === value)
      return Unit_getInstance();
    this.a9p_1 = value;
    var tmp0_safe_receiver = this.a9p_1;
    this.caz(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c9p_1);
    this.eaz();
    this.oav();
    this.g6a(value);
  };
  protoOf(View).u1y = function () {
    return this.a9p_1;
  };
  protoOf(View).gaz = function () {
    return !(this.u1y() == null) ? ensureNotNull(this.u1y()).gaz() * this.b9p_1 : this.b9p_1;
  };
  protoOf(View).l51 = function (value) {
    return setXY(this, _Vector2___get_x__impl__zywdz(value), _Vector2___get_y__impl__ttldg6(value));
  };
  protoOf(View).e51 = function () {
    return _Vector2___init__impl__67w0ru(this.b6d(), this.c6d());
  };
  protoOf(View).rc6 = function (v) {
    setXY(this, v, this.c6d());
  };
  protoOf(View).b6d = function () {
    this.gb0();
    return this.g9p_1;
  };
  protoOf(View).sc6 = function (v) {
    setXY(this, this.b6d(), v);
  };
  protoOf(View).c6d = function () {
    this.gb0();
    return this.h9p_1;
  };
  protoOf(View).haz = function () {
    return this.b6d();
  };
  protoOf(View).iaz = function () {
    return this.c6d();
  };
  protoOf(View).jaz = function () {
    return this.n9p_1;
  };
  protoOf(View).tc6 = function (value) {
    this.saz(_Scale___init__impl__ov1qs1(value, value));
  };
  protoOf(View).uc6 = function () {
    return _Scale___get_scaleAvg__impl__cb1hs2(this.taz());
  };
  protoOf(View).kaz = function (v) {
    this.gb0();
    if (!(this.i9p_1 === v)) {
      this.i9p_1 = v;
      this.pb0();
    }
  };
  protoOf(View).laz = function () {
    this.gb0();
    return this.i9p_1;
  };
  protoOf(View).maz = function (v) {
    this.gb0();
    if (!(this.j9p_1 === v)) {
      this.j9p_1 = v;
      this.pb0();
    }
  };
  protoOf(View).naz = function () {
    this.gb0();
    return this.j9p_1;
  };
  protoOf(View).oaz = function (value) {
    this.kaz(value);
  };
  protoOf(View).paz = function () {
    return this.laz();
  };
  protoOf(View).qaz = function (value) {
    this.maz(value);
  };
  protoOf(View).raz = function () {
    return this.naz();
  };
  protoOf(View).saz = function (value) {
    this.kaz(_Scale___get_scaleX__impl__iylwx0(value));
    this.maz(_Scale___get_scaleY__impl__9v0k57(value));
  };
  protoOf(View).taz = function () {
    return _Scale___init__impl__ov1qs1(this.laz(), this.naz());
  };
  protoOf(View).ac1 = function (v) {
    this.oaz(v);
    this.qaz(v);
  };
  protoOf(View).uaz = function () {
    this.gb0();
    return this.k9p_1;
  };
  protoOf(View).vaz = function () {
    this.gb0();
    return this.l9p_1;
  };
  protoOf(View).jc1 = function (v) {
    this.gb0();
    if (!equals(this.m9p_1, v)) {
      this.m9p_1 = v;
      this.pb0();
    }
  };
  protoOf(View).waz = function () {
    this.gb0();
    return this.m9p_1;
  };
  protoOf(View).xaz = function () {
    var tmp0_safe_receiver = this.u1y();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wb0(_Vector2___init__impl__67w0ru(this.b6d(), this.c6d()));
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Vector2(tmp_0)) == null) {
      tmp = _Vector2___init__impl__67w0ru(this.b6d(), this.c6d());
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(View).oag = function () {
    return this.lav();
  };
  protoOf(View).lav = function () {
    return _Rectangle___get_size__impl__14eamq(this.jb1());
  };
  protoOf(View).yaz = function () {
    return _Size___get_width__impl__58y75t(this.lav());
  };
  protoOf(View).zaz = function () {
    return _Size___get_height__impl__a04p02(this.lav());
  };
  protoOf(View).ck = function () {
    return this.yaz();
  };
  protoOf(View).dk = function () {
    return this.zaz();
  };
  protoOf(View).ab0 = function () {
    return this.yaz();
  };
  protoOf(View).bb0 = function () {
    return this.zaz();
  };
  protoOf(View).i4n = function (v) {
    if (!(v === this.z9p_1.k4n())) {
      this.z9p_1.i4n(v);
      this.kay();
    }
  };
  protoOf(View).k4n = function () {
    return this.z9p_1.k4n();
  };
  protoOf(View).cb0 = function (v) {
    if (!(this.z9p_1.h4n() === v)) {
      this.z9p_1.g4n(v);
      this.kay();
    }
  };
  protoOf(View).db0 = function () {
    return this.z9p_1.h4n();
  };
  protoOf(View).eb0 = function (_set____db54di) {
    var tmp0_setValue = alphaF$factory();
    return this.o9p_1.set(_set____db54di);
  };
  protoOf(View).fb0 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = alphaF$factory_0();
    tmp$ret$0 = this.o9p_1.get();
    return tmp$ret$0;
  };
  protoOf(View).gb0 = function () {
    if (this.s9p_1)
      return Unit_getInstance();
    this.s9p_1 = true;
    var t = Matrix__toTransform_impl_lr8urh(this.u9p_1);
    this.g9p_1 = _MatrixTransform___get_x__impl__5z12ed(t);
    this.h9p_1 = _MatrixTransform___get_y__impl__mulenu(t);
    this.i9p_1 = _MatrixTransform___get_scaleX__impl__t9pp1f(t);
    this.j9p_1 = _MatrixTransform___get_scaleY__impl__g37z8(t);
    this.k9p_1 = _MatrixTransform___get_skewX__impl__luxf0b(t);
    this.l9p_1 = _MatrixTransform___get_skewY__impl__6yp21w(t);
    this.m9p_1 = _MatrixTransform___get_rotation__impl__d5fsj(t);
  };
  protoOf(View).f1w = function () {
    var tmp0_safe_receiver = this.u1y();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f1w();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  };
  protoOf(View).hb0 = function () {
    return this.c9p_1;
  };
  protoOf(View).ib0 = function () {
    return this.r9p_1;
  };
  protoOf(View).jb0 = function () {
    if (!this.t9p_1) {
      this.t9p_1 = true;
      this.h9q_1 = true;
      this.u9p_1 = Companion_getInstance_23().h3g(this.b6d(), this.c6d(), this.waz(), this.laz(), this.naz(), this.uaz(), this.vaz(), 0.0, 0.0);
    }
    return this.u9p_1;
  };
  protoOf(View).kb0 = function () {
    if (!(this.w9p_1 === this.f9q_1)) {
      this.w9p_1 = this.f9q_1;
      this.h9q_1 = true;
      this.v9p_1 = !(this.u1y() == null) ? Matrix__times_impl_aro03c(this.jb0(), ensureNotNull(this.u1y()).kb0()) : this.jb0();
    }
    return this.v9p_1;
  };
  protoOf(View).lb0 = function () {
    if (!(this.y9p_1 === this.f9q_1)) {
      this.y9p_1 = this.f9q_1;
      this.h9q_1 = true;
      this.x9p_1 = Matrix__inverted_impl_3pqbyv(this.kb0());
    }
    return this.x9p_1;
  };
  protoOf(View).mb0 = function () {
    updateRenderColorTransformIfRequired(this);
    return this.a9q_1;
  };
  protoOf(View).nb0 = function () {
    updateRenderBlendModeIfRequired(this);
    return this.c9q_1;
  };
  protoOf(View).ob0 = function () {
    updateRenderColorTransformIfRequired(this);
    return this.a9q_1.k4n();
  };
  protoOf(View).pb0 = function () {
    this.t9p_1 = false;
    this.jay();
  };
  protoOf(View).jay = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.f9q_1;
    tmp0_this.f9q_1 = tmp1 + 1 | 0;
    this.h9q_1 = false;
    this.e9q_1 = true;
    this.fay();
  };
  protoOf(View).qb0 = function () {
    var tmp = this.j9q_1;
    if (!((tmp == null ? null : new Rectangle(tmp)) == null)) {
      this.j9q_1 = null;
      var tmp0_safe_receiver = this.u1y();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.qb0();
      }
    }
  };
  protoOf(View).oav = function () {
  };
  protoOf(View).fay = function () {
    var tmp0_safe_receiver = this.d9p_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.hay(this);
    }
    this.qb0();
  };
  protoOf(View).kay = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.g9q_1;
    tmp0_this.g9q_1 = tmp1 + 1 | 0;
    this.i9q_1 = false;
    this.e9q_1 = true;
    this.fay();
  };
  protoOf(View).mav = function (ctx) {
    if (!this.ib0())
      return Unit_getInstance();
    var tmp0_safe_receiver = this.l9q_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast = tmp0_safe_receiver.vp_1;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_unsafeCast;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      var array = tmp$ret$2;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        var tmp$ret$6;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$4;
        // Inline function 'korlibs.datastructure.get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp1_get = tmp0;
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = array;
        tmp$ret$4 = tmp$ret$3[tmp1_get];
        var tmp2_unsafeCast = tmp$ret$4;
        var tmp$ret$5;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$5 = tmp2_unsafeCast;
        tmp$ret$6 = tmp$ret$5;
        var tmp3__anonymous__ufb84q = tmp$ret$6;
        tmp3__anonymous__ufb84q.vc6(this, ctx);
      }
    }
    try {
      this.rb0(ctx);
    }finally {
      var tmp1_safe_receiver = this.l9q_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        var tmp$ret$9;
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        var tmp$ret$8;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp4_unsafeCast = tmp1_safe_receiver.vp_1;
        var tmp$ret$7;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$7 = tmp4_unsafeCast;
        tmp$ret$8 = tmp$ret$7;
        tmp$ret$9 = tmp$ret$8;
        var array_0 = tmp$ret$9;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          var tmp$ret$13;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$11;
          // Inline function 'korlibs.datastructure.get' call
          var tmp5_get = (tmp1_safe_receiver.j() - n_0 | 0) - 1 | 0;
          var tmp$ret$10;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$10 = array_0;
          tmp$ret$11 = tmp$ret$10[tmp5_get];
          var tmp6_unsafeCast = tmp$ret$11;
          var tmp$ret$12;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$12 = tmp6_unsafeCast;
          tmp$ret$13 = tmp$ret$12;
          var tmp7__anonymous__b0knam = tmp$ret$13;
          tmp7__anonymous__b0knam.wc6(this, ctx);
          var tmp0_0 = n_0;
          n_0 = tmp0_0 + 1 | 0;
        }
      }
    }
  };
  protoOf(View).rb0 = function (ctx) {
    var oldPhase = this.m9q_1;
    try {
      this.m9q_1 = 0;
      this.sb0(ctx);
    }finally {
      this.m9q_1 = oldPhase;
    }
  };
  protoOf(View).sb0 = function (ctx) {
    var stages = this.l9q_1;
    if (!(stages == null) ? this.m9q_1 < stages.j() : false) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.m9q_1;
      tmp0_this.m9q_1 = tmp1 + 1 | 0;
      stages.k(tmp1).xc6(this, ctx);
    } else {
      var tmp = this.m9q_1;
      var tmp2_safe_receiver = stages;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.j();
      if (tmp === (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs)) {
        this.qav(ctx);
        var tmp4_this = this;
        var tmp5 = tmp4_this.m9q_1;
        tmp4_this.m9q_1 = tmp5 + 1 | 0;
      }
    }
  };
  protoOf(View).tay = function (ctx) {
    if (this.k9q_1 ? true : this === ctx.r9y_1) {
      this.tb0(ctx);
    }
  };
  protoOf(View).tb0 = function (ctx) {
    var local = this.jb1();
    var tmp$ret$9;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var tmp$ret$8;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var tmp1_use = get_debugLineRenderContext(ctx);
    var tmp0_useBatcher = tmp1_use.rab_1;
    if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
      tmp0_useBatcher.y9y_1 = tmp1_use;
      tmp0_useBatcher.va3();
    }
    var tmp$ret$7;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var tmp1_drawWithGlobalMatrix = get_debugLineRenderContext(ctx);
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var tmp0_keep = currentMatrix$factory_0(tmp1_drawWithGlobalMatrix);
      var temp = tmp0_keep.get().z3f_1;
      try {
        var tmp$ret$5;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          tmp1_drawWithGlobalMatrix.dac_1 = null;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var tmp0_blending = Companion_getInstance_67().ga2_1;
          var doUpdate = !(tmp1_use.cac_1 === tmp0_blending);
          var old = tmp1_use.cac_1;
          try {
            if (doUpdate) {
              tmp1_use.rab_1.va3();
              tmp1_use.cac_1 = tmp0_blending;
            }
            var tmp0_drawVector = Colors_getInstance().l48_1;
            var tmp1_drawVector = tmp1_use.dac_1;
            var oldColor = tmp1_use.uab_1;
            tmp1_use.uab_1 = tmp0_drawVector;
            var tmp;
            try {
              var tmp$ret$0;
              // Inline function 'kotlin.apply' call
              var tmp0_apply = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              tmp0_apply.o3y(this.cb1());
              tmp$ret$0 = tmp0_apply;
              tmp1_use.iac(tmp$ret$0, tmp1_drawVector);
              tmp = Unit_getInstance();
            }finally {
              tmp1_use.uab_1 = oldColor;
            }
            tmp$ret$1 = tmp;
            break $l$block;
          }finally {
            if (doUpdate) {
              tmp1_use.rab_1.va3();
            }
            tmp1_use.cac_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var tmp1_drawVector_0 = Colors_getInstance().l48_1;
        var tmp2_drawVector = tmp1_use.dac_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = tmp1_use.uab_1;
        tmp1_use.uab_1 = tmp1_drawVector_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          var tmp$ret$2;
          // Inline function 'kotlin.apply' call
          var tmp0_apply_0 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          tmp0_apply_0.e3k(this.wb0(_Vector2___init__impl__67w0ru(_Rectangle___get_left__impl__sgtjiw(local), _Rectangle___get_top__impl__3kuxui(local))));
          tmp0_apply_0.j3o(this.wb0(_Vector2___init__impl__67w0ru(_Rectangle___get_right__impl__7wa90z(local), _Rectangle___get_top__impl__3kuxui(local))));
          tmp0_apply_0.j3o(this.wb0(_Vector2___init__impl__67w0ru(_Rectangle___get_right__impl__7wa90z(local), _Rectangle___get_bottom__impl__1duj44(local))));
          tmp0_apply_0.j3o(this.wb0(_Vector2___init__impl__67w0ru(_Rectangle___get_left__impl__sgtjiw(local), _Rectangle___get_bottom__impl__1duj44(local))));
          tmp0_apply_0.c1c();
          tmp$ret$2 = tmp0_apply_0;
          tmp1_use.iac(tmp$ret$2, tmp2_drawVector);
        }finally {
          tmp1_use.uab_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var tmp3_drawVector = Colors_getInstance().z4d_1;
        var tmp4_drawVector = tmp1_use.dac_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = tmp1_use.uab_1;
        tmp1_use.uab_1 = tmp3_drawVector;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          var tmp$ret$3;
          // Inline function 'kotlin.apply' call
          var tmp0_apply_1 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(ctx.q9y_1).sac();
          tmp0_apply_1.v3b(this.wb0(_Rectangle___get_topLeft__impl__xiee25(local)), anchorSize);
          tmp0_apply_1.v3b(this.wb0(_Rectangle___get_topRight__impl__6efxlk(local)), anchorSize);
          tmp0_apply_1.v3b(this.wb0(_Rectangle___get_bottomRight__impl__oqq9ry(local)), anchorSize);
          tmp0_apply_1.v3b(this.wb0(_Rectangle___get_bottomLeft__impl__2pw8cj(local)), anchorSize);
          tmp0_apply_1.v3b(this.wb0(interpolate_0(Companion_getInstance_49().n42_1, _Rectangle___get_topLeft__impl__xiee25(local), _Rectangle___get_topRight__impl__6efxlk(local))), anchorSize);
          tmp0_apply_1.v3b(this.wb0(interpolate_0(Companion_getInstance_49().n42_1, _Rectangle___get_topRight__impl__6efxlk(local), _Rectangle___get_bottomRight__impl__oqq9ry(local))), anchorSize);
          tmp0_apply_1.v3b(this.wb0(interpolate_0(Companion_getInstance_49().n42_1, _Rectangle___get_bottomRight__impl__oqq9ry(local), _Rectangle___get_bottomLeft__impl__2pw8cj(local))), anchorSize);
          tmp0_apply_1.v3b(this.wb0(interpolate_0(Companion_getInstance_49().n42_1, _Rectangle___get_bottomLeft__impl__2pw8cj(local), _Rectangle___get_topLeft__impl__xiee25(local))), anchorSize);
          tmp$ret$3 = tmp0_apply_1;
          tmp1_use.iac(tmp$ret$3, tmp4_drawVector);
        }finally {
          tmp1_use.uab_1 = oldColor_1;
        }
        var tmp5_drawVector = Colors_getInstance().n48_1;
        var tmp6_drawVector = tmp1_use.dac_1;
        var oldColor_2 = tmp1_use.uab_1;
        tmp1_use.uab_1 = tmp5_drawVector;
        var tmp_0;
        try {
          var tmp$ret$4;
          // Inline function 'kotlin.apply' call
          var tmp0_apply_2 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.xaz();
          tmp0_apply_2.n3y(_Vector2___init__impl__67w0ru(_Vector2___get_x__impl__zywdz(center), _Vector2___get_y__impl__ttldg6(center) - 5), _Vector2___init__impl__67w0ru(_Vector2___get_x__impl__zywdz(center), _Vector2___get_y__impl__ttldg6(center) + 5));
          tmp0_apply_2.n3y(_Vector2___init__impl__67w0ru(_Vector2___get_x__impl__zywdz(center) - 5, _Vector2___get_y__impl__ttldg6(center)), _Vector2___init__impl__67w0ru(_Vector2___get_x__impl__zywdz(center) + 5, _Vector2___get_y__impl__ttldg6(center)));
          tmp$ret$4 = tmp0_apply_2;
          tmp1_use.iac(tmp$ret$4, tmp6_drawVector);
          tmp_0 = Unit_getInstance();
        }finally {
          tmp1_use.uab_1 = oldColor_2;
        }
        tmp$ret$5 = tmp_0;
        tmp$ret$6 = tmp$ret$5;
        break $l$block_0;
      }finally {
        tmp0_keep.set(new Matrix(temp));
      }
    }
    tmp$ret$7 = tmp$ret$6;
    tmp$ret$8 = tmp$ret$7;
    tmp$ret$9 = tmp$ret$8;
  };
  protoOf(View).toString = function () {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.b6d() === 0.0) ? true : !(this.c6d() === 0.0))
      out = out + (':pos=(' + this.ub0(this.b6d()) + ',' + this.ub0(this.c6d()) + ')');
    if (!(this.laz() === 1.0) ? true : !(this.naz() === 1.0))
      out = out + (':scale=(' + this.vb0(this.paz()) + ',' + this.vb0(this.raz()) + ')');
    if (!equals(this.uaz(), Companion_getInstance_48().v3a_1) ? true : !equals(this.vaz(), Companion_getInstance_48().v3a_1))
      out = out + (':skew=(' + this.vb0(_Angle___get_degreesD__impl__9qro6(this.uaz())) + ',' + this.vb0(_Angle___get_degreesD__impl__9qro6(this.vaz())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.waz()), Companion_getInstance_48().v3a_1))
      out = out + (':rotation=(' + this.vb0(_Angle___get_degreesD__impl__9qro6(this.waz())) + '\xBA)');
    if (!(this.e9p_1 == null))
      out = out + (':name=(' + this.e9p_1 + ')');
    if (!this.f9p_1.equals(Companion_getInstance_67().xa1_1))
      out = out + (':blendMode=(' + this.f9p_1 + ')');
    if (!this.ib0())
      out = out + (':visible=' + this.ib0());
    if (!(this.fb0() === 1.0))
      out = out + (':alpha=' + niceStr(this.fb0(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.k4n()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().j48_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.k4n()));
    return out;
  };
  protoOf(View).ub0 = function (_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  };
  protoOf(View).vb0 = function (_this__u8e3s4) {
    return toStringDecimal_0(_this__u8e3s4, 2, true);
  };
  protoOf(View).wb0 = function (p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var tmp0_transform = this.kb0();
      if (_Matrix___get_isNIL__impl__n63x5q(tmp0_transform)) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = _Vector2___init__impl__67w0ru(_Matrix___get_a__impl__f7jypo(tmp0_transform) * _Vector2___get_x__impl__zywdz(p) + _Matrix___get_c__impl__slf2ke(tmp0_transform) * _Vector2___get_y__impl__ttldg6(p) + _Matrix___get_tx__impl__yc1n9(tmp0_transform), _Matrix___get_d__impl__87eht(tmp0_transform) * _Vector2___get_y__impl__ttldg6(p) + _Matrix___get_b__impl__dm2icj(tmp0_transform) * _Vector2___get_x__impl__zywdz(p) + _Matrix___get_ty__impl__tryipg(tmp0_transform));
    }
    return tmp$ret$0;
  };
  protoOf(View).xb0 = function () {
    var tmp0_safe_receiver = this.u1y();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.yay(this);
  };
  protoOf(View).yb0 = function (target, inclusive) {
    var tmp;
    if (target === this.u1y()) {
      tmp = this.jb0();
    } else if (target === this) {
      tmp = Companion_getInstance_23().v3f_1;
    } else {
      var commonAncestor = Companion_getInstance_71().oc6(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.u1y() == null ? inclusive : false) {
          return this.kb0();
        }
        tmp_0 = Matrix__times_impl_aro03c(this.kb0(), target.lb0());
      } else {
        tmp_0 = Companion_getInstance_23().v3f_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = Matrix__times_impl_aro03c(out, target.jb0());
    }
    return out;
  };
  protoOf(View).zb0 = function (bp) {
    return Rectangle__transformed_impl_5k4zxr(this.eb1(), bp.mac());
  };
  protoOf(View).ab1 = function (ctx) {
    return ctx.zac() ? this.zb0(ctx) : this.eb1();
  };
  protoOf(View).bb1 = function (ctx) {
    return this.ab1(ctx);
  };
  protoOf(View).cb1 = function () {
    return this.eb1();
  };
  protoOf(View).db1 = function (includeFilters) {
    return this.hb1(this.f1w(), VOID, true, includeFilters);
  };
  protoOf(View).eb1 = function (includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.db1(includeFilters) : $super.db1.call(this, includeFilters).q3b_1;
  };
  protoOf(View).fb1 = function (concat, doAnchoring, includeFilters) {
    var out = this.ib1(doAnchoring, includeFilters);
    if (_Matrix___get_isNotNIL__impl__wjqa0f(concat) ? !_Matrix___get_isIdentity__impl__oe9whb(concat) : false) {
      var tmp = Companion_getInstance_45();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var tmp0_transform = _Rectangle___get_topLeft__impl__xiee25(out);
        if (_Matrix___get_isNIL__impl__n63x5q(concat)) {
          tmp$ret$0 = tmp0_transform;
          break $l$block;
        }
        tmp$ret$0 = _Vector2___init__impl__67w0ru(_Matrix___get_a__impl__f7jypo(concat) * _Vector2___get_x__impl__zywdz(tmp0_transform) + _Matrix___get_c__impl__slf2ke(concat) * _Vector2___get_y__impl__ttldg6(tmp0_transform) + _Matrix___get_tx__impl__yc1n9(concat), _Matrix___get_d__impl__87eht(concat) * _Vector2___get_y__impl__ttldg6(tmp0_transform) + _Matrix___get_b__impl__dm2icj(concat) * _Vector2___get_x__impl__zywdz(tmp0_transform) + _Matrix___get_ty__impl__tryipg(concat));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var tmp1_transform = _Rectangle___get_topRight__impl__6efxlk(out);
        if (_Matrix___get_isNIL__impl__n63x5q(concat)) {
          tmp$ret$1 = tmp1_transform;
          break $l$block_0;
        }
        tmp$ret$1 = _Vector2___init__impl__67w0ru(_Matrix___get_a__impl__f7jypo(concat) * _Vector2___get_x__impl__zywdz(tmp1_transform) + _Matrix___get_c__impl__slf2ke(concat) * _Vector2___get_y__impl__ttldg6(tmp1_transform) + _Matrix___get_tx__impl__yc1n9(concat), _Matrix___get_d__impl__87eht(concat) * _Vector2___get_y__impl__ttldg6(tmp1_transform) + _Matrix___get_b__impl__dm2icj(concat) * _Vector2___get_x__impl__zywdz(tmp1_transform) + _Matrix___get_ty__impl__tryipg(concat));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var tmp2_transform = _Rectangle___get_bottomRight__impl__oqq9ry(out);
        if (_Matrix___get_isNIL__impl__n63x5q(concat)) {
          tmp$ret$2 = tmp2_transform;
          break $l$block_1;
        }
        tmp$ret$2 = _Vector2___init__impl__67w0ru(_Matrix___get_a__impl__f7jypo(concat) * _Vector2___get_x__impl__zywdz(tmp2_transform) + _Matrix___get_c__impl__slf2ke(concat) * _Vector2___get_y__impl__ttldg6(tmp2_transform) + _Matrix___get_tx__impl__yc1n9(concat), _Matrix___get_d__impl__87eht(concat) * _Vector2___get_y__impl__ttldg6(tmp2_transform) + _Matrix___get_b__impl__dm2icj(concat) * _Vector2___get_x__impl__zywdz(tmp2_transform) + _Matrix___get_ty__impl__tryipg(concat));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var tmp3_transform = _Rectangle___get_bottomLeft__impl__2pw8cj(out);
        if (_Matrix___get_isNIL__impl__n63x5q(concat)) {
          tmp$ret$3 = tmp3_transform;
          break $l$block_2;
        }
        tmp$ret$3 = _Vector2___init__impl__67w0ru(_Matrix___get_a__impl__f7jypo(concat) * _Vector2___get_x__impl__zywdz(tmp3_transform) + _Matrix___get_c__impl__slf2ke(concat) * _Vector2___get_y__impl__ttldg6(tmp3_transform) + _Matrix___get_tx__impl__yc1n9(concat), _Matrix___get_d__impl__87eht(concat) * _Vector2___get_y__impl__ttldg6(tmp3_transform) + _Matrix___get_b__impl__dm2icj(concat) * _Vector2___get_x__impl__zywdz(tmp3_transform) + _Matrix___get_ty__impl__tryipg(concat));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.g3b(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  };
  protoOf(View).gb1 = function (target, doAnchoring, inclusive, includeFilters) {
    var tmp0_elvis_lhs = target;
    return this.fb1(this.yb0(tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs, inclusive), doAnchoring, includeFilters);
  };
  protoOf(View).hb1 = function (target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.gb1(target, doAnchoring, inclusive, includeFilters) : $super.gb1.call(this, target, doAnchoring, inclusive, includeFilters).q3b_1;
  };
  protoOf(View).ib1 = function (doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.j9q_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Rectangle(tmp_0)) == null) {
      var tmp$ret$0;
      // Inline function 'kotlin.also' call
      var tmp0_also = this.nav();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.j9q_1 = tmp0_also;
      tmp$ret$0 = tmp0_also;
      tmp = tmp$ret$0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = Rectangle__translated_impl_5ia2y0(out, _Vector2___init__impl__67w0ru(this.zay(), this.aaz()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
        tmp$ret$1 = Unit_getInstance();
      }
    }
    return out;
  };
  protoOf(View).jb1 = function (doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.ib1(doAnchoring, includeFilters) : $super.ib1.call(this, doAnchoring, includeFilters).q3b_1;
  };
  protoOf(View).nav = function () {
    return Companion_getInstance_38().e3b();
  };
  function addUpdater(_this__u8e3s4, first, firstTime, updatable) {
    first = first === VOID ? true : first;
    firstTime = firstTime === VOID ? Companion_getInstance_7().yi_1 : firstTime;
    if (first)
      updatable(_this__u8e3s4, new TimeSpan(firstTime));
    var tmp = Companion_getInstance_72();
    return _this__u8e3s4.h6a(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
  }
  function addUpdater_0(_this__u8e3s4, updatable) {
    return addUpdater(_this__u8e3s4, true, VOID, updatable);
  }
  function scale(_this__u8e3s4, sx, sy) {
    sy = sy === VOID ? sx : sy;
    _this__u8e3s4.oaz(sx);
    _this__u8e3s4.qaz(sy);
    return _this__u8e3s4;
  }
  function position(_this__u8e3s4, x, y) {
    return xy(_this__u8e3s4, _Vector2___init__impl__67w0ru(x, y));
  }
  function descendantsWith(_this__u8e3s4, out, check) {
    var tmp;
    if (out === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp$ret$0 = ArrayList_init_$Create$_0();
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = out;
    }
    out = tmp;
    if (!(_this__u8e3s4 == null)) {
      if (check(_this__u8e3s4)) {
        // Inline function 'kotlin.collections.plusAssign' call
        out.b(_this__u8e3s4);
      }
      if (_this__u8e3s4.s9o_1) {
        var tmp$ret$1;
        // Inline function 'korlibs.korge.view.View.forEachChild' call
        var tmp0_safe_receiver = _this__u8e3s4.iay();
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'korlibs.datastructure.iterators.fastForEach' call
          var n = 0;
          while (n < tmp0_safe_receiver.j()) {
            // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
            var tmp0 = n;
            n = tmp0 + 1 | 0;
            var tmp0__anonymous__q1qw7t = tmp0_safe_receiver.k(tmp0);
            descendantsWith(tmp0__anonymous__q1qw7t, out, check);
          }
          tmp_0 = Unit_getInstance();
        }
        tmp$ret$1 = tmp_0;
      }
    }
    return out;
  }
  function addFixedUpdater(_this__u8e3s4, time, first, limitCallsPerFrame, updatable) {
    first = first === VOID ? true : first;
    limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
    var tmp$ret$0;
    // Inline function 'korlibs.time.milliseconds' call
    tmp$ret$0 = Companion_getInstance_7().bj(0.0);
    var accum = {_v: new TimeSpan(tmp$ret$0)};
    return addUpdater(_this__u8e3s4, first, time, addFixedUpdater$lambda(accum, time, updatable, _this__u8e3s4, limitCallsPerFrame));
  }
  function findFirstAscendant(_this__u8e3s4, cond) {
    var current = _this__u8e3s4;
    while (!(current == null)) {
      if (cond(current))
        return current;
      current = current.u1y();
    }
    return null;
  }
  function get_ancestorCount(_this__u8e3s4) {
    var count = 0;
    var tmp0_safe_receiver = _this__u8e3s4;
    var parent = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u1y();
    while (!(parent == null)) {
      var tmp1 = count;
      count = tmp1 + 1 | 0;
      parent = parent.u1y();
    }
    return count;
  }
  function ViewRenderPhase() {
  }
  function xy(_this__u8e3s4, p) {
    _this__u8e3s4.l51(p);
    return _this__u8e3s4;
  }
  function addFixedUpdater_0(_this__u8e3s4, timesPerSecond, initial, limitCallsPerFrame, updatable) {
    initial = initial === VOID ? true : initial;
    limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
    return addFixedUpdater(_this__u8e3s4, _Frequency___get_timeSpan__impl__f9mrmt(timesPerSecond), initial, limitCallsPerFrame, updatable);
  }
  function position_0(_this__u8e3s4, x, y) {
    return xy(_this__u8e3s4, _Vector2___init__impl__67w0ru_2(x, y));
  }
  function scale_0(_this__u8e3s4, sx, sy) {
    sy = sy === VOID ? sx : sy;
    return scale(_this__u8e3s4, sx, sy);
  }
  function addUpdater$lambda($updatable, $this_addUpdater) {
    return function (it) {
      $updatable($this_addUpdater, new TimeSpan(TimeSpan__times_impl_86ofia_0(it.lb4_1, $this_addUpdater.gaz())));
      return Unit_getInstance();
    };
  }
  function addFixedUpdater$lambda($accum, $time, $updatable, $this_addFixedUpdater, $limitCallsPerFrame) {
    return function ($this$addUpdater, dt) {
      $accum._v = new TimeSpan(TimeSpan__plus_impl_qdd6zo($accum._v.lj_1, dt.lj_1));
      var calls = 0;
      $l$loop: while (TimeSpan__compareTo_impl_zidry4($accum._v.lj_1, TimeSpan__times_impl_86ofia_1($time, 0.75)) >= 0) {
        $accum._v = new TimeSpan(TimeSpan__minus_impl_5w5v8s($accum._v.lj_1, $time));
        $updatable($this_addFixedUpdater);
        var tmp0 = calls;
        calls = tmp0 + 1 | 0;
        if (calls >= $limitCallsPerFrame) {
          var tmp$ret$0;
          // Inline function 'korlibs.time.milliseconds' call
          tmp$ret$0 = Companion_getInstance_7().bj(0.0);
          $accum._v = new TimeSpan(tmp$ret$0);
          break $l$loop;
        }
      }
      var tmp;
      if (calls > 0) {
        var tmp_0;
        if (TimeSpan__compareTo_impl_zidry4($accum._v.lj_1, TimeSpan__times_impl_86ofia_1($time, 0.25)) < 0) {
          var tmp$ret$1;
          // Inline function 'korlibs.time.milliseconds' call
          tmp$ret$1 = Companion_getInstance_7().bj(0.0);
          $accum._v = new TimeSpan(tmp$ret$1);
          tmp_0 = Unit_getInstance();
        }
        tmp = tmp_0;
      }
      return Unit_getInstance();
    };
  }
  function alpha$factory($b0) {
    return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
      return $b0.db0();
    }, function (value) {
      return $b0.cb0(value);
    });
  }
  function alphaF$factory() {
    return getPropertyCallableRef('alphaF', 1, KMutableProperty1, function (receiver) {
      return receiver.fb0();
    }, function (receiver, value) {
      return receiver.eb0(value);
    });
  }
  function alphaF$factory_0() {
    return getPropertyCallableRef('alphaF', 1, KMutableProperty1, function (receiver) {
      return receiver.fb0();
    }, function (receiver, value) {
      return receiver.eb0(value);
    });
  }
  function currentMatrix$factory_0($b0) {
    return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
      return new Matrix($b0.dac_1);
    }, function (value) {
      $b0.dac_1 = value.z3f_1;
      return Unit_getInstance();
    });
  }
  function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0, resultContinuation) {
    this.gc7_1 = $view;
    this.hc7_1 = $ctx;
    this.ic7_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.gc7_1.ic1(ensureNotNull(this.hc7_1.q9y_1), VOID, this.ic7_1.dc1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda).n1f = function (completion) {
    var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda(this.gc7_1, this.hc7_1, this.ic7_1, completion);
    return i;
  };
  function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0, resultContinuation) {
    var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function Mixin_0() {
    this.cc1_1 = true;
    this.dc1_1 = null;
  }
  protoOf(Mixin_0).fc1 = function (_set____db54di) {
    this.cc1_1 = _set____db54di;
  };
  protoOf(Mixin_0).bc1 = function (value) {
    this.cc1_1 = false;
    this.dc1_1 = value;
  };
  protoOf(Mixin_0).zc0 = function (_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.bc1(sourceFile);
    _this__u8e3s4.fc1(true);
    return Unit_getInstance();
  };
  protoOf(Mixin_0).hc1 = function (views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    throw new NotImplementedError('An operation is not implemented: Must override this');
  };
  protoOf(Mixin_0).gc1 = function (ctx, view) {
    if (this.cc1_1)
      return Unit_getInstance();
    this.jc7(ctx, view);
  };
  protoOf(Mixin_0).jc7 = function (ctx, view) {
    if (!this.cc1_1 ? !(this.dc1_1 == null) : false) {
      this.cc1_1 = true;
      launchImmediately_0(ctx.y9x_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this, null));
    }
  };
  function ViewFileRef() {
  }
  function Views$_init_$lambda_jivasj(it) {
    return new Stage(it);
  }
  function Views$realSettingsFolder$delegate$lambda(this$0) {
    return function () {
      return !(this$0.o9m_1 == null) ? ensureNotNull(this$0.o9m_1) : Companion_getInstance_6().yv() ? '/Users/' + Companion_getInstance_22().ro('USER') + '/Library/Preferences/' + this$0.kc7() : Companion_getInstance_6().wv() ? '' + Companion_getInstance_22().ro('APPDATA') + '/' + this$0.kc7() : '' + Companion_getInstance_22().ro('HOME') + '/.config/' + this$0.kc7();
    };
  }
  function Views$close$slambda(this$0, resultContinuation) {
    this.tc7_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Views$close$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Views$close$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(Views$close$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.tc7_1.uc7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(Views$close$slambda).n1f = function (completion) {
    var i = new Views$close$slambda(this.tc7_1, completion);
    return i;
  };
  function Views$close$slambda_0(this$0, resultContinuation) {
    var i = new Views$close$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function Views$tempViewsPool$lambda(it) {
    return FastArrayList_init_$Create$();
  }
  function Views$lambda(this$0) {
    return function (it) {
      this$0.f9n_1.za7();
      return Unit_getInstance();
    };
  }
  function Views$lambda_0(this$0) {
    return function (it) {
      this$0.f9n_1.daa();
      return Unit_getInstance();
    };
  }
  function $initCOROUTINE$20(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dc8_1 = _this__u8e3s4;
  }
  protoOf($initCOROUTINE$20).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = debugBmpFont(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.dc8_1.b9n_1 = ARGUMENT;
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $closeSuspendCOROUTINE$21(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mc8_1 = _this__u8e3s4;
  }
  protoOf($closeSuspendCOROUTINE$21).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            KorgeReload_getInstance().qa1();
            var tmp_0 = this;
            tmp_0.nc8_1 = this.mc8_1.o9n_1;
            this.oc8_1 = 0;
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (!(this.oc8_1 < this.nc8_1.j())) {
              this.hh_1 = 3;
              continue $sm;
            }

            var tmp_1 = this;
            var tmp0 = this.oc8_1;
            this.oc8_1 = tmp0 + 1 | 0;
            tmp_1.pc8_1 = this.nc8_1.k(tmp0);
            this.hh_1 = 2;
            suspendResult = this.pc8_1.a1n(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 1;
            continue $sm;
          case 3:
            this.mc8_1.o9n_1.v2();
            cancel(this.mc8_1.g9m_1);
            this.mc8_1.m9m_1.a83();
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function Views(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_62().f9j_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    BaseEventListener.call(this);
    this.g9m_1 = coroutineContext;
    this.h9m_1 = ag;
    this.i9m_1 = injector;
    this.j9m_1 = input;
    this.k9m_1 = timeProvider;
    this.l9m_1 = stats;
    this.m9m_1 = gameWindow;
    this.n9m_1 = gameId;
    this.o9m_1 = settingsFolder;
    this.p9m_1 = batchMaxQuads;
    this.q9m_1 = bp;
    this.r9m_1 = stageBuilder;
    this.s9m_1 = new Mixin();
    this.t9m_1 = this;
    this.u9m_1 = false;
    this.v9m_1 = continuousRenderMode$factory(this.m9m_1);
    this.w9m_1 = new ReshapeEvent(0, 0);
    this.x9m_1 = new UpdateEvent();
    this.y9m_1 = new ViewsUpdateEvent(this);
    this.z9m_1 = new ViewsResizedEvent(this);
    var tmp_0 = this;
    tmp_0.a9n_1 = lazy(Views$realSettingsFolder$delegate$lambda(this));
    this.c9n_1 = null;
    this.d9n_1 = get_resourcesVfs();
    this.e9n_1 = get_RegisteredImageFormats();
    this.f9n_1 = new RenderContext(this.h9m_1, this, this.m9m_1, this.l9m_1, this.g9m_1, this.p9m_1);
    this.g9n_1 = true;
    this.h9n_1 = Colors_getInstance().k48_1;
    var tmp_1 = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$0 = HashMap_init_$Create$();
    tmp_1.i9n_1 = tmp$ret$0;
    var tmp_2 = this;
    var tmp$ret$1;
    // Inline function 'korlibs.time.milliseconds' call
    tmp$ret$1 = Companion_getInstance_7().bj(100.0);
    tmp_2.j9n_1 = tmp$ret$1;
    this.k9n_1 = new Resources(this.g9m_1, this.d9n_1);
    this.l9n_1 = false;
    var tmp_3 = this;
    DefaultViewport_getInstance();
    tmp_3.m9n_1 = 1280;
    var tmp_4 = this;
    DefaultViewport_getInstance();
    tmp_4.n9n_1 = 720;
    var tmp_5 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$2 = ArrayList_init_$Create$_0();
    tmp_5.o9n_1 = tmp$ret$2;
    this.p9n_1 = Companion_getInstance_1().d3j_1;
    this.q9n_1 = Companion_getInstance_2().m3a_1;
    this.r9n_1 = true;
    this.s9n_1 = this.r9m_1(this);
    this.t9n_1 = this.s9n_1;
    this.u9n_1 = true;
    this.v9n_1 = false;
    this.w9n_1 = debugExtraFontScale$factory(this.f9n_1);
    this.x9n_1 = debugExtraFontColor$factory(this.f9n_1);
    this.y9n_1 = FastArrayList_init_$Create$();
    this.z9n_1 = this.k9m_1.si();
    var tmp_6 = this;
    tmp_6.a9o_1 = Pool_init_$Create$(VOID, Views$tempViewsPool$lambda);
    this.b9o_1 = _SizeInt___init__impl__vivn9_0();
    this.c9o_1 = _SizeInt___init__impl__vivn9_0();
    this.d9o_1 = _SizeInt___init__impl__vivn9_0();
    this.e9o_1 = new Signal();
    this.f9o_1 = new Signal();
    this.g9o_1 = -1.0;
    this.i9m_1.k9g(getKClass(CoroutineContext), this.g9m_1);
    this.i9m_1.k9g(getKClass(AG), this.h9m_1);
    this.i9m_1.k9g(getKClass(Views), this);
    this.f9o_1.n1g(Views$lambda(this));
    this.e9o_1.n1g(Views$lambda_0(this));
    installFpsDebugOverlay(this);
    this.h9o_1 = Companion_getInstance_22().ro('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    this.i9o_1 = new EventResult();
    this.j9o_1 = new Signal();
    this.k9o_1 = new Signal();
    this.l9o_1 = new Signal();
    this.m9o_1 = ArrayList_init_$Create$_0();
    this.n9o_1 = updatedSinceFrame$factory(this.m9m_1);
  }
  protoOf(Views).h10 = function () {
    return this.g9m_1;
  };
  protoOf(Views).lu = function (_set____db54di) {
    this.s9m_1.lu(_set____db54di);
  };
  protoOf(Views).mu = function () {
    return this.s9m_1.mu();
  };
  protoOf(Views).kac = function (_set____db54di) {
    this.q9m_1.kac(_set____db54di);
  };
  protoOf(Views).lac = function (_set____db54di) {
    this.q9m_1.lac(_set____db54di);
  };
  protoOf(Views).mac = function () {
    return this.q9m_1.mac();
  };
  protoOf(Views).nac = function () {
    return this.q9m_1.nac();
  };
  protoOf(Views).oac = function (_set____db54di) {
    this.q9m_1.oac(_set____db54di);
  };
  protoOf(Views).pac = function () {
    return this.q9m_1.pac();
  };
  protoOf(Views).qac = function (_set____db54di) {
    this.q9m_1.qac(_set____db54di);
  };
  protoOf(Views).rac = function () {
    return this.q9m_1.rac();
  };
  protoOf(Views).sac = function () {
    return this.q9m_1.sac();
  };
  protoOf(Views).tac = function (_set____db54di) {
    this.q9m_1.tac(_set____db54di);
  };
  protoOf(Views).uac = function () {
    return this.q9m_1.uac();
  };
  protoOf(Views).c9u = function (pos) {
    return this.q9m_1.c9u(pos);
  };
  protoOf(Views).k7x = function () {
    return this.m9m_1.k7x();
  };
  protoOf(Views).h7x = function () {
    return this.m9m_1.h7x();
  };
  protoOf(Views).i7x = function () {
    return this.m9m_1.i7x();
  };
  protoOf(Views).j7x = function () {
    return this.m9m_1.j7x();
  };
  protoOf(Views).ga6 = function () {
    return this.t9m_1;
  };
  protoOf(Views).ua0 = function (_set____db54di) {
    var tmp0_setValue = forceRenderEveryFrame$factory();
    return this.v9m_1.set(_set____db54di);
  };
  protoOf(Views).e9v = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = forceRenderEveryFrame$factory_0();
    tmp$ret$0 = this.v9m_1.get();
    return tmp$ret$0;
  };
  protoOf(Views).kc7 = function () {
    return replace(replace(replace(this.n9m_1, '\\', ''), '/', ''), '..', '');
  };
  protoOf(Views).ebs = function () {
    var tmp = this.b9n_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  };
  protoOf(Views).p1s = function ($completion) {
    var tmp = new $initCOROUTINE$20(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Views).ta0 = function () {
    return this.k9n_1;
  };
  protoOf(Views).va0 = function () {
    return this.h9m_1.e6i_1.e6k_1;
  };
  protoOf(Views).wa0 = function () {
    return this.h9m_1.e6i_1.f6k_1;
  };
  protoOf(Views).qc8 = function (value) {
    this.m9n_1 = numberToInt(value);
  };
  protoOf(Views).rc8 = function () {
    return this.m9n_1;
  };
  protoOf(Views).sc8 = function (value) {
    this.n9n_1 = numberToInt(value);
  };
  protoOf(Views).tc8 = function () {
    return this.n9n_1;
  };
  protoOf(Views).nc1 = function (value) {
    this.qc8(_Size___get_width__impl__58y75t(value));
    this.sc8(_Size___get_height__impl__a04p02(value));
  };
  protoOf(Views).mc1 = function () {
    return _Size___init__impl__aywn0g(this.rc8(), this.tc8());
  };
  protoOf(Views).c1c = function () {
    launchImmediately(this, Views$close$slambda_0(this, null));
  };
  protoOf(Views).uc7 = function ($completion) {
    var tmp = new $closeSuspendCOROUTINE$21(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Views).l9w = function (_set____db54di) {
    var tmp0_setValue = debugFontExtraScale$factory();
    return this.w9n_1.set(_set____db54di);
  };
  protoOf(Views).uc8 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = debugFontExtraScale$factory_0();
    tmp$ret$0 = this.w9n_1.get();
    return tmp$ret$0;
  };
  protoOf(Views).m9w = function (_set____db54di) {
    var tmp0_setValue = debugFontColor$factory();
    return this.x9n_1.set(new RGBA(_set____db54di));
  };
  protoOf(Views).vc8 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = debugFontColor$factory_0();
    tmp$ret$0 = this.x9n_1.get().q4n_1;
    return tmp$ret$0;
  };
  protoOf(Views).wbr = function (block) {
    this.y9n_1.b(block);
  };
  protoOf(Views).q6a = function (event) {
    protoOf(BaseEventListener).q6a.call(this, event);
    var e = event;
    e.x6a(this.t9m_1);
    if (e instanceof KeyEvent) {
      this.j9m_1.ta4(e);
      this.j9m_1.p9u_1.oa4(e);
      if ((e.i6b_1.equals(Type_UP_getInstance_0()) ? this.u9n_1 : false) ? e.k6b_1.equals(Key_F12_getInstance()) ? true : e.k6b_1.equals(Key_F7_getInstance()) : false) {
        this.v9n_1 = !this.v9n_1;
        this.m9m_1.n82(this.v9n_1);
        this.hay(this.s9n_1);
      }
    }
    try {
      this.s9n_1.q6a(e);
    } catch ($p) {
      if ($p instanceof PreventDefaultException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
  };
  protoOf(Views).wc8 = function () {
    this.h9m_1.k6i();
    if (this.g9n_1) {
      var tmp0_$this = this.f9n_1;
      var tmp1_color = this.h9n_1;
      tmp0_$this.bad(tmp1_color, 1.0, 0, true, true, true);
    }
    this.e9o_1.o1g(this.f9n_1);
    this.f9n_1.va3();
    this.s9n_1.mav(this.f9n_1);
    this.f9n_1.va3();
    this.s9n_1.tay(this.f9n_1);
    if (this.v9n_1) {
      var tmp$ret$7;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp3_fastForEach = this.y9n_1;
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast = tmp3_fastForEach.vp_1;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_unsafeCast;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      var array = tmp$ret$2;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.render.<anonymous>.<anonymous>' call
        var tmp$ret$6;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$4;
        // Inline function 'korlibs.datastructure.get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp1_get = tmp0;
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = array;
        tmp$ret$4 = tmp$ret$3[tmp1_get];
        var tmp2_unsafeCast = tmp$ret$4;
        var tmp$ret$5;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$5 = tmp2_unsafeCast;
        tmp$ret$6 = tmp$ret$5;
        var tmp4__anonymous__pkmkx7 = tmp$ret$6;
        tmp4__anonymous__pkmkx7(this, this.f9n_1);
      }
      tmp$ret$7 = Unit_getInstance();
    }
    this.f9o_1.o1g(this.f9n_1);
    this.f9n_1.va3();
  };
  protoOf(Views).f9v = function (fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.k9m_1.si();
    this.t9m_1.l9m_1.k6i();
    var tmp$ret$1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp1_trace = Companion_getInstance_57().q9i_1;
    var tmp0_log = Level_TRACE_getInstance();
    var tmp;
    if (tmp1_trace.zz(tmp0_log)) {
      var tmp$ret$0;
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      tmp$ret$0 = 'ag.onRender';
      tmp1_trace.a10(tmp0_log, tmp$ret$0);
      tmp = Unit_getInstance();
    }
    tmp$ret$1 = tmp;
    var delta = DateTime__minus_impl_10njw8(currentTime, this.z9n_1);
    var adelta = TimeSpan__compareTo_impl_zidry4(delta, this.t9m_1.j9n_1) > 0 ? this.t9m_1.j9n_1 : delta;
    this.z9n_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_getInstance_7().zi_1)) {
        this.xc8(fixedSizeStep);
      } else {
        this.xc8(adelta);
      }
    }
    var doRender2 = doRender ? forceRender ? true : this.yc8() > 0 : false;
    if (doRender2) {
      if (this.h9o_1) {
        println('Views.frameUpdateAndRender[' + toString(Companion_getInstance_5().ui()) + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.yc8() + ']');
      }
      this.wc8();
      this.k6i();
    }
  };
  protoOf(Views).xc8 = function (elapsed) {
    this.j9m_1.pa4(elapsed);
    this.i9o_1.dt();
    updateSingleViewWithViewsAll(this.s9n_1, this, elapsed);
    this.j9m_1.qa4(elapsed);
  };
  protoOf(Views).b9v = function () {
  };
  protoOf(Views).t9x = function (width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.c9o_1 = _SizeInt___init__impl__vivn9(actualWidth, actualHeight);
    this.zc8();
  };
  protoOf(Views).zc8 = function () {
    setBoundsInfo(this.q9m_1, _Size___init__impl__aywn0g_0(this.m9n_1, this.n9n_1), toFloat(this.c9o_1), this.p9n_1, this.q9n_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.f9n_1.e9y_1 = this.q9m_1.mac();
    this.f9n_1.f9y_1 = this.q9m_1.rac();
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = this.w9m_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    tmp0_apply.j6e_1 = _SizeInt___get_width__impl__swntg6(this.c9o_1);
    tmp0_apply.k6e_1 = _SizeInt___get_height__impl__d3sy61(this.c9o_1);
    tmp$ret$0 = tmp0_apply;
    this.s9n_1.q6a(this.w9m_1);
    this.q6a(this.w9m_1);
    this.s9n_1.jay();
  };
  protoOf(Views).ac9 = function (viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened ? !this.m9m_1.o82() : false)
      return Unit_getInstance();
    println('debugHightlightView: ' + viewToHightlight);
    this.j9o_1.o1g(viewToHightlight);
  };
  protoOf(Views).xam = function (viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.ac9(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.ac9.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  };
  protoOf(Views).bc9 = function (_set____db54di) {
    var tmp0_setValue = updatedSinceFrame$factory_0();
    return this.n9o_1.set(_set____db54di);
  };
  protoOf(Views).yc8 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = updatedSinceFrame$factory_1();
    tmp$ret$0 = this.n9o_1.get();
    return tmp$ret$0;
  };
  protoOf(Views).k6i = function () {
    this.m9m_1.k6i();
  };
  protoOf(Views).hay = function (view) {
    this.m9m_1.k83();
  };
  function Base() {
    this.cc9_1 = Companion_getInstance_23().g3g();
    this.dc9_1 = _MatrixTransform___init__impl__7axsoi();
    this.ec9_1 = Companion_getInstance_23().g3g();
    this.fc9_1 = _MatrixTransform___init__impl__7axsoi();
    var tmp = this;
    var tmp_0 = Companion_getInstance_38();
    DefaultViewport_getInstance();
    DefaultViewport_getInstance();
    tmp.gc9_1 = tmp_0.n3i(0, 0, 1280, 720);
  }
  protoOf(Base).qac = function (_set____db54di) {
    this.cc9_1 = _set____db54di;
  };
  protoOf(Base).rac = function () {
    return this.cc9_1;
  };
  protoOf(Base).tac = function (_set____db54di) {
    this.dc9_1 = _set____db54di;
  };
  protoOf(Base).uac = function () {
    return this.dc9_1;
  };
  protoOf(Base).lac = function (_set____db54di) {
    this.ec9_1 = _set____db54di;
  };
  protoOf(Base).mac = function () {
    return this.ec9_1;
  };
  protoOf(Base).oac = function (_set____db54di) {
    this.fc9_1 = _set____db54di;
  };
  protoOf(Base).pac = function () {
    return this.fc9_1;
  };
  protoOf(Base).kac = function (_set____db54di) {
    this.gc9_1 = _set____db54di;
  };
  function BoundsProvider() {
  }
  function Companion_14() {
    Companion_instance_14 = this;
  }
  var Companion_instance_14;
  function Companion_getInstance_72() {
    if (Companion_instance_14 == null)
      new Companion_14();
    return Companion_instance_14;
  }
  function UpdateEvent(deltaTime) {
    Companion_getInstance_72();
    deltaTime = deltaTime === VOID ? Companion_getInstance_7().yi_1 : deltaTime;
    Event.call(this);
    this.lb4_1 = deltaTime;
  }
  protoOf(UpdateEvent).r6a = function () {
    return Companion_getInstance_72();
  };
  protoOf(UpdateEvent).toString = function () {
    return 'UpdateEvent(time=' + new TimeSpan(this.lb4_1) + ')';
  };
  function Companion_15() {
    Companion_instance_15 = this;
  }
  var Companion_instance_15;
  function Companion_getInstance_73() {
    if (Companion_instance_15 == null)
      new Companion_15();
    return Companion_instance_15;
  }
  function ViewsUpdateEvent(views, delta) {
    Companion_getInstance_73();
    delta = delta === VOID ? Companion_getInstance_7().yi_1 : delta;
    Event.call(this);
    this.jc9_1 = views;
    this.kc9_1 = delta;
  }
  protoOf(ViewsUpdateEvent).r6a = function () {
    return Companion_getInstance_73();
  };
  protoOf(ViewsUpdateEvent).toString = function () {
    return 'ViewsUpdateEvent(time=' + new TimeSpan(this.kc9_1) + ')';
  };
  function Companion_16() {
    Companion_instance_16 = this;
  }
  var Companion_instance_16;
  function Companion_getInstance_74() {
    if (Companion_instance_16 == null)
      new Companion_16();
    return Companion_instance_16;
  }
  function ViewsResizedEvent(views, size) {
    Companion_getInstance_74();
    size = size === VOID ? _SizeInt___init__impl__vivn9(0, 0) : size;
    Event.call(this);
    this.nc9_1 = views;
    this.oc9_1 = size;
  }
  protoOf(ViewsResizedEvent).r6a = function () {
    return Companion_getInstance_74();
  };
  protoOf(ViewsResizedEvent).toString = function () {
    return 'ViewsResizedEvent(size=' + new SizeInt(this.oc9_1) + ')';
  };
  function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = views.x9m_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
    tmp0_also.lb4_1 = delta;
    tmp$ret$0 = tmp0_also;
    _this__u8e3s4.q6a(tmp$ret$0);
    var tmp$ret$1;
    // Inline function 'kotlin.also' call
    var tmp1_also = views.y9m_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
    tmp1_also.kc9_1 = delta;
    tmp$ret$1 = tmp1_also;
    _this__u8e3s4.q6a(tmp$ret$1);
  }
  function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
    scaleMode = scaleMode === VOID ? Companion_getInstance_1().g3j() : scaleMode;
    anchor = anchor === VOID ? Companion_getInstance_2().r3a() : anchor;
    virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
    targetSize = targetSize === VOID ? Ref_0() : targetSize;
    var reqVirtualSize_0 = toInt(reqVirtualSize);
    var actualSize_0 = toInt(actualSize);
    virtualSize.wt(new SizeInt(reqVirtualSize_0));
    targetSize.wt(new SizeInt(scaleMode.j3j(virtualSize.q().l3j_1, actualSize_0)));
    var ratioX = _SizeInt___get_width__impl__swntg6(targetSize.q().l3j_1) / _SizeInt___get_width__impl__swntg6(reqVirtualSize_0);
    var ratioY = _SizeInt___get_height__impl__d3sy61(targetSize.q().l3j_1) / _SizeInt___get_height__impl__d3sy61(reqVirtualSize_0);
    var actualVirtualWidth = toIntRound(_SizeInt___get_width__impl__swntg6(actualSize_0) / ratioX);
    var actualVirtualHeight = toIntRound(_SizeInt___get_height__impl__d3sy61(actualSize_0) / ratioY);
    _this__u8e3s4.lac(Matrix__pretranslated_impl_9mjs3v(Matrix__prescaled_impl_gy2bxt(Companion_getInstance_23().v3f_1, ratioX, ratioY), toIntRound((actualVirtualWidth - _SizeInt___get_width__impl__swntg6(reqVirtualSize_0) | 0) * _Anchor___get_doubleX__impl__n5i2d2(anchor)), toIntRound((actualVirtualHeight - _SizeInt___get_height__impl__d3sy61(reqVirtualSize_0) | 0) * _Anchor___get_doubleY__impl__5o4ep5(anchor))));
    _this__u8e3s4.qac(Matrix__inverted_impl_3pqbyv(_this__u8e3s4.mac()));
    _this__u8e3s4.oac(Matrix__toTransform_impl_lr8urh(_this__u8e3s4.mac()));
    _this__u8e3s4.tac(Matrix__toTransform_impl_lr8urh(_this__u8e3s4.rac()));
    var tl = _this__u8e3s4.c9u(_Vector2___init__impl__67w0ru_2(0, 0));
    var br = _this__u8e3s4.c9u(_Vector2___init__impl__67w0ru_0(_SizeInt___get_width__impl__swntg6(actualSize_0), _SizeInt___get_height__impl__d3sy61(actualSize_0)));
    _this__u8e3s4.kac(Companion_getInstance_38().s3i(_Vector2___get_x__impl__zywdz(tl), _Vector2___get_y__impl__ttldg6(tl), _Vector2___get_x__impl__zywdz(br), _Vector2___get_y__impl__ttldg6(br)));
  }
  function views($completion) {
    var tmp = new $viewsCOROUTINE$22($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function $viewsCOROUTINE$22(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($viewsCOROUTINE$22).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.hh_1 = 1;
            suspendResult = injector(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.xc9_1 = suspendResult;
            this.hh_1 = 2;
            suspendResult = this.xc9_1.r9g(getKClass(Views), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function continuousRenderMode$factory($b0) {
    return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
      return $b0.e83();
    }, function (value) {
      return $b0.d83(value);
    });
  }
  function debugExtraFontScale$factory($b0) {
    return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
      return $b0.s9y_1;
    }, function (value) {
      $b0.s9y_1 = value;
      return Unit_getInstance();
    });
  }
  function debugExtraFontColor$factory($b0) {
    return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
      return new RGBA($b0.t9y_1);
    }, function (value) {
      $b0.t9y_1 = value.q4n_1;
      return Unit_getInstance();
    });
  }
  function updatedSinceFrame$factory($b0) {
    return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
      return $b0.t7z_1;
    }, function (value) {
      $b0.t7z_1 = value;
      return Unit_getInstance();
    });
  }
  function forceRenderEveryFrame$factory() {
    return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
      return receiver.e9v();
    }, function (receiver, value) {
      return receiver.ua0(value);
    });
  }
  function forceRenderEveryFrame$factory_0() {
    return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
      return receiver.e9v();
    }, function (receiver, value) {
      return receiver.ua0(value);
    });
  }
  function debugFontExtraScale$factory() {
    return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
      return receiver.uc8();
    }, function (receiver, value) {
      return receiver.l9w(value);
    });
  }
  function debugFontExtraScale$factory_0() {
    return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
      return receiver.uc8();
    }, function (receiver, value) {
      return receiver.l9w(value);
    });
  }
  function debugFontColor$factory() {
    return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver.vc8());
    }, function (receiver, value) {
      return receiver.m9w(value.q4n_1);
    });
  }
  function debugFontColor$factory_0() {
    return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver.vc8());
    }, function (receiver, value) {
      return receiver.m9w(value.q4n_1);
    });
  }
  function virtualSize$factory($b0) {
    return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
      return new SizeInt($b0.b9o_1);
    }, function (value) {
      $b0.b9o_1 = value.l3j_1;
      return Unit_getInstance();
    });
  }
  function targetSize$factory($b0) {
    return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
      return new SizeInt($b0.d9o_1);
    }, function (value) {
      $b0.d9o_1 = value.l3j_1;
      return Unit_getInstance();
    });
  }
  function updatedSinceFrame$factory_0() {
    return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
      return receiver.yc8();
    }, function (receiver, value) {
      return receiver.bc9(value);
    });
  }
  function updatedSinceFrame$factory_1() {
    return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
      return receiver.yc8();
    }, function (receiver, value) {
      return receiver.bc9(value);
    });
  }
  var renderToTextureResultPool$delegate;
  function Companion_17() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.floatArrayOf' call
    tmp$ret$0 = new Float32Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
    tmp.yc9_1 = tmp$ret$0;
  }
  protoOf(Companion_17).zc9 = function (scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var tmp0_minByOrNull = this.yc9_1;
      var tmp$ret$0;
      // Inline function 'kotlin.collections.isEmpty' call
      tmp$ret$0 = tmp0_minByOrNull.length === 0;
      if (tmp$ret$0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = tmp0_minByOrNull[0];
      var lastIndex = get_lastIndex_1(tmp0_minByOrNull);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      var tmp$ret$3;
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      var tmp1__anonymous__uwfjfc = minElem;
      var tmp$ret$2;
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp0__get_absoluteValue__nukmtt = scale - tmp1__anonymous__uwfjfc;
      tmp$ret$2 = Math.abs(tmp0__get_absoluteValue__nukmtt);
      tmp$ret$3 = tmp$ret$2;
      var minValue = tmp$ret$3;
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = tmp0_minByOrNull[i];
          var tmp$ret$5;
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          var tmp$ret$4;
          // Inline function 'kotlin.math.absoluteValue' call
          var tmp0__get_absoluteValue__nukmtt_0 = scale - e;
          tmp$ret$4 = Math.abs(tmp0__get_absoluteValue__nukmtt_0);
          tmp$ret$5 = tmp$ret$4;
          var v = tmp$ret$5;
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  };
  var Companion_instance_17;
  function Companion_getInstance_75() {
    if (Companion_instance_17 == null)
      new Companion_17();
    return Companion_instance_17;
  }
  function Filter() {
  }
  function expandedBorderRectangle(_this__u8e3s4, inp) {
    _init_properties_Filter_kt__xu8pbc();
    return Rectangle__expanded_impl_r32sv9(inp, getBorder(_this__u8e3s4, toIntCeil(_Rectangle___get_width__impl__y1u79l(inp)), toIntCeil(_Rectangle___get_height__impl__kro6o8(inp))));
  }
  function RenderToTextureResult() {
    this.dca_1 = null;
    this.eca_1 = 0;
    this.fca_1 = 0;
    this.gca_1 = 0;
    this.hca_1 = 0;
    this.ica_1 = 1.0;
    this.jca_1 = Companion_getInstance_23().v3f_1;
    this.kca_1 = null;
    this.lca_1 = null;
    this.mca_1 = null;
    this.nca_1 = null;
  }
  protoOf(RenderToTextureResult).p13 = function () {
    if (this.lca_1 == null ? true : this.nca_1 == null)
      return Unit_getInstance();
    var tmp0_safe_receiver = this.lca_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.nca_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.gad(tmp0_safe_receiver);
        tmp = Unit_getInstance();
      }
      tmp$ret$0 = tmp;
      tmp$ret$1 = tmp$ret$0;
    }
    this.dca_1 = null;
    this.kca_1 = null;
    this.lca_1 = null;
    this.nca_1 = null;
    this.mca_1 = null;
  };
  function getBorder(_this__u8e3s4, texWidth, texHeight) {
    _init_properties_Filter_kt__xu8pbc();
    return _this__u8e3s4.bca(texWidth, texHeight);
  }
  function renderToTextureResultPool$delegate$lambda() {
    _init_properties_Filter_kt__xu8pbc();
    var tmp = renderToTextureResultPool$delegate$lambda$lambda;
    return new Pool(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
  }
  function renderToTextureResultPool$delegate$lambda$lambda(it) {
    _init_properties_Filter_kt__xu8pbc();
    it.p13();
    return Unit_getInstance();
  }
  function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
    _init_properties_Filter_kt__xu8pbc();
    return new RenderToTextureResult();
  }
  var properties_initialized_Filter_kt_lkm0w6;
  function _init_properties_Filter_kt__xu8pbc() {
    if (properties_initialized_Filter_kt_lkm0w6) {
    } else {
      properties_initialized_Filter_kt_lkm0w6 = true;
      renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
    }
  }
  function Companion_18() {
    Companion_instance_18 = this;
    IdentityFilter.call(this, true);
  }
  var Companion_instance_18;
  function Companion_getInstance_76() {
    if (Companion_instance_18 == null)
      new Companion_18();
    return Companion_instance_18;
  }
  function IdentityFilter(smoothing) {
    Companion_getInstance_76();
    this.oca_1 = smoothing;
  }
  protoOf(IdentityFilter).cca = function (ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    var tmp$ret$1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var tmp$ret$0;
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var tmp1_use = ctx.u9y_1;
    var tmp0_useBatcher = tmp1_use.qa2_1;
    if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
      tmp0_useBatcher.y9y_1 = tmp1_use;
      tmp0_useBatcher.va3();
    }
    tmp1_use.xa3(texture, VOID, VOID, VOID, VOID, matrix, this.oca_1, renderColorMul, blendMode, Companion_getInstance_62().m9j_1);
    tmp$ret$0 = Unit_getInstance();
    tmp$ret$1 = tmp$ret$0;
  };
  function get_backdropFilter(_this__u8e3s4) {
    var tmp$ret$2;
    // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
    var tmp0_safe_receiver = _this__u8e3s4.l9q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp0_safe_receiver.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          var tmp$ret$0;
          // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
          tmp$ret$0 = element instanceof ViewRenderPhaseBackdropFilter;
          if (tmp$ret$0) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var tmp_0 = tmp;
    tmp$ret$2 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
    var tmp0_safe_receiver_0 = tmp$ret$2;
    return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.pca_1;
  }
  function ViewRenderPhaseBackdropFilter() {
  }
  function set_filterScale(_this__u8e3s4, _set____db54di) {
    _init_properties_ViewFilter_kt__pd9xp9();
    var tmp1_setValue = filterScale$factory();
    var tmp0_setValueUntransformed = filterScale$delegate.ru_1(_this__u8e3s4, _set____db54di);
    var tmp0_elvis_lhs = filterScale$delegate.pu_1;
    setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp1_setValue.callableName : tmp0_elvis_lhs, tmp0_setValueUntransformed);
    return Unit_getInstance();
  }
  function get_filterScale(_this__u8e3s4) {
    _init_properties_ViewFilter_kt__pd9xp9();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var tmp0_getValue = filterScale$factory_0();
      var tmp0_elvis_lhs = filterScale$delegate.pu_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp0_getValue.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = filterScale$delegate.qu_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = filterScale$delegate.pu_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp0_getValue.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var filterScale$delegate;
  function renderFiltered(_this__u8e3s4, ctx, filter, first) {
    first = first === VOID ? true : first;
    _init_properties_ViewFilter_kt__pd9xp9();
    var bounds = _this__u8e3s4.jb1(VOID, false);
    if (_Rectangle___get_width__impl__y1u79l(bounds) <= 0.0 ? true : _Rectangle___get_height__impl__kro6o8(bounds) <= 0.0)
      return Unit_getInstance();
    var tmp = Companion_getInstance_75();
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = get_filterScale(_this__u8e3s4);
    var tmp1_min = filter.aca();
    tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
    var tryFilterScale = tmp.zc9(tmp$ret$0);
    var texWidthNoBorder = coerceAtLeast(numberToInt(_Rectangle___get_width__impl__y1u79l(bounds) * tryFilterScale), 1);
    var texHeightNoBorder = coerceAtLeast(numberToInt(_Rectangle___get_height__impl__kro6o8(bounds) * tryFilterScale), 1);
    var realFilterScale = clamp(texWidthNoBorder / _Rectangle___get_width__impl__y1u79l(bounds), 0.03125, 1.0);
    var tmp0_subject = false;
    var tmp_0;
    switch (tmp0_subject) {
      case true:
        tmp_0 = clamp_1(toIntCeil_0(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
        break;
      case false:
        tmp_0 = 0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var edgeSize = tmp_0;
    var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
    var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
    var addx = -_Rectangle___get_x__impl__vgifdj(bounds) + edgeSize;
    var addy = -_Rectangle___get_y__impl__aqz5je(bounds) + edgeSize;
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
    ctx.va3();
    // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
    var rb = ctx.fad(texWidth, texHeight, false, true, 1);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.g9z(rb);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        var tmp$ret$5;
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var tmp$ret$4;
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var tmp1_use = ctx.u9y_1;
        var tmp0_useBatcher = tmp1_use.qa2_1;
        if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
          tmp0_useBatcher.y9y_1 = tmp1_use;
          tmp0_useBatcher.va3();
        }
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var tmp0_scissor = _AGScissor___init__impl__g8s683(0, 0, rb.e6k_1, rb.f6k_1);
          var temp = tmp1_use.oa3_1;
          tmp1_use.uaa();
          tmp1_use.oa3_1 = tmp0_scissor;
          try {
            {
              ctx.bad(Colors_getInstance().o48_1);
            }
            var mat = Matrix__scaled$default_impl_qe0yl1(Matrix__translated_impl_3xg5y(_this__u8e3s4.lb0(), addx, addy), realFilterScale);
            var tmp$ret$2;
            // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
            var tmp4_setViewMatrixTemp = ctx.u9y_1;
            var tmp3_setViewMatrixTemp = tmp4_setViewMatrixTemp.qa2_1;
            tmp3_setViewMatrixTemp.va3();
            var temp4 = tmp3_setViewMatrixTemp.h9y_1;
            var temp2d = tmp3_setViewMatrixTemp.i9y_1;
            tmp3_setViewMatrixTemp.i9y_1 = mat;
            tmp3_setViewMatrixTemp.h9y_1 = toMatrix4(mat);
            var tmp$ret$1;
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var tmp0_push = tmp3_setViewMatrixTemp.i6p(ProjViewUB_getInstance());
              var tmp0_this = tmp0_push;
              var tmp1 = tmp0_this.x6q();
              tmp0_this.a7b(tmp1 + 1 | 0);
              tmp0_push.tn(tmp0_push.x6q() + 1 | 0);
              var blockSize = tmp0_push.a6p_1;
              var index0 = imul(tmp0_push.x6q() - 1 | 0, blockSize);
              var index1 = imul(tmp0_push.x6q(), blockSize);
              var texBlockSize = tmp0_push.y6o_1.t6x().j();
              var texIndex0 = imul(tmp0_push.x6q() - 1 | 0, texBlockSize);
              var texIndex1 = imul(tmp0_push.x6q(), texBlockSize);
              if (tmp0_push.x6q() > 0) {
                arraycopy_2(tmp0_push.c6p_1, index0, tmp0_push.c6p_1, index1, blockSize);
              } else {
                arrayfill_0(tmp0_push.c6p_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var tmp1__anonymous__uwfjfc = tmp0_push.y6o_1;
              var tmp2__anonymous__z9zvc9 = tmp0_push.d6p_1;
              tmp2__anonymous__z9zvc9.h7b(tmp1__anonymous__uwfjfc.s6x(), tmp3_setViewMatrixTemp.h9y_1);
              if (tmp0_push.x6q() >= 1) {
                var equals = arrayequal(tmp0_push.c6p_1, index0, tmp0_push.c6p_1, index1, blockSize);
                if (equals) {
                  var tmp2_this = tmp0_push;
                  var tmp3 = tmp2_this.x6q();
                  tmp2_this.a7b(tmp3 - 1 | 0);
                  tmp$ret$1 = false;
                  break $l$block;
                }
              }
              tmp$ret$1 = true;
            }
            var tmp_1;
            try {
              var tmp_2;
              if (first) {
                _this__u8e3s4.rb0(ctx);
                tmp_2 = Unit_getInstance();
              } else {
                _this__u8e3s4.sb0(ctx);
                tmp_2 = Unit_getInstance();
              }
              tmp_1 = tmp_2;
            }finally {
              tmp3_setViewMatrixTemp.va3();
              tmp3_setViewMatrixTemp.h9y_1 = temp4;
              tmp3_setViewMatrixTemp.i9y_1 = temp2d;
              tmp3_setViewMatrixTemp.i6p(ProjViewUB_getInstance()).b7b();
            }
            tmp$ret$2 = tmp_1;
            tmp$ret$3 = tmp$ret$2;
            break $l$block_0;
          }finally {
            tmp1_use.uaa();
            tmp1_use.oa3_1 = temp;
          }
        }
        tmp$ret$4 = tmp$ret$3;
        tmp$ret$5 = tmp$ret$4;
      }finally {
        ctx.h9z();
      }
      // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
      var tmp2__anonymous__z9zvc9_0 = Texture(rb).t3s(0, 0, texWidth, texHeight);
      var mat_0 = Matrix__prescaled$default_impl_m96zqs_0(Matrix__pretranslated_impl_9mjs3v_0(_this__u8e3s4.kb0(), -addx, -addy), 1.0 / realFilterScale);
      filter.cca(ctx, mat_0, tmp2__anonymous__z9zvc9_0, texWidth, texHeight, _this__u8e3s4.ob0(), _this__u8e3s4.f9p_1, realFilterScale);
      ctx.va3();
    }finally {
      ctx.gad(rb);
    }
  }
  function get_filter(_this__u8e3s4) {
    _init_properties_ViewFilter_kt__pd9xp9();
    var tmp$ret$2;
    // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
    var tmp0_safe_receiver = _this__u8e3s4.l9q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp0_safe_receiver.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          var tmp$ret$0;
          // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
          tmp$ret$0 = element instanceof ViewRenderPhaseFilter;
          if (tmp$ret$0) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var tmp_0 = tmp;
    tmp$ret$2 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
    var tmp0_safe_receiver_0 = tmp$ret$2;
    return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.qca_1;
  }
  function ViewRenderPhaseFilter() {
  }
  function filterScale$delegate$lambda($this$extraPropertyThis, it) {
    _init_properties_ViewFilter_kt__pd9xp9();
    return Companion_getInstance_75().zc9(it);
  }
  function filterScale$delegate$lambda_0($this$extraPropertyThis) {
    _init_properties_ViewFilter_kt__pd9xp9();
    return 1.0;
  }
  function filterScale$factory() {
    return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
      return get_filterScale(receiver);
    }, function (receiver, value) {
      return set_filterScale(receiver, value);
    });
  }
  function filterScale$factory_0() {
    return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
      return get_filterScale(receiver);
    }, function (receiver, value) {
      return set_filterScale(receiver, value);
    });
  }
  var properties_initialized_ViewFilter_kt_mku9up;
  function _init_properties_ViewFilter_kt__pd9xp9() {
    if (properties_initialized_ViewFilter_kt_mku9up) {
    } else {
      properties_initialized_ViewFilter_kt_mku9up = true;
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.extraPropertyThis' call
      var tmp1_extraPropertyThis = filterScale$delegate$lambda;
      var tmp2_extraPropertyThis = filterScale$delegate$lambda_0;
      var tmp$ret$0;
      // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
      var tmp0_withTransform = new PropertyThis(null, tmp2_extraPropertyThis);
      tmp0_withTransform.ru_1 = tmp1_extraPropertyThis;
      tmp$ret$0 = tmp0_withTransform;
      tmp$ret$1 = tmp$ret$0;
      filterScale$delegate = tmp$ret$1;
    }
  }
  function _get_shapeBounds__actvvf($this) {
    var valid = $this.abx_1 ? $this.lbx_1 : $this.kbx_1;
    if (!valid) {
      if ($this.abx_1)
        $this.lbx_1 = true;
      else
        $this.kbx_1 = true;
      var result = $this.ibx_1.k64($this.abx_1);
      if ($this.abx_1)
        $this.obx_1 = result;
      else
        $this.nbx_1 = result;
      return result;
    }
    return $this.abx_1 ? $this.obx_1 : $this.nbx_1;
  }
  function invalidateShape($this) {
    $this.mbx_1 = 0;
    $this.jbx_1 = false;
    $this.kbx_1 = false;
    $this.lbx_1 = false;
    $this.fay();
  }
  function requireShape($this) {
    if ($this.jbx_1)
      return Unit_getInstance();
    $this.jbx_1 = true;
    $this.bbx_1.v2();
    $this.bbx_1.bcb();
    $this.bbx_1.ccb(Companion_getInstance_32().r6j_1);
    $this.pbx_1 = true;
    renderShape($this, $this.ibx_1);
    $this.bbx_1.i6i();
    $this.rbx_1 = $this.qbx_1;
  }
  function renderCommands($this, ctx, doRequireTexture) {
    var mat = doRequireTexture ? Matrix__times_impl_aro03c($this.kb0(), _Matrix___get_immutable__impl__k08qr(ctx.v9x_1.mac())) : $this.kb0();
    $this.sbx_1 = Matrix__pretranslated_impl_9mjs3v_0(mat, -$this.zay(), -$this.aaz());
    requireShape($this);
    $this.bbx_1.dcb(ctx, $this.sbx_1, $this.jb0(), $this.fbx_1, $this.ob0(), doRequireTexture);
  }
  function renderShape($this, shape) {
    var tmp0_subject = shape;
    if (equals(tmp0_subject, EmptyShape_getInstance()))
    ;
    else {
      if (tmp0_subject instanceof CompoundShape) {
        var tmp1_iterator = shape.x64_1.g();
        while (tmp1_iterator.h()) {
          var v = tmp1_iterator.i();
          renderShape($this, v);
        }
      } else {
        if (tmp0_subject instanceof TextShape) {
          renderShape($this, shape.p65());
        } else {
          if (tmp0_subject instanceof FillShape) {
            var tmp2_this = $this;
            var tmp3 = tmp2_this.mbx_1;
            tmp2_this.mbx_1 = tmp3 + 1 | 0;
            if ($this.mbx_1 > $this.tbx_1)
              return Unit_getInstance();
            renderFill($this, shape);
          } else {
            if (tmp0_subject instanceof PolylineShape) {
              var tmp4_this = $this;
              var tmp5 = tmp4_this.mbx_1;
              tmp4_this.mbx_1 = tmp5 + 1 | 0;
              if ($this.mbx_1 > $this.tbx_1)
                return Unit_getInstance();
              renderStroke$default($this, shape.c65_1, shape.z64_1, shape.b65_1, shape.e65_1, shape.d65_1);
            } else {
              var tmp0_TODO = 'shape=' + shape;
              throw new NotImplementedError('An operation is not implemented: ' + tmp0_TODO);
            }
          }
        }
      }
    }
  }
  function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
    var gpuShapeViewCommands = $this.bbx_1;
    var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
    gpuShapeViewCommands.ccb(Companion_getInstance_32().r6j_1);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < pointsList.j()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp0__anonymous__q1qw7t = pointsList.k(tmp0);
      var startIndex = gpuShapeViewCommands.ecb();
      var vector = tmp0__anonymous__q1qw7t.d3p();
      // Inline function 'korlibs.math.geom.fastForEachGeneric' call
      var inductionVariable = 0;
      var last = vector.j();
      if (inductionVariable < last)
        do {
          var n_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
          var x = vector.fk(n_0, 0);
          var y = vector.fk(n_0, 1);
          var dx = vector.fk(n_0, 2);
          var dy = vector.fk(n_0, 3);
          var len = vector.fk(n_0, 4);
          var tmp$ret$0;
          // Inline function 'kotlin.math.absoluteValue' call
          var tmp0__get_absoluteValue__nukmtt = vector.fk(n_0, 5);
          tmp$ret$0 = Math.abs(tmp0__get_absoluteValue__nukmtt);
          var maxLen = tmp$ret$0;
          var px = x + dx * len;
          var py = y + dy * len;
          gpuShapeViewCommands.fcb(px, py, $this.hbx_1 ? len : 0.0, $this.hbx_1 ? maxLen : $this.vbx_1);
        }
         while (inductionVariable < last);
      var endIndex = gpuShapeViewCommands.gcb();
      var info = GpuShapeViewPrograms_getInstance().zcb(stateTransform, paint, globalAlpha, strokeInfo.m3o_1);
      var tmp0_drawType = Companion_getInstance_34().j6t_1;
      var tmp1_blendMode = Companion_getInstance_67().wa1_1;
      gpuShapeViewCommands.acc(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
    }
  }
  function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
    forceClosed = forceClosed === VOID ? null : forceClosed;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_31().f6j_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_30().d6j_1 : stencilRef;
    return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
  }
  function PointsResult(bounds, vertexCount, vertexStart, vertexEnd) {
    this.bcc_1 = bounds;
    this.ccc_1 = vertexCount;
    this.dcc_1 = vertexStart;
    this.ecc_1 = vertexEnd;
  }
  function getPointsForPath($this, points, type) {
    if (points.j() < 3)
      return null;
    var vertexStart = $this.bbx_1.ecb();
    var bb = BoundsBuilder__plus_impl_cz7f7x_0(Companion_getInstance_45().f3b(), points);
    var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
    var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
    var pMid = _Vector2___init__impl__67w0ru(xMid, yMid);
    var isStrip = type === Companion_getInstance_34().j6t_1;
    var antialiased = $this.hbx_1;
    var isStripAndAntialiased = antialiased ? isStrip : false;
    if (!isStrip) {
      $this.bbx_1.fcb(xMid, yMid, 0.0, $this.vbx_1);
    }
    var inductionVariable = 0;
    var last = points.j() + 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var p = points.p3b(n % points.j() | 0);
        var tmp1_container = p;
        var x = Vector2__component1_impl_k3h45m(tmp1_container);
        var y = Vector2__component2_impl_kkiqjt(tmp1_container);
        var len = isStripAndAntialiased ? Companion_getInstance_9().p3j(p, pMid) : 0.0;
        var maxLen = isStripAndAntialiased ? len : $this.vbx_1;
        if (isStrip) {
          $this.bbx_1.fcb(xMid, yMid, 0.0, maxLen);
        }
        $this.bbx_1.fcb(x, y, len, maxLen);
      }
       while (inductionVariable < last);
    var vertexEnd = $this.bbx_1.gcb();
    return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.j() + 2 | 0, vertexStart, vertexEnd);
  }
  function getPointsForPath_0($this, path, type) {
    return getPointsForPath($this, get_cachedPoints(path), type);
  }
  function getPointsForPathList($this, path, type) {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp1_mapNotNull = getPoints2List(path);
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp1_mapNotNull.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
      tmp$ret$0 = getPointsForPath($this, element, type);
      var tmp0_safe_receiver = tmp$ret$0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.b(tmp0_safe_receiver);
        tmp$ret$1 = Unit_getInstance();
      }
    }
    tmp$ret$2 = tmp0_mapNotNullTo;
    tmp$ret$3 = tmp$ret$2;
    return tmp$ret$3;
  }
  function renderFill($this, shape) {
    var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().zcb(shape.o64_1, shape.n64_1, shape.p64_1, 1.0E7);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var paintShader = tmp;
    var drawFill = !$this.ubx_1;
    var drawAntialiasingBorder = $this.ubx_1 ? true : $this.hbx_1;
    var shapeIsConvex = shape.v64();
    var isSimpleDraw = (shapeIsConvex ? shape.m64_1 == null : false) ? !$this.ubx_1 : false;
    var pathDataList = getPointsForPathList($this, shape.l64_1, isSimpleDraw ? Companion_getInstance_34().j6t_1 : Companion_getInstance_34().k6t_1);
    var tmp$ret$1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    var bb = Companion_getInstance_45().f3b();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < pathDataList.j()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp0__anonymous__q1qw7t = pathDataList.k(tmp0);
      bb = plus_0(bb, tmp0__anonymous__q1qw7t.bcc_1);
    }
    tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
    tmp$ret$1 = tmp$ret$0;
    var pathBoundsNoExpanded = tmp$ret$1;
    var pathBounds = toAGScissor(Rectangle__expanded_impl_r32sv9(pathBoundsNoExpanded, _MarginInt___init__impl__dx1aag(2)));
    var clipDataStart = $this.bbx_1.ecb();
    var tmp1_safe_receiver = shape.m64_1;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp$ret$3;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$2;
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      tmp$ret$2 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_34().k6t_1);
      tmp$ret$3 = tmp$ret$2;
      tmp_0 = tmp$ret$3;
    }
    var clipData = tmp_0;
    var clipDataEnd = $this.bbx_1.gcb();
    var tmp2_safe_receiver = clipData;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.bcc_1;
    var tmp_1;
    var tmp_2 = tmp3_elvis_lhs;
    if ((tmp_2 == null ? null : new AGScissor(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_32().r6j_1;
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    var clipBounds = tmp_1;
    if (!isSimpleDraw ? true : $this.pbx_1) {
      $this.pbx_1 = true;
      $this.bbx_1.ccb(isSimpleDraw ? Companion_getInstance_32().r6j_1 : !equals(clipBounds, Companion_getInstance_32().r6j_1) ? Companion_getInstance_32().h6s(pathBounds, clipBounds) : pathBounds);
    }
    if (isSimpleDraw) {
      $this.pbx_1 = false;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < pathDataList.j()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
        var tmp0_0 = n_0;
        n_0 = tmp0_0 + 1 | 0;
        var tmp0__anonymous__q1qw7t_0 = pathDataList.k(tmp0_0);
        var tmp0_$this = $this.bbx_1;
        var tmp1_drawType = Companion_getInstance_34().j6t_1;
        var tmp2_startIndex = tmp0__anonymous__q1qw7t_0.dcc_1;
        var tmp3_endIndex = tmp0__anonymous__q1qw7t_0.ecc_1;
        var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
        var tmp5_blendMode = $this.nb0();
        tmp0_$this.acc(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
      }
      return Unit_getInstance();
    }
    var winding = shape.l64_1.b3o_1;
    var stencilReferenceValue = 1;
    var stencilCompare = Companion_getInstance_51().j6r_1;
    if (drawFill) {
      var tmp4_subject = winding;
      var tmp0_1 = tmp4_subject.j5_1;
      if (tmp0_1 === 0) {
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_51().j6r_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_31().f6j_1, true), Companion_getInstance_51().i6r_1), Companion_getInstance_52().u6r_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_30().d6j_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n_1 = 0;
        while (n_1 < pathDataList.j()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var tmp0_2 = n_1;
          n_1 = tmp0_2 + 1 | 0;
          var tmp1__anonymous__uwfjfc = pathDataList.k(tmp0_2);
          writeStencil($this, tmp1__anonymous__uwfjfc.dcc_1, tmp1__anonymous__uwfjfc.ecc_1, stencilOpFunc, stencilRef, Companion_getInstance_53().t6j_1);
        }
      } else if (tmp0_1 === 1) {
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_51().p6r_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_31().f6j_1, true), Companion_getInstance_51().i6r_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_30().d6j_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n_2 = 0;
        while (n_2 < pathDataList.j()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var tmp0_3 = n_2;
          n_2 = tmp0_3 + 1 | 0;
          var tmp2__anonymous__z9zvc9 = pathDataList.k(tmp0_3);
          writeStencil($this, tmp2__anonymous__z9zvc9.dcc_1, tmp2__anonymous__z9zvc9.ecc_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_52().t6r_1, Companion_getInstance_52().r6r_1), stencilRef_0, Companion_getInstance_53().t6j_1);
        }
      }
      if (!(clipData == null)) {
        if (winding.equals(Winding_NON_ZERO_getInstance())) {
          writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_31().f6j_1, true), Companion_getInstance_51().p6r_1), Companion_getInstance_52().u6r_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_30().d6j_1, 0), 255), Companion_getInstance_53().u6j_1);
        }
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_31().f6j_1, true), Companion_getInstance_51().i6r_1), Companion_getInstance_52().u6r_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_30().d6j_1, 2), Companion_getInstance_53().w6j_1);
        stencilReferenceValue = 3;
      }
    }
    if (drawAntialiasingBorder ? shape.m64_1 == null : false) {
      renderStroke($this, shape.o64_1, shape.l64_1, shape.n64_1, shape.p64_1, new StrokeInfo(1.6 / $this.qbx_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_31().f6j_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_31().f6j_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_30().d6j_1, stencilReferenceValue), 0));
    }
    if (drawFill) {
      writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
      $this.bbx_1.j76(0);
    }
  }
  function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
    var tmp0_$this = $this.bbx_1;
    var tmp1_drawType = Companion_getInstance_34().k6t_1;
    var tmp2_paintShader = GpuShapeViewPrograms_getInstance().ycb_1;
    var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
    var tmp4_blendMode = Companion_getInstance_67().ya1_1;
    tmp0_$this.fcc(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
  }
  function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
    var vstart = $this.bbx_1.ecb();
    var x0 = _AGScissor___get_left__impl__jiavfz(pathBounds);
    var y0 = _AGScissor___get_top__impl__wmf8dv(pathBounds);
    var x1 = _AGScissor___get_right__impl__3hpzkc(pathBounds);
    var y1 = _AGScissor___get_bottom__impl__6wmhqj(pathBounds);
    $this.bbx_1.fcb(x0, y0, 0.0, $this.vbx_1);
    $this.bbx_1.fcb(x1, y0, 0.0, $this.vbx_1);
    $this.bbx_1.fcb(x1, y1, 0.0, $this.vbx_1);
    $this.bbx_1.fcb(x0, y1, 0.0, $this.vbx_1);
    var vend = $this.bbx_1.gcb();
    var tmp0_$this = $this.bbx_1;
    var tmp1_drawType = Companion_getInstance_34().k6t_1;
    var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
    var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_31().f6j_1, true), stencilCompare);
    var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_30().d6j_1, stencilReferenceValue), 0);
    var tmp5_blendMode = $this.nb0();
    tmp0_$this.acc(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
  }
  function GpuShapeView(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_getInstance() : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    View_init_$Init$(this);
    this.xbw_1 = autoScaling;
    this.ybw_1 = true;
    this.zbw_1 = true;
    this.abx_1 = true;
    this.bbx_1 = new GpuShapeViewCommands();
    this.cbx_1 = 1000;
    this.dbx_1 = 1000;
    this.ebx_1 = Companion_getInstance_2().i3a_1;
    this.fbx_1 = true;
    this.gbx_1 = false;
    this.hbx_1 = antialiased;
    this.ibx_1 = shape;
    this.jbx_1 = false;
    this.kbx_1 = false;
    this.lbx_1 = false;
    this.mbx_1 = 0;
    this.nbx_1 = Companion_getInstance_38().p3i();
    this.obx_1 = Companion_getInstance_38().p3i();
    this.pbx_1 = false;
    this.qbx_1 = 1.0;
    var tmp = this;
    FloatCompanionObject_getInstance();
    tmp.rbx_1 = NaN;
    this.sbx_1 = Companion_getInstance_23().g3g();
    this.tbx_1 = 100000;
    this.ubx_1 = false;
    this.vbx_1 = 10000.0;
    invalidateShape(this);
  }
  protoOf(GpuShapeView).ib8 = function (value) {
    this.ebx_1 = value;
    this.jay();
  };
  protoOf(GpuShapeView).mbg = function () {
    return this.ebx_1;
  };
  protoOf(GpuShapeView).xbx = function (value) {
    this.hbx_1 = value;
    invalidateShape(this);
  };
  protoOf(GpuShapeView).wbx = function (value) {
    this.ibx_1 = value;
    invalidateShape(this);
  };
  protoOf(GpuShapeView).zay = function () {
    return _Rectangle___get_width__impl__y1u79l(_get_shapeBounds__actvvf(this)) * _Anchor___get_sx__impl__4wuc7c(this.mbg());
  };
  protoOf(GpuShapeView).aaz = function () {
    return _Rectangle___get_height__impl__kro6o8(_get_shapeBounds__actvvf(this)) * _Anchor___get_sy__impl__xqgt9j(this.mbg());
  };
  protoOf(GpuShapeView).jay = function () {
    protoOf(View).jay.call(this);
    invalidateShape(this);
  };
  protoOf(GpuShapeView).nav = function () {
    return Companion_getInstance_38().o3i(_Rectangle___get_x__impl__vgifdj(_get_shapeBounds__actvvf(this)) - this.pc6(), _Rectangle___get_y__impl__aqz5je(_get_shapeBounds__actvvf(this)) - this.qc6(), _Rectangle___get_width__impl__y1u79l(_get_shapeBounds__actvvf(this)), _Rectangle___get_height__impl__kro6o8(_get_shapeBounds__actvvf(this)));
  };
  protoOf(GpuShapeView).gcc = function (_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp;
    if (equals(tmp0_subject, EmptyShape_getInstance())) {
      tmp = false;
    } else {
      if (tmp0_subject instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp0_any = _this__u8e3s4.x64_1;
          var tmp_0;
          if (isInterface(tmp0_any, Collection)) {
            tmp_0 = tmp0_any.l();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = tmp0_any.g();
          while (tmp0_iterator.h()) {
            var element = tmp0_iterator.i();
            var tmp$ret$1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            tmp$ret$1 = this.gcc(element);
            if (tmp$ret$1) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (tmp0_subject instanceof TextShape) {
          tmp = this.gcc(_this__u8e3s4.p65());
        } else {
          if (tmp0_subject instanceof FillShape) {
            tmp = !_this__u8e3s4.v64();
          } else {
            if (tmp0_subject instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(GpuShapeView).qav = function (ctx) {
    this.qbx_1 = _MatrixTransform___get_scaleAvg__impl__ku8ljx(Matrix__toTransform_impl_lr8urh(this.kb0())) * ctx.v9x_1.nac();
    if (!(this.rbx_1 === this.qbx_1)) {
      invalidateShape(this);
    }
    ctx.va3();
    var doRequireTexture = this.gcc(this.ibx_1);
    var tmp$ret$6;
    // Inline function 'korlibs.time.measureTime' call
    var start = PerformanceCounter_getInstance().ij();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.u9x_1.e6i_1;
      this.cbx_1 = currentFrameBuffer.e6k_1;
      this.dbx_1 = currentFrameBuffer.f6k_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var tmp0_renderToTexture = this.cbx_1;
      var tmp1_renderToTexture = this.dbx_1;
      ctx.va3();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.fad(tmp0_renderToTexture, tmp1_renderToTexture, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.g9z(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          var tmp$ret$2;
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          var tmp$ret$1;
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var tmp1_use = ctx.u9y_1;
          var tmp0_useBatcher = tmp1_use.qa2_1;
          if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
            tmp0_useBatcher.y9y_1 = tmp1_use;
            tmp0_useBatcher.va3();
          }
          var tmp$ret$0;
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var tmp0_scissor = _AGScissor___init__impl__g8s683(0, 0, rb.e6k_1, rb.f6k_1);
            var temp = tmp1_use.oa3_1;
            tmp1_use.uaa();
            tmp1_use.oa3_1 = tmp0_scissor;
            try {
              {
                ctx.bad(Colors_getInstance().o48_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              tmp$ret$0 = Unit_getInstance();
              break $l$block;
            }finally {
              tmp1_use.uaa();
              tmp1_use.oa3_1 = temp;
            }
          }
          tmp$ret$1 = tmp$ret$0;
          tmp$ret$2 = tmp$ret$1;
        }finally {
          ctx.h9z();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var tmp2__anonymous__z9zvc9 = Texture(rb).t3s(0, 0, tmp0_renderToTexture, tmp1_renderToTexture);
        var tmp$ret$4;
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var tmp$ret$3;
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var tmp1_use_0 = ctx.u9y_1;
        var tmp0_useBatcher_0 = tmp1_use_0.qa2_1;
        if (!(tmp0_useBatcher_0.y9y_1 === tmp1_use_0)) {
          tmp0_useBatcher_0.y9y_1 = tmp1_use_0;
          tmp0_useBatcher_0.va3();
        }
        tmp1_use_0.xa3(tmp2__anonymous__z9zvc9, VOID, VOID, VOID, VOID, _Matrix___get_immutable__impl__k08qr(ctx.v9x_1.rac()));
        tmp$ret$3 = Unit_getInstance();
        tmp$ret$4 = tmp$ret$3;
        ctx.va3();
      }finally {
        ctx.gad(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var end = PerformanceCounter_getInstance().ij();
    var tmp$ret$5;
    // Inline function 'korlibs.time.microseconds' call
    var tmp0__get_microseconds__mq1imi = end - start;
    tmp$ret$5 = Companion_getInstance_7().nj(tmp0__get_microseconds__mq1imi);
    tmp$ret$6 = tmp$ret$5;
    var time = tmp$ret$6;
  };
  function ScissorCommand(scissor) {
    this.hcc_1 = scissor;
  }
  protoOf(ScissorCommand).toString = function () {
    return 'ScissorCommand(scissor=' + new AGScissor(this.hcc_1) + ')';
  };
  protoOf(ScissorCommand).hashCode = function () {
    return AGScissor__hashCode_impl_x18ye4(this.hcc_1);
  };
  protoOf(ScissorCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!equals(this.hcc_1, tmp0_other_with_cast.hcc_1))
      return false;
    return true;
  };
  function ClearCommand(i) {
    this.icc_1 = i;
  }
  protoOf(ClearCommand).toString = function () {
    return 'ClearCommand(i=' + this.icc_1 + ')';
  };
  protoOf(ClearCommand).hashCode = function () {
    return this.icc_1;
  };
  protoOf(ClearCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.icc_1 === tmp0_other_with_cast.icc_1))
      return false;
    return true;
  };
  function ShapeCommand(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_34().f6t_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_54().i6j_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_31().f6j_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_30().d6j_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_53().t6j_1 : cullFace;
    this.jcc_1 = drawType;
    this.kcc_1 = vertexIndex;
    this.lcc_1 = vertexEnd;
    this.mcc_1 = paintShader;
    this.ncc_1 = program;
    this.occ_1 = colorMask;
    this.pcc_1 = stencilOpFunc;
    this.qcc_1 = stencilRef;
    this.rcc_1 = blendMode;
    this.scc_1 = cullFace;
  }
  protoOf(ShapeCommand).caa = function () {
    return this.lcc_1 - this.kcc_1 | 0;
  };
  protoOf(ShapeCommand).toString = function () {
    return 'ShapeCommand(drawType=' + new AGDrawType(this.jcc_1) + ', vertexIndex=' + this.kcc_1 + ', vertexEnd=' + this.lcc_1 + ', paintShader=' + this.mcc_1 + ', program=' + this.ncc_1 + ', colorMask=' + new AGColorMask(this.occ_1) + ', stencilOpFunc=' + new AGStencilOpFunc(this.pcc_1) + ', stencilRef=' + new AGStencilReference(this.qcc_1) + ', blendMode=' + this.rcc_1 + ', cullFace=' + new AGCullFace(this.scc_1) + ')';
  };
  protoOf(ShapeCommand).hashCode = function () {
    var result = AGDrawType__hashCode_impl_ylaury(this.jcc_1);
    result = imul(result, 31) + this.kcc_1 | 0;
    result = imul(result, 31) + this.lcc_1 | 0;
    result = imul(result, 31) + (this.mcc_1 == null ? 0 : this.mcc_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ncc_1 == null ? 0 : this.ncc_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.occ_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.pcc_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.qcc_1) | 0;
    result = imul(result, 31) + (this.rcc_1 == null ? 0 : this.rcc_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.scc_1) | 0;
    return result;
  };
  protoOf(ShapeCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.jcc_1 === tmp0_other_with_cast.jcc_1))
      return false;
    if (!(this.kcc_1 === tmp0_other_with_cast.kcc_1))
      return false;
    if (!(this.lcc_1 === tmp0_other_with_cast.lcc_1))
      return false;
    if (!equals(this.mcc_1, tmp0_other_with_cast.mcc_1))
      return false;
    if (!equals(this.ncc_1, tmp0_other_with_cast.ncc_1))
      return false;
    if (!(this.occ_1 === tmp0_other_with_cast.occ_1))
      return false;
    if (!(this.pcc_1 === tmp0_other_with_cast.pcc_1))
      return false;
    if (!equals(this.qcc_1, tmp0_other_with_cast.qcc_1))
      return false;
    if (!equals(this.rcc_1, tmp0_other_with_cast.rcc_1))
      return false;
    if (!(this.scc_1 === tmp0_other_with_cast.scc_1))
      return false;
    return true;
  };
  function GpuShapeViewCommands() {
    this.rca_1 = 0;
    this.sca_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$_0();
    tmp.tca_1 = tmp$ret$0;
    this.uca_1 = null;
    this.vca_1 = FastArrayList_init_$Create$();
    this.wca_1 = 0;
    this.xca_1 = 0;
    this.yca_1 = _MatrixTransform___init__impl__7axsoi();
    this.zca_1 = FastArrayList_init_$Create$();
    this.acb_1 = AGTextureUnits_init_$Create$();
  }
  protoOf(GpuShapeViewCommands).v2 = function () {
    this.rca_1 = 0;
    this.sca_1.v2();
    this.tca_1.v2();
  };
  protoOf(GpuShapeViewCommands).fcb = function (x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.wca_1;
      tmp0_this.wca_1 = tmp1 + 1 | 0;
      tmp = tmp1 <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.sca_1.hn(x, y, len, maxLen);
    var tmp2_this = this;
    var tmp3 = tmp2_this.rca_1;
    tmp2_this.rca_1 = tmp3 + 1 | 0;
    return tmp3;
  };
  protoOf(GpuShapeViewCommands).ecb = function () {
    this.xca_1 = this.rca_1;
    return this.xca_1;
  };
  protoOf(GpuShapeViewCommands).gcb = function () {
    return this.rca_1;
  };
  protoOf(GpuShapeViewCommands).fcc = function (drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    var tmp0_this = this;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.tca_1;
    var tmp1_plusAssign = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    tmp0_plusAssign.b(tmp1_plusAssign);
  };
  protoOf(GpuShapeViewCommands).acc = function (drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_54().i6j_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_31().f6j_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_30().d6j_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_67().wa1_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_53().t6j_1 : cullFace;
    startIndex = startIndex === VOID ? this.xca_1 : startIndex;
    endIndex = endIndex === VOID ? this.rca_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.fcc(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.fcc.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  };
  protoOf(GpuShapeViewCommands).j76 = function (i) {
    var tmp0_this = this;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.tca_1;
    var tmp1_plusAssign = new ClearCommand(i);
    tmp0_plusAssign.b(tmp1_plusAssign);
  };
  protoOf(GpuShapeViewCommands).bcb = function (i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.j76(i);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.j76.call(this, i);
    }
    return tmp;
  };
  protoOf(GpuShapeViewCommands).ccb = function (scissor) {
    var tmp0_this = this;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.tca_1;
    var tmp1_plusAssign = new ScissorCommand(scissor);
    tmp0_plusAssign.b(tmp1_plusAssign);
  };
  protoOf(GpuShapeViewCommands).i6i = function () {
    var tmp0_safe_receiver = this.uca_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_this = this;
      var tmp0_plusAssign = tmp0_this.vca_1;
      tmp0_plusAssign.b(tmp0_safe_receiver);
      tmp$ret$0 = Unit_getInstance();
    }
    this.uca_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.sca_1.on())));
  };
  protoOf(GpuShapeViewCommands).dcb = function (ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.uca_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.o9y_1.pa9(this.vca_1);
    this.vca_1.v2();
    ctx.va3();
    var ag = ctx.u9x_1;
    var vao = new AGVertexArrayObject(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().qcb_1, ctx.na9(vertices))]), true);
    var tmp$ret$4;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var tmp$ret$3;
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var tmp1_use = ctx.u9y_1;
    var tmp0_useBatcher = tmp1_use.qa2_1;
    if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
      tmp0_useBatcher.y9y_1 = tmp1_use;
      tmp0_useBatcher.va3();
    }
    tmp1_use.dab();
    var tempMat = Matrix__premultiplied_impl_rsndx4(doRequireTexture ? Companion_getInstance_23().v3f_1 : tmp1_use.aaa(), globalMatrix);
    var tmp$ret$2;
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var tmp3_setViewMatrixTemp = tmp1_use.qa2_1;
    tmp3_setViewMatrixTemp.va3();
    var temp4 = tmp3_setViewMatrixTemp.h9y_1;
    var temp2d = tmp3_setViewMatrixTemp.i9y_1;
    tmp3_setViewMatrixTemp.i9y_1 = tempMat;
    tmp3_setViewMatrixTemp.h9y_1 = toMatrix4(tempMat);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var tmp0_push = tmp3_setViewMatrixTemp.i6p(ProjViewUB_getInstance());
      var tmp0_this = tmp0_push;
      var tmp1 = tmp0_this.x6q();
      tmp0_this.a7b(tmp1 + 1 | 0);
      tmp0_push.tn(tmp0_push.x6q() + 1 | 0);
      var blockSize = tmp0_push.a6p_1;
      var index0 = imul(tmp0_push.x6q() - 1 | 0, blockSize);
      var index1 = imul(tmp0_push.x6q(), blockSize);
      var texBlockSize = tmp0_push.y6o_1.t6x().j();
      var texIndex0 = imul(tmp0_push.x6q() - 1 | 0, texBlockSize);
      var texIndex1 = imul(tmp0_push.x6q(), texBlockSize);
      if (tmp0_push.x6q() > 0) {
        arraycopy_2(tmp0_push.c6p_1, index0, tmp0_push.c6p_1, index1, blockSize);
      } else {
        arrayfill_0(tmp0_push.c6p_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var tmp1__anonymous__uwfjfc = tmp0_push.y6o_1;
      var tmp2__anonymous__z9zvc9 = tmp0_push.d6p_1;
      tmp2__anonymous__z9zvc9.h7b(tmp1__anonymous__uwfjfc.s6x(), tmp3_setViewMatrixTemp.h9y_1);
      if (tmp0_push.x6q() >= 1) {
        var equals = arrayequal(tmp0_push.c6p_1, index0, tmp0_push.c6p_1, index1, blockSize);
        if (equals) {
          var tmp2_this = tmp0_push;
          var tmp3 = tmp2_this.x6q();
          tmp2_this.a7b(tmp3 - 1 | 0);
          tmp$ret$0 = false;
          break $l$block;
        }
      }
      tmp$ret$0 = true;
    }
    var tmp_0;
    try {
      this.yca_1 = Matrix__toTransform_impl_lr8urh(globalMatrix);
      var program = GpuShapeViewPrograms_getInstance().xcb_1;
      var scissor = Companion_getInstance_32().r6j_1;
      var tmp0_fastForEach = this.tca_1;
      var n = 0;
      while (n < tmp0_fastForEach.j()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp1__anonymous__uwfjfc_0 = tmp0_fastForEach.k(tmp0);
        var tmp0_subject = tmp1__anonymous__uwfjfc_0;
        if (tmp0_subject instanceof ScissorCommand) {
          scissor = tmp1__anonymous__uwfjfc_0.hcc_1;
        } else {
          if (tmp0_subject instanceof ClearCommand) {
            var tmp1_stencil = tmp1__anonymous__uwfjfc_0.icc_1;
            ctx.bad(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (tmp0_subject instanceof ShapeCommand) {
              var paintShader = tmp1__anonymous__uwfjfc_0.mcc_1;
              tmp1_use.mab(tmp1__anonymous__uwfjfc_0.caa());
              var pixelScale = _MatrixTransform___get_scaleAvg__impl__ku8ljx(this.yca_1) / ctx.v9x_1.nac();
              if (!(paintShader == null)) {
                var tmp$ret$1;
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var tmp0_push_0 = tmp1_use.qa2_1.i6p(ShapeViewUB_getInstance());
                  var tmp0_this_0 = tmp0_push_0;
                  var tmp1_0 = tmp0_this_0.x6q();
                  tmp0_this_0.a7b(tmp1_0 + 1 | 0);
                  tmp0_push_0.tn(tmp0_push_0.x6q() + 1 | 0);
                  var blockSize_0 = tmp0_push_0.a6p_1;
                  var index0_0 = imul(tmp0_push_0.x6q() - 1 | 0, blockSize_0);
                  var index1_0 = imul(tmp0_push_0.x6q(), blockSize_0);
                  var texBlockSize_0 = tmp0_push_0.y6o_1.t6x().j();
                  var texIndex0_0 = imul(tmp0_push_0.x6q() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(tmp0_push_0.x6q(), texBlockSize_0);
                  if (tmp0_push_0.x6q() > 0) {
                    arraycopy_2(tmp0_push_0.c6p_1, index0_0, tmp0_push_0.c6p_1, index1_0, blockSize_0);
                  } else {
                    arrayfill_0(tmp0_push_0.c6p_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var tmp1__anonymous__uwfjfc_1 = tmp0_push_0.y6o_1;
                  var tmp2__anonymous__z9zvc9_0 = tmp0_push_0.d6p_1;
                  tmp2__anonymous__z9zvc9_0.d7b(paintShader.tcc_1);
                  tmp2__anonymous__z9zvc9_0.k7b(tmp1__anonymous__uwfjfc_1.icd(), pixelScale);
                  tmp2__anonymous__z9zvc9_0.e7b(tmp1__anonymous__uwfjfc_1.jcd(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (tmp0_push_0.x6q() >= 1) {
                    var equals_0 = arrayequal(tmp0_push_0.c6p_1, index0_0, tmp0_push_0.c6p_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var tmp2_this_0 = tmp0_push_0;
                      var tmp3_0 = tmp2_this_0.x6q();
                      tmp2_this_0.a7b(tmp3_0 - 1 | 0);
                      tmp$ret$1 = false;
                      break $l$block_0;
                    }
                  }
                  tmp$ret$1 = true;
                }
                if (!(paintShader.ucc_1 == null)) {
                  var tex = ctx.k9y_1.os();
                  tex.s6m(paintShader.ucc_1);
                  this.acb_1.d6o(DefaultShaders_getInstance().x6v(), tex);
                  this.zca_1.b(tex);
                }
              }
              var tmp2_elvis_lhs = tmp1__anonymous__uwfjfc_0.ncc_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.z9y_1.x6j_1;
              var tmp5_frameBufferInfo = ctx.z9y_1.k6k();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.jac(_program);
              var tmp8_textureUnits = this.acb_1.dn();
              var tmp9_stencilOpFunc = tmp1__anonymous__uwfjfc_0.pcc_1;
              var tmp10_stencilRef = tmp1__anonymous__uwfjfc_0.qcc_1;
              var tmp11_colorMask = tmp1__anonymous__uwfjfc_0.occ_1;
              var tmp3_elvis_lhs = tmp1__anonymous__uwfjfc_0.rcc_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_67().wa1_1 : tmp3_elvis_lhs).eab_1;
              var tmp13_cullFace = tmp1__anonymous__uwfjfc_0.scc_1;
              var tmp14_drawType = tmp1__anonymous__uwfjfc_0.jcc_1;
              var tmp15_drawOffset = tmp1__anonymous__uwfjfc_0.kcc_1;
              var tmp16_vertexCount = tmp1__anonymous__uwfjfc_0.caa();
              draw_1(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            }
          }
        }
      }
      tmp_0 = Unit_getInstance();
    }finally {
      tmp3_setViewMatrixTemp.va3();
      tmp3_setViewMatrixTemp.h9y_1 = temp4;
      tmp3_setViewMatrixTemp.i9y_1 = temp2d;
      tmp3_setViewMatrixTemp.i6p(ProjViewUB_getInstance()).b7b();
    }
    tmp$ret$2 = tmp_0;
    tmp$ret$3 = tmp$ret$2;
    tmp$ret$4 = tmp$ret$3;
    var tmp1_iterator = this.zca_1.g();
    while (tmp1_iterator.h()) {
      var tex_0 = tmp1_iterator.i();
      ctx.k9y_1.ps(tex_0);
    }
    this.zca_1.v2();
  };
  function ShapeViewUB() {
    ShapeViewUB_instance = this;
    UniformBlock.call(this, 5);
    this.acd_1 = this.y6x().q6x(this, u_ProgramType$factory());
    this.bcd_1 = this.a6y().q6x(this, u_Color$factory());
    this.ccd_1 = this.a6y().q6x(this, u_ColorMul$factory());
    this.dcd_1 = this.y6x().q6x(this, u_GlobalAlpha$factory());
    this.ecd_1 = this.y6x().q6x(this, u_GlobalPixelScale$factory());
    this.fcd_1 = this.j6x().q6x(this, u_Transform$factory());
    this.gcd_1 = this.a6y().q6x(this, u_Gradientp0$factory());
    this.hcd_1 = this.a6y().q6x(this, u_Gradientp1$factory());
  }
  protoOf(ShapeViewUB).kcd = function () {
    return this.acd_1.r5(this, u_ProgramType$factory_0());
  };
  protoOf(ShapeViewUB).lcd = function () {
    return this.bcd_1.r5(this, u_Color$factory_0());
  };
  protoOf(ShapeViewUB).jcd = function () {
    return this.ccd_1.r5(this, u_ColorMul$factory_0());
  };
  protoOf(ShapeViewUB).mcd = function () {
    return this.dcd_1.r5(this, u_GlobalAlpha$factory_0());
  };
  protoOf(ShapeViewUB).icd = function () {
    return this.ecd_1.r5(this, u_GlobalPixelScale$factory_0());
  };
  protoOf(ShapeViewUB).ncd = function () {
    return this.fcd_1.r5(this, u_Transform$factory_0());
  };
  protoOf(ShapeViewUB).ocd = function () {
    return this.gcd_1.r5(this, u_Gradientp0$factory_0());
  };
  protoOf(ShapeViewUB).pcd = function () {
    return this.hcd_1.r5(this, u_Gradientp1$factory_0());
  };
  var ShapeViewUB_instance;
  function ShapeViewUB_getInstance() {
    if (ShapeViewUB_instance == null)
      new ShapeViewUB();
    return ShapeViewUB_instance;
  }
  function PaintShader(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().xcb_1 : program;
    this.tcc_1 = uniforms;
    this.ucc_1 = texture;
    this.vcc_1 = program;
  }
  protoOf(PaintShader).toString = function () {
    return 'PaintShader(uniforms=' + this.tcc_1 + ', texture=' + this.ucc_1 + ', program=' + this.vcc_1 + ')';
  };
  protoOf(PaintShader).hashCode = function () {
    var result = hashCode(this.tcc_1);
    result = imul(result, 31) + (this.ucc_1 == null ? 0 : hashCode(this.ucc_1)) | 0;
    result = imul(result, 31) + this.vcc_1.hashCode() | 0;
    return result;
  };
  protoOf(PaintShader).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.tcc_1, tmp0_other_with_cast.tcc_1))
      return false;
    if (!equals(this.ucc_1, tmp0_other_with_cast.ucc_1))
      return false;
    if (!this.vcc_1.equals(tmp0_other_with_cast.vcc_1))
      return false;
    return true;
  };
  function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($tmp1_also) {
    return function ($this$IF_ELSE_LIST, it) {
      var tmp0_subject = it;
      var tmp;
      GpuShapeViewPrograms_getInstance();
      if (tmp0_subject === 0) {
        $this$IF_ELSE_LIST.s6v($this$IF_ELSE_LIST.t6v(), GpuShapeViewPrograms_getInstance().lcd());
        tmp = Unit_getInstance();
      } else {
        GpuShapeViewPrograms_getInstance();
        if (tmp0_subject === 1) {
          $this$IF_ELSE_LIST.s6v($this$IF_ELSE_LIST.t6v(), $this$IF_ELSE_LIST.z6v($tmp1_also.x6v(), $this$IF_ELSE_LIST.p6z($this$IF_ELSE_LIST.r6z([$this$IF_ELSE_LIST.y6v($this$IF_ELSE_LIST.k6y(GpuShapeViewPrograms_getInstance().ncd(), $this$IF_ELSE_LIST.v6v([$tmp1_also.g6y(), $this$IF_ELSE_LIST.u6v(0.0), $this$IF_ELSE_LIST.u6v(1.0)])), 'xy')]))));
          tmp = Unit_getInstance();
        } else {
          GpuShapeViewPrograms_getInstance();
          if (tmp0_subject === 2) {
            $this$IF_ELSE_LIST.s6v($this$IF_ELSE_LIST.t6v(), $this$IF_ELSE_LIST.z6v($tmp1_also.x6v(), $this$IF_ELSE_LIST.y6v($this$IF_ELSE_LIST.k6y(GpuShapeViewPrograms_getInstance().ncd(), $this$IF_ELSE_LIST.v6v([$this$IF_ELSE_LIST.s6z($tmp1_also.g6y()), $this$IF_ELSE_LIST.t6z($tmp1_also.g6y()), $this$IF_ELSE_LIST.u6v(0.0), $this$IF_ELSE_LIST.u6v(1.0)])), 'xy')));
            tmp = Unit_getInstance();
          } else {
            GpuShapeViewPrograms_getInstance();
            if (tmp0_subject === 3) {
              var rpoint = $this$IF_ELSE_LIST.j6z(VarType_Float2_getInstance());
              $this$IF_ELSE_LIST.s6v($this$IF_ELSE_LIST.y6v(rpoint, 'xy'), $this$IF_ELSE_LIST.y6v($this$IF_ELSE_LIST.k6y(GpuShapeViewPrograms_getInstance().ncd(), $this$IF_ELSE_LIST.v6v([$this$IF_ELSE_LIST.s6z($tmp1_also.g6y()), $this$IF_ELSE_LIST.t6z($tmp1_also.g6y()), $this$IF_ELSE_LIST.u6v(0.0), $this$IF_ELSE_LIST.u6v(1.0)])), 'xy'));
              var x = $this$IF_ELSE_LIST.s6z(rpoint);
              var y = $this$IF_ELSE_LIST.t6z(rpoint);
              var x0 = $this$IF_ELSE_LIST.s6z(GpuShapeViewPrograms_getInstance().ocd());
              var y0 = $this$IF_ELSE_LIST.t6z(GpuShapeViewPrograms_getInstance().ocd());
              var r0 = $this$IF_ELSE_LIST.u6z(GpuShapeViewPrograms_getInstance().ocd());
              var x1 = $this$IF_ELSE_LIST.s6z(GpuShapeViewPrograms_getInstance().pcd());
              var y1 = $this$IF_ELSE_LIST.t6z(GpuShapeViewPrograms_getInstance().pcd());
              var r1 = $this$IF_ELSE_LIST.u6z(GpuShapeViewPrograms_getInstance().pcd());
              var ratio = $this$IF_ELSE_LIST.s6z($tmp1_also.o6y());
              var r0r1_2 = $this$IF_ELSE_LIST.t6z($tmp1_also.o6y());
              var r0pow2 = $this$IF_ELSE_LIST.u6z($tmp1_also.o6y());
              var r1pow2 = $this$IF_ELSE_LIST.v6z($tmp1_also.o6y());
              var y0_y1 = $this$IF_ELSE_LIST.s6z($tmp1_also.d70());
              var x0_x1 = $this$IF_ELSE_LIST.t6z($tmp1_also.d70());
              var r0_r1 = $this$IF_ELSE_LIST.u6z($tmp1_also.d70());
              var radial_scale = $this$IF_ELSE_LIST.v6z($tmp1_also.d70());
              $this$IF_ELSE_LIST.s6v(r0r1_2, $this$IF_ELSE_LIST.k6y($this$IF_ELSE_LIST.k6y($this$IF_ELSE_LIST.u6v(2.0), r0), r1));
              $this$IF_ELSE_LIST.s6v(r0pow2, GpuShapeViewPrograms_getInstance().qcd(r0));
              $this$IF_ELSE_LIST.s6v(r1pow2, GpuShapeViewPrograms_getInstance().qcd(r1));
              $this$IF_ELSE_LIST.s6v(x0_x1, $this$IF_ELSE_LIST.x6z(x0, x1));
              $this$IF_ELSE_LIST.s6v(y0_y1, $this$IF_ELSE_LIST.x6z(y0, y1));
              $this$IF_ELSE_LIST.s6v(r0_r1, $this$IF_ELSE_LIST.x6z(r0, r1));
              $this$IF_ELSE_LIST.s6v(radial_scale, $this$IF_ELSE_LIST.p6y($this$IF_ELSE_LIST.u6v(1.0), $this$IF_ELSE_LIST.x6z($this$IF_ELSE_LIST.x6z(GpuShapeViewPrograms_getInstance().qcd($this$IF_ELSE_LIST.x6z(r0, r1)), GpuShapeViewPrograms_getInstance().qcd($this$IF_ELSE_LIST.x6z(x0, x1))), GpuShapeViewPrograms_getInstance().qcd($this$IF_ELSE_LIST.x6z(y0, y1)))));
              $this$IF_ELSE_LIST.s6v(ratio, $this$IF_ELSE_LIST.x6z($this$IF_ELSE_LIST.u6v(1.0), $this$IF_ELSE_LIST.k6y($this$IF_ELSE_LIST.x6z($this$IF_ELSE_LIST.y6z($this$IF_ELSE_LIST.y6z($this$IF_ELSE_LIST.k6y($this$IF_ELSE_LIST.w6z(r1), r0_r1), $this$IF_ELSE_LIST.k6y(x0_x1, $this$IF_ELSE_LIST.x6z(x1, x))), $this$IF_ELSE_LIST.k6y(y0_y1, $this$IF_ELSE_LIST.x6z(y1, y))), $this$IF_ELSE_LIST.n6z($this$IF_ELSE_LIST.x6z($this$IF_ELSE_LIST.y6z($this$IF_ELSE_LIST.x6z($this$IF_ELSE_LIST.k6y(r1pow2, $this$IF_ELSE_LIST.y6z(GpuShapeViewPrograms_getInstance().qcd($this$IF_ELSE_LIST.x6z(x0, x)), GpuShapeViewPrograms_getInstance().qcd($this$IF_ELSE_LIST.x6z(y0, y)))), $this$IF_ELSE_LIST.k6y(r0r1_2, $this$IF_ELSE_LIST.y6z($this$IF_ELSE_LIST.k6y($this$IF_ELSE_LIST.x6z(x0, x), $this$IF_ELSE_LIST.x6z(x1, x)), $this$IF_ELSE_LIST.k6y($this$IF_ELSE_LIST.x6z(y0, y), $this$IF_ELSE_LIST.x6z(y1, y))))), $this$IF_ELSE_LIST.k6y(r0pow2, $this$IF_ELSE_LIST.y6z(GpuShapeViewPrograms_getInstance().qcd($this$IF_ELSE_LIST.x6z(x1, x)), GpuShapeViewPrograms_getInstance().qcd($this$IF_ELSE_LIST.x6z(y1, y))))), GpuShapeViewPrograms_getInstance().qcd($this$IF_ELSE_LIST.x6z($this$IF_ELSE_LIST.y6z($this$IF_ELSE_LIST.y6z($this$IF_ELSE_LIST.x6z($this$IF_ELSE_LIST.x6z($this$IF_ELSE_LIST.k6y(x1, y0), $this$IF_ELSE_LIST.k6y(x, y0)), $this$IF_ELSE_LIST.k6y(x0, y1)), $this$IF_ELSE_LIST.k6y(x, y1)), $this$IF_ELSE_LIST.k6y(x0, y)), $this$IF_ELSE_LIST.k6y(x1, y)))))), radial_scale)));
              $this$IF_ELSE_LIST.s6v($this$IF_ELSE_LIST.t6v(), $this$IF_ELSE_LIST.z6v($tmp1_also.x6v(), $this$IF_ELSE_LIST.r6z([ratio, $this$IF_ELSE_LIST.u6v(0.0)])));
              tmp = Unit_getInstance();
            } else {
              GpuShapeViewPrograms_getInstance();
              if (tmp0_subject === 4) {
                var rpoint_0 = $this$IF_ELSE_LIST.j6z(VarType_Float2_getInstance());
                $this$IF_ELSE_LIST.s6v($this$IF_ELSE_LIST.y6v(rpoint_0, 'xy'), $this$IF_ELSE_LIST.y6v($this$IF_ELSE_LIST.k6y(GpuShapeViewPrograms_getInstance().ncd(), $this$IF_ELSE_LIST.v6v([$this$IF_ELSE_LIST.s6z($tmp1_also.g6y()), $this$IF_ELSE_LIST.t6z($tmp1_also.g6y()), $this$IF_ELSE_LIST.u6v(0.0), $this$IF_ELSE_LIST.u6v(1.0)])), 'xy'));
                var x_0 = $this$IF_ELSE_LIST.s6z(rpoint_0);
                var y_0 = $this$IF_ELSE_LIST.t6z(rpoint_0);
                var ratio_0 = $this$IF_ELSE_LIST.s6z($tmp1_also.o6y());
                var angle = $this$IF_ELSE_LIST.t6z($tmp1_also.o6y());
                var x0_0 = $this$IF_ELSE_LIST.s6z(GpuShapeViewPrograms_getInstance().ocd());
                var y0_0 = $this$IF_ELSE_LIST.t6z(GpuShapeViewPrograms_getInstance().ocd());
                var PI2 = $this$IF_ELSE_LIST.u6v(get_PI() * 2);
                $this$IF_ELSE_LIST.s6v(angle, $this$IF_ELSE_LIST.l6z($this$IF_ELSE_LIST.x6z(y_0, y0_0), $this$IF_ELSE_LIST.x6z(x_0, x0_0)));
                var tmp$ret$0;
                // Inline function 'korlibs.graphics.shader.Builder.IF' call
                var tmp1_IF = $this$IF_ELSE_LIST.a70(angle, $this$IF_ELSE_LIST.u6v(0.0));
                var body = $this$IF_ELSE_LIST.q6y();
                // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call
                body.s6v(angle, body.y6z(angle, PI2));
                var stmIf = new If(tmp1_IF, body.s6y());
                var tmp0_this = $this$IF_ELSE_LIST;
                // Inline function 'kotlin.collections.plusAssign' call
                var tmp0_plusAssign = tmp0_this.r6v_1;
                tmp0_plusAssign.b(stmIf);
                tmp$ret$0 = stmIf;
                $this$IF_ELSE_LIST.s6v(ratio_0, $this$IF_ELSE_LIST.p6y(angle, PI2));
                $this$IF_ELSE_LIST.s6v($this$IF_ELSE_LIST.t6v(), $this$IF_ELSE_LIST.z6v($tmp1_also.x6v(), $this$IF_ELSE_LIST.p6z($this$IF_ELSE_LIST.r6z([ratio_0, $this$IF_ELSE_LIST.u6v(0.0)]))));
                tmp = Unit_getInstance();
              }
            }
          }
        }
      }
      return Unit_getInstance();
    };
  }
  function GpuShapeViewPrograms() {
    GpuShapeViewPrograms_instance = this;
    this.hcb_1 = Attribute_init_$Create$('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.icb_1 = Attribute_init_$Create$('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.jcb_1 = Varying_init_$Create$('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.kcb_1 = Varying_init_$Create$('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.lcb_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l6s_1]);
    this.mcb_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().m6s_1]);
    this.ncb_1 = ProgramLayout_init_$Create$([this.icb_1]);
    this.ocb_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l6s_1, DefaultShaders_getInstance().m6s_1]);
    this.pcb_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l6s_1, this.icb_1]);
    this.qcb_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l6s_1, this.icb_1, this.hcb_1]);
    this.rcb_1 = 0;
    this.scb_1 = 1;
    this.tcb_1 = 2;
    this.ucb_1 = 3;
    this.vcb_1 = 4;
    this.wcb_1 = 5;
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    tmp0_also.s6v(tmp0_also.t6v(), tmp0_also.k6y(tmp0_also.k6y(tmp0_also.r6x(), tmp0_also.s6x()), tmp0_also.v6v([tmp0_also.l6y(), tmp0_also.u6v(0.0), tmp0_also.u6v(1.0)])));
    tmp0_also.s6v(tmp0_also.g6y(), DefaultShaders_getInstance().l6s_1);
    tmp0_also.s6v(GpuShapeViewPrograms_getInstance().kcb_1, GpuShapeViewPrograms_getInstance().icb_1);
    tmp0_also.s6v(GpuShapeViewPrograms_getInstance().jcb_1, GpuShapeViewPrograms_getInstance().hcb_1);
    tmp$ret$0 = tmp0_also;
    tmp$ret$1 = VertexShader(tmp$ret$0.w6v());
    var tmp0_vertex = tmp$ret$1;
    var tmp$ret$5;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    var tmp$ret$4;
    // Inline function 'kotlin.also' call
    var tmp1_also = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    var tmp$ret$2;
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var tmp_0 = GpuShapeViewPrograms_getInstance().kcd();
    GpuShapeViewPrograms_getInstance();
    var tmp1_IF = tmp1_also.z6z(tmp_0, tmp1_also.u6v(5));
    var body = tmp1_also.q6y();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.s6v(body.t6v(), body.v6v([body.u6v(1.0), body.u6v(0.0), body.u6v(0.0), body.u6v(1.0)]));
    body.i6z();
    var stmIf = new If(tmp1_IF, body.s6y());
    var tmp0_this = tmp1_also;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.r6v_1;
    tmp0_plusAssign.b(stmIf);
    tmp$ret$2 = stmIf;
    var tmp$ret$3;
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var tmp3_IF = tmp1_also.c70(tmp1_also.o6z(GpuShapeViewPrograms_getInstance().kcb_1), GpuShapeViewPrograms_getInstance().jcb_1);
    var body_0 = tmp1_also.q6y();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.g6z();
    var stmIf_0 = new If(tmp3_IF, body_0.s6y());
    var tmp0_this_0 = tmp1_also;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp2_plusAssign = tmp0_this_0.r6v_1;
    tmp2_plusAssign.b(stmIf_0);
    tmp$ret$3 = stmIf_0;
    var tmp_1 = GpuShapeViewPrograms_getInstance().kcd();
    tmp1_also.f6z(tmp_1, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(tmp1_also));
    var aaAlpha = tmp1_also.x6z(tmp1_also.u6v(1.0), tmp1_also.q6z(tmp1_also.x6z(tmp1_also.k6y(GpuShapeViewPrograms_getInstance().jcb_1, GpuShapeViewPrograms_getInstance().icd()), tmp1_also.u6v(1.5)), tmp1_also.k6y(GpuShapeViewPrograms_getInstance().jcb_1, GpuShapeViewPrograms_getInstance().icd()), tmp1_also.o6z(tmp1_also.k6y(GpuShapeViewPrograms_getInstance().kcb_1, GpuShapeViewPrograms_getInstance().icd()))));
    tmp1_also.s6v(tmp1_also.t6v(), tmp1_also.k6y(tmp1_also.k6y(tmp1_also.k6y(tmp1_also.t6v(), GpuShapeViewPrograms_getInstance().jcd()), GpuShapeViewPrograms_getInstance().mcd()), aaAlpha));
    tmp$ret$4 = tmp1_also;
    tmp$ret$5 = FragmentShader(tmp$ret$4.w6v());
    var tmp1_fragment = tmp$ret$5;
    tmp.xcb_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_2 = this;
    var tmp$ret$9;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var tmp2_single = Companion_getInstance_55();
    var tmp3_single = ShapeViewUB_getInstance();
    var tmp$ret$8;
    // Inline function 'kotlin.also' call
    var tmp$ret$6;
    // Inline function 'kotlin.also' call
    var tmp0_also_0 = new UniformBlockBuffer(tmp3_single);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    tmp0_also_0.dt();
    tmp$ret$6 = tmp0_also_0;
    var tmp1_also_0 = tmp$ret$6;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    var tmp$ret$7;
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var tmp0_this_1 = tmp1_also_0;
      var tmp1 = tmp0_this_1.x6q();
      tmp0_this_1.a7b(tmp1 + 1 | 0);
      tmp1_also_0.tn(tmp1_also_0.x6q() + 1 | 0);
      var blockSize = tmp1_also_0.a6p_1;
      var index0 = imul(tmp1_also_0.x6q() - 1 | 0, blockSize);
      var index1 = imul(tmp1_also_0.x6q(), blockSize);
      var texBlockSize = tmp1_also_0.y6o_1.t6x().j();
      var texIndex0 = imul(tmp1_also_0.x6q() - 1 | 0, texBlockSize);
      var texIndex1 = imul(tmp1_also_0.x6q(), texBlockSize);
      if (tmp1_also_0.x6q() > 0) {
        arraycopy_2(tmp1_also_0.c6p_1, index0, tmp1_also_0.c6p_1, index1, blockSize);
      } else {
        arrayfill_0(tmp1_also_0.c6p_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      var tmp0__anonymous__q1qw7t = tmp1_also_0.y6o_1;
      var tmp1__anonymous__uwfjfc = tmp1_also_0.d6p_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      var tmp_3 = ShapeViewUB_getInstance().kcd();
      GpuShapeViewPrograms_getInstance();
      tmp1__anonymous__uwfjfc.k7b(tmp_3, 5);
      if (tmp1_also_0.x6q() >= 1) {
        var equals = arrayequal(tmp1_also_0.c6p_1, index0, tmp1_also_0.c6p_1, index1, blockSize);
        if (equals) {
          var tmp2_this = tmp1_also_0;
          var tmp3 = tmp2_this.x6q();
          tmp2_this.a7b(tmp3 - 1 | 0);
          tmp$ret$7 = false;
          break $l$block;
        }
      }
      tmp$ret$7 = true;
    }
    tmp$ret$8 = tmp1_also_0;
    tmp$ret$9 = tmp$ret$8;
    tmp_2.ycb_1 = new PaintShader(tmp$ret$9, null);
  }
  protoOf(GpuShapeViewPrograms).kcd = function () {
    return ShapeViewUB_getInstance().kcd().r6q_1;
  };
  protoOf(GpuShapeViewPrograms).lcd = function () {
    return ShapeViewUB_getInstance().lcd().r6q_1;
  };
  protoOf(GpuShapeViewPrograms).jcd = function () {
    return ShapeViewUB_getInstance().jcd().r6q_1;
  };
  protoOf(GpuShapeViewPrograms).mcd = function () {
    return ShapeViewUB_getInstance().mcd().r6q_1;
  };
  protoOf(GpuShapeViewPrograms).icd = function () {
    return ShapeViewUB_getInstance().icd().r6q_1;
  };
  protoOf(GpuShapeViewPrograms).ncd = function () {
    return ShapeViewUB_getInstance().ncd().r6q_1;
  };
  protoOf(GpuShapeViewPrograms).ocd = function () {
    return ShapeViewUB_getInstance().ocd().r6q_1;
  };
  protoOf(GpuShapeViewPrograms).pcd = function () {
    return ShapeViewUB_getInstance().pcd().r6q_1;
  };
  protoOf(GpuShapeViewPrograms).qcd = function (_this__u8e3s4) {
    var tmp$ret$1;
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    var tmp0_invoke = Companion_getInstance_56();
    var tmp$ret$0;
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var tmp1__anonymous__uwfjfc = tmp0_invoke.q7h_1;
    tmp$ret$0 = tmp1__anonymous__uwfjfc.m6z(_this__u8e3s4, tmp1__anonymous__uwfjfc.u6v(2.0));
    tmp$ret$1 = tmp$ret$0;
    return tmp$ret$1;
  };
  protoOf(GpuShapeViewPrograms).zcb = function (stateTransform, paint, globalAlpha, lineWidth) {
    var tmp0_subject = paint;
    var tmp;
    if (tmp0_subject instanceof NonePaint) {
      tmp = null;
    } else {
      if (tmp0_subject instanceof RGBA) {
        var tmp$ret$3;
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var tmp2_single = Companion_getInstance_55();
        var tmp3_single = ShapeViewUB_getInstance();
        var tmp$ret$2;
        // Inline function 'kotlin.also' call
        var tmp$ret$0;
        // Inline function 'kotlin.also' call
        var tmp0_also = new UniformBlockBuffer(tmp3_single);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        tmp0_also.dt();
        tmp$ret$0 = tmp0_also;
        var tmp1_also = tmp$ret$0;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var tmp0_this = tmp1_also;
          var tmp1 = tmp0_this.x6q();
          tmp0_this.a7b(tmp1 + 1 | 0);
          tmp1_also.tn(tmp1_also.x6q() + 1 | 0);
          var blockSize = tmp1_also.a6p_1;
          var index0 = imul(tmp1_also.x6q() - 1 | 0, blockSize);
          var index1 = imul(tmp1_also.x6q(), blockSize);
          var texBlockSize = tmp1_also.y6o_1.t6x().j();
          var texIndex0 = imul(tmp1_also.x6q() - 1 | 0, texBlockSize);
          var texIndex1 = imul(tmp1_also.x6q(), texBlockSize);
          if (tmp1_also.x6q() > 0) {
            arraycopy_2(tmp1_also.c6p_1, index0, tmp1_also.c6p_1, index1, blockSize);
          } else {
            arrayfill_0(tmp1_also.c6p_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var tmp0__anonymous__q1qw7t = tmp1_also.y6o_1;
          var tmp1__anonymous__uwfjfc = tmp1_also.d6p_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var tmp_0 = tmp0__anonymous__q1qw7t.kcd();
          GpuShapeViewPrograms_getInstance();
          tmp1__anonymous__uwfjfc.k7b(tmp_0, 0);
          tmp1__anonymous__uwfjfc.e7b(tmp0__anonymous__q1qw7t.lcd(), _RGBA___get_premultiplied__impl__3bulqc(paint.q4n_1));
          tmp1__anonymous__uwfjfc.k7b(tmp0__anonymous__q1qw7t.mcd(), globalAlpha);
          if (tmp1_also.x6q() >= 1) {
            var equals = arrayequal(tmp1_also.c6p_1, index0, tmp1_also.c6p_1, index1, blockSize);
            if (equals) {
              var tmp2_this = tmp1_also;
              var tmp3 = tmp2_this.x6q();
              tmp2_this.a7b(tmp3 - 1 | 0);
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        tmp$ret$2 = tmp1_also;
        tmp$ret$3 = tmp$ret$2;
        tmp = new PaintShader(tmp$ret$3, null);
      } else {
        if (tmp0_subject instanceof BitmapPaint) {
          var mat = Matrix__scaled_impl_ogn4b6(Matrix__inverted_impl_3pqbyv(Matrix__preconcated_impl_s9s2ig(Matrix__preconcated_impl_s9s2ig(Companion_getInstance_23().v3f_1, paint.k5x_1), stateTransform)), 1.0 / paint.j5x_1.r46_1, 1.0 / paint.j5x_1.s46_1);
          var tmp$ret$7;
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var tmp6_single = Companion_getInstance_55();
          var tmp7_single = ShapeViewUB_getInstance();
          var tmp$ret$6;
          // Inline function 'kotlin.also' call
          var tmp$ret$4;
          // Inline function 'kotlin.also' call
          var tmp4_also = new UniformBlockBuffer(tmp7_single);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          tmp4_also.dt();
          tmp$ret$4 = tmp4_also;
          var tmp5_also = tmp$ret$4;
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          var tmp$ret$5;
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var tmp0_this_0 = tmp5_also;
            var tmp1_0 = tmp0_this_0.x6q();
            tmp0_this_0.a7b(tmp1_0 + 1 | 0);
            tmp5_also.tn(tmp5_also.x6q() + 1 | 0);
            var blockSize_0 = tmp5_also.a6p_1;
            var index0_0 = imul(tmp5_also.x6q() - 1 | 0, blockSize_0);
            var index1_0 = imul(tmp5_also.x6q(), blockSize_0);
            var texBlockSize_0 = tmp5_also.y6o_1.t6x().j();
            var texIndex0_0 = imul(tmp5_also.x6q() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(tmp5_also.x6q(), texBlockSize_0);
            if (tmp5_also.x6q() > 0) {
              arraycopy_2(tmp5_also.c6p_1, index0_0, tmp5_also.c6p_1, index1_0, blockSize_0);
            } else {
              arrayfill_0(tmp5_also.c6p_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var tmp0__anonymous__q1qw7t_0 = tmp5_also.y6o_1;
            var tmp1__anonymous__uwfjfc_0 = tmp5_also.d6p_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var tmp_1 = tmp0__anonymous__q1qw7t_0.kcd();
            GpuShapeViewPrograms_getInstance();
            tmp1__anonymous__uwfjfc_0.k7b(tmp_1, 1);
            tmp1__anonymous__uwfjfc_0.h7b(tmp0__anonymous__q1qw7t_0.ncd(), toMatrix4(mat));
            tmp1__anonymous__uwfjfc_0.k7b(tmp0__anonymous__q1qw7t_0.mcd(), globalAlpha);
            if (tmp5_also.x6q() >= 1) {
              var equals_0 = arrayequal(tmp5_also.c6p_1, index0_0, tmp5_also.c6p_1, index1_0, blockSize_0);
              if (equals_0) {
                var tmp2_this_0 = tmp5_also;
                var tmp3_0 = tmp2_this_0.x6q();
                tmp2_this_0.a7b(tmp3_0 - 1 | 0);
                tmp$ret$5 = false;
                break $l$block_0;
              }
            }
            tmp$ret$5 = true;
          }
          tmp$ret$6 = tmp5_also;
          tmp$ret$7 = tmp$ret$6;
          tmp = new PaintShader(tmp$ret$7, paint.j5x_1);
        } else {
          if (tmp0_subject instanceof GradientPaint) {
            var gradientBitmap = new Bitmap32(256, 1, VOID, true);
            var tmp$ret$8;
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var tmp8_lock = gradientBitmap.w46_1;
            {
              gradientBitmap.f47();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.v5w(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.t47_1));
            }finally {
              result = gradientBitmap.x47(tmp8_lock);
            }
            tmp$ret$8 = result;
            var npaint = paint.w5w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Matrix__preconcated_impl_s9s2ig(Matrix__preconcated_impl_s9s2ig(Companion_getInstance_23().v3f_1, paint.f5g_1), stateTransform));
            var tmp1_subject = paint.v5f_1;
            var tmp0 = tmp1_subject.j5_1;
            var mat_0 = tmp0 === 0 ? npaint.l5g_1 : Matrix__inverted_impl_3pqbyv(npaint.f5g_1);
            var tmp$ret$12;
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var tmp11_single = Companion_getInstance_55();
            var tmp12_single = ShapeViewUB_getInstance();
            var tmp$ret$11;
            // Inline function 'kotlin.also' call
            var tmp$ret$9;
            // Inline function 'kotlin.also' call
            var tmp9_also = new UniformBlockBuffer(tmp12_single);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            tmp9_also.dt();
            tmp$ret$9 = tmp9_also;
            var tmp10_also = tmp$ret$9;
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            var tmp$ret$10;
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var tmp0_this_1 = tmp10_also;
              var tmp1_1 = tmp0_this_1.x6q();
              tmp0_this_1.a7b(tmp1_1 + 1 | 0);
              tmp10_also.tn(tmp10_also.x6q() + 1 | 0);
              var blockSize_1 = tmp10_also.a6p_1;
              var index0_1 = imul(tmp10_also.x6q() - 1 | 0, blockSize_1);
              var index1_1 = imul(tmp10_also.x6q(), blockSize_1);
              var texBlockSize_1 = tmp10_also.y6o_1.t6x().j();
              var texIndex0_1 = imul(tmp10_also.x6q() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(tmp10_also.x6q(), texBlockSize_1);
              if (tmp10_also.x6q() > 0) {
                arraycopy_2(tmp10_also.c6p_1, index0_1, tmp10_also.c6p_1, index1_1, blockSize_1);
              } else {
                arrayfill_0(tmp10_also.c6p_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var tmp0__anonymous__q1qw7t_1 = tmp10_also.y6o_1;
              var tmp1__anonymous__uwfjfc_1 = tmp10_also.d6p_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var tmp_2 = tmp0__anonymous__q1qw7t_1.kcd();
              var tmp0_subject_0 = paint.v5f_1;
              var tmp0_0 = tmp0_subject_0.j5_1;
              var tmp_3;
              switch (tmp0_0) {
                case 1:
                  GpuShapeViewPrograms_getInstance();
                  tmp_3 = 3;
                  break;
                case 2:
                  GpuShapeViewPrograms_getInstance();
                  tmp_3 = 4;
                  break;
                default:
                  GpuShapeViewPrograms_getInstance();
                  tmp_3 = 2;
                  break;
              }
              tmp1__anonymous__uwfjfc_1.k7b(tmp_2, tmp_3);
              tmp1__anonymous__uwfjfc_1.h7b(tmp0__anonymous__q1qw7t_1.ncd(), toMatrix4(mat_0));
              tmp1__anonymous__uwfjfc_1.g7b(tmp0__anonymous__q1qw7t_1.ocd(), _Vector4___init__impl__rdvxwo(paint.w5f_1, paint.x5f_1, paint.y5f_1, 1.0));
              tmp1__anonymous__uwfjfc_1.g7b(tmp0__anonymous__q1qw7t_1.pcd(), _Vector4___init__impl__rdvxwo(paint.z5f_1, paint.a5g_1, paint.b5g_1, 1.0));
              tmp1__anonymous__uwfjfc_1.k7b(tmp0__anonymous__q1qw7t_1.mcd(), globalAlpha);
              if (tmp10_also.x6q() >= 1) {
                var equals_1 = arrayequal(tmp10_also.c6p_1, index0_1, tmp10_also.c6p_1, index1_1, blockSize_1);
                if (equals_1) {
                  var tmp2_this_1 = tmp10_also;
                  var tmp3_1 = tmp2_this_1.x6q();
                  tmp2_this_1.a7b(tmp3_1 - 1 | 0);
                  tmp$ret$10 = false;
                  break $l$block_1;
                }
              }
              tmp$ret$10 = true;
            }
            tmp$ret$11 = tmp10_also;
            tmp$ret$12 = tmp$ret$11;
            tmp = new PaintShader(tmp$ret$12, gradientBitmap);
          } else {
            var tmp13_TODO = 'paint=' + paint;
            throw new NotImplementedError('An operation is not implemented: ' + tmp13_TODO);
          }
        }
      }
    }
    return tmp;
  };
  var GpuShapeViewPrograms_instance;
  function GpuShapeViewPrograms_getInstance() {
    if (GpuShapeViewPrograms_instance == null)
      new GpuShapeViewPrograms();
    return GpuShapeViewPrograms_instance;
  }
  function u_ProgramType$factory() {
    return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
      return receiver.kcd();
    }, null);
  }
  function u_Color$factory() {
    return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
      return receiver.lcd();
    }, null);
  }
  function u_ColorMul$factory() {
    return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
      return receiver.jcd();
    }, null);
  }
  function u_GlobalAlpha$factory() {
    return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
      return receiver.mcd();
    }, null);
  }
  function u_GlobalPixelScale$factory() {
    return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
      return receiver.icd();
    }, null);
  }
  function u_Transform$factory() {
    return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
      return receiver.ncd();
    }, null);
  }
  function u_Gradientp0$factory() {
    return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
      return receiver.ocd();
    }, null);
  }
  function u_Gradientp1$factory() {
    return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
      return receiver.pcd();
    }, null);
  }
  function u_ProgramType$factory_0() {
    return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
      return receiver.kcd();
    }, null);
  }
  function u_Color$factory_0() {
    return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
      return receiver.lcd();
    }, null);
  }
  function u_ColorMul$factory_0() {
    return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
      return receiver.jcd();
    }, null);
  }
  function u_GlobalAlpha$factory_0() {
    return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
      return receiver.mcd();
    }, null);
  }
  function u_GlobalPixelScale$factory_0() {
    return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
      return receiver.icd();
    }, null);
  }
  function u_Transform$factory_0() {
    return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
      return receiver.ncd();
    }, null);
  }
  function u_Gradientp0$factory_0() {
    return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
      return receiver.ocd();
    }, null);
  }
  function u_Gradientp1$factory_0() {
    return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
      return receiver.pcd();
    }, null);
  }
  function completeViews(views) {
  }
  function get_KorgeReloadInternal() {
    _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
    return KorgeReloadInternal;
  }
  var KorgeReloadInternal;
  function KorgeReloadInternal$1() {
    KorgeReloadInternalImpl.call(this);
  }
  var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
  function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
    if (properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    } else {
      properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
      KorgeReloadInternal = new KorgeReloadInternal$1();
    }
  }
  //region block: post-declaration
  protoOf(SDFShaders).k6z = get_Float1;
  protoOf(SDFShaders).a7i = get_Float2;
  protoOf(SDFShaders).d7k = get_Float4;
  protoOf(SDFShaders).t6v = get_out;
  protoOf(SDFShaders).l6z = atan;
  protoOf(SDFShaders).z6v = texture2D;
  protoOf(SDFShaders).m6z = pow;
  protoOf(SDFShaders).n6z = sqrt;
  protoOf(SDFShaders).o6z = abs;
  protoOf(SDFShaders).p6z = fract;
  protoOf(SDFShaders).u6v = get_lit;
  protoOf(SDFShaders).r6z = vec2;
  protoOf(SDFShaders).v6v = vec4;
  protoOf(SDFShaders).y6v = get_0;
  protoOf(SDFShaders).s6z = get_x;
  protoOf(SDFShaders).t6z = get_y;
  protoOf(SDFShaders).u6z = get_z;
  protoOf(SDFShaders).v6z = get_w;
  protoOf(SDFShaders).w6z = unaryMinus;
  protoOf(SDFShaders).x6z = minus;
  protoOf(SDFShaders).y6z = plus;
  protoOf(SDFShaders).k6y = times;
  protoOf(SDFShaders).p6y = div;
  protoOf(SDFShaders).z6z = eq;
  protoOf(SDFShaders).a70 = lt;
  protoOf(SDFShaders).b70 = le;
  protoOf(SDFShaders).c70 = gt;
  protoOf(BaseView).o6a = dispatch$default;
  protoOf(BaseView).q6a = dispatch;
  protoOf(BaseView).p6a = onEvents;
  protoOf(View).o6a = dispatch$default;
  protoOf(View).q6a = dispatch;
  protoOf(View).p6a = onEvents;
  protoOf(Container).o6a = dispatch$default;
  protoOf(Container).q6a = dispatch;
  protoOf(Container).p6a = onEvents;
  protoOf(CachedContainer).o6a = dispatch$default;
  protoOf(CachedContainer).q6a = dispatch;
  protoOf(CachedContainer).p6a = onEvents;
  protoOf(FixedSizeCachedContainer).o6a = dispatch$default;
  protoOf(FixedSizeCachedContainer).q6a = dispatch;
  protoOf(FixedSizeCachedContainer).p6a = onEvents;
  protoOf(UIView).o6a = dispatch$default;
  protoOf(UIView).q6a = dispatch;
  protoOf(UIView).p6a = onEvents;
  protoOf(SceneContainer).o6a = dispatch$default;
  protoOf(SceneContainer).q6a = dispatch;
  protoOf(SceneContainer).p6a = onEvents;
  protoOf(TransitionView).o6a = dispatch$default;
  protoOf(TransitionView).q6a = dispatch;
  protoOf(TransitionView).p6a = onEvents;
  protoOf(Transition$1).lb1 = start;
  protoOf(Transition$1).mb1 = end;
  protoOf(RectBase).o6a = dispatch$default;
  protoOf(RectBase).q6a = dispatch;
  protoOf(RectBase).p6a = onEvents;
  protoOf(BaseImage).o6a = dispatch$default;
  protoOf(BaseImage).q6a = dispatch;
  protoOf(BaseImage).p6a = onEvents;
  protoOf(BaseGraphics).o6a = dispatch$default;
  protoOf(BaseGraphics).q6a = dispatch;
  protoOf(BaseGraphics).p6a = onEvents;
  protoOf(CpuGraphics).o6a = dispatch$default;
  protoOf(CpuGraphics).q6a = dispatch;
  protoOf(CpuGraphics).p6a = onEvents;
  protoOf(DummyView).o6a = dispatch$default;
  protoOf(DummyView).q6a = dispatch;
  protoOf(DummyView).p6a = onEvents;
  protoOf(FixedSizeContainer).o6a = dispatch$default;
  protoOf(FixedSizeContainer).q6a = dispatch;
  protoOf(FixedSizeContainer).p6a = onEvents;
  protoOf(SContainer).o6a = dispatch$default;
  protoOf(SContainer).q6a = dispatch;
  protoOf(SContainer).p6a = onEvents;
  protoOf(Graphics).o6a = dispatch$default;
  protoOf(Graphics).q6a = dispatch;
  protoOf(Graphics).p6a = onEvents;
  protoOf(Image).ic1 = forceLoadSourceFile$default;
  protoOf(Image).o6a = dispatch$default;
  protoOf(Image).q6a = dispatch;
  protoOf(Image).p6a = onEvents;
  protoOf(Stage).o6a = dispatch$default;
  protoOf(Stage).q6a = dispatch;
  protoOf(Stage).p6a = onEvents;
  protoOf(Text).o6a = dispatch$default;
  protoOf(Text).q6a = dispatch;
  protoOf(Text).p6a = onEvents;
  protoOf(Mixin_0).ic1 = forceLoadSourceFile$default;
  protoOf(Views).o6a = dispatch$default;
  protoOf(Views).p6a = onEvents;
  protoOf(Base).sac = get_windowToGlobalScaleAvg;
  protoOf(Base).nac = get_globalToWindowScaleAvg;
  protoOf(Base).c9u = windowToGlobalCoords;
  protoOf(IdentityFilter).aca = get_recommendedFilterScale;
  protoOf(IdentityFilter).bca = computeBorder;
  protoOf(Companion_18).aca = get_recommendedFilterScale;
  protoOf(Companion_18).bca = computeBorder;
  protoOf(GpuShapeView).o6a = dispatch$default;
  protoOf(GpuShapeView).q6a = dispatch;
  protoOf(GpuShapeView).p6a = onEvents;
  //endregion
  //region block: init
  debugBmpFontOrNull = null;
  TEXTURED_ARRAY_COMPONENTS_PER_VERTEX = 6;
  VERTEX_INDEX_SIZE = 6;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = delay;
  _.$_$.b = delay_0;
  _.$_$.c = tween;
  _.$_$.d = views;
  _.$_$.e = Korge_0;
  _.$_$.f = Image_init_$Create$;
  _.$_$.g = Companion_getInstance_62;
  _.$_$.h = Companion_getInstance_64;
  _.$_$.i = Companion_getInstance_67;
  _.$_$.j = Companion_getInstance_70;
  _.$_$.k = get_keys_0;
  _.$_$.l = get_TEXTURED_ARRAY_QUAD_INDICES;
  _.$_$.m = TexturedVertexArray;
  _.$_$.n = get_AlphaTransition;
  _.$_$.o = SceneContainer;
  _.$_$.p = Scene;
  _.$_$.q = withEasing;
  _.$_$.r = V2;
  _.$_$.s = _interpolateFloat;
  _.$_$.t = Container;
  _.$_$.u = FixedSizeContainer;
  _.$_$.v = Stage;
  _.$_$.w = Text;
  _.$_$.x = addFixedUpdater_0;
  _.$_$.y = addTo;
  _.$_$.z = anchor_0;
  _.$_$.a1 = anchor_1;
  _.$_$.b1 = findFirstAscendant;
  _.$_$.c1 = position;
  _.$_$.d1 = position_0;
  _.$_$.e1 = scale;
  _.$_$.f1 = scale_0;
  //endregion
  return _;
}));
